// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.Icon svg {
  transition: 0.2s;
}
.Icon--rotate svg {
  transform: rotate(180deg);
}
.Icon--size svg {
  width: 100%;
  height: 100%;
}
.Icon.custom-stroke-color svg {
  stroke: inherit;
}
.Icon.custom-stroke-color svg path,
.Icon.custom-stroke-color svg polygon,
.Icon.custom-stroke-color svg circle,
.Icon.custom-stroke-color svg rect {
  stroke: inherit;
}
.Icon.custom-fill-color svg {
  fill: inherit;
}
.Icon.custom-fill-color svg path,
.Icon.custom-fill-color svg polygon,
.Icon.custom-fill-color svg circle,
.Icon.custom-fill-color svg rect {
  fill: inherit;
}
.Icon--neutral-25.change-stroke-color svg path {
  stroke: #fdfdfd;
}
.Icon--neutral-25.change-stroke-color svg polygon {
  stroke: #fdfdfd;
}
.Icon--neutral-25.change-stroke-color svg circle {
  stroke: #fdfdfd;
}
.Icon--neutral-25.change-stroke-color svg rect {
  stroke: #fdfdfd;
}
.Icon--neutral-25.change-fill-color svg path {
  fill: #fdfdfd;
}
.Icon--neutral-25.change-fill-color svg polygon {
  fill: #fdfdfd;
}
.Icon--neutral-25.change-fill-color svg circle {
  fill: #fdfdfd;
}
.Icon--neutral-25.change-fill-color svg rect {
  fill: #fdfdfd;
}
.Icon--neutral-50.change-stroke-color svg path {
  stroke: #f9fafa;
}
.Icon--neutral-50.change-stroke-color svg polygon {
  stroke: #f9fafa;
}
.Icon--neutral-50.change-stroke-color svg circle {
  stroke: #f9fafa;
}
.Icon--neutral-50.change-stroke-color svg rect {
  stroke: #f9fafa;
}
.Icon--neutral-50.change-fill-color svg path {
  fill: #f9fafa;
}
.Icon--neutral-50.change-fill-color svg polygon {
  fill: #f9fafa;
}
.Icon--neutral-50.change-fill-color svg circle {
  fill: #f9fafa;
}
.Icon--neutral-50.change-fill-color svg rect {
  fill: #f9fafa;
}
.Icon--neutral-75.change-stroke-color svg path {
  stroke: #f6f6f6;
}
.Icon--neutral-75.change-stroke-color svg polygon {
  stroke: #f6f6f6;
}
.Icon--neutral-75.change-stroke-color svg circle {
  stroke: #f6f6f6;
}
.Icon--neutral-75.change-stroke-color svg rect {
  stroke: #f6f6f6;
}
.Icon--neutral-75.change-fill-color svg path {
  fill: #f6f6f6;
}
.Icon--neutral-75.change-fill-color svg polygon {
  fill: #f6f6f6;
}
.Icon--neutral-75.change-fill-color svg circle {
  fill: #f6f6f6;
}
.Icon--neutral-75.change-fill-color svg rect {
  fill: #f6f6f6;
}
.Icon--neutral-100.change-stroke-color svg path {
  stroke: #f5f5f5;
}
.Icon--neutral-100.change-stroke-color svg polygon {
  stroke: #f5f5f5;
}
.Icon--neutral-100.change-stroke-color svg circle {
  stroke: #f5f5f5;
}
.Icon--neutral-100.change-stroke-color svg rect {
  stroke: #f5f5f5;
}
.Icon--neutral-100.change-fill-color svg path {
  fill: #f5f5f5;
}
.Icon--neutral-100.change-fill-color svg polygon {
  fill: #f5f5f5;
}
.Icon--neutral-100.change-fill-color svg circle {
  fill: #f5f5f5;
}
.Icon--neutral-100.change-fill-color svg rect {
  fill: #f5f5f5;
}
.Icon--neutral-200.change-stroke-color svg path {
  stroke: #e9eaeb;
}
.Icon--neutral-200.change-stroke-color svg polygon {
  stroke: #e9eaeb;
}
.Icon--neutral-200.change-stroke-color svg circle {
  stroke: #e9eaeb;
}
.Icon--neutral-200.change-stroke-color svg rect {
  stroke: #e9eaeb;
}
.Icon--neutral-200.change-fill-color svg path {
  fill: #e9eaeb;
}
.Icon--neutral-200.change-fill-color svg polygon {
  fill: #e9eaeb;
}
.Icon--neutral-200.change-fill-color svg circle {
  fill: #e9eaeb;
}
.Icon--neutral-200.change-fill-color svg rect {
  fill: #e9eaeb;
}
.Icon--neutral-300.change-stroke-color svg path {
  stroke: #d5d7da;
}
.Icon--neutral-300.change-stroke-color svg polygon {
  stroke: #d5d7da;
}
.Icon--neutral-300.change-stroke-color svg circle {
  stroke: #d5d7da;
}
.Icon--neutral-300.change-stroke-color svg rect {
  stroke: #d5d7da;
}
.Icon--neutral-300.change-fill-color svg path {
  fill: #d5d7da;
}
.Icon--neutral-300.change-fill-color svg polygon {
  fill: #d5d7da;
}
.Icon--neutral-300.change-fill-color svg circle {
  fill: #d5d7da;
}
.Icon--neutral-300.change-fill-color svg rect {
  fill: #d5d7da;
}
.Icon--neutral-400.change-stroke-color svg path {
  stroke: #a4a7ae;
}
.Icon--neutral-400.change-stroke-color svg polygon {
  stroke: #a4a7ae;
}
.Icon--neutral-400.change-stroke-color svg circle {
  stroke: #a4a7ae;
}
.Icon--neutral-400.change-stroke-color svg rect {
  stroke: #a4a7ae;
}
.Icon--neutral-400.change-fill-color svg path {
  fill: #a4a7ae;
}
.Icon--neutral-400.change-fill-color svg polygon {
  fill: #a4a7ae;
}
.Icon--neutral-400.change-fill-color svg circle {
  fill: #a4a7ae;
}
.Icon--neutral-400.change-fill-color svg rect {
  fill: #a4a7ae;
}
.Icon--neutral-500.change-stroke-color svg path {
  stroke: #717680;
}
.Icon--neutral-500.change-stroke-color svg polygon {
  stroke: #717680;
}
.Icon--neutral-500.change-stroke-color svg circle {
  stroke: #717680;
}
.Icon--neutral-500.change-stroke-color svg rect {
  stroke: #717680;
}
.Icon--neutral-500.change-fill-color svg path {
  fill: #717680;
}
.Icon--neutral-500.change-fill-color svg polygon {
  fill: #717680;
}
.Icon--neutral-500.change-fill-color svg circle {
  fill: #717680;
}
.Icon--neutral-500.change-fill-color svg rect {
  fill: #717680;
}
.Icon--neutral-600.change-stroke-color svg path {
  stroke: #535862;
}
.Icon--neutral-600.change-stroke-color svg polygon {
  stroke: #535862;
}
.Icon--neutral-600.change-stroke-color svg circle {
  stroke: #535862;
}
.Icon--neutral-600.change-stroke-color svg rect {
  stroke: #535862;
}
.Icon--neutral-600.change-fill-color svg path {
  fill: #535862;
}
.Icon--neutral-600.change-fill-color svg polygon {
  fill: #535862;
}
.Icon--neutral-600.change-fill-color svg circle {
  fill: #535862;
}
.Icon--neutral-600.change-fill-color svg rect {
  fill: #535862;
}
.Icon--neutral-700.change-stroke-color svg path {
  stroke: #414651;
}
.Icon--neutral-700.change-stroke-color svg polygon {
  stroke: #414651;
}
.Icon--neutral-700.change-stroke-color svg circle {
  stroke: #414651;
}
.Icon--neutral-700.change-stroke-color svg rect {
  stroke: #414651;
}
.Icon--neutral-700.change-fill-color svg path {
  fill: #414651;
}
.Icon--neutral-700.change-fill-color svg polygon {
  fill: #414651;
}
.Icon--neutral-700.change-fill-color svg circle {
  fill: #414651;
}
.Icon--neutral-700.change-fill-color svg rect {
  fill: #414651;
}
.Icon--neutral-800.change-stroke-color svg path {
  stroke: #252b37;
}
.Icon--neutral-800.change-stroke-color svg polygon {
  stroke: #252b37;
}
.Icon--neutral-800.change-stroke-color svg circle {
  stroke: #252b37;
}
.Icon--neutral-800.change-stroke-color svg rect {
  stroke: #252b37;
}
.Icon--neutral-800.change-fill-color svg path {
  fill: #252b37;
}
.Icon--neutral-800.change-fill-color svg polygon {
  fill: #252b37;
}
.Icon--neutral-800.change-fill-color svg circle {
  fill: #252b37;
}
.Icon--neutral-800.change-fill-color svg rect {
  fill: #252b37;
}
.Icon--neutral-900.change-stroke-color svg path {
  stroke: #181d27;
}
.Icon--neutral-900.change-stroke-color svg polygon {
  stroke: #181d27;
}
.Icon--neutral-900.change-stroke-color svg circle {
  stroke: #181d27;
}
.Icon--neutral-900.change-stroke-color svg rect {
  stroke: #181d27;
}
.Icon--neutral-900.change-fill-color svg path {
  fill: #181d27;
}
.Icon--neutral-900.change-fill-color svg polygon {
  fill: #181d27;
}
.Icon--neutral-900.change-fill-color svg circle {
  fill: #181d27;
}
.Icon--neutral-900.change-fill-color svg rect {
  fill: #181d27;
}
.Icon--neutral-950.change-stroke-color svg path {
  stroke: #0a0d12;
}
.Icon--neutral-950.change-stroke-color svg polygon {
  stroke: #0a0d12;
}
.Icon--neutral-950.change-stroke-color svg circle {
  stroke: #0a0d12;
}
.Icon--neutral-950.change-stroke-color svg rect {
  stroke: #0a0d12;
}
.Icon--neutral-950.change-fill-color svg path {
  fill: #0a0d12;
}
.Icon--neutral-950.change-fill-color svg polygon {
  fill: #0a0d12;
}
.Icon--neutral-950.change-fill-color svg circle {
  fill: #0a0d12;
}
.Icon--neutral-950.change-fill-color svg rect {
  fill: #0a0d12;
}
.Icon--neutral-dark-25.change-stroke-color svg path {
  stroke: #fafafa;
}
.Icon--neutral-dark-25.change-stroke-color svg polygon {
  stroke: #fafafa;
}
.Icon--neutral-dark-25.change-stroke-color svg circle {
  stroke: #fafafa;
}
.Icon--neutral-dark-25.change-stroke-color svg rect {
  stroke: #fafafa;
}
.Icon--neutral-dark-25.change-fill-color svg path {
  fill: #fafafa;
}
.Icon--neutral-dark-25.change-fill-color svg polygon {
  fill: #fafafa;
}
.Icon--neutral-dark-25.change-fill-color svg circle {
  fill: #fafafa;
}
.Icon--neutral-dark-25.change-fill-color svg rect {
  fill: #fafafa;
}
.Icon--neutral-dark-50.change-stroke-color svg path {
  stroke: #f7f7f7;
}
.Icon--neutral-dark-50.change-stroke-color svg polygon {
  stroke: #f7f7f7;
}
.Icon--neutral-dark-50.change-stroke-color svg circle {
  stroke: #f7f7f7;
}
.Icon--neutral-dark-50.change-stroke-color svg rect {
  stroke: #f7f7f7;
}
.Icon--neutral-dark-50.change-fill-color svg path {
  fill: #f7f7f7;
}
.Icon--neutral-dark-50.change-fill-color svg polygon {
  fill: #f7f7f7;
}
.Icon--neutral-dark-50.change-fill-color svg circle {
  fill: #f7f7f7;
}
.Icon--neutral-dark-50.change-fill-color svg rect {
  fill: #f7f7f7;
}
.Icon--neutral-dark-100.change-stroke-color svg path {
  stroke: #f0f0f1;
}
.Icon--neutral-dark-100.change-stroke-color svg polygon {
  stroke: #f0f0f1;
}
.Icon--neutral-dark-100.change-stroke-color svg circle {
  stroke: #f0f0f1;
}
.Icon--neutral-dark-100.change-stroke-color svg rect {
  stroke: #f0f0f1;
}
.Icon--neutral-dark-100.change-fill-color svg path {
  fill: #f0f0f1;
}
.Icon--neutral-dark-100.change-fill-color svg polygon {
  fill: #f0f0f1;
}
.Icon--neutral-dark-100.change-fill-color svg circle {
  fill: #f0f0f1;
}
.Icon--neutral-dark-100.change-fill-color svg rect {
  fill: #f0f0f1;
}
.Icon--neutral-dark-200.change-stroke-color svg path {
  stroke: #ececed;
}
.Icon--neutral-dark-200.change-stroke-color svg polygon {
  stroke: #ececed;
}
.Icon--neutral-dark-200.change-stroke-color svg circle {
  stroke: #ececed;
}
.Icon--neutral-dark-200.change-stroke-color svg rect {
  stroke: #ececed;
}
.Icon--neutral-dark-200.change-fill-color svg path {
  fill: #ececed;
}
.Icon--neutral-dark-200.change-fill-color svg polygon {
  fill: #ececed;
}
.Icon--neutral-dark-200.change-fill-color svg circle {
  fill: #ececed;
}
.Icon--neutral-dark-200.change-fill-color svg rect {
  fill: #ececed;
}
.Icon--neutral-dark-300.change-stroke-color svg path {
  stroke: #cecfd2;
}
.Icon--neutral-dark-300.change-stroke-color svg polygon {
  stroke: #cecfd2;
}
.Icon--neutral-dark-300.change-stroke-color svg circle {
  stroke: #cecfd2;
}
.Icon--neutral-dark-300.change-stroke-color svg rect {
  stroke: #cecfd2;
}
.Icon--neutral-dark-300.change-fill-color svg path {
  fill: #cecfd2;
}
.Icon--neutral-dark-300.change-fill-color svg polygon {
  fill: #cecfd2;
}
.Icon--neutral-dark-300.change-fill-color svg circle {
  fill: #cecfd2;
}
.Icon--neutral-dark-300.change-fill-color svg rect {
  fill: #cecfd2;
}
.Icon--neutral-dark-400.change-stroke-color svg path {
  stroke: #94979c;
}
.Icon--neutral-dark-400.change-stroke-color svg polygon {
  stroke: #94979c;
}
.Icon--neutral-dark-400.change-stroke-color svg circle {
  stroke: #94979c;
}
.Icon--neutral-dark-400.change-stroke-color svg rect {
  stroke: #94979c;
}
.Icon--neutral-dark-400.change-fill-color svg path {
  fill: #94979c;
}
.Icon--neutral-dark-400.change-fill-color svg polygon {
  fill: #94979c;
}
.Icon--neutral-dark-400.change-fill-color svg circle {
  fill: #94979c;
}
.Icon--neutral-dark-400.change-fill-color svg rect {
  fill: #94979c;
}
.Icon--neutral-dark-500.change-stroke-color svg path {
  stroke: #85888e;
}
.Icon--neutral-dark-500.change-stroke-color svg polygon {
  stroke: #85888e;
}
.Icon--neutral-dark-500.change-stroke-color svg circle {
  stroke: #85888e;
}
.Icon--neutral-dark-500.change-stroke-color svg rect {
  stroke: #85888e;
}
.Icon--neutral-dark-500.change-fill-color svg path {
  fill: #85888e;
}
.Icon--neutral-dark-500.change-fill-color svg polygon {
  fill: #85888e;
}
.Icon--neutral-dark-500.change-fill-color svg circle {
  fill: #85888e;
}
.Icon--neutral-dark-500.change-fill-color svg rect {
  fill: #85888e;
}
.Icon--neutral-dark-600.change-stroke-color svg path {
  stroke: #61656c;
}
.Icon--neutral-dark-600.change-stroke-color svg polygon {
  stroke: #61656c;
}
.Icon--neutral-dark-600.change-stroke-color svg circle {
  stroke: #61656c;
}
.Icon--neutral-dark-600.change-stroke-color svg rect {
  stroke: #61656c;
}
.Icon--neutral-dark-600.change-fill-color svg path {
  fill: #61656c;
}
.Icon--neutral-dark-600.change-fill-color svg polygon {
  fill: #61656c;
}
.Icon--neutral-dark-600.change-fill-color svg circle {
  fill: #61656c;
}
.Icon--neutral-dark-600.change-fill-color svg rect {
  fill: #61656c;
}
.Icon--neutral-dark-700.change-stroke-color svg path {
  stroke: #373a41;
}
.Icon--neutral-dark-700.change-stroke-color svg polygon {
  stroke: #373a41;
}
.Icon--neutral-dark-700.change-stroke-color svg circle {
  stroke: #373a41;
}
.Icon--neutral-dark-700.change-stroke-color svg rect {
  stroke: #373a41;
}
.Icon--neutral-dark-700.change-fill-color svg path {
  fill: #373a41;
}
.Icon--neutral-dark-700.change-fill-color svg polygon {
  fill: #373a41;
}
.Icon--neutral-dark-700.change-fill-color svg circle {
  fill: #373a41;
}
.Icon--neutral-dark-700.change-fill-color svg rect {
  fill: #373a41;
}
.Icon--neutral-dark-800.change-stroke-color svg path {
  stroke: #22262f;
}
.Icon--neutral-dark-800.change-stroke-color svg polygon {
  stroke: #22262f;
}
.Icon--neutral-dark-800.change-stroke-color svg circle {
  stroke: #22262f;
}
.Icon--neutral-dark-800.change-stroke-color svg rect {
  stroke: #22262f;
}
.Icon--neutral-dark-800.change-fill-color svg path {
  fill: #22262f;
}
.Icon--neutral-dark-800.change-fill-color svg polygon {
  fill: #22262f;
}
.Icon--neutral-dark-800.change-fill-color svg circle {
  fill: #22262f;
}
.Icon--neutral-dark-800.change-fill-color svg rect {
  fill: #22262f;
}
.Icon--neutral-dark-900.change-stroke-color svg path {
  stroke: #13161b;
}
.Icon--neutral-dark-900.change-stroke-color svg polygon {
  stroke: #13161b;
}
.Icon--neutral-dark-900.change-stroke-color svg circle {
  stroke: #13161b;
}
.Icon--neutral-dark-900.change-stroke-color svg rect {
  stroke: #13161b;
}
.Icon--neutral-dark-900.change-fill-color svg path {
  fill: #13161b;
}
.Icon--neutral-dark-900.change-fill-color svg polygon {
  fill: #13161b;
}
.Icon--neutral-dark-900.change-fill-color svg circle {
  fill: #13161b;
}
.Icon--neutral-dark-900.change-fill-color svg rect {
  fill: #13161b;
}
.Icon--neutral-dark-950.change-stroke-color svg path {
  stroke: #0c0e12;
}
.Icon--neutral-dark-950.change-stroke-color svg polygon {
  stroke: #0c0e12;
}
.Icon--neutral-dark-950.change-stroke-color svg circle {
  stroke: #0c0e12;
}
.Icon--neutral-dark-950.change-stroke-color svg rect {
  stroke: #0c0e12;
}
.Icon--neutral-dark-950.change-fill-color svg path {
  fill: #0c0e12;
}
.Icon--neutral-dark-950.change-fill-color svg polygon {
  fill: #0c0e12;
}
.Icon--neutral-dark-950.change-fill-color svg circle {
  fill: #0c0e12;
}
.Icon--neutral-dark-950.change-fill-color svg rect {
  fill: #0c0e12;
}
.Icon--primary-10.change-stroke-color svg path {
  stroke: #fafdff;
}
.Icon--primary-10.change-stroke-color svg polygon {
  stroke: #fafdff;
}
.Icon--primary-10.change-stroke-color svg circle {
  stroke: #fafdff;
}
.Icon--primary-10.change-stroke-color svg rect {
  stroke: #fafdff;
}
.Icon--primary-10.change-fill-color svg path {
  fill: #fafdff;
}
.Icon--primary-10.change-fill-color svg polygon {
  fill: #fafdff;
}
.Icon--primary-10.change-fill-color svg circle {
  fill: #fafdff;
}
.Icon--primary-10.change-fill-color svg rect {
  fill: #fafdff;
}
.Icon--primary-25.change-stroke-color svg path {
  stroke: #f5fbff;
}
.Icon--primary-25.change-stroke-color svg polygon {
  stroke: #f5fbff;
}
.Icon--primary-25.change-stroke-color svg circle {
  stroke: #f5fbff;
}
.Icon--primary-25.change-stroke-color svg rect {
  stroke: #f5fbff;
}
.Icon--primary-25.change-fill-color svg path {
  fill: #f5fbff;
}
.Icon--primary-25.change-fill-color svg polygon {
  fill: #f5fbff;
}
.Icon--primary-25.change-fill-color svg circle {
  fill: #f5fbff;
}
.Icon--primary-25.change-fill-color svg rect {
  fill: #f5fbff;
}
.Icon--primary-50.change-stroke-color svg path {
  stroke: #f0f9ff;
}
.Icon--primary-50.change-stroke-color svg polygon {
  stroke: #f0f9ff;
}
.Icon--primary-50.change-stroke-color svg circle {
  stroke: #f0f9ff;
}
.Icon--primary-50.change-stroke-color svg rect {
  stroke: #f0f9ff;
}
.Icon--primary-50.change-fill-color svg path {
  fill: #f0f9ff;
}
.Icon--primary-50.change-fill-color svg polygon {
  fill: #f0f9ff;
}
.Icon--primary-50.change-fill-color svg circle {
  fill: #f0f9ff;
}
.Icon--primary-50.change-fill-color svg rect {
  fill: #f0f9ff;
}
.Icon--primary-100.change-stroke-color svg path {
  stroke: #e0f2fe;
}
.Icon--primary-100.change-stroke-color svg polygon {
  stroke: #e0f2fe;
}
.Icon--primary-100.change-stroke-color svg circle {
  stroke: #e0f2fe;
}
.Icon--primary-100.change-stroke-color svg rect {
  stroke: #e0f2fe;
}
.Icon--primary-100.change-fill-color svg path {
  fill: #e0f2fe;
}
.Icon--primary-100.change-fill-color svg polygon {
  fill: #e0f2fe;
}
.Icon--primary-100.change-fill-color svg circle {
  fill: #e0f2fe;
}
.Icon--primary-100.change-fill-color svg rect {
  fill: #e0f2fe;
}
.Icon--primary-200.change-stroke-color svg path {
  stroke: #b9e6fe;
}
.Icon--primary-200.change-stroke-color svg polygon {
  stroke: #b9e6fe;
}
.Icon--primary-200.change-stroke-color svg circle {
  stroke: #b9e6fe;
}
.Icon--primary-200.change-stroke-color svg rect {
  stroke: #b9e6fe;
}
.Icon--primary-200.change-fill-color svg path {
  fill: #b9e6fe;
}
.Icon--primary-200.change-fill-color svg polygon {
  fill: #b9e6fe;
}
.Icon--primary-200.change-fill-color svg circle {
  fill: #b9e6fe;
}
.Icon--primary-200.change-fill-color svg rect {
  fill: #b9e6fe;
}
.Icon--primary-300.change-stroke-color svg path {
  stroke: #7cd4fd;
}
.Icon--primary-300.change-stroke-color svg polygon {
  stroke: #7cd4fd;
}
.Icon--primary-300.change-stroke-color svg circle {
  stroke: #7cd4fd;
}
.Icon--primary-300.change-stroke-color svg rect {
  stroke: #7cd4fd;
}
.Icon--primary-300.change-fill-color svg path {
  fill: #7cd4fd;
}
.Icon--primary-300.change-fill-color svg polygon {
  fill: #7cd4fd;
}
.Icon--primary-300.change-fill-color svg circle {
  fill: #7cd4fd;
}
.Icon--primary-300.change-fill-color svg rect {
  fill: #7cd4fd;
}
.Icon--primary-400.change-stroke-color svg path {
  stroke: #36bffa;
}
.Icon--primary-400.change-stroke-color svg polygon {
  stroke: #36bffa;
}
.Icon--primary-400.change-stroke-color svg circle {
  stroke: #36bffa;
}
.Icon--primary-400.change-stroke-color svg rect {
  stroke: #36bffa;
}
.Icon--primary-400.change-fill-color svg path {
  fill: #36bffa;
}
.Icon--primary-400.change-fill-color svg polygon {
  fill: #36bffa;
}
.Icon--primary-400.change-fill-color svg circle {
  fill: #36bffa;
}
.Icon--primary-400.change-fill-color svg rect {
  fill: #36bffa;
}
.Icon--primary-500.change-stroke-color svg path {
  stroke: #0ba5ec;
}
.Icon--primary-500.change-stroke-color svg polygon {
  stroke: #0ba5ec;
}
.Icon--primary-500.change-stroke-color svg circle {
  stroke: #0ba5ec;
}
.Icon--primary-500.change-stroke-color svg rect {
  stroke: #0ba5ec;
}
.Icon--primary-500.change-fill-color svg path {
  fill: #0ba5ec;
}
.Icon--primary-500.change-fill-color svg polygon {
  fill: #0ba5ec;
}
.Icon--primary-500.change-fill-color svg circle {
  fill: #0ba5ec;
}
.Icon--primary-500.change-fill-color svg rect {
  fill: #0ba5ec;
}
.Icon--primary-600.change-stroke-color svg path {
  stroke: #0086c9;
}
.Icon--primary-600.change-stroke-color svg polygon {
  stroke: #0086c9;
}
.Icon--primary-600.change-stroke-color svg circle {
  stroke: #0086c9;
}
.Icon--primary-600.change-stroke-color svg rect {
  stroke: #0086c9;
}
.Icon--primary-600.change-fill-color svg path {
  fill: #0086c9;
}
.Icon--primary-600.change-fill-color svg polygon {
  fill: #0086c9;
}
.Icon--primary-600.change-fill-color svg circle {
  fill: #0086c9;
}
.Icon--primary-600.change-fill-color svg rect {
  fill: #0086c9;
}
.Icon--primary-700.change-stroke-color svg path {
  stroke: #026aa2;
}
.Icon--primary-700.change-stroke-color svg polygon {
  stroke: #026aa2;
}
.Icon--primary-700.change-stroke-color svg circle {
  stroke: #026aa2;
}
.Icon--primary-700.change-stroke-color svg rect {
  stroke: #026aa2;
}
.Icon--primary-700.change-fill-color svg path {
  fill: #026aa2;
}
.Icon--primary-700.change-fill-color svg polygon {
  fill: #026aa2;
}
.Icon--primary-700.change-fill-color svg circle {
  fill: #026aa2;
}
.Icon--primary-700.change-fill-color svg rect {
  fill: #026aa2;
}
.Icon--primary-800.change-stroke-color svg path {
  stroke: #065986;
}
.Icon--primary-800.change-stroke-color svg polygon {
  stroke: #065986;
}
.Icon--primary-800.change-stroke-color svg circle {
  stroke: #065986;
}
.Icon--primary-800.change-stroke-color svg rect {
  stroke: #065986;
}
.Icon--primary-800.change-fill-color svg path {
  fill: #065986;
}
.Icon--primary-800.change-fill-color svg polygon {
  fill: #065986;
}
.Icon--primary-800.change-fill-color svg circle {
  fill: #065986;
}
.Icon--primary-800.change-fill-color svg rect {
  fill: #065986;
}
.Icon--primary-900.change-stroke-color svg path {
  stroke: #0b4a6f;
}
.Icon--primary-900.change-stroke-color svg polygon {
  stroke: #0b4a6f;
}
.Icon--primary-900.change-stroke-color svg circle {
  stroke: #0b4a6f;
}
.Icon--primary-900.change-stroke-color svg rect {
  stroke: #0b4a6f;
}
.Icon--primary-900.change-fill-color svg path {
  fill: #0b4a6f;
}
.Icon--primary-900.change-fill-color svg polygon {
  fill: #0b4a6f;
}
.Icon--primary-900.change-fill-color svg circle {
  fill: #0b4a6f;
}
.Icon--primary-900.change-fill-color svg rect {
  fill: #0b4a6f;
}
.Icon--primary-950.change-stroke-color svg path {
  stroke: #062c41;
}
.Icon--primary-950.change-stroke-color svg polygon {
  stroke: #062c41;
}
.Icon--primary-950.change-stroke-color svg circle {
  stroke: #062c41;
}
.Icon--primary-950.change-stroke-color svg rect {
  stroke: #062c41;
}
.Icon--primary-950.change-fill-color svg path {
  fill: #062c41;
}
.Icon--primary-950.change-fill-color svg polygon {
  fill: #062c41;
}
.Icon--primary-950.change-fill-color svg circle {
  fill: #062c41;
}
.Icon--primary-950.change-fill-color svg rect {
  fill: #062c41;
}
.Icon--danger-25.change-stroke-color svg path {
  stroke: #fffbfa;
}
.Icon--danger-25.change-stroke-color svg polygon {
  stroke: #fffbfa;
}
.Icon--danger-25.change-stroke-color svg circle {
  stroke: #fffbfa;
}
.Icon--danger-25.change-stroke-color svg rect {
  stroke: #fffbfa;
}
.Icon--danger-25.change-fill-color svg path {
  fill: #fffbfa;
}
.Icon--danger-25.change-fill-color svg polygon {
  fill: #fffbfa;
}
.Icon--danger-25.change-fill-color svg circle {
  fill: #fffbfa;
}
.Icon--danger-25.change-fill-color svg rect {
  fill: #fffbfa;
}
.Icon--danger-50.change-stroke-color svg path {
  stroke: #fef3f2;
}
.Icon--danger-50.change-stroke-color svg polygon {
  stroke: #fef3f2;
}
.Icon--danger-50.change-stroke-color svg circle {
  stroke: #fef3f2;
}
.Icon--danger-50.change-stroke-color svg rect {
  stroke: #fef3f2;
}
.Icon--danger-50.change-fill-color svg path {
  fill: #fef3f2;
}
.Icon--danger-50.change-fill-color svg polygon {
  fill: #fef3f2;
}
.Icon--danger-50.change-fill-color svg circle {
  fill: #fef3f2;
}
.Icon--danger-50.change-fill-color svg rect {
  fill: #fef3f2;
}
.Icon--danger-100.change-stroke-color svg path {
  stroke: #fee4e2;
}
.Icon--danger-100.change-stroke-color svg polygon {
  stroke: #fee4e2;
}
.Icon--danger-100.change-stroke-color svg circle {
  stroke: #fee4e2;
}
.Icon--danger-100.change-stroke-color svg rect {
  stroke: #fee4e2;
}
.Icon--danger-100.change-fill-color svg path {
  fill: #fee4e2;
}
.Icon--danger-100.change-fill-color svg polygon {
  fill: #fee4e2;
}
.Icon--danger-100.change-fill-color svg circle {
  fill: #fee4e2;
}
.Icon--danger-100.change-fill-color svg rect {
  fill: #fee4e2;
}
.Icon--danger-200.change-stroke-color svg path {
  stroke: #fecdca;
}
.Icon--danger-200.change-stroke-color svg polygon {
  stroke: #fecdca;
}
.Icon--danger-200.change-stroke-color svg circle {
  stroke: #fecdca;
}
.Icon--danger-200.change-stroke-color svg rect {
  stroke: #fecdca;
}
.Icon--danger-200.change-fill-color svg path {
  fill: #fecdca;
}
.Icon--danger-200.change-fill-color svg polygon {
  fill: #fecdca;
}
.Icon--danger-200.change-fill-color svg circle {
  fill: #fecdca;
}
.Icon--danger-200.change-fill-color svg rect {
  fill: #fecdca;
}
.Icon--danger-300.change-stroke-color svg path {
  stroke: #fda29b;
}
.Icon--danger-300.change-stroke-color svg polygon {
  stroke: #fda29b;
}
.Icon--danger-300.change-stroke-color svg circle {
  stroke: #fda29b;
}
.Icon--danger-300.change-stroke-color svg rect {
  stroke: #fda29b;
}
.Icon--danger-300.change-fill-color svg path {
  fill: #fda29b;
}
.Icon--danger-300.change-fill-color svg polygon {
  fill: #fda29b;
}
.Icon--danger-300.change-fill-color svg circle {
  fill: #fda29b;
}
.Icon--danger-300.change-fill-color svg rect {
  fill: #fda29b;
}
.Icon--danger-400.change-stroke-color svg path {
  stroke: #f97066;
}
.Icon--danger-400.change-stroke-color svg polygon {
  stroke: #f97066;
}
.Icon--danger-400.change-stroke-color svg circle {
  stroke: #f97066;
}
.Icon--danger-400.change-stroke-color svg rect {
  stroke: #f97066;
}
.Icon--danger-400.change-fill-color svg path {
  fill: #f97066;
}
.Icon--danger-400.change-fill-color svg polygon {
  fill: #f97066;
}
.Icon--danger-400.change-fill-color svg circle {
  fill: #f97066;
}
.Icon--danger-400.change-fill-color svg rect {
  fill: #f97066;
}
.Icon--danger-500.change-stroke-color svg path {
  stroke: #f04438;
}
.Icon--danger-500.change-stroke-color svg polygon {
  stroke: #f04438;
}
.Icon--danger-500.change-stroke-color svg circle {
  stroke: #f04438;
}
.Icon--danger-500.change-stroke-color svg rect {
  stroke: #f04438;
}
.Icon--danger-500.change-fill-color svg path {
  fill: #f04438;
}
.Icon--danger-500.change-fill-color svg polygon {
  fill: #f04438;
}
.Icon--danger-500.change-fill-color svg circle {
  fill: #f04438;
}
.Icon--danger-500.change-fill-color svg rect {
  fill: #f04438;
}
.Icon--danger-600.change-stroke-color svg path {
  stroke: #d92d20;
}
.Icon--danger-600.change-stroke-color svg polygon {
  stroke: #d92d20;
}
.Icon--danger-600.change-stroke-color svg circle {
  stroke: #d92d20;
}
.Icon--danger-600.change-stroke-color svg rect {
  stroke: #d92d20;
}
.Icon--danger-600.change-fill-color svg path {
  fill: #d92d20;
}
.Icon--danger-600.change-fill-color svg polygon {
  fill: #d92d20;
}
.Icon--danger-600.change-fill-color svg circle {
  fill: #d92d20;
}
.Icon--danger-600.change-fill-color svg rect {
  fill: #d92d20;
}
.Icon--danger-700.change-stroke-color svg path {
  stroke: #b42318;
}
.Icon--danger-700.change-stroke-color svg polygon {
  stroke: #b42318;
}
.Icon--danger-700.change-stroke-color svg circle {
  stroke: #b42318;
}
.Icon--danger-700.change-stroke-color svg rect {
  stroke: #b42318;
}
.Icon--danger-700.change-fill-color svg path {
  fill: #b42318;
}
.Icon--danger-700.change-fill-color svg polygon {
  fill: #b42318;
}
.Icon--danger-700.change-fill-color svg circle {
  fill: #b42318;
}
.Icon--danger-700.change-fill-color svg rect {
  fill: #b42318;
}
.Icon--danger-800.change-stroke-color svg path {
  stroke: #912018;
}
.Icon--danger-800.change-stroke-color svg polygon {
  stroke: #912018;
}
.Icon--danger-800.change-stroke-color svg circle {
  stroke: #912018;
}
.Icon--danger-800.change-stroke-color svg rect {
  stroke: #912018;
}
.Icon--danger-800.change-fill-color svg path {
  fill: #912018;
}
.Icon--danger-800.change-fill-color svg polygon {
  fill: #912018;
}
.Icon--danger-800.change-fill-color svg circle {
  fill: #912018;
}
.Icon--danger-800.change-fill-color svg rect {
  fill: #912018;
}
.Icon--danger-900.change-stroke-color svg path {
  stroke: #7a271a;
}
.Icon--danger-900.change-stroke-color svg polygon {
  stroke: #7a271a;
}
.Icon--danger-900.change-stroke-color svg circle {
  stroke: #7a271a;
}
.Icon--danger-900.change-stroke-color svg rect {
  stroke: #7a271a;
}
.Icon--danger-900.change-fill-color svg path {
  fill: #7a271a;
}
.Icon--danger-900.change-fill-color svg polygon {
  fill: #7a271a;
}
.Icon--danger-900.change-fill-color svg circle {
  fill: #7a271a;
}
.Icon--danger-900.change-fill-color svg rect {
  fill: #7a271a;
}
.Icon--danger-950.change-stroke-color svg path {
  stroke: #55160c;
}
.Icon--danger-950.change-stroke-color svg polygon {
  stroke: #55160c;
}
.Icon--danger-950.change-stroke-color svg circle {
  stroke: #55160c;
}
.Icon--danger-950.change-stroke-color svg rect {
  stroke: #55160c;
}
.Icon--danger-950.change-fill-color svg path {
  fill: #55160c;
}
.Icon--danger-950.change-fill-color svg polygon {
  fill: #55160c;
}
.Icon--danger-950.change-fill-color svg circle {
  fill: #55160c;
}
.Icon--danger-950.change-fill-color svg rect {
  fill: #55160c;
}
.Icon--warning-25.change-stroke-color svg path {
  stroke: #fffcf5;
}
.Icon--warning-25.change-stroke-color svg polygon {
  stroke: #fffcf5;
}
.Icon--warning-25.change-stroke-color svg circle {
  stroke: #fffcf5;
}
.Icon--warning-25.change-stroke-color svg rect {
  stroke: #fffcf5;
}
.Icon--warning-25.change-fill-color svg path {
  fill: #fffcf5;
}
.Icon--warning-25.change-fill-color svg polygon {
  fill: #fffcf5;
}
.Icon--warning-25.change-fill-color svg circle {
  fill: #fffcf5;
}
.Icon--warning-25.change-fill-color svg rect {
  fill: #fffcf5;
}
.Icon--warning-50.change-stroke-color svg path {
  stroke: #fffaeb;
}
.Icon--warning-50.change-stroke-color svg polygon {
  stroke: #fffaeb;
}
.Icon--warning-50.change-stroke-color svg circle {
  stroke: #fffaeb;
}
.Icon--warning-50.change-stroke-color svg rect {
  stroke: #fffaeb;
}
.Icon--warning-50.change-fill-color svg path {
  fill: #fffaeb;
}
.Icon--warning-50.change-fill-color svg polygon {
  fill: #fffaeb;
}
.Icon--warning-50.change-fill-color svg circle {
  fill: #fffaeb;
}
.Icon--warning-50.change-fill-color svg rect {
  fill: #fffaeb;
}
.Icon--warning-100.change-stroke-color svg path {
  stroke: #fef0c7;
}
.Icon--warning-100.change-stroke-color svg polygon {
  stroke: #fef0c7;
}
.Icon--warning-100.change-stroke-color svg circle {
  stroke: #fef0c7;
}
.Icon--warning-100.change-stroke-color svg rect {
  stroke: #fef0c7;
}
.Icon--warning-100.change-fill-color svg path {
  fill: #fef0c7;
}
.Icon--warning-100.change-fill-color svg polygon {
  fill: #fef0c7;
}
.Icon--warning-100.change-fill-color svg circle {
  fill: #fef0c7;
}
.Icon--warning-100.change-fill-color svg rect {
  fill: #fef0c7;
}
.Icon--warning-200.change-stroke-color svg path {
  stroke: #fedf89;
}
.Icon--warning-200.change-stroke-color svg polygon {
  stroke: #fedf89;
}
.Icon--warning-200.change-stroke-color svg circle {
  stroke: #fedf89;
}
.Icon--warning-200.change-stroke-color svg rect {
  stroke: #fedf89;
}
.Icon--warning-200.change-fill-color svg path {
  fill: #fedf89;
}
.Icon--warning-200.change-fill-color svg polygon {
  fill: #fedf89;
}
.Icon--warning-200.change-fill-color svg circle {
  fill: #fedf89;
}
.Icon--warning-200.change-fill-color svg rect {
  fill: #fedf89;
}
.Icon--warning-300.change-stroke-color svg path {
  stroke: #fec84b;
}
.Icon--warning-300.change-stroke-color svg polygon {
  stroke: #fec84b;
}
.Icon--warning-300.change-stroke-color svg circle {
  stroke: #fec84b;
}
.Icon--warning-300.change-stroke-color svg rect {
  stroke: #fec84b;
}
.Icon--warning-300.change-fill-color svg path {
  fill: #fec84b;
}
.Icon--warning-300.change-fill-color svg polygon {
  fill: #fec84b;
}
.Icon--warning-300.change-fill-color svg circle {
  fill: #fec84b;
}
.Icon--warning-300.change-fill-color svg rect {
  fill: #fec84b;
}
.Icon--warning-400.change-stroke-color svg path {
  stroke: #fdb022;
}
.Icon--warning-400.change-stroke-color svg polygon {
  stroke: #fdb022;
}
.Icon--warning-400.change-stroke-color svg circle {
  stroke: #fdb022;
}
.Icon--warning-400.change-stroke-color svg rect {
  stroke: #fdb022;
}
.Icon--warning-400.change-fill-color svg path {
  fill: #fdb022;
}
.Icon--warning-400.change-fill-color svg polygon {
  fill: #fdb022;
}
.Icon--warning-400.change-fill-color svg circle {
  fill: #fdb022;
}
.Icon--warning-400.change-fill-color svg rect {
  fill: #fdb022;
}
.Icon--warning-500.change-stroke-color svg path {
  stroke: #f79009;
}
.Icon--warning-500.change-stroke-color svg polygon {
  stroke: #f79009;
}
.Icon--warning-500.change-stroke-color svg circle {
  stroke: #f79009;
}
.Icon--warning-500.change-stroke-color svg rect {
  stroke: #f79009;
}
.Icon--warning-500.change-fill-color svg path {
  fill: #f79009;
}
.Icon--warning-500.change-fill-color svg polygon {
  fill: #f79009;
}
.Icon--warning-500.change-fill-color svg circle {
  fill: #f79009;
}
.Icon--warning-500.change-fill-color svg rect {
  fill: #f79009;
}
.Icon--warning-600.change-stroke-color svg path {
  stroke: #dc6803;
}
.Icon--warning-600.change-stroke-color svg polygon {
  stroke: #dc6803;
}
.Icon--warning-600.change-stroke-color svg circle {
  stroke: #dc6803;
}
.Icon--warning-600.change-stroke-color svg rect {
  stroke: #dc6803;
}
.Icon--warning-600.change-fill-color svg path {
  fill: #dc6803;
}
.Icon--warning-600.change-fill-color svg polygon {
  fill: #dc6803;
}
.Icon--warning-600.change-fill-color svg circle {
  fill: #dc6803;
}
.Icon--warning-600.change-fill-color svg rect {
  fill: #dc6803;
}
.Icon--warning-700.change-stroke-color svg path {
  stroke: #b54708;
}
.Icon--warning-700.change-stroke-color svg polygon {
  stroke: #b54708;
}
.Icon--warning-700.change-stroke-color svg circle {
  stroke: #b54708;
}
.Icon--warning-700.change-stroke-color svg rect {
  stroke: #b54708;
}
.Icon--warning-700.change-fill-color svg path {
  fill: #b54708;
}
.Icon--warning-700.change-fill-color svg polygon {
  fill: #b54708;
}
.Icon--warning-700.change-fill-color svg circle {
  fill: #b54708;
}
.Icon--warning-700.change-fill-color svg rect {
  fill: #b54708;
}
.Icon--warning-800.change-stroke-color svg path {
  stroke: #93370d;
}
.Icon--warning-800.change-stroke-color svg polygon {
  stroke: #93370d;
}
.Icon--warning-800.change-stroke-color svg circle {
  stroke: #93370d;
}
.Icon--warning-800.change-stroke-color svg rect {
  stroke: #93370d;
}
.Icon--warning-800.change-fill-color svg path {
  fill: #93370d;
}
.Icon--warning-800.change-fill-color svg polygon {
  fill: #93370d;
}
.Icon--warning-800.change-fill-color svg circle {
  fill: #93370d;
}
.Icon--warning-800.change-fill-color svg rect {
  fill: #93370d;
}
.Icon--warning-900.change-stroke-color svg path {
  stroke: #7a2e0e;
}
.Icon--warning-900.change-stroke-color svg polygon {
  stroke: #7a2e0e;
}
.Icon--warning-900.change-stroke-color svg circle {
  stroke: #7a2e0e;
}
.Icon--warning-900.change-stroke-color svg rect {
  stroke: #7a2e0e;
}
.Icon--warning-900.change-fill-color svg path {
  fill: #7a2e0e;
}
.Icon--warning-900.change-fill-color svg polygon {
  fill: #7a2e0e;
}
.Icon--warning-900.change-fill-color svg circle {
  fill: #7a2e0e;
}
.Icon--warning-900.change-fill-color svg rect {
  fill: #7a2e0e;
}
.Icon--warning-950.change-stroke-color svg path {
  stroke: #4e1d09;
}
.Icon--warning-950.change-stroke-color svg polygon {
  stroke: #4e1d09;
}
.Icon--warning-950.change-stroke-color svg circle {
  stroke: #4e1d09;
}
.Icon--warning-950.change-stroke-color svg rect {
  stroke: #4e1d09;
}
.Icon--warning-950.change-fill-color svg path {
  fill: #4e1d09;
}
.Icon--warning-950.change-fill-color svg polygon {
  fill: #4e1d09;
}
.Icon--warning-950.change-fill-color svg circle {
  fill: #4e1d09;
}
.Icon--warning-950.change-fill-color svg rect {
  fill: #4e1d09;
}
.Icon--success-25.change-stroke-color svg path {
  stroke: #f6fef9;
}
.Icon--success-25.change-stroke-color svg polygon {
  stroke: #f6fef9;
}
.Icon--success-25.change-stroke-color svg circle {
  stroke: #f6fef9;
}
.Icon--success-25.change-stroke-color svg rect {
  stroke: #f6fef9;
}
.Icon--success-25.change-fill-color svg path {
  fill: #f6fef9;
}
.Icon--success-25.change-fill-color svg polygon {
  fill: #f6fef9;
}
.Icon--success-25.change-fill-color svg circle {
  fill: #f6fef9;
}
.Icon--success-25.change-fill-color svg rect {
  fill: #f6fef9;
}
.Icon--success-50.change-stroke-color svg path {
  stroke: #edfcf2;
}
.Icon--success-50.change-stroke-color svg polygon {
  stroke: #edfcf2;
}
.Icon--success-50.change-stroke-color svg circle {
  stroke: #edfcf2;
}
.Icon--success-50.change-stroke-color svg rect {
  stroke: #edfcf2;
}
.Icon--success-50.change-fill-color svg path {
  fill: #edfcf2;
}
.Icon--success-50.change-fill-color svg polygon {
  fill: #edfcf2;
}
.Icon--success-50.change-fill-color svg circle {
  fill: #edfcf2;
}
.Icon--success-50.change-fill-color svg rect {
  fill: #edfcf2;
}
.Icon--success-100.change-stroke-color svg path {
  stroke: #d3f8df;
}
.Icon--success-100.change-stroke-color svg polygon {
  stroke: #d3f8df;
}
.Icon--success-100.change-stroke-color svg circle {
  stroke: #d3f8df;
}
.Icon--success-100.change-stroke-color svg rect {
  stroke: #d3f8df;
}
.Icon--success-100.change-fill-color svg path {
  fill: #d3f8df;
}
.Icon--success-100.change-fill-color svg polygon {
  fill: #d3f8df;
}
.Icon--success-100.change-fill-color svg circle {
  fill: #d3f8df;
}
.Icon--success-100.change-fill-color svg rect {
  fill: #d3f8df;
}
.Icon--success-200.change-stroke-color svg path {
  stroke: #aaf0c4;
}
.Icon--success-200.change-stroke-color svg polygon {
  stroke: #aaf0c4;
}
.Icon--success-200.change-stroke-color svg circle {
  stroke: #aaf0c4;
}
.Icon--success-200.change-stroke-color svg rect {
  stroke: #aaf0c4;
}
.Icon--success-200.change-fill-color svg path {
  fill: #aaf0c4;
}
.Icon--success-200.change-fill-color svg polygon {
  fill: #aaf0c4;
}
.Icon--success-200.change-fill-color svg circle {
  fill: #aaf0c4;
}
.Icon--success-200.change-fill-color svg rect {
  fill: #aaf0c4;
}
.Icon--success-300.change-stroke-color svg path {
  stroke: #73e2a3;
}
.Icon--success-300.change-stroke-color svg polygon {
  stroke: #73e2a3;
}
.Icon--success-300.change-stroke-color svg circle {
  stroke: #73e2a3;
}
.Icon--success-300.change-stroke-color svg rect {
  stroke: #73e2a3;
}
.Icon--success-300.change-fill-color svg path {
  fill: #73e2a3;
}
.Icon--success-300.change-fill-color svg polygon {
  fill: #73e2a3;
}
.Icon--success-300.change-fill-color svg circle {
  fill: #73e2a3;
}
.Icon--success-300.change-fill-color svg rect {
  fill: #73e2a3;
}
.Icon--success-400.change-stroke-color svg path {
  stroke: #3ccb7f;
}
.Icon--success-400.change-stroke-color svg polygon {
  stroke: #3ccb7f;
}
.Icon--success-400.change-stroke-color svg circle {
  stroke: #3ccb7f;
}
.Icon--success-400.change-stroke-color svg rect {
  stroke: #3ccb7f;
}
.Icon--success-400.change-fill-color svg path {
  fill: #3ccb7f;
}
.Icon--success-400.change-fill-color svg polygon {
  fill: #3ccb7f;
}
.Icon--success-400.change-fill-color svg circle {
  fill: #3ccb7f;
}
.Icon--success-400.change-fill-color svg rect {
  fill: #3ccb7f;
}
.Icon--success-500.change-stroke-color svg path {
  stroke: #16b364;
}
.Icon--success-500.change-stroke-color svg polygon {
  stroke: #16b364;
}
.Icon--success-500.change-stroke-color svg circle {
  stroke: #16b364;
}
.Icon--success-500.change-stroke-color svg rect {
  stroke: #16b364;
}
.Icon--success-500.change-fill-color svg path {
  fill: #16b364;
}
.Icon--success-500.change-fill-color svg polygon {
  fill: #16b364;
}
.Icon--success-500.change-fill-color svg circle {
  fill: #16b364;
}
.Icon--success-500.change-fill-color svg rect {
  fill: #16b364;
}
.Icon--success-600.change-stroke-color svg path {
  stroke: #099250;
}
.Icon--success-600.change-stroke-color svg polygon {
  stroke: #099250;
}
.Icon--success-600.change-stroke-color svg circle {
  stroke: #099250;
}
.Icon--success-600.change-stroke-color svg rect {
  stroke: #099250;
}
.Icon--success-600.change-fill-color svg path {
  fill: #099250;
}
.Icon--success-600.change-fill-color svg polygon {
  fill: #099250;
}
.Icon--success-600.change-fill-color svg circle {
  fill: #099250;
}
.Icon--success-600.change-fill-color svg rect {
  fill: #099250;
}
.Icon--success-700.change-stroke-color svg path {
  stroke: #087443;
}
.Icon--success-700.change-stroke-color svg polygon {
  stroke: #087443;
}
.Icon--success-700.change-stroke-color svg circle {
  stroke: #087443;
}
.Icon--success-700.change-stroke-color svg rect {
  stroke: #087443;
}
.Icon--success-700.change-fill-color svg path {
  fill: #087443;
}
.Icon--success-700.change-fill-color svg polygon {
  fill: #087443;
}
.Icon--success-700.change-fill-color svg circle {
  fill: #087443;
}
.Icon--success-700.change-fill-color svg rect {
  fill: #087443;
}
.Icon--success-800.change-stroke-color svg path {
  stroke: #095c37;
}
.Icon--success-800.change-stroke-color svg polygon {
  stroke: #095c37;
}
.Icon--success-800.change-stroke-color svg circle {
  stroke: #095c37;
}
.Icon--success-800.change-stroke-color svg rect {
  stroke: #095c37;
}
.Icon--success-800.change-fill-color svg path {
  fill: #095c37;
}
.Icon--success-800.change-fill-color svg polygon {
  fill: #095c37;
}
.Icon--success-800.change-fill-color svg circle {
  fill: #095c37;
}
.Icon--success-800.change-fill-color svg rect {
  fill: #095c37;
}
.Icon--success-900.change-stroke-color svg path {
  stroke: #084c2e;
}
.Icon--success-900.change-stroke-color svg polygon {
  stroke: #084c2e;
}
.Icon--success-900.change-stroke-color svg circle {
  stroke: #084c2e;
}
.Icon--success-900.change-stroke-color svg rect {
  stroke: #084c2e;
}
.Icon--success-900.change-fill-color svg path {
  fill: #084c2e;
}
.Icon--success-900.change-fill-color svg polygon {
  fill: #084c2e;
}
.Icon--success-900.change-fill-color svg circle {
  fill: #084c2e;
}
.Icon--success-900.change-fill-color svg rect {
  fill: #084c2e;
}
.Icon--success-950.change-stroke-color svg path {
  stroke: #052e1c;
}
.Icon--success-950.change-stroke-color svg polygon {
  stroke: #052e1c;
}
.Icon--success-950.change-stroke-color svg circle {
  stroke: #052e1c;
}
.Icon--success-950.change-stroke-color svg rect {
  stroke: #052e1c;
}
.Icon--success-950.change-fill-color svg path {
  fill: #052e1c;
}
.Icon--success-950.change-fill-color svg polygon {
  fill: #052e1c;
}
.Icon--success-950.change-fill-color svg circle {
  fill: #052e1c;
}
.Icon--success-950.change-fill-color svg rect {
  fill: #052e1c;
}
.Icon--moss-25.change-stroke-color svg path {
  stroke: #fafdf7;
}
.Icon--moss-25.change-stroke-color svg polygon {
  stroke: #fafdf7;
}
.Icon--moss-25.change-stroke-color svg circle {
  stroke: #fafdf7;
}
.Icon--moss-25.change-stroke-color svg rect {
  stroke: #fafdf7;
}
.Icon--moss-25.change-fill-color svg path {
  fill: #fafdf7;
}
.Icon--moss-25.change-fill-color svg polygon {
  fill: #fafdf7;
}
.Icon--moss-25.change-fill-color svg circle {
  fill: #fafdf7;
}
.Icon--moss-25.change-fill-color svg rect {
  fill: #fafdf7;
}
.Icon--moss-50.change-stroke-color svg path {
  stroke: #f5fbee;
}
.Icon--moss-50.change-stroke-color svg polygon {
  stroke: #f5fbee;
}
.Icon--moss-50.change-stroke-color svg circle {
  stroke: #f5fbee;
}
.Icon--moss-50.change-stroke-color svg rect {
  stroke: #f5fbee;
}
.Icon--moss-50.change-fill-color svg path {
  fill: #f5fbee;
}
.Icon--moss-50.change-fill-color svg polygon {
  fill: #f5fbee;
}
.Icon--moss-50.change-fill-color svg circle {
  fill: #f5fbee;
}
.Icon--moss-50.change-fill-color svg rect {
  fill: #f5fbee;
}
.Icon--moss-100.change-stroke-color svg path {
  stroke: #e6f4d7;
}
.Icon--moss-100.change-stroke-color svg polygon {
  stroke: #e6f4d7;
}
.Icon--moss-100.change-stroke-color svg circle {
  stroke: #e6f4d7;
}
.Icon--moss-100.change-stroke-color svg rect {
  stroke: #e6f4d7;
}
.Icon--moss-100.change-fill-color svg path {
  fill: #e6f4d7;
}
.Icon--moss-100.change-fill-color svg polygon {
  fill: #e6f4d7;
}
.Icon--moss-100.change-fill-color svg circle {
  fill: #e6f4d7;
}
.Icon--moss-100.change-fill-color svg rect {
  fill: #e6f4d7;
}
.Icon--moss-200.change-stroke-color svg path {
  stroke: #ceeab0;
}
.Icon--moss-200.change-stroke-color svg polygon {
  stroke: #ceeab0;
}
.Icon--moss-200.change-stroke-color svg circle {
  stroke: #ceeab0;
}
.Icon--moss-200.change-stroke-color svg rect {
  stroke: #ceeab0;
}
.Icon--moss-200.change-fill-color svg path {
  fill: #ceeab0;
}
.Icon--moss-200.change-fill-color svg polygon {
  fill: #ceeab0;
}
.Icon--moss-200.change-fill-color svg circle {
  fill: #ceeab0;
}
.Icon--moss-200.change-fill-color svg rect {
  fill: #ceeab0;
}
.Icon--moss-300.change-stroke-color svg path {
  stroke: #acdc79;
}
.Icon--moss-300.change-stroke-color svg polygon {
  stroke: #acdc79;
}
.Icon--moss-300.change-stroke-color svg circle {
  stroke: #acdc79;
}
.Icon--moss-300.change-stroke-color svg rect {
  stroke: #acdc79;
}
.Icon--moss-300.change-fill-color svg path {
  fill: #acdc79;
}
.Icon--moss-300.change-fill-color svg polygon {
  fill: #acdc79;
}
.Icon--moss-300.change-fill-color svg circle {
  fill: #acdc79;
}
.Icon--moss-300.change-fill-color svg rect {
  fill: #acdc79;
}
.Icon--moss-400.change-stroke-color svg path {
  stroke: #86cb3c;
}
.Icon--moss-400.change-stroke-color svg polygon {
  stroke: #86cb3c;
}
.Icon--moss-400.change-stroke-color svg circle {
  stroke: #86cb3c;
}
.Icon--moss-400.change-stroke-color svg rect {
  stroke: #86cb3c;
}
.Icon--moss-400.change-fill-color svg path {
  fill: #86cb3c;
}
.Icon--moss-400.change-fill-color svg polygon {
  fill: #86cb3c;
}
.Icon--moss-400.change-fill-color svg circle {
  fill: #86cb3c;
}
.Icon--moss-400.change-fill-color svg rect {
  fill: #86cb3c;
}
.Icon--moss-500.change-stroke-color svg path {
  stroke: #669f2a;
}
.Icon--moss-500.change-stroke-color svg polygon {
  stroke: #669f2a;
}
.Icon--moss-500.change-stroke-color svg circle {
  stroke: #669f2a;
}
.Icon--moss-500.change-stroke-color svg rect {
  stroke: #669f2a;
}
.Icon--moss-500.change-fill-color svg path {
  fill: #669f2a;
}
.Icon--moss-500.change-fill-color svg polygon {
  fill: #669f2a;
}
.Icon--moss-500.change-fill-color svg circle {
  fill: #669f2a;
}
.Icon--moss-500.change-fill-color svg rect {
  fill: #669f2a;
}
.Icon--moss-600.change-stroke-color svg path {
  stroke: #4f7a21;
}
.Icon--moss-600.change-stroke-color svg polygon {
  stroke: #4f7a21;
}
.Icon--moss-600.change-stroke-color svg circle {
  stroke: #4f7a21;
}
.Icon--moss-600.change-stroke-color svg rect {
  stroke: #4f7a21;
}
.Icon--moss-600.change-fill-color svg path {
  fill: #4f7a21;
}
.Icon--moss-600.change-fill-color svg polygon {
  fill: #4f7a21;
}
.Icon--moss-600.change-fill-color svg circle {
  fill: #4f7a21;
}
.Icon--moss-600.change-fill-color svg rect {
  fill: #4f7a21;
}
.Icon--moss-700.change-stroke-color svg path {
  stroke: #3f621a;
}
.Icon--moss-700.change-stroke-color svg polygon {
  stroke: #3f621a;
}
.Icon--moss-700.change-stroke-color svg circle {
  stroke: #3f621a;
}
.Icon--moss-700.change-stroke-color svg rect {
  stroke: #3f621a;
}
.Icon--moss-700.change-fill-color svg path {
  fill: #3f621a;
}
.Icon--moss-700.change-fill-color svg polygon {
  fill: #3f621a;
}
.Icon--moss-700.change-fill-color svg circle {
  fill: #3f621a;
}
.Icon--moss-700.change-fill-color svg rect {
  fill: #3f621a;
}
.Icon--moss-800.change-stroke-color svg path {
  stroke: #335015;
}
.Icon--moss-800.change-stroke-color svg polygon {
  stroke: #335015;
}
.Icon--moss-800.change-stroke-color svg circle {
  stroke: #335015;
}
.Icon--moss-800.change-stroke-color svg rect {
  stroke: #335015;
}
.Icon--moss-800.change-fill-color svg path {
  fill: #335015;
}
.Icon--moss-800.change-fill-color svg polygon {
  fill: #335015;
}
.Icon--moss-800.change-fill-color svg circle {
  fill: #335015;
}
.Icon--moss-800.change-fill-color svg rect {
  fill: #335015;
}
.Icon--moss-900.change-stroke-color svg path {
  stroke: #2b4212;
}
.Icon--moss-900.change-stroke-color svg polygon {
  stroke: #2b4212;
}
.Icon--moss-900.change-stroke-color svg circle {
  stroke: #2b4212;
}
.Icon--moss-900.change-stroke-color svg rect {
  stroke: #2b4212;
}
.Icon--moss-900.change-fill-color svg path {
  fill: #2b4212;
}
.Icon--moss-900.change-fill-color svg polygon {
  fill: #2b4212;
}
.Icon--moss-900.change-fill-color svg circle {
  fill: #2b4212;
}
.Icon--moss-900.change-fill-color svg rect {
  fill: #2b4212;
}
.Icon--moss-950.change-stroke-color svg path {
  stroke: #1a280b;
}
.Icon--moss-950.change-stroke-color svg polygon {
  stroke: #1a280b;
}
.Icon--moss-950.change-stroke-color svg circle {
  stroke: #1a280b;
}
.Icon--moss-950.change-stroke-color svg rect {
  stroke: #1a280b;
}
.Icon--moss-950.change-fill-color svg path {
  fill: #1a280b;
}
.Icon--moss-950.change-fill-color svg polygon {
  fill: #1a280b;
}
.Icon--moss-950.change-fill-color svg circle {
  fill: #1a280b;
}
.Icon--moss-950.change-fill-color svg rect {
  fill: #1a280b;
}
.Icon--green-light-25.change-stroke-color svg path {
  stroke: #fafef5;
}
.Icon--green-light-25.change-stroke-color svg polygon {
  stroke: #fafef5;
}
.Icon--green-light-25.change-stroke-color svg circle {
  stroke: #fafef5;
}
.Icon--green-light-25.change-stroke-color svg rect {
  stroke: #fafef5;
}
.Icon--green-light-25.change-fill-color svg path {
  fill: #fafef5;
}
.Icon--green-light-25.change-fill-color svg polygon {
  fill: #fafef5;
}
.Icon--green-light-25.change-fill-color svg circle {
  fill: #fafef5;
}
.Icon--green-light-25.change-fill-color svg rect {
  fill: #fafef5;
}
.Icon--green-light-50.change-stroke-color svg path {
  stroke: #f3fee7;
}
.Icon--green-light-50.change-stroke-color svg polygon {
  stroke: #f3fee7;
}
.Icon--green-light-50.change-stroke-color svg circle {
  stroke: #f3fee7;
}
.Icon--green-light-50.change-stroke-color svg rect {
  stroke: #f3fee7;
}
.Icon--green-light-50.change-fill-color svg path {
  fill: #f3fee7;
}
.Icon--green-light-50.change-fill-color svg polygon {
  fill: #f3fee7;
}
.Icon--green-light-50.change-fill-color svg circle {
  fill: #f3fee7;
}
.Icon--green-light-50.change-fill-color svg rect {
  fill: #f3fee7;
}
.Icon--green-light-100.change-stroke-color svg path {
  stroke: #e4fbcc;
}
.Icon--green-light-100.change-stroke-color svg polygon {
  stroke: #e4fbcc;
}
.Icon--green-light-100.change-stroke-color svg circle {
  stroke: #e4fbcc;
}
.Icon--green-light-100.change-stroke-color svg rect {
  stroke: #e4fbcc;
}
.Icon--green-light-100.change-fill-color svg path {
  fill: #e4fbcc;
}
.Icon--green-light-100.change-fill-color svg polygon {
  fill: #e4fbcc;
}
.Icon--green-light-100.change-fill-color svg circle {
  fill: #e4fbcc;
}
.Icon--green-light-100.change-fill-color svg rect {
  fill: #e4fbcc;
}
.Icon--green-light-200.change-stroke-color svg path {
  stroke: #d0f8ab;
}
.Icon--green-light-200.change-stroke-color svg polygon {
  stroke: #d0f8ab;
}
.Icon--green-light-200.change-stroke-color svg circle {
  stroke: #d0f8ab;
}
.Icon--green-light-200.change-stroke-color svg rect {
  stroke: #d0f8ab;
}
.Icon--green-light-200.change-fill-color svg path {
  fill: #d0f8ab;
}
.Icon--green-light-200.change-fill-color svg polygon {
  fill: #d0f8ab;
}
.Icon--green-light-200.change-fill-color svg circle {
  fill: #d0f8ab;
}
.Icon--green-light-200.change-fill-color svg rect {
  fill: #d0f8ab;
}
.Icon--green-light-300.change-stroke-color svg path {
  stroke: #a6ef67;
}
.Icon--green-light-300.change-stroke-color svg polygon {
  stroke: #a6ef67;
}
.Icon--green-light-300.change-stroke-color svg circle {
  stroke: #a6ef67;
}
.Icon--green-light-300.change-stroke-color svg rect {
  stroke: #a6ef67;
}
.Icon--green-light-300.change-fill-color svg path {
  fill: #a6ef67;
}
.Icon--green-light-300.change-fill-color svg polygon {
  fill: #a6ef67;
}
.Icon--green-light-300.change-fill-color svg circle {
  fill: #a6ef67;
}
.Icon--green-light-300.change-fill-color svg rect {
  fill: #a6ef67;
}
.Icon--green-light-400.change-stroke-color svg path {
  stroke: #85e13a;
}
.Icon--green-light-400.change-stroke-color svg polygon {
  stroke: #85e13a;
}
.Icon--green-light-400.change-stroke-color svg circle {
  stroke: #85e13a;
}
.Icon--green-light-400.change-stroke-color svg rect {
  stroke: #85e13a;
}
.Icon--green-light-400.change-fill-color svg path {
  fill: #85e13a;
}
.Icon--green-light-400.change-fill-color svg polygon {
  fill: #85e13a;
}
.Icon--green-light-400.change-fill-color svg circle {
  fill: #85e13a;
}
.Icon--green-light-400.change-fill-color svg rect {
  fill: #85e13a;
}
.Icon--green-light-500.change-stroke-color svg path {
  stroke: #66c61c;
}
.Icon--green-light-500.change-stroke-color svg polygon {
  stroke: #66c61c;
}
.Icon--green-light-500.change-stroke-color svg circle {
  stroke: #66c61c;
}
.Icon--green-light-500.change-stroke-color svg rect {
  stroke: #66c61c;
}
.Icon--green-light-500.change-fill-color svg path {
  fill: #66c61c;
}
.Icon--green-light-500.change-fill-color svg polygon {
  fill: #66c61c;
}
.Icon--green-light-500.change-fill-color svg circle {
  fill: #66c61c;
}
.Icon--green-light-500.change-fill-color svg rect {
  fill: #66c61c;
}
.Icon--green-light-600.change-stroke-color svg path {
  stroke: #4ca30d;
}
.Icon--green-light-600.change-stroke-color svg polygon {
  stroke: #4ca30d;
}
.Icon--green-light-600.change-stroke-color svg circle {
  stroke: #4ca30d;
}
.Icon--green-light-600.change-stroke-color svg rect {
  stroke: #4ca30d;
}
.Icon--green-light-600.change-fill-color svg path {
  fill: #4ca30d;
}
.Icon--green-light-600.change-fill-color svg polygon {
  fill: #4ca30d;
}
.Icon--green-light-600.change-fill-color svg circle {
  fill: #4ca30d;
}
.Icon--green-light-600.change-fill-color svg rect {
  fill: #4ca30d;
}
.Icon--green-light-700.change-stroke-color svg path {
  stroke: #3b7c0f;
}
.Icon--green-light-700.change-stroke-color svg polygon {
  stroke: #3b7c0f;
}
.Icon--green-light-700.change-stroke-color svg circle {
  stroke: #3b7c0f;
}
.Icon--green-light-700.change-stroke-color svg rect {
  stroke: #3b7c0f;
}
.Icon--green-light-700.change-fill-color svg path {
  fill: #3b7c0f;
}
.Icon--green-light-700.change-fill-color svg polygon {
  fill: #3b7c0f;
}
.Icon--green-light-700.change-fill-color svg circle {
  fill: #3b7c0f;
}
.Icon--green-light-700.change-fill-color svg rect {
  fill: #3b7c0f;
}
.Icon--green-light-800.change-stroke-color svg path {
  stroke: #326212;
}
.Icon--green-light-800.change-stroke-color svg polygon {
  stroke: #326212;
}
.Icon--green-light-800.change-stroke-color svg circle {
  stroke: #326212;
}
.Icon--green-light-800.change-stroke-color svg rect {
  stroke: #326212;
}
.Icon--green-light-800.change-fill-color svg path {
  fill: #326212;
}
.Icon--green-light-800.change-fill-color svg polygon {
  fill: #326212;
}
.Icon--green-light-800.change-fill-color svg circle {
  fill: #326212;
}
.Icon--green-light-800.change-fill-color svg rect {
  fill: #326212;
}
.Icon--green-light-900.change-stroke-color svg path {
  stroke: #2b5314;
}
.Icon--green-light-900.change-stroke-color svg polygon {
  stroke: #2b5314;
}
.Icon--green-light-900.change-stroke-color svg circle {
  stroke: #2b5314;
}
.Icon--green-light-900.change-stroke-color svg rect {
  stroke: #2b5314;
}
.Icon--green-light-900.change-fill-color svg path {
  fill: #2b5314;
}
.Icon--green-light-900.change-fill-color svg polygon {
  fill: #2b5314;
}
.Icon--green-light-900.change-fill-color svg circle {
  fill: #2b5314;
}
.Icon--green-light-900.change-fill-color svg rect {
  fill: #2b5314;
}
.Icon--green-light-950.change-stroke-color svg path {
  stroke: #15290a;
}
.Icon--green-light-950.change-stroke-color svg polygon {
  stroke: #15290a;
}
.Icon--green-light-950.change-stroke-color svg circle {
  stroke: #15290a;
}
.Icon--green-light-950.change-stroke-color svg rect {
  stroke: #15290a;
}
.Icon--green-light-950.change-fill-color svg path {
  fill: #15290a;
}
.Icon--green-light-950.change-fill-color svg polygon {
  fill: #15290a;
}
.Icon--green-light-950.change-fill-color svg circle {
  fill: #15290a;
}
.Icon--green-light-950.change-fill-color svg rect {
  fill: #15290a;
}
.Icon--teal-25.change-stroke-color svg path {
  stroke: #f6fefc;
}
.Icon--teal-25.change-stroke-color svg polygon {
  stroke: #f6fefc;
}
.Icon--teal-25.change-stroke-color svg circle {
  stroke: #f6fefc;
}
.Icon--teal-25.change-stroke-color svg rect {
  stroke: #f6fefc;
}
.Icon--teal-25.change-fill-color svg path {
  fill: #f6fefc;
}
.Icon--teal-25.change-fill-color svg polygon {
  fill: #f6fefc;
}
.Icon--teal-25.change-fill-color svg circle {
  fill: #f6fefc;
}
.Icon--teal-25.change-fill-color svg rect {
  fill: #f6fefc;
}
.Icon--teal-50.change-stroke-color svg path {
  stroke: #f0fdf9;
}
.Icon--teal-50.change-stroke-color svg polygon {
  stroke: #f0fdf9;
}
.Icon--teal-50.change-stroke-color svg circle {
  stroke: #f0fdf9;
}
.Icon--teal-50.change-stroke-color svg rect {
  stroke: #f0fdf9;
}
.Icon--teal-50.change-fill-color svg path {
  fill: #f0fdf9;
}
.Icon--teal-50.change-fill-color svg polygon {
  fill: #f0fdf9;
}
.Icon--teal-50.change-fill-color svg circle {
  fill: #f0fdf9;
}
.Icon--teal-50.change-fill-color svg rect {
  fill: #f0fdf9;
}
.Icon--teal-100.change-stroke-color svg path {
  stroke: #ccfbef;
}
.Icon--teal-100.change-stroke-color svg polygon {
  stroke: #ccfbef;
}
.Icon--teal-100.change-stroke-color svg circle {
  stroke: #ccfbef;
}
.Icon--teal-100.change-stroke-color svg rect {
  stroke: #ccfbef;
}
.Icon--teal-100.change-fill-color svg path {
  fill: #ccfbef;
}
.Icon--teal-100.change-fill-color svg polygon {
  fill: #ccfbef;
}
.Icon--teal-100.change-fill-color svg circle {
  fill: #ccfbef;
}
.Icon--teal-100.change-fill-color svg rect {
  fill: #ccfbef;
}
.Icon--teal-200.change-stroke-color svg path {
  stroke: #99f6e0;
}
.Icon--teal-200.change-stroke-color svg polygon {
  stroke: #99f6e0;
}
.Icon--teal-200.change-stroke-color svg circle {
  stroke: #99f6e0;
}
.Icon--teal-200.change-stroke-color svg rect {
  stroke: #99f6e0;
}
.Icon--teal-200.change-fill-color svg path {
  fill: #99f6e0;
}
.Icon--teal-200.change-fill-color svg polygon {
  fill: #99f6e0;
}
.Icon--teal-200.change-fill-color svg circle {
  fill: #99f6e0;
}
.Icon--teal-200.change-fill-color svg rect {
  fill: #99f6e0;
}
.Icon--teal-300.change-stroke-color svg path {
  stroke: #5fe9d0;
}
.Icon--teal-300.change-stroke-color svg polygon {
  stroke: #5fe9d0;
}
.Icon--teal-300.change-stroke-color svg circle {
  stroke: #5fe9d0;
}
.Icon--teal-300.change-stroke-color svg rect {
  stroke: #5fe9d0;
}
.Icon--teal-300.change-fill-color svg path {
  fill: #5fe9d0;
}
.Icon--teal-300.change-fill-color svg polygon {
  fill: #5fe9d0;
}
.Icon--teal-300.change-fill-color svg circle {
  fill: #5fe9d0;
}
.Icon--teal-300.change-fill-color svg rect {
  fill: #5fe9d0;
}
.Icon--teal-400.change-stroke-color svg path {
  stroke: #2ed3b7;
}
.Icon--teal-400.change-stroke-color svg polygon {
  stroke: #2ed3b7;
}
.Icon--teal-400.change-stroke-color svg circle {
  stroke: #2ed3b7;
}
.Icon--teal-400.change-stroke-color svg rect {
  stroke: #2ed3b7;
}
.Icon--teal-400.change-fill-color svg path {
  fill: #2ed3b7;
}
.Icon--teal-400.change-fill-color svg polygon {
  fill: #2ed3b7;
}
.Icon--teal-400.change-fill-color svg circle {
  fill: #2ed3b7;
}
.Icon--teal-400.change-fill-color svg rect {
  fill: #2ed3b7;
}
.Icon--teal-500.change-stroke-color svg path {
  stroke: #15b79e;
}
.Icon--teal-500.change-stroke-color svg polygon {
  stroke: #15b79e;
}
.Icon--teal-500.change-stroke-color svg circle {
  stroke: #15b79e;
}
.Icon--teal-500.change-stroke-color svg rect {
  stroke: #15b79e;
}
.Icon--teal-500.change-fill-color svg path {
  fill: #15b79e;
}
.Icon--teal-500.change-fill-color svg polygon {
  fill: #15b79e;
}
.Icon--teal-500.change-fill-color svg circle {
  fill: #15b79e;
}
.Icon--teal-500.change-fill-color svg rect {
  fill: #15b79e;
}
.Icon--teal-600.change-stroke-color svg path {
  stroke: #0e9384;
}
.Icon--teal-600.change-stroke-color svg polygon {
  stroke: #0e9384;
}
.Icon--teal-600.change-stroke-color svg circle {
  stroke: #0e9384;
}
.Icon--teal-600.change-stroke-color svg rect {
  stroke: #0e9384;
}
.Icon--teal-600.change-fill-color svg path {
  fill: #0e9384;
}
.Icon--teal-600.change-fill-color svg polygon {
  fill: #0e9384;
}
.Icon--teal-600.change-fill-color svg circle {
  fill: #0e9384;
}
.Icon--teal-600.change-fill-color svg rect {
  fill: #0e9384;
}
.Icon--teal-700.change-stroke-color svg path {
  stroke: #107569;
}
.Icon--teal-700.change-stroke-color svg polygon {
  stroke: #107569;
}
.Icon--teal-700.change-stroke-color svg circle {
  stroke: #107569;
}
.Icon--teal-700.change-stroke-color svg rect {
  stroke: #107569;
}
.Icon--teal-700.change-fill-color svg path {
  fill: #107569;
}
.Icon--teal-700.change-fill-color svg polygon {
  fill: #107569;
}
.Icon--teal-700.change-fill-color svg circle {
  fill: #107569;
}
.Icon--teal-700.change-fill-color svg rect {
  fill: #107569;
}
.Icon--teal-800.change-stroke-color svg path {
  stroke: #125d56;
}
.Icon--teal-800.change-stroke-color svg polygon {
  stroke: #125d56;
}
.Icon--teal-800.change-stroke-color svg circle {
  stroke: #125d56;
}
.Icon--teal-800.change-stroke-color svg rect {
  stroke: #125d56;
}
.Icon--teal-800.change-fill-color svg path {
  fill: #125d56;
}
.Icon--teal-800.change-fill-color svg polygon {
  fill: #125d56;
}
.Icon--teal-800.change-fill-color svg circle {
  fill: #125d56;
}
.Icon--teal-800.change-fill-color svg rect {
  fill: #125d56;
}
.Icon--teal-900.change-stroke-color svg path {
  stroke: #134e48;
}
.Icon--teal-900.change-stroke-color svg polygon {
  stroke: #134e48;
}
.Icon--teal-900.change-stroke-color svg circle {
  stroke: #134e48;
}
.Icon--teal-900.change-stroke-color svg rect {
  stroke: #134e48;
}
.Icon--teal-900.change-fill-color svg path {
  fill: #134e48;
}
.Icon--teal-900.change-fill-color svg polygon {
  fill: #134e48;
}
.Icon--teal-900.change-fill-color svg circle {
  fill: #134e48;
}
.Icon--teal-900.change-fill-color svg rect {
  fill: #134e48;
}
.Icon--teal-950.change-stroke-color svg path {
  stroke: #0a2926;
}
.Icon--teal-950.change-stroke-color svg polygon {
  stroke: #0a2926;
}
.Icon--teal-950.change-stroke-color svg circle {
  stroke: #0a2926;
}
.Icon--teal-950.change-stroke-color svg rect {
  stroke: #0a2926;
}
.Icon--teal-950.change-fill-color svg path {
  fill: #0a2926;
}
.Icon--teal-950.change-fill-color svg polygon {
  fill: #0a2926;
}
.Icon--teal-950.change-fill-color svg circle {
  fill: #0a2926;
}
.Icon--teal-950.change-fill-color svg rect {
  fill: #0a2926;
}
.Icon--cyan-25.change-stroke-color svg path {
  stroke: #f5feff;
}
.Icon--cyan-25.change-stroke-color svg polygon {
  stroke: #f5feff;
}
.Icon--cyan-25.change-stroke-color svg circle {
  stroke: #f5feff;
}
.Icon--cyan-25.change-stroke-color svg rect {
  stroke: #f5feff;
}
.Icon--cyan-25.change-fill-color svg path {
  fill: #f5feff;
}
.Icon--cyan-25.change-fill-color svg polygon {
  fill: #f5feff;
}
.Icon--cyan-25.change-fill-color svg circle {
  fill: #f5feff;
}
.Icon--cyan-25.change-fill-color svg rect {
  fill: #f5feff;
}
.Icon--cyan-50.change-stroke-color svg path {
  stroke: #ecfdff;
}
.Icon--cyan-50.change-stroke-color svg polygon {
  stroke: #ecfdff;
}
.Icon--cyan-50.change-stroke-color svg circle {
  stroke: #ecfdff;
}
.Icon--cyan-50.change-stroke-color svg rect {
  stroke: #ecfdff;
}
.Icon--cyan-50.change-fill-color svg path {
  fill: #ecfdff;
}
.Icon--cyan-50.change-fill-color svg polygon {
  fill: #ecfdff;
}
.Icon--cyan-50.change-fill-color svg circle {
  fill: #ecfdff;
}
.Icon--cyan-50.change-fill-color svg rect {
  fill: #ecfdff;
}
.Icon--cyan-100.change-stroke-color svg path {
  stroke: #cff9fe;
}
.Icon--cyan-100.change-stroke-color svg polygon {
  stroke: #cff9fe;
}
.Icon--cyan-100.change-stroke-color svg circle {
  stroke: #cff9fe;
}
.Icon--cyan-100.change-stroke-color svg rect {
  stroke: #cff9fe;
}
.Icon--cyan-100.change-fill-color svg path {
  fill: #cff9fe;
}
.Icon--cyan-100.change-fill-color svg polygon {
  fill: #cff9fe;
}
.Icon--cyan-100.change-fill-color svg circle {
  fill: #cff9fe;
}
.Icon--cyan-100.change-fill-color svg rect {
  fill: #cff9fe;
}
.Icon--cyan-200.change-stroke-color svg path {
  stroke: #a5f0fc;
}
.Icon--cyan-200.change-stroke-color svg polygon {
  stroke: #a5f0fc;
}
.Icon--cyan-200.change-stroke-color svg circle {
  stroke: #a5f0fc;
}
.Icon--cyan-200.change-stroke-color svg rect {
  stroke: #a5f0fc;
}
.Icon--cyan-200.change-fill-color svg path {
  fill: #a5f0fc;
}
.Icon--cyan-200.change-fill-color svg polygon {
  fill: #a5f0fc;
}
.Icon--cyan-200.change-fill-color svg circle {
  fill: #a5f0fc;
}
.Icon--cyan-200.change-fill-color svg rect {
  fill: #a5f0fc;
}
.Icon--cyan-300.change-stroke-color svg path {
  stroke: #67e3f9;
}
.Icon--cyan-300.change-stroke-color svg polygon {
  stroke: #67e3f9;
}
.Icon--cyan-300.change-stroke-color svg circle {
  stroke: #67e3f9;
}
.Icon--cyan-300.change-stroke-color svg rect {
  stroke: #67e3f9;
}
.Icon--cyan-300.change-fill-color svg path {
  fill: #67e3f9;
}
.Icon--cyan-300.change-fill-color svg polygon {
  fill: #67e3f9;
}
.Icon--cyan-300.change-fill-color svg circle {
  fill: #67e3f9;
}
.Icon--cyan-300.change-fill-color svg rect {
  fill: #67e3f9;
}
.Icon--cyan-400.change-stroke-color svg path {
  stroke: #22ccee;
}
.Icon--cyan-400.change-stroke-color svg polygon {
  stroke: #22ccee;
}
.Icon--cyan-400.change-stroke-color svg circle {
  stroke: #22ccee;
}
.Icon--cyan-400.change-stroke-color svg rect {
  stroke: #22ccee;
}
.Icon--cyan-400.change-fill-color svg path {
  fill: #22ccee;
}
.Icon--cyan-400.change-fill-color svg polygon {
  fill: #22ccee;
}
.Icon--cyan-400.change-fill-color svg circle {
  fill: #22ccee;
}
.Icon--cyan-400.change-fill-color svg rect {
  fill: #22ccee;
}
.Icon--cyan-500.change-stroke-color svg path {
  stroke: #06aed4;
}
.Icon--cyan-500.change-stroke-color svg polygon {
  stroke: #06aed4;
}
.Icon--cyan-500.change-stroke-color svg circle {
  stroke: #06aed4;
}
.Icon--cyan-500.change-stroke-color svg rect {
  stroke: #06aed4;
}
.Icon--cyan-500.change-fill-color svg path {
  fill: #06aed4;
}
.Icon--cyan-500.change-fill-color svg polygon {
  fill: #06aed4;
}
.Icon--cyan-500.change-fill-color svg circle {
  fill: #06aed4;
}
.Icon--cyan-500.change-fill-color svg rect {
  fill: #06aed4;
}
.Icon--cyan-600.change-stroke-color svg path {
  stroke: #088ab2;
}
.Icon--cyan-600.change-stroke-color svg polygon {
  stroke: #088ab2;
}
.Icon--cyan-600.change-stroke-color svg circle {
  stroke: #088ab2;
}
.Icon--cyan-600.change-stroke-color svg rect {
  stroke: #088ab2;
}
.Icon--cyan-600.change-fill-color svg path {
  fill: #088ab2;
}
.Icon--cyan-600.change-fill-color svg polygon {
  fill: #088ab2;
}
.Icon--cyan-600.change-fill-color svg circle {
  fill: #088ab2;
}
.Icon--cyan-600.change-fill-color svg rect {
  fill: #088ab2;
}
.Icon--cyan-700.change-stroke-color svg path {
  stroke: #0e7090;
}
.Icon--cyan-700.change-stroke-color svg polygon {
  stroke: #0e7090;
}
.Icon--cyan-700.change-stroke-color svg circle {
  stroke: #0e7090;
}
.Icon--cyan-700.change-stroke-color svg rect {
  stroke: #0e7090;
}
.Icon--cyan-700.change-fill-color svg path {
  fill: #0e7090;
}
.Icon--cyan-700.change-fill-color svg polygon {
  fill: #0e7090;
}
.Icon--cyan-700.change-fill-color svg circle {
  fill: #0e7090;
}
.Icon--cyan-700.change-fill-color svg rect {
  fill: #0e7090;
}
.Icon--cyan-800.change-stroke-color svg path {
  stroke: #155b75;
}
.Icon--cyan-800.change-stroke-color svg polygon {
  stroke: #155b75;
}
.Icon--cyan-800.change-stroke-color svg circle {
  stroke: #155b75;
}
.Icon--cyan-800.change-stroke-color svg rect {
  stroke: #155b75;
}
.Icon--cyan-800.change-fill-color svg path {
  fill: #155b75;
}
.Icon--cyan-800.change-fill-color svg polygon {
  fill: #155b75;
}
.Icon--cyan-800.change-fill-color svg circle {
  fill: #155b75;
}
.Icon--cyan-800.change-fill-color svg rect {
  fill: #155b75;
}
.Icon--cyan-900.change-stroke-color svg path {
  stroke: #164c63;
}
.Icon--cyan-900.change-stroke-color svg polygon {
  stroke: #164c63;
}
.Icon--cyan-900.change-stroke-color svg circle {
  stroke: #164c63;
}
.Icon--cyan-900.change-stroke-color svg rect {
  stroke: #164c63;
}
.Icon--cyan-900.change-fill-color svg path {
  fill: #164c63;
}
.Icon--cyan-900.change-fill-color svg polygon {
  fill: #164c63;
}
.Icon--cyan-900.change-fill-color svg circle {
  fill: #164c63;
}
.Icon--cyan-900.change-fill-color svg rect {
  fill: #164c63;
}
.Icon--cyan-950.change-stroke-color svg path {
  stroke: #0d2d3a;
}
.Icon--cyan-950.change-stroke-color svg polygon {
  stroke: #0d2d3a;
}
.Icon--cyan-950.change-stroke-color svg circle {
  stroke: #0d2d3a;
}
.Icon--cyan-950.change-stroke-color svg rect {
  stroke: #0d2d3a;
}
.Icon--cyan-950.change-fill-color svg path {
  fill: #0d2d3a;
}
.Icon--cyan-950.change-fill-color svg polygon {
  fill: #0d2d3a;
}
.Icon--cyan-950.change-fill-color svg circle {
  fill: #0d2d3a;
}
.Icon--cyan-950.change-fill-color svg rect {
  fill: #0d2d3a;
}
.Icon--blue-dark-25.change-stroke-color svg path {
  stroke: #f5f8ff;
}
.Icon--blue-dark-25.change-stroke-color svg polygon {
  stroke: #f5f8ff;
}
.Icon--blue-dark-25.change-stroke-color svg circle {
  stroke: #f5f8ff;
}
.Icon--blue-dark-25.change-stroke-color svg rect {
  stroke: #f5f8ff;
}
.Icon--blue-dark-25.change-fill-color svg path {
  fill: #f5f8ff;
}
.Icon--blue-dark-25.change-fill-color svg polygon {
  fill: #f5f8ff;
}
.Icon--blue-dark-25.change-fill-color svg circle {
  fill: #f5f8ff;
}
.Icon--blue-dark-25.change-fill-color svg rect {
  fill: #f5f8ff;
}
.Icon--blue-dark-50.change-stroke-color svg path {
  stroke: #eff4ff;
}
.Icon--blue-dark-50.change-stroke-color svg polygon {
  stroke: #eff4ff;
}
.Icon--blue-dark-50.change-stroke-color svg circle {
  stroke: #eff4ff;
}
.Icon--blue-dark-50.change-stroke-color svg rect {
  stroke: #eff4ff;
}
.Icon--blue-dark-50.change-fill-color svg path {
  fill: #eff4ff;
}
.Icon--blue-dark-50.change-fill-color svg polygon {
  fill: #eff4ff;
}
.Icon--blue-dark-50.change-fill-color svg circle {
  fill: #eff4ff;
}
.Icon--blue-dark-50.change-fill-color svg rect {
  fill: #eff4ff;
}
.Icon--blue-dark-100.change-stroke-color svg path {
  stroke: #d1e0ff;
}
.Icon--blue-dark-100.change-stroke-color svg polygon {
  stroke: #d1e0ff;
}
.Icon--blue-dark-100.change-stroke-color svg circle {
  stroke: #d1e0ff;
}
.Icon--blue-dark-100.change-stroke-color svg rect {
  stroke: #d1e0ff;
}
.Icon--blue-dark-100.change-fill-color svg path {
  fill: #d1e0ff;
}
.Icon--blue-dark-100.change-fill-color svg polygon {
  fill: #d1e0ff;
}
.Icon--blue-dark-100.change-fill-color svg circle {
  fill: #d1e0ff;
}
.Icon--blue-dark-100.change-fill-color svg rect {
  fill: #d1e0ff;
}
.Icon--blue-dark-200.change-stroke-color svg path {
  stroke: #b2ccff;
}
.Icon--blue-dark-200.change-stroke-color svg polygon {
  stroke: #b2ccff;
}
.Icon--blue-dark-200.change-stroke-color svg circle {
  stroke: #b2ccff;
}
.Icon--blue-dark-200.change-stroke-color svg rect {
  stroke: #b2ccff;
}
.Icon--blue-dark-200.change-fill-color svg path {
  fill: #b2ccff;
}
.Icon--blue-dark-200.change-fill-color svg polygon {
  fill: #b2ccff;
}
.Icon--blue-dark-200.change-fill-color svg circle {
  fill: #b2ccff;
}
.Icon--blue-dark-200.change-fill-color svg rect {
  fill: #b2ccff;
}
.Icon--blue-dark-300.change-stroke-color svg path {
  stroke: #84adff;
}
.Icon--blue-dark-300.change-stroke-color svg polygon {
  stroke: #84adff;
}
.Icon--blue-dark-300.change-stroke-color svg circle {
  stroke: #84adff;
}
.Icon--blue-dark-300.change-stroke-color svg rect {
  stroke: #84adff;
}
.Icon--blue-dark-300.change-fill-color svg path {
  fill: #84adff;
}
.Icon--blue-dark-300.change-fill-color svg polygon {
  fill: #84adff;
}
.Icon--blue-dark-300.change-fill-color svg circle {
  fill: #84adff;
}
.Icon--blue-dark-300.change-fill-color svg rect {
  fill: #84adff;
}
.Icon--blue-dark-400.change-stroke-color svg path {
  stroke: #528bff;
}
.Icon--blue-dark-400.change-stroke-color svg polygon {
  stroke: #528bff;
}
.Icon--blue-dark-400.change-stroke-color svg circle {
  stroke: #528bff;
}
.Icon--blue-dark-400.change-stroke-color svg rect {
  stroke: #528bff;
}
.Icon--blue-dark-400.change-fill-color svg path {
  fill: #528bff;
}
.Icon--blue-dark-400.change-fill-color svg polygon {
  fill: #528bff;
}
.Icon--blue-dark-400.change-fill-color svg circle {
  fill: #528bff;
}
.Icon--blue-dark-400.change-fill-color svg rect {
  fill: #528bff;
}
.Icon--blue-dark-500.change-stroke-color svg path {
  stroke: #2970ff;
}
.Icon--blue-dark-500.change-stroke-color svg polygon {
  stroke: #2970ff;
}
.Icon--blue-dark-500.change-stroke-color svg circle {
  stroke: #2970ff;
}
.Icon--blue-dark-500.change-stroke-color svg rect {
  stroke: #2970ff;
}
.Icon--blue-dark-500.change-fill-color svg path {
  fill: #2970ff;
}
.Icon--blue-dark-500.change-fill-color svg polygon {
  fill: #2970ff;
}
.Icon--blue-dark-500.change-fill-color svg circle {
  fill: #2970ff;
}
.Icon--blue-dark-500.change-fill-color svg rect {
  fill: #2970ff;
}
.Icon--blue-dark-600.change-stroke-color svg path {
  stroke: #155eef;
}
.Icon--blue-dark-600.change-stroke-color svg polygon {
  stroke: #155eef;
}
.Icon--blue-dark-600.change-stroke-color svg circle {
  stroke: #155eef;
}
.Icon--blue-dark-600.change-stroke-color svg rect {
  stroke: #155eef;
}
.Icon--blue-dark-600.change-fill-color svg path {
  fill: #155eef;
}
.Icon--blue-dark-600.change-fill-color svg polygon {
  fill: #155eef;
}
.Icon--blue-dark-600.change-fill-color svg circle {
  fill: #155eef;
}
.Icon--blue-dark-600.change-fill-color svg rect {
  fill: #155eef;
}
.Icon--blue-dark-700.change-stroke-color svg path {
  stroke: #004eeb;
}
.Icon--blue-dark-700.change-stroke-color svg polygon {
  stroke: #004eeb;
}
.Icon--blue-dark-700.change-stroke-color svg circle {
  stroke: #004eeb;
}
.Icon--blue-dark-700.change-stroke-color svg rect {
  stroke: #004eeb;
}
.Icon--blue-dark-700.change-fill-color svg path {
  fill: #004eeb;
}
.Icon--blue-dark-700.change-fill-color svg polygon {
  fill: #004eeb;
}
.Icon--blue-dark-700.change-fill-color svg circle {
  fill: #004eeb;
}
.Icon--blue-dark-700.change-fill-color svg rect {
  fill: #004eeb;
}
.Icon--blue-dark-800.change-stroke-color svg path {
  stroke: #0040c1;
}
.Icon--blue-dark-800.change-stroke-color svg polygon {
  stroke: #0040c1;
}
.Icon--blue-dark-800.change-stroke-color svg circle {
  stroke: #0040c1;
}
.Icon--blue-dark-800.change-stroke-color svg rect {
  stroke: #0040c1;
}
.Icon--blue-dark-800.change-fill-color svg path {
  fill: #0040c1;
}
.Icon--blue-dark-800.change-fill-color svg polygon {
  fill: #0040c1;
}
.Icon--blue-dark-800.change-fill-color svg circle {
  fill: #0040c1;
}
.Icon--blue-dark-800.change-fill-color svg rect {
  fill: #0040c1;
}
.Icon--blue-dark-900.change-stroke-color svg path {
  stroke: #00359e;
}
.Icon--blue-dark-900.change-stroke-color svg polygon {
  stroke: #00359e;
}
.Icon--blue-dark-900.change-stroke-color svg circle {
  stroke: #00359e;
}
.Icon--blue-dark-900.change-stroke-color svg rect {
  stroke: #00359e;
}
.Icon--blue-dark-900.change-fill-color svg path {
  fill: #00359e;
}
.Icon--blue-dark-900.change-fill-color svg polygon {
  fill: #00359e;
}
.Icon--blue-dark-900.change-fill-color svg circle {
  fill: #00359e;
}
.Icon--blue-dark-900.change-fill-color svg rect {
  fill: #00359e;
}
.Icon--blue-dark-950.change-stroke-color svg path {
  stroke: #002266;
}
.Icon--blue-dark-950.change-stroke-color svg polygon {
  stroke: #002266;
}
.Icon--blue-dark-950.change-stroke-color svg circle {
  stroke: #002266;
}
.Icon--blue-dark-950.change-stroke-color svg rect {
  stroke: #002266;
}
.Icon--blue-dark-950.change-fill-color svg path {
  fill: #002266;
}
.Icon--blue-dark-950.change-fill-color svg polygon {
  fill: #002266;
}
.Icon--blue-dark-950.change-fill-color svg circle {
  fill: #002266;
}
.Icon--blue-dark-950.change-fill-color svg rect {
  fill: #002266;
}
.Icon--violet-25.change-stroke-color svg path {
  stroke: #fbfaff;
}
.Icon--violet-25.change-stroke-color svg polygon {
  stroke: #fbfaff;
}
.Icon--violet-25.change-stroke-color svg circle {
  stroke: #fbfaff;
}
.Icon--violet-25.change-stroke-color svg rect {
  stroke: #fbfaff;
}
.Icon--violet-25.change-fill-color svg path {
  fill: #fbfaff;
}
.Icon--violet-25.change-fill-color svg polygon {
  fill: #fbfaff;
}
.Icon--violet-25.change-fill-color svg circle {
  fill: #fbfaff;
}
.Icon--violet-25.change-fill-color svg rect {
  fill: #fbfaff;
}
.Icon--violet-50.change-stroke-color svg path {
  stroke: #f5f3ff;
}
.Icon--violet-50.change-stroke-color svg polygon {
  stroke: #f5f3ff;
}
.Icon--violet-50.change-stroke-color svg circle {
  stroke: #f5f3ff;
}
.Icon--violet-50.change-stroke-color svg rect {
  stroke: #f5f3ff;
}
.Icon--violet-50.change-fill-color svg path {
  fill: #f5f3ff;
}
.Icon--violet-50.change-fill-color svg polygon {
  fill: #f5f3ff;
}
.Icon--violet-50.change-fill-color svg circle {
  fill: #f5f3ff;
}
.Icon--violet-50.change-fill-color svg rect {
  fill: #f5f3ff;
}
.Icon--violet-100.change-stroke-color svg path {
  stroke: #ece9fe;
}
.Icon--violet-100.change-stroke-color svg polygon {
  stroke: #ece9fe;
}
.Icon--violet-100.change-stroke-color svg circle {
  stroke: #ece9fe;
}
.Icon--violet-100.change-stroke-color svg rect {
  stroke: #ece9fe;
}
.Icon--violet-100.change-fill-color svg path {
  fill: #ece9fe;
}
.Icon--violet-100.change-fill-color svg polygon {
  fill: #ece9fe;
}
.Icon--violet-100.change-fill-color svg circle {
  fill: #ece9fe;
}
.Icon--violet-100.change-fill-color svg rect {
  fill: #ece9fe;
}
.Icon--violet-200.change-stroke-color svg path {
  stroke: #ddd6fe;
}
.Icon--violet-200.change-stroke-color svg polygon {
  stroke: #ddd6fe;
}
.Icon--violet-200.change-stroke-color svg circle {
  stroke: #ddd6fe;
}
.Icon--violet-200.change-stroke-color svg rect {
  stroke: #ddd6fe;
}
.Icon--violet-200.change-fill-color svg path {
  fill: #ddd6fe;
}
.Icon--violet-200.change-fill-color svg polygon {
  fill: #ddd6fe;
}
.Icon--violet-200.change-fill-color svg circle {
  fill: #ddd6fe;
}
.Icon--violet-200.change-fill-color svg rect {
  fill: #ddd6fe;
}
.Icon--violet-300.change-stroke-color svg path {
  stroke: #c3b5fd;
}
.Icon--violet-300.change-stroke-color svg polygon {
  stroke: #c3b5fd;
}
.Icon--violet-300.change-stroke-color svg circle {
  stroke: #c3b5fd;
}
.Icon--violet-300.change-stroke-color svg rect {
  stroke: #c3b5fd;
}
.Icon--violet-300.change-fill-color svg path {
  fill: #c3b5fd;
}
.Icon--violet-300.change-fill-color svg polygon {
  fill: #c3b5fd;
}
.Icon--violet-300.change-fill-color svg circle {
  fill: #c3b5fd;
}
.Icon--violet-300.change-fill-color svg rect {
  fill: #c3b5fd;
}
.Icon--violet-400.change-stroke-color svg path {
  stroke: #a48afb;
}
.Icon--violet-400.change-stroke-color svg polygon {
  stroke: #a48afb;
}
.Icon--violet-400.change-stroke-color svg circle {
  stroke: #a48afb;
}
.Icon--violet-400.change-stroke-color svg rect {
  stroke: #a48afb;
}
.Icon--violet-400.change-fill-color svg path {
  fill: #a48afb;
}
.Icon--violet-400.change-fill-color svg polygon {
  fill: #a48afb;
}
.Icon--violet-400.change-fill-color svg circle {
  fill: #a48afb;
}
.Icon--violet-400.change-fill-color svg rect {
  fill: #a48afb;
}
.Icon--violet-500.change-stroke-color svg path {
  stroke: #875bf7;
}
.Icon--violet-500.change-stroke-color svg polygon {
  stroke: #875bf7;
}
.Icon--violet-500.change-stroke-color svg circle {
  stroke: #875bf7;
}
.Icon--violet-500.change-stroke-color svg rect {
  stroke: #875bf7;
}
.Icon--violet-500.change-fill-color svg path {
  fill: #875bf7;
}
.Icon--violet-500.change-fill-color svg polygon {
  fill: #875bf7;
}
.Icon--violet-500.change-fill-color svg circle {
  fill: #875bf7;
}
.Icon--violet-500.change-fill-color svg rect {
  fill: #875bf7;
}
.Icon--violet-600.change-stroke-color svg path {
  stroke: #7839ee;
}
.Icon--violet-600.change-stroke-color svg polygon {
  stroke: #7839ee;
}
.Icon--violet-600.change-stroke-color svg circle {
  stroke: #7839ee;
}
.Icon--violet-600.change-stroke-color svg rect {
  stroke: #7839ee;
}
.Icon--violet-600.change-fill-color svg path {
  fill: #7839ee;
}
.Icon--violet-600.change-fill-color svg polygon {
  fill: #7839ee;
}
.Icon--violet-600.change-fill-color svg circle {
  fill: #7839ee;
}
.Icon--violet-600.change-fill-color svg rect {
  fill: #7839ee;
}
.Icon--violet-700.change-stroke-color svg path {
  stroke: #6927da;
}
.Icon--violet-700.change-stroke-color svg polygon {
  stroke: #6927da;
}
.Icon--violet-700.change-stroke-color svg circle {
  stroke: #6927da;
}
.Icon--violet-700.change-stroke-color svg rect {
  stroke: #6927da;
}
.Icon--violet-700.change-fill-color svg path {
  fill: #6927da;
}
.Icon--violet-700.change-fill-color svg polygon {
  fill: #6927da;
}
.Icon--violet-700.change-fill-color svg circle {
  fill: #6927da;
}
.Icon--violet-700.change-fill-color svg rect {
  fill: #6927da;
}
.Icon--violet-800.change-stroke-color svg path {
  stroke: #5720b7;
}
.Icon--violet-800.change-stroke-color svg polygon {
  stroke: #5720b7;
}
.Icon--violet-800.change-stroke-color svg circle {
  stroke: #5720b7;
}
.Icon--violet-800.change-stroke-color svg rect {
  stroke: #5720b7;
}
.Icon--violet-800.change-fill-color svg path {
  fill: #5720b7;
}
.Icon--violet-800.change-fill-color svg polygon {
  fill: #5720b7;
}
.Icon--violet-800.change-fill-color svg circle {
  fill: #5720b7;
}
.Icon--violet-800.change-fill-color svg rect {
  fill: #5720b7;
}
.Icon--violet-900.change-stroke-color svg path {
  stroke: #491c96;
}
.Icon--violet-900.change-stroke-color svg polygon {
  stroke: #491c96;
}
.Icon--violet-900.change-stroke-color svg circle {
  stroke: #491c96;
}
.Icon--violet-900.change-stroke-color svg rect {
  stroke: #491c96;
}
.Icon--violet-900.change-fill-color svg path {
  fill: #491c96;
}
.Icon--violet-900.change-fill-color svg polygon {
  fill: #491c96;
}
.Icon--violet-900.change-fill-color svg circle {
  fill: #491c96;
}
.Icon--violet-900.change-fill-color svg rect {
  fill: #491c96;
}
.Icon--violet-950.change-stroke-color svg path {
  stroke: #2e125e;
}
.Icon--violet-950.change-stroke-color svg polygon {
  stroke: #2e125e;
}
.Icon--violet-950.change-stroke-color svg circle {
  stroke: #2e125e;
}
.Icon--violet-950.change-stroke-color svg rect {
  stroke: #2e125e;
}
.Icon--violet-950.change-fill-color svg path {
  fill: #2e125e;
}
.Icon--violet-950.change-fill-color svg polygon {
  fill: #2e125e;
}
.Icon--violet-950.change-fill-color svg circle {
  fill: #2e125e;
}
.Icon--violet-950.change-fill-color svg rect {
  fill: #2e125e;
}
.Icon--purple-25.change-stroke-color svg path {
  stroke: #fafaff;
}
.Icon--purple-25.change-stroke-color svg polygon {
  stroke: #fafaff;
}
.Icon--purple-25.change-stroke-color svg circle {
  stroke: #fafaff;
}
.Icon--purple-25.change-stroke-color svg rect {
  stroke: #fafaff;
}
.Icon--purple-25.change-fill-color svg path {
  fill: #fafaff;
}
.Icon--purple-25.change-fill-color svg polygon {
  fill: #fafaff;
}
.Icon--purple-25.change-fill-color svg circle {
  fill: #fafaff;
}
.Icon--purple-25.change-fill-color svg rect {
  fill: #fafaff;
}
.Icon--purple-50.change-stroke-color svg path {
  stroke: #f4f3ff;
}
.Icon--purple-50.change-stroke-color svg polygon {
  stroke: #f4f3ff;
}
.Icon--purple-50.change-stroke-color svg circle {
  stroke: #f4f3ff;
}
.Icon--purple-50.change-stroke-color svg rect {
  stroke: #f4f3ff;
}
.Icon--purple-50.change-fill-color svg path {
  fill: #f4f3ff;
}
.Icon--purple-50.change-fill-color svg polygon {
  fill: #f4f3ff;
}
.Icon--purple-50.change-fill-color svg circle {
  fill: #f4f3ff;
}
.Icon--purple-50.change-fill-color svg rect {
  fill: #f4f3ff;
}
.Icon--purple-100.change-stroke-color svg path {
  stroke: #ebe9fe;
}
.Icon--purple-100.change-stroke-color svg polygon {
  stroke: #ebe9fe;
}
.Icon--purple-100.change-stroke-color svg circle {
  stroke: #ebe9fe;
}
.Icon--purple-100.change-stroke-color svg rect {
  stroke: #ebe9fe;
}
.Icon--purple-100.change-fill-color svg path {
  fill: #ebe9fe;
}
.Icon--purple-100.change-fill-color svg polygon {
  fill: #ebe9fe;
}
.Icon--purple-100.change-fill-color svg circle {
  fill: #ebe9fe;
}
.Icon--purple-100.change-fill-color svg rect {
  fill: #ebe9fe;
}
.Icon--purple-200.change-stroke-color svg path {
  stroke: #d9d6fe;
}
.Icon--purple-200.change-stroke-color svg polygon {
  stroke: #d9d6fe;
}
.Icon--purple-200.change-stroke-color svg circle {
  stroke: #d9d6fe;
}
.Icon--purple-200.change-stroke-color svg rect {
  stroke: #d9d6fe;
}
.Icon--purple-200.change-fill-color svg path {
  fill: #d9d6fe;
}
.Icon--purple-200.change-fill-color svg polygon {
  fill: #d9d6fe;
}
.Icon--purple-200.change-fill-color svg circle {
  fill: #d9d6fe;
}
.Icon--purple-200.change-fill-color svg rect {
  fill: #d9d6fe;
}
.Icon--purple-300.change-stroke-color svg path {
  stroke: #bdb4fe;
}
.Icon--purple-300.change-stroke-color svg polygon {
  stroke: #bdb4fe;
}
.Icon--purple-300.change-stroke-color svg circle {
  stroke: #bdb4fe;
}
.Icon--purple-300.change-stroke-color svg rect {
  stroke: #bdb4fe;
}
.Icon--purple-300.change-fill-color svg path {
  fill: #bdb4fe;
}
.Icon--purple-300.change-fill-color svg polygon {
  fill: #bdb4fe;
}
.Icon--purple-300.change-fill-color svg circle {
  fill: #bdb4fe;
}
.Icon--purple-300.change-fill-color svg rect {
  fill: #bdb4fe;
}
.Icon--purple-400.change-stroke-color svg path {
  stroke: #9b8afb;
}
.Icon--purple-400.change-stroke-color svg polygon {
  stroke: #9b8afb;
}
.Icon--purple-400.change-stroke-color svg circle {
  stroke: #9b8afb;
}
.Icon--purple-400.change-stroke-color svg rect {
  stroke: #9b8afb;
}
.Icon--purple-400.change-fill-color svg path {
  fill: #9b8afb;
}
.Icon--purple-400.change-fill-color svg polygon {
  fill: #9b8afb;
}
.Icon--purple-400.change-fill-color svg circle {
  fill: #9b8afb;
}
.Icon--purple-400.change-fill-color svg rect {
  fill: #9b8afb;
}
.Icon--purple-500.change-stroke-color svg path {
  stroke: #7a5af8;
}
.Icon--purple-500.change-stroke-color svg polygon {
  stroke: #7a5af8;
}
.Icon--purple-500.change-stroke-color svg circle {
  stroke: #7a5af8;
}
.Icon--purple-500.change-stroke-color svg rect {
  stroke: #7a5af8;
}
.Icon--purple-500.change-fill-color svg path {
  fill: #7a5af8;
}
.Icon--purple-500.change-fill-color svg polygon {
  fill: #7a5af8;
}
.Icon--purple-500.change-fill-color svg circle {
  fill: #7a5af8;
}
.Icon--purple-500.change-fill-color svg rect {
  fill: #7a5af8;
}
.Icon--purple-600.change-stroke-color svg path {
  stroke: #6938ef;
}
.Icon--purple-600.change-stroke-color svg polygon {
  stroke: #6938ef;
}
.Icon--purple-600.change-stroke-color svg circle {
  stroke: #6938ef;
}
.Icon--purple-600.change-stroke-color svg rect {
  stroke: #6938ef;
}
.Icon--purple-600.change-fill-color svg path {
  fill: #6938ef;
}
.Icon--purple-600.change-fill-color svg polygon {
  fill: #6938ef;
}
.Icon--purple-600.change-fill-color svg circle {
  fill: #6938ef;
}
.Icon--purple-600.change-fill-color svg rect {
  fill: #6938ef;
}
.Icon--purple-700.change-stroke-color svg path {
  stroke: #5925dc;
}
.Icon--purple-700.change-stroke-color svg polygon {
  stroke: #5925dc;
}
.Icon--purple-700.change-stroke-color svg circle {
  stroke: #5925dc;
}
.Icon--purple-700.change-stroke-color svg rect {
  stroke: #5925dc;
}
.Icon--purple-700.change-fill-color svg path {
  fill: #5925dc;
}
.Icon--purple-700.change-fill-color svg polygon {
  fill: #5925dc;
}
.Icon--purple-700.change-fill-color svg circle {
  fill: #5925dc;
}
.Icon--purple-700.change-fill-color svg rect {
  fill: #5925dc;
}
.Icon--purple-800.change-stroke-color svg path {
  stroke: #4a1fb8;
}
.Icon--purple-800.change-stroke-color svg polygon {
  stroke: #4a1fb8;
}
.Icon--purple-800.change-stroke-color svg circle {
  stroke: #4a1fb8;
}
.Icon--purple-800.change-stroke-color svg rect {
  stroke: #4a1fb8;
}
.Icon--purple-800.change-fill-color svg path {
  fill: #4a1fb8;
}
.Icon--purple-800.change-fill-color svg polygon {
  fill: #4a1fb8;
}
.Icon--purple-800.change-fill-color svg circle {
  fill: #4a1fb8;
}
.Icon--purple-800.change-fill-color svg rect {
  fill: #4a1fb8;
}
.Icon--purple-900.change-stroke-color svg path {
  stroke: #3e1c96;
}
.Icon--purple-900.change-stroke-color svg polygon {
  stroke: #3e1c96;
}
.Icon--purple-900.change-stroke-color svg circle {
  stroke: #3e1c96;
}
.Icon--purple-900.change-stroke-color svg rect {
  stroke: #3e1c96;
}
.Icon--purple-900.change-fill-color svg path {
  fill: #3e1c96;
}
.Icon--purple-900.change-fill-color svg polygon {
  fill: #3e1c96;
}
.Icon--purple-900.change-fill-color svg circle {
  fill: #3e1c96;
}
.Icon--purple-900.change-fill-color svg rect {
  fill: #3e1c96;
}
.Icon--purple-950.change-stroke-color svg path {
  stroke: #27115f;
}
.Icon--purple-950.change-stroke-color svg polygon {
  stroke: #27115f;
}
.Icon--purple-950.change-stroke-color svg circle {
  stroke: #27115f;
}
.Icon--purple-950.change-stroke-color svg rect {
  stroke: #27115f;
}
.Icon--purple-950.change-fill-color svg path {
  fill: #27115f;
}
.Icon--purple-950.change-fill-color svg polygon {
  fill: #27115f;
}
.Icon--purple-950.change-fill-color svg circle {
  fill: #27115f;
}
.Icon--purple-950.change-fill-color svg rect {
  fill: #27115f;
}
.Icon--fuchsia-25.change-stroke-color svg path {
  stroke: #fefaff;
}
.Icon--fuchsia-25.change-stroke-color svg polygon {
  stroke: #fefaff;
}
.Icon--fuchsia-25.change-stroke-color svg circle {
  stroke: #fefaff;
}
.Icon--fuchsia-25.change-stroke-color svg rect {
  stroke: #fefaff;
}
.Icon--fuchsia-25.change-fill-color svg path {
  fill: #fefaff;
}
.Icon--fuchsia-25.change-fill-color svg polygon {
  fill: #fefaff;
}
.Icon--fuchsia-25.change-fill-color svg circle {
  fill: #fefaff;
}
.Icon--fuchsia-25.change-fill-color svg rect {
  fill: #fefaff;
}
.Icon--fuchsia-50.change-stroke-color svg path {
  stroke: #fdf4ff;
}
.Icon--fuchsia-50.change-stroke-color svg polygon {
  stroke: #fdf4ff;
}
.Icon--fuchsia-50.change-stroke-color svg circle {
  stroke: #fdf4ff;
}
.Icon--fuchsia-50.change-stroke-color svg rect {
  stroke: #fdf4ff;
}
.Icon--fuchsia-50.change-fill-color svg path {
  fill: #fdf4ff;
}
.Icon--fuchsia-50.change-fill-color svg polygon {
  fill: #fdf4ff;
}
.Icon--fuchsia-50.change-fill-color svg circle {
  fill: #fdf4ff;
}
.Icon--fuchsia-50.change-fill-color svg rect {
  fill: #fdf4ff;
}
.Icon--fuchsia-100.change-stroke-color svg path {
  stroke: #fbe8ff;
}
.Icon--fuchsia-100.change-stroke-color svg polygon {
  stroke: #fbe8ff;
}
.Icon--fuchsia-100.change-stroke-color svg circle {
  stroke: #fbe8ff;
}
.Icon--fuchsia-100.change-stroke-color svg rect {
  stroke: #fbe8ff;
}
.Icon--fuchsia-100.change-fill-color svg path {
  fill: #fbe8ff;
}
.Icon--fuchsia-100.change-fill-color svg polygon {
  fill: #fbe8ff;
}
.Icon--fuchsia-100.change-fill-color svg circle {
  fill: #fbe8ff;
}
.Icon--fuchsia-100.change-fill-color svg rect {
  fill: #fbe8ff;
}
.Icon--fuchsia-200.change-stroke-color svg path {
  stroke: #f6d0fe;
}
.Icon--fuchsia-200.change-stroke-color svg polygon {
  stroke: #f6d0fe;
}
.Icon--fuchsia-200.change-stroke-color svg circle {
  stroke: #f6d0fe;
}
.Icon--fuchsia-200.change-stroke-color svg rect {
  stroke: #f6d0fe;
}
.Icon--fuchsia-200.change-fill-color svg path {
  fill: #f6d0fe;
}
.Icon--fuchsia-200.change-fill-color svg polygon {
  fill: #f6d0fe;
}
.Icon--fuchsia-200.change-fill-color svg circle {
  fill: #f6d0fe;
}
.Icon--fuchsia-200.change-fill-color svg rect {
  fill: #f6d0fe;
}
.Icon--fuchsia-300.change-stroke-color svg path {
  stroke: #eeaafd;
}
.Icon--fuchsia-300.change-stroke-color svg polygon {
  stroke: #eeaafd;
}
.Icon--fuchsia-300.change-stroke-color svg circle {
  stroke: #eeaafd;
}
.Icon--fuchsia-300.change-stroke-color svg rect {
  stroke: #eeaafd;
}
.Icon--fuchsia-300.change-fill-color svg path {
  fill: #eeaafd;
}
.Icon--fuchsia-300.change-fill-color svg polygon {
  fill: #eeaafd;
}
.Icon--fuchsia-300.change-fill-color svg circle {
  fill: #eeaafd;
}
.Icon--fuchsia-300.change-fill-color svg rect {
  fill: #eeaafd;
}
.Icon--fuchsia-400.change-stroke-color svg path {
  stroke: #e478fa;
}
.Icon--fuchsia-400.change-stroke-color svg polygon {
  stroke: #e478fa;
}
.Icon--fuchsia-400.change-stroke-color svg circle {
  stroke: #e478fa;
}
.Icon--fuchsia-400.change-stroke-color svg rect {
  stroke: #e478fa;
}
.Icon--fuchsia-400.change-fill-color svg path {
  fill: #e478fa;
}
.Icon--fuchsia-400.change-fill-color svg polygon {
  fill: #e478fa;
}
.Icon--fuchsia-400.change-fill-color svg circle {
  fill: #e478fa;
}
.Icon--fuchsia-400.change-fill-color svg rect {
  fill: #e478fa;
}
.Icon--fuchsia-500.change-stroke-color svg path {
  stroke: #d444f1;
}
.Icon--fuchsia-500.change-stroke-color svg polygon {
  stroke: #d444f1;
}
.Icon--fuchsia-500.change-stroke-color svg circle {
  stroke: #d444f1;
}
.Icon--fuchsia-500.change-stroke-color svg rect {
  stroke: #d444f1;
}
.Icon--fuchsia-500.change-fill-color svg path {
  fill: #d444f1;
}
.Icon--fuchsia-500.change-fill-color svg polygon {
  fill: #d444f1;
}
.Icon--fuchsia-500.change-fill-color svg circle {
  fill: #d444f1;
}
.Icon--fuchsia-500.change-fill-color svg rect {
  fill: #d444f1;
}
.Icon--fuchsia-600.change-stroke-color svg path {
  stroke: #ba24d5;
}
.Icon--fuchsia-600.change-stroke-color svg polygon {
  stroke: #ba24d5;
}
.Icon--fuchsia-600.change-stroke-color svg circle {
  stroke: #ba24d5;
}
.Icon--fuchsia-600.change-stroke-color svg rect {
  stroke: #ba24d5;
}
.Icon--fuchsia-600.change-fill-color svg path {
  fill: #ba24d5;
}
.Icon--fuchsia-600.change-fill-color svg polygon {
  fill: #ba24d5;
}
.Icon--fuchsia-600.change-fill-color svg circle {
  fill: #ba24d5;
}
.Icon--fuchsia-600.change-fill-color svg rect {
  fill: #ba24d5;
}
.Icon--fuchsia-700.change-stroke-color svg path {
  stroke: #9f1ab1;
}
.Icon--fuchsia-700.change-stroke-color svg polygon {
  stroke: #9f1ab1;
}
.Icon--fuchsia-700.change-stroke-color svg circle {
  stroke: #9f1ab1;
}
.Icon--fuchsia-700.change-stroke-color svg rect {
  stroke: #9f1ab1;
}
.Icon--fuchsia-700.change-fill-color svg path {
  fill: #9f1ab1;
}
.Icon--fuchsia-700.change-fill-color svg polygon {
  fill: #9f1ab1;
}
.Icon--fuchsia-700.change-fill-color svg circle {
  fill: #9f1ab1;
}
.Icon--fuchsia-700.change-fill-color svg rect {
  fill: #9f1ab1;
}
.Icon--fuchsia-800.change-stroke-color svg path {
  stroke: #821890;
}
.Icon--fuchsia-800.change-stroke-color svg polygon {
  stroke: #821890;
}
.Icon--fuchsia-800.change-stroke-color svg circle {
  stroke: #821890;
}
.Icon--fuchsia-800.change-stroke-color svg rect {
  stroke: #821890;
}
.Icon--fuchsia-800.change-fill-color svg path {
  fill: #821890;
}
.Icon--fuchsia-800.change-fill-color svg polygon {
  fill: #821890;
}
.Icon--fuchsia-800.change-fill-color svg circle {
  fill: #821890;
}
.Icon--fuchsia-800.change-fill-color svg rect {
  fill: #821890;
}
.Icon--fuchsia-900.change-stroke-color svg path {
  stroke: #6f1877;
}
.Icon--fuchsia-900.change-stroke-color svg polygon {
  stroke: #6f1877;
}
.Icon--fuchsia-900.change-stroke-color svg circle {
  stroke: #6f1877;
}
.Icon--fuchsia-900.change-stroke-color svg rect {
  stroke: #6f1877;
}
.Icon--fuchsia-900.change-fill-color svg path {
  fill: #6f1877;
}
.Icon--fuchsia-900.change-fill-color svg polygon {
  fill: #6f1877;
}
.Icon--fuchsia-900.change-fill-color svg circle {
  fill: #6f1877;
}
.Icon--fuchsia-900.change-fill-color svg rect {
  fill: #6f1877;
}
.Icon--fuchsia-950.change-stroke-color svg path {
  stroke: #47104c;
}
.Icon--fuchsia-950.change-stroke-color svg polygon {
  stroke: #47104c;
}
.Icon--fuchsia-950.change-stroke-color svg circle {
  stroke: #47104c;
}
.Icon--fuchsia-950.change-stroke-color svg rect {
  stroke: #47104c;
}
.Icon--fuchsia-950.change-fill-color svg path {
  fill: #47104c;
}
.Icon--fuchsia-950.change-fill-color svg polygon {
  fill: #47104c;
}
.Icon--fuchsia-950.change-fill-color svg circle {
  fill: #47104c;
}
.Icon--fuchsia-950.change-fill-color svg rect {
  fill: #47104c;
}
.Icon--pink-25.change-stroke-color svg path {
  stroke: #fef6fb;
}
.Icon--pink-25.change-stroke-color svg polygon {
  stroke: #fef6fb;
}
.Icon--pink-25.change-stroke-color svg circle {
  stroke: #fef6fb;
}
.Icon--pink-25.change-stroke-color svg rect {
  stroke: #fef6fb;
}
.Icon--pink-25.change-fill-color svg path {
  fill: #fef6fb;
}
.Icon--pink-25.change-fill-color svg polygon {
  fill: #fef6fb;
}
.Icon--pink-25.change-fill-color svg circle {
  fill: #fef6fb;
}
.Icon--pink-25.change-fill-color svg rect {
  fill: #fef6fb;
}
.Icon--pink-50.change-stroke-color svg path {
  stroke: #fdf2fa;
}
.Icon--pink-50.change-stroke-color svg polygon {
  stroke: #fdf2fa;
}
.Icon--pink-50.change-stroke-color svg circle {
  stroke: #fdf2fa;
}
.Icon--pink-50.change-stroke-color svg rect {
  stroke: #fdf2fa;
}
.Icon--pink-50.change-fill-color svg path {
  fill: #fdf2fa;
}
.Icon--pink-50.change-fill-color svg polygon {
  fill: #fdf2fa;
}
.Icon--pink-50.change-fill-color svg circle {
  fill: #fdf2fa;
}
.Icon--pink-50.change-fill-color svg rect {
  fill: #fdf2fa;
}
.Icon--pink-100.change-stroke-color svg path {
  stroke: #fce7f6;
}
.Icon--pink-100.change-stroke-color svg polygon {
  stroke: #fce7f6;
}
.Icon--pink-100.change-stroke-color svg circle {
  stroke: #fce7f6;
}
.Icon--pink-100.change-stroke-color svg rect {
  stroke: #fce7f6;
}
.Icon--pink-100.change-fill-color svg path {
  fill: #fce7f6;
}
.Icon--pink-100.change-fill-color svg polygon {
  fill: #fce7f6;
}
.Icon--pink-100.change-fill-color svg circle {
  fill: #fce7f6;
}
.Icon--pink-100.change-fill-color svg rect {
  fill: #fce7f6;
}
.Icon--pink-200.change-stroke-color svg path {
  stroke: #fcceee;
}
.Icon--pink-200.change-stroke-color svg polygon {
  stroke: #fcceee;
}
.Icon--pink-200.change-stroke-color svg circle {
  stroke: #fcceee;
}
.Icon--pink-200.change-stroke-color svg rect {
  stroke: #fcceee;
}
.Icon--pink-200.change-fill-color svg path {
  fill: #fcceee;
}
.Icon--pink-200.change-fill-color svg polygon {
  fill: #fcceee;
}
.Icon--pink-200.change-fill-color svg circle {
  fill: #fcceee;
}
.Icon--pink-200.change-fill-color svg rect {
  fill: #fcceee;
}
.Icon--pink-300.change-stroke-color svg path {
  stroke: #faa7e0;
}
.Icon--pink-300.change-stroke-color svg polygon {
  stroke: #faa7e0;
}
.Icon--pink-300.change-stroke-color svg circle {
  stroke: #faa7e0;
}
.Icon--pink-300.change-stroke-color svg rect {
  stroke: #faa7e0;
}
.Icon--pink-300.change-fill-color svg path {
  fill: #faa7e0;
}
.Icon--pink-300.change-fill-color svg polygon {
  fill: #faa7e0;
}
.Icon--pink-300.change-fill-color svg circle {
  fill: #faa7e0;
}
.Icon--pink-300.change-fill-color svg rect {
  fill: #faa7e0;
}
.Icon--pink-400.change-stroke-color svg path {
  stroke: #f670c7;
}
.Icon--pink-400.change-stroke-color svg polygon {
  stroke: #f670c7;
}
.Icon--pink-400.change-stroke-color svg circle {
  stroke: #f670c7;
}
.Icon--pink-400.change-stroke-color svg rect {
  stroke: #f670c7;
}
.Icon--pink-400.change-fill-color svg path {
  fill: #f670c7;
}
.Icon--pink-400.change-fill-color svg polygon {
  fill: #f670c7;
}
.Icon--pink-400.change-fill-color svg circle {
  fill: #f670c7;
}
.Icon--pink-400.change-fill-color svg rect {
  fill: #f670c7;
}
.Icon--pink-500.change-stroke-color svg path {
  stroke: #ee46bc;
}
.Icon--pink-500.change-stroke-color svg polygon {
  stroke: #ee46bc;
}
.Icon--pink-500.change-stroke-color svg circle {
  stroke: #ee46bc;
}
.Icon--pink-500.change-stroke-color svg rect {
  stroke: #ee46bc;
}
.Icon--pink-500.change-fill-color svg path {
  fill: #ee46bc;
}
.Icon--pink-500.change-fill-color svg polygon {
  fill: #ee46bc;
}
.Icon--pink-500.change-fill-color svg circle {
  fill: #ee46bc;
}
.Icon--pink-500.change-fill-color svg rect {
  fill: #ee46bc;
}
.Icon--pink-600.change-stroke-color svg path {
  stroke: #dd2590;
}
.Icon--pink-600.change-stroke-color svg polygon {
  stroke: #dd2590;
}
.Icon--pink-600.change-stroke-color svg circle {
  stroke: #dd2590;
}
.Icon--pink-600.change-stroke-color svg rect {
  stroke: #dd2590;
}
.Icon--pink-600.change-fill-color svg path {
  fill: #dd2590;
}
.Icon--pink-600.change-fill-color svg polygon {
  fill: #dd2590;
}
.Icon--pink-600.change-fill-color svg circle {
  fill: #dd2590;
}
.Icon--pink-600.change-fill-color svg rect {
  fill: #dd2590;
}
.Icon--pink-700.change-stroke-color svg path {
  stroke: #c11574;
}
.Icon--pink-700.change-stroke-color svg polygon {
  stroke: #c11574;
}
.Icon--pink-700.change-stroke-color svg circle {
  stroke: #c11574;
}
.Icon--pink-700.change-stroke-color svg rect {
  stroke: #c11574;
}
.Icon--pink-700.change-fill-color svg path {
  fill: #c11574;
}
.Icon--pink-700.change-fill-color svg polygon {
  fill: #c11574;
}
.Icon--pink-700.change-fill-color svg circle {
  fill: #c11574;
}
.Icon--pink-700.change-fill-color svg rect {
  fill: #c11574;
}
.Icon--pink-800.change-stroke-color svg path {
  stroke: #9e165f;
}
.Icon--pink-800.change-stroke-color svg polygon {
  stroke: #9e165f;
}
.Icon--pink-800.change-stroke-color svg circle {
  stroke: #9e165f;
}
.Icon--pink-800.change-stroke-color svg rect {
  stroke: #9e165f;
}
.Icon--pink-800.change-fill-color svg path {
  fill: #9e165f;
}
.Icon--pink-800.change-fill-color svg polygon {
  fill: #9e165f;
}
.Icon--pink-800.change-fill-color svg circle {
  fill: #9e165f;
}
.Icon--pink-800.change-fill-color svg rect {
  fill: #9e165f;
}
.Icon--pink-900.change-stroke-color svg path {
  stroke: #851651;
}
.Icon--pink-900.change-stroke-color svg polygon {
  stroke: #851651;
}
.Icon--pink-900.change-stroke-color svg circle {
  stroke: #851651;
}
.Icon--pink-900.change-stroke-color svg rect {
  stroke: #851651;
}
.Icon--pink-900.change-fill-color svg path {
  fill: #851651;
}
.Icon--pink-900.change-fill-color svg polygon {
  fill: #851651;
}
.Icon--pink-900.change-fill-color svg circle {
  fill: #851651;
}
.Icon--pink-900.change-fill-color svg rect {
  fill: #851651;
}
.Icon--pink-950.change-stroke-color svg path {
  stroke: #4e0d30;
}
.Icon--pink-950.change-stroke-color svg polygon {
  stroke: #4e0d30;
}
.Icon--pink-950.change-stroke-color svg circle {
  stroke: #4e0d30;
}
.Icon--pink-950.change-stroke-color svg rect {
  stroke: #4e0d30;
}
.Icon--pink-950.change-fill-color svg path {
  fill: #4e0d30;
}
.Icon--pink-950.change-fill-color svg polygon {
  fill: #4e0d30;
}
.Icon--pink-950.change-fill-color svg circle {
  fill: #4e0d30;
}
.Icon--pink-950.change-fill-color svg rect {
  fill: #4e0d30;
}
.Icon--rose-25.change-stroke-color svg path {
  stroke: #fff5f6;
}
.Icon--rose-25.change-stroke-color svg polygon {
  stroke: #fff5f6;
}
.Icon--rose-25.change-stroke-color svg circle {
  stroke: #fff5f6;
}
.Icon--rose-25.change-stroke-color svg rect {
  stroke: #fff5f6;
}
.Icon--rose-25.change-fill-color svg path {
  fill: #fff5f6;
}
.Icon--rose-25.change-fill-color svg polygon {
  fill: #fff5f6;
}
.Icon--rose-25.change-fill-color svg circle {
  fill: #fff5f6;
}
.Icon--rose-25.change-fill-color svg rect {
  fill: #fff5f6;
}
.Icon--rose-50.change-stroke-color svg path {
  stroke: #fff1f3;
}
.Icon--rose-50.change-stroke-color svg polygon {
  stroke: #fff1f3;
}
.Icon--rose-50.change-stroke-color svg circle {
  stroke: #fff1f3;
}
.Icon--rose-50.change-stroke-color svg rect {
  stroke: #fff1f3;
}
.Icon--rose-50.change-fill-color svg path {
  fill: #fff1f3;
}
.Icon--rose-50.change-fill-color svg polygon {
  fill: #fff1f3;
}
.Icon--rose-50.change-fill-color svg circle {
  fill: #fff1f3;
}
.Icon--rose-50.change-fill-color svg rect {
  fill: #fff1f3;
}
.Icon--rose-100.change-stroke-color svg path {
  stroke: #ffe4e8;
}
.Icon--rose-100.change-stroke-color svg polygon {
  stroke: #ffe4e8;
}
.Icon--rose-100.change-stroke-color svg circle {
  stroke: #ffe4e8;
}
.Icon--rose-100.change-stroke-color svg rect {
  stroke: #ffe4e8;
}
.Icon--rose-100.change-fill-color svg path {
  fill: #ffe4e8;
}
.Icon--rose-100.change-fill-color svg polygon {
  fill: #ffe4e8;
}
.Icon--rose-100.change-fill-color svg circle {
  fill: #ffe4e8;
}
.Icon--rose-100.change-fill-color svg rect {
  fill: #ffe4e8;
}
.Icon--rose-200.change-stroke-color svg path {
  stroke: #fecdd6;
}
.Icon--rose-200.change-stroke-color svg polygon {
  stroke: #fecdd6;
}
.Icon--rose-200.change-stroke-color svg circle {
  stroke: #fecdd6;
}
.Icon--rose-200.change-stroke-color svg rect {
  stroke: #fecdd6;
}
.Icon--rose-200.change-fill-color svg path {
  fill: #fecdd6;
}
.Icon--rose-200.change-fill-color svg polygon {
  fill: #fecdd6;
}
.Icon--rose-200.change-fill-color svg circle {
  fill: #fecdd6;
}
.Icon--rose-200.change-fill-color svg rect {
  fill: #fecdd6;
}
.Icon--rose-300.change-stroke-color svg path {
  stroke: #fea3b4;
}
.Icon--rose-300.change-stroke-color svg polygon {
  stroke: #fea3b4;
}
.Icon--rose-300.change-stroke-color svg circle {
  stroke: #fea3b4;
}
.Icon--rose-300.change-stroke-color svg rect {
  stroke: #fea3b4;
}
.Icon--rose-300.change-fill-color svg path {
  fill: #fea3b4;
}
.Icon--rose-300.change-fill-color svg polygon {
  fill: #fea3b4;
}
.Icon--rose-300.change-fill-color svg circle {
  fill: #fea3b4;
}
.Icon--rose-300.change-fill-color svg rect {
  fill: #fea3b4;
}
.Icon--rose-400.change-stroke-color svg path {
  stroke: #fd6f8e;
}
.Icon--rose-400.change-stroke-color svg polygon {
  stroke: #fd6f8e;
}
.Icon--rose-400.change-stroke-color svg circle {
  stroke: #fd6f8e;
}
.Icon--rose-400.change-stroke-color svg rect {
  stroke: #fd6f8e;
}
.Icon--rose-400.change-fill-color svg path {
  fill: #fd6f8e;
}
.Icon--rose-400.change-fill-color svg polygon {
  fill: #fd6f8e;
}
.Icon--rose-400.change-fill-color svg circle {
  fill: #fd6f8e;
}
.Icon--rose-400.change-fill-color svg rect {
  fill: #fd6f8e;
}
.Icon--rose-500.change-stroke-color svg path {
  stroke: #f63d68;
}
.Icon--rose-500.change-stroke-color svg polygon {
  stroke: #f63d68;
}
.Icon--rose-500.change-stroke-color svg circle {
  stroke: #f63d68;
}
.Icon--rose-500.change-stroke-color svg rect {
  stroke: #f63d68;
}
.Icon--rose-500.change-fill-color svg path {
  fill: #f63d68;
}
.Icon--rose-500.change-fill-color svg polygon {
  fill: #f63d68;
}
.Icon--rose-500.change-fill-color svg circle {
  fill: #f63d68;
}
.Icon--rose-500.change-fill-color svg rect {
  fill: #f63d68;
}
.Icon--rose-600.change-stroke-color svg path {
  stroke: #e31b54;
}
.Icon--rose-600.change-stroke-color svg polygon {
  stroke: #e31b54;
}
.Icon--rose-600.change-stroke-color svg circle {
  stroke: #e31b54;
}
.Icon--rose-600.change-stroke-color svg rect {
  stroke: #e31b54;
}
.Icon--rose-600.change-fill-color svg path {
  fill: #e31b54;
}
.Icon--rose-600.change-fill-color svg polygon {
  fill: #e31b54;
}
.Icon--rose-600.change-fill-color svg circle {
  fill: #e31b54;
}
.Icon--rose-600.change-fill-color svg rect {
  fill: #e31b54;
}
.Icon--rose-700.change-stroke-color svg path {
  stroke: #c01048;
}
.Icon--rose-700.change-stroke-color svg polygon {
  stroke: #c01048;
}
.Icon--rose-700.change-stroke-color svg circle {
  stroke: #c01048;
}
.Icon--rose-700.change-stroke-color svg rect {
  stroke: #c01048;
}
.Icon--rose-700.change-fill-color svg path {
  fill: #c01048;
}
.Icon--rose-700.change-fill-color svg polygon {
  fill: #c01048;
}
.Icon--rose-700.change-fill-color svg circle {
  fill: #c01048;
}
.Icon--rose-700.change-fill-color svg rect {
  fill: #c01048;
}
.Icon--rose-800.change-stroke-color svg path {
  stroke: #a11043;
}
.Icon--rose-800.change-stroke-color svg polygon {
  stroke: #a11043;
}
.Icon--rose-800.change-stroke-color svg circle {
  stroke: #a11043;
}
.Icon--rose-800.change-stroke-color svg rect {
  stroke: #a11043;
}
.Icon--rose-800.change-fill-color svg path {
  fill: #a11043;
}
.Icon--rose-800.change-fill-color svg polygon {
  fill: #a11043;
}
.Icon--rose-800.change-fill-color svg circle {
  fill: #a11043;
}
.Icon--rose-800.change-fill-color svg rect {
  fill: #a11043;
}
.Icon--rose-900.change-stroke-color svg path {
  stroke: #89123e;
}
.Icon--rose-900.change-stroke-color svg polygon {
  stroke: #89123e;
}
.Icon--rose-900.change-stroke-color svg circle {
  stroke: #89123e;
}
.Icon--rose-900.change-stroke-color svg rect {
  stroke: #89123e;
}
.Icon--rose-900.change-fill-color svg path {
  fill: #89123e;
}
.Icon--rose-900.change-fill-color svg polygon {
  fill: #89123e;
}
.Icon--rose-900.change-fill-color svg circle {
  fill: #89123e;
}
.Icon--rose-900.change-fill-color svg rect {
  fill: #89123e;
}
.Icon--rose-950.change-stroke-color svg path {
  stroke: #510b24;
}
.Icon--rose-950.change-stroke-color svg polygon {
  stroke: #510b24;
}
.Icon--rose-950.change-stroke-color svg circle {
  stroke: #510b24;
}
.Icon--rose-950.change-stroke-color svg rect {
  stroke: #510b24;
}
.Icon--rose-950.change-fill-color svg path {
  fill: #510b24;
}
.Icon--rose-950.change-fill-color svg polygon {
  fill: #510b24;
}
.Icon--rose-950.change-fill-color svg circle {
  fill: #510b24;
}
.Icon--rose-950.change-fill-color svg rect {
  fill: #510b24;
}
.Icon--orange-dark-25.change-stroke-color svg path {
  stroke: #fff9f5;
}
.Icon--orange-dark-25.change-stroke-color svg polygon {
  stroke: #fff9f5;
}
.Icon--orange-dark-25.change-stroke-color svg circle {
  stroke: #fff9f5;
}
.Icon--orange-dark-25.change-stroke-color svg rect {
  stroke: #fff9f5;
}
.Icon--orange-dark-25.change-fill-color svg path {
  fill: #fff9f5;
}
.Icon--orange-dark-25.change-fill-color svg polygon {
  fill: #fff9f5;
}
.Icon--orange-dark-25.change-fill-color svg circle {
  fill: #fff9f5;
}
.Icon--orange-dark-25.change-fill-color svg rect {
  fill: #fff9f5;
}
.Icon--orange-dark-50.change-stroke-color svg path {
  stroke: #fff4ed;
}
.Icon--orange-dark-50.change-stroke-color svg polygon {
  stroke: #fff4ed;
}
.Icon--orange-dark-50.change-stroke-color svg circle {
  stroke: #fff4ed;
}
.Icon--orange-dark-50.change-stroke-color svg rect {
  stroke: #fff4ed;
}
.Icon--orange-dark-50.change-fill-color svg path {
  fill: #fff4ed;
}
.Icon--orange-dark-50.change-fill-color svg polygon {
  fill: #fff4ed;
}
.Icon--orange-dark-50.change-fill-color svg circle {
  fill: #fff4ed;
}
.Icon--orange-dark-50.change-fill-color svg rect {
  fill: #fff4ed;
}
.Icon--orange-dark-100.change-stroke-color svg path {
  stroke: #ffe6d5;
}
.Icon--orange-dark-100.change-stroke-color svg polygon {
  stroke: #ffe6d5;
}
.Icon--orange-dark-100.change-stroke-color svg circle {
  stroke: #ffe6d5;
}
.Icon--orange-dark-100.change-stroke-color svg rect {
  stroke: #ffe6d5;
}
.Icon--orange-dark-100.change-fill-color svg path {
  fill: #ffe6d5;
}
.Icon--orange-dark-100.change-fill-color svg polygon {
  fill: #ffe6d5;
}
.Icon--orange-dark-100.change-fill-color svg circle {
  fill: #ffe6d5;
}
.Icon--orange-dark-100.change-fill-color svg rect {
  fill: #ffe6d5;
}
.Icon--orange-dark-200.change-stroke-color svg path {
  stroke: #ffd6ae;
}
.Icon--orange-dark-200.change-stroke-color svg polygon {
  stroke: #ffd6ae;
}
.Icon--orange-dark-200.change-stroke-color svg circle {
  stroke: #ffd6ae;
}
.Icon--orange-dark-200.change-stroke-color svg rect {
  stroke: #ffd6ae;
}
.Icon--orange-dark-200.change-fill-color svg path {
  fill: #ffd6ae;
}
.Icon--orange-dark-200.change-fill-color svg polygon {
  fill: #ffd6ae;
}
.Icon--orange-dark-200.change-fill-color svg circle {
  fill: #ffd6ae;
}
.Icon--orange-dark-200.change-fill-color svg rect {
  fill: #ffd6ae;
}
.Icon--orange-dark-300.change-stroke-color svg path {
  stroke: #ff9c66;
}
.Icon--orange-dark-300.change-stroke-color svg polygon {
  stroke: #ff9c66;
}
.Icon--orange-dark-300.change-stroke-color svg circle {
  stroke: #ff9c66;
}
.Icon--orange-dark-300.change-stroke-color svg rect {
  stroke: #ff9c66;
}
.Icon--orange-dark-300.change-fill-color svg path {
  fill: #ff9c66;
}
.Icon--orange-dark-300.change-fill-color svg polygon {
  fill: #ff9c66;
}
.Icon--orange-dark-300.change-fill-color svg circle {
  fill: #ff9c66;
}
.Icon--orange-dark-300.change-fill-color svg rect {
  fill: #ff9c66;
}
.Icon--orange-dark-400.change-stroke-color svg path {
  stroke: #ff692d;
}
.Icon--orange-dark-400.change-stroke-color svg polygon {
  stroke: #ff692d;
}
.Icon--orange-dark-400.change-stroke-color svg circle {
  stroke: #ff692d;
}
.Icon--orange-dark-400.change-stroke-color svg rect {
  stroke: #ff692d;
}
.Icon--orange-dark-400.change-fill-color svg path {
  fill: #ff692d;
}
.Icon--orange-dark-400.change-fill-color svg polygon {
  fill: #ff692d;
}
.Icon--orange-dark-400.change-fill-color svg circle {
  fill: #ff692d;
}
.Icon--orange-dark-400.change-fill-color svg rect {
  fill: #ff692d;
}
.Icon--orange-dark-500.change-stroke-color svg path {
  stroke: #ff4405;
}
.Icon--orange-dark-500.change-stroke-color svg polygon {
  stroke: #ff4405;
}
.Icon--orange-dark-500.change-stroke-color svg circle {
  stroke: #ff4405;
}
.Icon--orange-dark-500.change-stroke-color svg rect {
  stroke: #ff4405;
}
.Icon--orange-dark-500.change-fill-color svg path {
  fill: #ff4405;
}
.Icon--orange-dark-500.change-fill-color svg polygon {
  fill: #ff4405;
}
.Icon--orange-dark-500.change-fill-color svg circle {
  fill: #ff4405;
}
.Icon--orange-dark-500.change-fill-color svg rect {
  fill: #ff4405;
}
.Icon--orange-dark-600.change-stroke-color svg path {
  stroke: #e62e05;
}
.Icon--orange-dark-600.change-stroke-color svg polygon {
  stroke: #e62e05;
}
.Icon--orange-dark-600.change-stroke-color svg circle {
  stroke: #e62e05;
}
.Icon--orange-dark-600.change-stroke-color svg rect {
  stroke: #e62e05;
}
.Icon--orange-dark-600.change-fill-color svg path {
  fill: #e62e05;
}
.Icon--orange-dark-600.change-fill-color svg polygon {
  fill: #e62e05;
}
.Icon--orange-dark-600.change-fill-color svg circle {
  fill: #e62e05;
}
.Icon--orange-dark-600.change-fill-color svg rect {
  fill: #e62e05;
}
.Icon--orange-dark-700.change-stroke-color svg path {
  stroke: #bc1b06;
}
.Icon--orange-dark-700.change-stroke-color svg polygon {
  stroke: #bc1b06;
}
.Icon--orange-dark-700.change-stroke-color svg circle {
  stroke: #bc1b06;
}
.Icon--orange-dark-700.change-stroke-color svg rect {
  stroke: #bc1b06;
}
.Icon--orange-dark-700.change-fill-color svg path {
  fill: #bc1b06;
}
.Icon--orange-dark-700.change-fill-color svg polygon {
  fill: #bc1b06;
}
.Icon--orange-dark-700.change-fill-color svg circle {
  fill: #bc1b06;
}
.Icon--orange-dark-700.change-fill-color svg rect {
  fill: #bc1b06;
}
.Icon--orange-dark-800.change-stroke-color svg path {
  stroke: #97180c;
}
.Icon--orange-dark-800.change-stroke-color svg polygon {
  stroke: #97180c;
}
.Icon--orange-dark-800.change-stroke-color svg circle {
  stroke: #97180c;
}
.Icon--orange-dark-800.change-stroke-color svg rect {
  stroke: #97180c;
}
.Icon--orange-dark-800.change-fill-color svg path {
  fill: #97180c;
}
.Icon--orange-dark-800.change-fill-color svg polygon {
  fill: #97180c;
}
.Icon--orange-dark-800.change-fill-color svg circle {
  fill: #97180c;
}
.Icon--orange-dark-800.change-fill-color svg rect {
  fill: #97180c;
}
.Icon--orange-dark-900.change-stroke-color svg path {
  stroke: #771a0d;
}
.Icon--orange-dark-900.change-stroke-color svg polygon {
  stroke: #771a0d;
}
.Icon--orange-dark-900.change-stroke-color svg circle {
  stroke: #771a0d;
}
.Icon--orange-dark-900.change-stroke-color svg rect {
  stroke: #771a0d;
}
.Icon--orange-dark-900.change-fill-color svg path {
  fill: #771a0d;
}
.Icon--orange-dark-900.change-fill-color svg polygon {
  fill: #771a0d;
}
.Icon--orange-dark-900.change-fill-color svg circle {
  fill: #771a0d;
}
.Icon--orange-dark-900.change-fill-color svg rect {
  fill: #771a0d;
}
.Icon--orange-dark-950.change-stroke-color svg path {
  stroke: #57130a;
}
.Icon--orange-dark-950.change-stroke-color svg polygon {
  stroke: #57130a;
}
.Icon--orange-dark-950.change-stroke-color svg circle {
  stroke: #57130a;
}
.Icon--orange-dark-950.change-stroke-color svg rect {
  stroke: #57130a;
}
.Icon--orange-dark-950.change-fill-color svg path {
  fill: #57130a;
}
.Icon--orange-dark-950.change-fill-color svg polygon {
  fill: #57130a;
}
.Icon--orange-dark-950.change-fill-color svg circle {
  fill: #57130a;
}
.Icon--orange-dark-950.change-fill-color svg rect {
  fill: #57130a;
}
.Icon--yellow-25.change-stroke-color svg path {
  stroke: #fefdf0;
}
.Icon--yellow-25.change-stroke-color svg polygon {
  stroke: #fefdf0;
}
.Icon--yellow-25.change-stroke-color svg circle {
  stroke: #fefdf0;
}
.Icon--yellow-25.change-stroke-color svg rect {
  stroke: #fefdf0;
}
.Icon--yellow-25.change-fill-color svg path {
  fill: #fefdf0;
}
.Icon--yellow-25.change-fill-color svg polygon {
  fill: #fefdf0;
}
.Icon--yellow-25.change-fill-color svg circle {
  fill: #fefdf0;
}
.Icon--yellow-25.change-fill-color svg rect {
  fill: #fefdf0;
}
.Icon--yellow-50.change-stroke-color svg path {
  stroke: #fefbe8;
}
.Icon--yellow-50.change-stroke-color svg polygon {
  stroke: #fefbe8;
}
.Icon--yellow-50.change-stroke-color svg circle {
  stroke: #fefbe8;
}
.Icon--yellow-50.change-stroke-color svg rect {
  stroke: #fefbe8;
}
.Icon--yellow-50.change-fill-color svg path {
  fill: #fefbe8;
}
.Icon--yellow-50.change-fill-color svg polygon {
  fill: #fefbe8;
}
.Icon--yellow-50.change-fill-color svg circle {
  fill: #fefbe8;
}
.Icon--yellow-50.change-fill-color svg rect {
  fill: #fefbe8;
}
.Icon--yellow-100.change-stroke-color svg path {
  stroke: #fef7c3;
}
.Icon--yellow-100.change-stroke-color svg polygon {
  stroke: #fef7c3;
}
.Icon--yellow-100.change-stroke-color svg circle {
  stroke: #fef7c3;
}
.Icon--yellow-100.change-stroke-color svg rect {
  stroke: #fef7c3;
}
.Icon--yellow-100.change-fill-color svg path {
  fill: #fef7c3;
}
.Icon--yellow-100.change-fill-color svg polygon {
  fill: #fef7c3;
}
.Icon--yellow-100.change-fill-color svg circle {
  fill: #fef7c3;
}
.Icon--yellow-100.change-fill-color svg rect {
  fill: #fef7c3;
}
.Icon--yellow-200.change-stroke-color svg path {
  stroke: #feee95;
}
.Icon--yellow-200.change-stroke-color svg polygon {
  stroke: #feee95;
}
.Icon--yellow-200.change-stroke-color svg circle {
  stroke: #feee95;
}
.Icon--yellow-200.change-stroke-color svg rect {
  stroke: #feee95;
}
.Icon--yellow-200.change-fill-color svg path {
  fill: #feee95;
}
.Icon--yellow-200.change-fill-color svg polygon {
  fill: #feee95;
}
.Icon--yellow-200.change-fill-color svg circle {
  fill: #feee95;
}
.Icon--yellow-200.change-fill-color svg rect {
  fill: #feee95;
}
.Icon--yellow-300.change-stroke-color svg path {
  stroke: #fde272;
}
.Icon--yellow-300.change-stroke-color svg polygon {
  stroke: #fde272;
}
.Icon--yellow-300.change-stroke-color svg circle {
  stroke: #fde272;
}
.Icon--yellow-300.change-stroke-color svg rect {
  stroke: #fde272;
}
.Icon--yellow-300.change-fill-color svg path {
  fill: #fde272;
}
.Icon--yellow-300.change-fill-color svg polygon {
  fill: #fde272;
}
.Icon--yellow-300.change-fill-color svg circle {
  fill: #fde272;
}
.Icon--yellow-300.change-fill-color svg rect {
  fill: #fde272;
}
.Icon--yellow-400.change-stroke-color svg path {
  stroke: #fac515;
}
.Icon--yellow-400.change-stroke-color svg polygon {
  stroke: #fac515;
}
.Icon--yellow-400.change-stroke-color svg circle {
  stroke: #fac515;
}
.Icon--yellow-400.change-stroke-color svg rect {
  stroke: #fac515;
}
.Icon--yellow-400.change-fill-color svg path {
  fill: #fac515;
}
.Icon--yellow-400.change-fill-color svg polygon {
  fill: #fac515;
}
.Icon--yellow-400.change-fill-color svg circle {
  fill: #fac515;
}
.Icon--yellow-400.change-fill-color svg rect {
  fill: #fac515;
}
.Icon--yellow-500.change-stroke-color svg path {
  stroke: #eaaa08;
}
.Icon--yellow-500.change-stroke-color svg polygon {
  stroke: #eaaa08;
}
.Icon--yellow-500.change-stroke-color svg circle {
  stroke: #eaaa08;
}
.Icon--yellow-500.change-stroke-color svg rect {
  stroke: #eaaa08;
}
.Icon--yellow-500.change-fill-color svg path {
  fill: #eaaa08;
}
.Icon--yellow-500.change-fill-color svg polygon {
  fill: #eaaa08;
}
.Icon--yellow-500.change-fill-color svg circle {
  fill: #eaaa08;
}
.Icon--yellow-500.change-fill-color svg rect {
  fill: #eaaa08;
}
.Icon--yellow-600.change-stroke-color svg path {
  stroke: #ca8504;
}
.Icon--yellow-600.change-stroke-color svg polygon {
  stroke: #ca8504;
}
.Icon--yellow-600.change-stroke-color svg circle {
  stroke: #ca8504;
}
.Icon--yellow-600.change-stroke-color svg rect {
  stroke: #ca8504;
}
.Icon--yellow-600.change-fill-color svg path {
  fill: #ca8504;
}
.Icon--yellow-600.change-fill-color svg polygon {
  fill: #ca8504;
}
.Icon--yellow-600.change-fill-color svg circle {
  fill: #ca8504;
}
.Icon--yellow-600.change-fill-color svg rect {
  fill: #ca8504;
}
.Icon--yellow-700.change-stroke-color svg path {
  stroke: #a15c07;
}
.Icon--yellow-700.change-stroke-color svg polygon {
  stroke: #a15c07;
}
.Icon--yellow-700.change-stroke-color svg circle {
  stroke: #a15c07;
}
.Icon--yellow-700.change-stroke-color svg rect {
  stroke: #a15c07;
}
.Icon--yellow-700.change-fill-color svg path {
  fill: #a15c07;
}
.Icon--yellow-700.change-fill-color svg polygon {
  fill: #a15c07;
}
.Icon--yellow-700.change-fill-color svg circle {
  fill: #a15c07;
}
.Icon--yellow-700.change-fill-color svg rect {
  fill: #a15c07;
}
.Icon--yellow-800.change-stroke-color svg path {
  stroke: #854a0e;
}
.Icon--yellow-800.change-stroke-color svg polygon {
  stroke: #854a0e;
}
.Icon--yellow-800.change-stroke-color svg circle {
  stroke: #854a0e;
}
.Icon--yellow-800.change-stroke-color svg rect {
  stroke: #854a0e;
}
.Icon--yellow-800.change-fill-color svg path {
  fill: #854a0e;
}
.Icon--yellow-800.change-fill-color svg polygon {
  fill: #854a0e;
}
.Icon--yellow-800.change-fill-color svg circle {
  fill: #854a0e;
}
.Icon--yellow-800.change-fill-color svg rect {
  fill: #854a0e;
}
.Icon--yellow-900.change-stroke-color svg path {
  stroke: #713b12;
}
.Icon--yellow-900.change-stroke-color svg polygon {
  stroke: #713b12;
}
.Icon--yellow-900.change-stroke-color svg circle {
  stroke: #713b12;
}
.Icon--yellow-900.change-stroke-color svg rect {
  stroke: #713b12;
}
.Icon--yellow-900.change-fill-color svg path {
  fill: #713b12;
}
.Icon--yellow-900.change-fill-color svg polygon {
  fill: #713b12;
}
.Icon--yellow-900.change-fill-color svg circle {
  fill: #713b12;
}
.Icon--yellow-900.change-fill-color svg rect {
  fill: #713b12;
}
.Icon--yellow-950.change-stroke-color svg path {
  stroke: #542c0d;
}
.Icon--yellow-950.change-stroke-color svg polygon {
  stroke: #542c0d;
}
.Icon--yellow-950.change-stroke-color svg circle {
  stroke: #542c0d;
}
.Icon--yellow-950.change-stroke-color svg rect {
  stroke: #542c0d;
}
.Icon--yellow-950.change-fill-color svg path {
  fill: #542c0d;
}
.Icon--yellow-950.change-fill-color svg polygon {
  fill: #542c0d;
}
.Icon--yellow-950.change-fill-color svg circle {
  fill: #542c0d;
}
.Icon--yellow-950.change-fill-color svg rect {
  fill: #542c0d;
}
.Icon--white-500.change-stroke-color svg path {
  stroke: #ffffff;
}
.Icon--white-500.change-stroke-color svg polygon {
  stroke: #ffffff;
}
.Icon--white-500.change-stroke-color svg circle {
  stroke: #ffffff;
}
.Icon--white-500.change-stroke-color svg rect {
  stroke: #ffffff;
}
.Icon--white-500.change-fill-color svg path {
  fill: #ffffff;
}
.Icon--white-500.change-fill-color svg polygon {
  fill: #ffffff;
}
.Icon--white-500.change-fill-color svg circle {
  fill: #ffffff;
}
.Icon--white-500.change-fill-color svg rect {
  fill: #ffffff;
}
.Icon--black-500.change-stroke-color svg path {
  stroke: #000000;
}
.Icon--black-500.change-stroke-color svg polygon {
  stroke: #000000;
}
.Icon--black-500.change-stroke-color svg circle {
  stroke: #000000;
}
.Icon--black-500.change-stroke-color svg rect {
  stroke: #000000;
}
.Icon--black-500.change-fill-color svg path {
  fill: #000000;
}
.Icon--black-500.change-fill-color svg polygon {
  fill: #000000;
}
.Icon--black-500.change-fill-color svg circle {
  fill: #000000;
}
.Icon--black-500.change-fill-color svg rect {
  fill: #000000;
}
.Icon--black.change-stroke-color svg path,
.Icon--black.change-stroke-color svg polygon,
.Icon--black.change-stroke-color svg circle {
  stroke: black;
}
.Icon--black.change-fill-color svg path,
.Icon--black.change-fill-color svg polygon,
.Icon--black.change-fill-color svg circle {
  fill: black;
}
.Icon--white.change-stroke-color svg path,
.Icon--white.change-stroke-color svg polygon,
.Icon--white.change-stroke-color svg circle {
  stroke: white;
}
.Icon--white.change-fill-color svg path,
.Icon--white.change-fill-color svg polygon,
.Icon--white.change-fill-color svg circle {
  fill: white;
}

button.text-neutral-25:hover .Icon--neutral-25.change-fill-color svg path {
  fill: rgb(235.29, 235.29, 235.29) !important;
}
button.text-neutral-25:hover .Icon--neutral-25.change-stroke-color svg path {
  stroke: rgb(235.29, 235.29, 235.29) !important;
}

button.text-neutral-25:active .Icon--neutral-25.change-fill-color svg path {
  fill: rgb(215.05, 215.05, 215.05) !important;
}
button.text-neutral-25:active .Icon--neutral-25.change-stroke-color svg path {
  stroke: rgb(215.05, 215.05, 215.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-25:not(.change-stroke-color) svg path {
  fill: rgb(235.29, 235.29, 235.29) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-25:not(.change-stroke-color) svg path {
  fill: rgb(235.29, 235.29, 235.29) !important;
}

button.text-neutral-50:hover .Icon--neutral-50.change-fill-color svg path {
  fill: rgb(229.9472727273, 234.1227272727, 234.1227272727) !important;
}
button.text-neutral-50:hover .Icon--neutral-50.change-stroke-color svg path {
  stroke: rgb(229.9472727273, 234.1227272727, 234.1227272727) !important;
}

button.text-neutral-50:active .Icon--neutral-50.change-fill-color svg path {
  fill: rgb(208.1727272727, 215.9772727273, 215.9772727273) !important;
}
button.text-neutral-50:active .Icon--neutral-50.change-stroke-color svg path {
  stroke: rgb(208.1727272727, 215.9772727273, 215.9772727273) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-50:not(.change-stroke-color) svg path {
  fill: rgb(229.9472727273, 234.1227272727, 234.1227272727) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-50:not(.change-stroke-color) svg path {
  fill: rgb(229.9472727273, 234.1227272727, 234.1227272727) !important;
}

button.text-neutral-75:hover .Icon--neutral-75.change-fill-color svg path {
  fill: rgb(228.78, 228.78, 228.78) !important;
}
button.text-neutral-75:hover .Icon--neutral-75.change-stroke-color svg path {
  stroke: rgb(228.78, 228.78, 228.78) !important;
}

button.text-neutral-75:active .Icon--neutral-75.change-fill-color svg path {
  fill: rgb(209.1, 209.1, 209.1) !important;
}
button.text-neutral-75:active .Icon--neutral-75.change-stroke-color svg path {
  stroke: rgb(209.1, 209.1, 209.1) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-75:not(.change-stroke-color) svg path {
  fill: rgb(228.78, 228.78, 228.78) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-75:not(.change-stroke-color) svg path {
  fill: rgb(228.78, 228.78, 228.78) !important;
}

button.text-neutral-100:hover .Icon--neutral-100.change-fill-color svg path {
  fill: rgb(227.85, 227.85, 227.85) !important;
}
button.text-neutral-100:hover .Icon--neutral-100.change-stroke-color svg path {
  stroke: rgb(227.85, 227.85, 227.85) !important;
}

button.text-neutral-100:active .Icon--neutral-100.change-fill-color svg path {
  fill: rgb(208.25, 208.25, 208.25) !important;
}
button.text-neutral-100:active .Icon--neutral-100.change-stroke-color svg path {
  stroke: rgb(208.25, 208.25, 208.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-100:not(.change-stroke-color) svg path {
  fill: rgb(227.85, 227.85, 227.85) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-100:not(.change-stroke-color) svg path {
  fill: rgb(227.85, 227.85, 227.85) !important;
}

button.text-neutral-200:hover .Icon--neutral-200.change-fill-color svg path {
  fill: rgb(215.84, 217.62, 219.4) !important;
}
button.text-neutral-200:hover .Icon--neutral-200.change-stroke-color svg path {
  stroke: rgb(215.84, 217.62, 219.4) !important;
}

button.text-neutral-200:active .Icon--neutral-200.change-fill-color svg path {
  fill: rgb(196.2285714286, 198.9, 201.5714285714) !important;
}
button.text-neutral-200:active .Icon--neutral-200.change-stroke-color svg path {
  stroke: rgb(196.2285714286, 198.9, 201.5714285714) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-200:not(.change-stroke-color) svg path {
  fill: rgb(215.84, 217.62, 219.4) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-200:not(.change-stroke-color) svg path {
  fill: rgb(215.84, 217.62, 219.4) !important;
}

button.text-neutral-300:hover .Icon--neutral-300.change-fill-color svg path {
  fill: rgb(196.9602531646, 199.7240506329, 203.8697468354) !important;
}
button.text-neutral-300:hover .Icon--neutral-300.change-stroke-color svg path {
  stroke: rgb(196.9602531646, 199.7240506329, 203.8697468354) !important;
}

button.text-neutral-300:active .Icon--neutral-300.change-fill-color svg path {
  fill: rgb(178.6291139241, 182.2658227848, 187.7208860759) !important;
}
button.text-neutral-300:active .Icon--neutral-300.change-stroke-color svg path {
  stroke: rgb(178.6291139241, 182.2658227848, 187.7208860759) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-300:not(.change-stroke-color) svg path {
  fill: rgb(196.9602531646, 199.7240506329, 203.8697468354) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-300:not(.change-stroke-color) svg path {
  fill: rgb(196.9602531646, 199.7240506329, 203.8697468354) !important;
}

button.text-neutral-400:hover .Icon--neutral-400.change-fill-color svg path {
  fill: rgb(151.4822093023, 154.8948837209, 162.8577906977) !important;
}
button.text-neutral-400:hover .Icon--neutral-400.change-stroke-color svg path {
  stroke: rgb(151.4822093023, 154.8948837209, 162.8577906977) !important;
}

button.text-neutral-400:active .Icon--neutral-400.change-fill-color svg path {
  fill: rgb(137.1761627907, 141.0604651163, 150.1238372093) !important;
}
button.text-neutral-400:active .Icon--neutral-400.change-stroke-color svg path {
  stroke: rgb(137.1761627907, 141.0604651163, 150.1238372093) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-400:not(.change-stroke-color) svg path {
  fill: rgb(151.4822093023, 154.8948837209, 162.8577906977) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-400:not(.change-stroke-color) svg path {
  fill: rgb(151.4822093023, 154.8948837209, 162.8577906977) !important;
}

button.text-neutral-500:hover .Icon--neutral-500.change-fill-color svg path {
  fill: rgb(105.09, 109.74, 119.04) !important;
}
button.text-neutral-500:hover .Icon--neutral-500.change-stroke-color svg path {
  stroke: rgb(105.09, 109.74, 119.04) !important;
}

button.text-neutral-500:active .Icon--neutral-500.change-fill-color svg path {
  fill: rgb(96.05, 100.3, 108.8) !important;
}
button.text-neutral-500:active .Icon--neutral-500.change-stroke-color svg path {
  stroke: rgb(96.05, 100.3, 108.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-500:not(.change-stroke-color) svg path {
  fill: rgb(105.09, 109.74, 119.04) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-500:not(.change-stroke-color) svg path {
  fill: rgb(105.09, 109.74, 119.04) !important;
}

button.text-neutral-600:hover .Icon--neutral-600.change-fill-color svg path {
  fill: rgb(77.19, 81.84, 91.14) !important;
}
button.text-neutral-600:hover .Icon--neutral-600.change-stroke-color svg path {
  stroke: rgb(77.19, 81.84, 91.14) !important;
}

button.text-neutral-600:active .Icon--neutral-600.change-fill-color svg path {
  fill: rgb(70.55, 74.8, 83.3) !important;
}
button.text-neutral-600:active .Icon--neutral-600.change-stroke-color svg path {
  stroke: rgb(70.55, 74.8, 83.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-600:not(.change-stroke-color) svg path {
  fill: rgb(77.19, 81.84, 91.14) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-600:not(.change-stroke-color) svg path {
  fill: rgb(77.19, 81.84, 91.14) !important;
}

button.text-neutral-700:hover .Icon--neutral-700.change-fill-color svg path {
  fill: rgb(60.45, 65.1, 75.33) !important;
}
button.text-neutral-700:hover .Icon--neutral-700.change-stroke-color svg path {
  stroke: rgb(60.45, 65.1, 75.33) !important;
}

button.text-neutral-700:active .Icon--neutral-700.change-fill-color svg path {
  fill: rgb(55.25, 59.5, 68.85) !important;
}
button.text-neutral-700:active .Icon--neutral-700.change-stroke-color svg path {
  stroke: rgb(55.25, 59.5, 68.85) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-700:not(.change-stroke-color) svg path {
  fill: rgb(60.45, 65.1, 75.33) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-700:not(.change-stroke-color) svg path {
  fill: rgb(60.45, 65.1, 75.33) !important;
}

button.text-neutral-800:hover .Icon--neutral-800.change-fill-color svg path {
  fill: rgb(34.41, 39.99, 51.15) !important;
}
button.text-neutral-800:hover .Icon--neutral-800.change-stroke-color svg path {
  stroke: rgb(34.41, 39.99, 51.15) !important;
}

button.text-neutral-800:active .Icon--neutral-800.change-fill-color svg path {
  fill: rgb(31.45, 36.55, 46.75) !important;
}
button.text-neutral-800:active .Icon--neutral-800.change-stroke-color svg path {
  stroke: rgb(31.45, 36.55, 46.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-800:not(.change-stroke-color) svg path {
  fill: rgb(34.41, 39.99, 51.15) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-800:not(.change-stroke-color) svg path {
  fill: rgb(34.41, 39.99, 51.15) !important;
}

button.text-neutral-900:hover .Icon--neutral-900.change-fill-color svg path {
  fill: rgb(22.32, 26.97, 36.27) !important;
}
button.text-neutral-900:hover .Icon--neutral-900.change-stroke-color svg path {
  stroke: rgb(22.32, 26.97, 36.27) !important;
}

button.text-neutral-900:active .Icon--neutral-900.change-fill-color svg path {
  fill: rgb(20.4, 24.65, 33.15) !important;
}
button.text-neutral-900:active .Icon--neutral-900.change-stroke-color svg path {
  stroke: rgb(20.4, 24.65, 33.15) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-900:not(.change-stroke-color) svg path {
  fill: rgb(22.32, 26.97, 36.27) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-900:not(.change-stroke-color) svg path {
  fill: rgb(22.32, 26.97, 36.27) !important;
}

button.text-neutral-950:hover .Icon--neutral-950.change-fill-color svg path {
  fill: rgb(9.3, 12.09, 16.74) !important;
}
button.text-neutral-950:hover .Icon--neutral-950.change-stroke-color svg path {
  stroke: rgb(9.3, 12.09, 16.74) !important;
}

button.text-neutral-950:active .Icon--neutral-950.change-fill-color svg path {
  fill: rgb(8.5, 11.05, 15.3) !important;
}
button.text-neutral-950:active .Icon--neutral-950.change-stroke-color svg path {
  stroke: rgb(8.5, 11.05, 15.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-950:not(.change-stroke-color) svg path {
  fill: rgb(9.3, 12.09, 16.74) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-950:not(.change-stroke-color) svg path {
  fill: rgb(9.3, 12.09, 16.74) !important;
}

button.text-neutral-dark-25:hover .Icon--neutral-dark-25.change-fill-color svg path {
  fill: rgb(232.5, 232.5, 232.5) !important;
}
button.text-neutral-dark-25:hover .Icon--neutral-dark-25.change-stroke-color svg path {
  stroke: rgb(232.5, 232.5, 232.5) !important;
}

button.text-neutral-dark-25:active .Icon--neutral-dark-25.change-fill-color svg path {
  fill: rgb(212.5, 212.5, 212.5) !important;
}
button.text-neutral-dark-25:active .Icon--neutral-dark-25.change-stroke-color svg path {
  stroke: rgb(212.5, 212.5, 212.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-25:not(.change-stroke-color) svg path {
  fill: rgb(232.5, 232.5, 232.5) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-25:not(.change-stroke-color) svg path {
  fill: rgb(232.5, 232.5, 232.5) !important;
}

button.text-neutral-dark-50:hover .Icon--neutral-dark-50.change-fill-color svg path {
  fill: rgb(229.71, 229.71, 229.71) !important;
}
button.text-neutral-dark-50:hover .Icon--neutral-dark-50.change-stroke-color svg path {
  stroke: rgb(229.71, 229.71, 229.71) !important;
}

button.text-neutral-dark-50:active .Icon--neutral-dark-50.change-fill-color svg path {
  fill: rgb(209.95, 209.95, 209.95) !important;
}
button.text-neutral-dark-50:active .Icon--neutral-dark-50.change-stroke-color svg path {
  stroke: rgb(209.95, 209.95, 209.95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-50:not(.change-stroke-color) svg path {
  fill: rgb(229.71, 229.71, 229.71) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-50:not(.change-stroke-color) svg path {
  fill: rgb(229.71, 229.71, 229.71) !important;
}

button.text-neutral-dark-100:hover .Icon--neutral-dark-100.change-fill-color svg path {
  fill: rgb(222.5844827586, 222.5844827586, 224.7455172414) !important;
}
button.text-neutral-dark-100:hover .Icon--neutral-dark-100.change-stroke-color svg path {
  stroke: rgb(222.5844827586, 222.5844827586, 224.7455172414) !important;
}

button.text-neutral-dark-100:active .Icon--neutral-dark-100.change-fill-color svg path {
  fill: rgb(202.6810344828, 202.6810344828, 206.1689655172) !important;
}
button.text-neutral-dark-100:active .Icon--neutral-dark-100.change-stroke-color svg path {
  stroke: rgb(202.6810344828, 202.6810344828, 206.1689655172) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-100:not(.change-stroke-color) svg path {
  fill: rgb(222.5844827586, 222.5844827586, 224.7455172414) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-100:not(.change-stroke-color) svg path {
  fill: rgb(222.5844827586, 222.5844827586, 224.7455172414) !important;
}

button.text-neutral-dark-200:hover .Icon--neutral-dark-200.change-fill-color svg path {
  fill: rgb(218.9975675676, 218.9975675676, 220.8924324324) !important;
}
button.text-neutral-dark-200:hover .Icon--neutral-dark-200.change-stroke-color svg path {
  stroke: rgb(218.9975675676, 218.9975675676, 220.8924324324) !important;
}

button.text-neutral-dark-200:active .Icon--neutral-dark-200.change-fill-color svg path {
  fill: rgb(199.5662162162, 199.5662162162, 202.4837837838) !important;
}
button.text-neutral-dark-200:active .Icon--neutral-dark-200.change-stroke-color svg path {
  stroke: rgb(199.5662162162, 199.5662162162, 202.4837837838) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-200:not(.change-stroke-color) svg path {
  fill: rgb(218.9975675676, 218.9975675676, 220.8924324324) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-200:not(.change-stroke-color) svg path {
  fill: rgb(218.9975675676, 218.9975675676, 220.8924324324) !important;
}

button.text-neutral-dark-300:hover .Icon--neutral-dark-300.change-fill-color svg path {
  fill: rgb(190.8204255319, 192.130212766, 196.0595744681) !important;
}
button.text-neutral-dark-300:hover .Icon--neutral-dark-300.change-stroke-color svg path {
  stroke: rgb(190.8204255319, 192.130212766, 196.0595744681) !important;
}

button.text-neutral-dark-300:active .Icon--neutral-dark-300.change-fill-color svg path {
  fill: rgb(173.4723404255, 175.1361702128, 180.1276595745) !important;
}
button.text-neutral-dark-300:active .Icon--neutral-dark-300.change-stroke-color svg path {
  stroke: rgb(173.4723404255, 175.1361702128, 180.1276595745) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-300:not(.change-stroke-color) svg path {
  fill: rgb(190.8204255319, 192.130212766, 196.0595744681) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-300:not(.change-stroke-color) svg path {
  fill: rgb(190.8204255319, 192.130212766, 196.0595744681) !important;
}

button.text-neutral-dark-400:hover .Icon--neutral-dark-400.change-fill-color svg path {
  fill: rgb(136.9467961165, 140.2566990291, 145.7732038835) !important;
}
button.text-neutral-dark-400:hover .Icon--neutral-dark-400.change-stroke-color svg path {
  stroke: rgb(136.9467961165, 140.2566990291, 145.7732038835) !important;
}

button.text-neutral-dark-400:active .Icon--neutral-dark-400.change-fill-color svg path {
  fill: rgb(124.3145631068, 127.9786407767, 134.0854368932) !important;
}
button.text-neutral-dark-400:active .Icon--neutral-dark-400.change-stroke-color svg path {
  stroke: rgb(124.3145631068, 127.9786407767, 134.0854368932) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-400:not(.change-stroke-color) svg path {
  fill: rgb(136.9467961165, 140.2566990291, 145.7732038835) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-400:not(.change-stroke-color) svg path {
  fill: rgb(136.9467961165, 140.2566990291, 145.7732038835) !important;
}

button.text-neutral-dark-500:hover .Icon--neutral-dark-500.change-fill-color svg path {
  fill: rgb(123.0063829787, 126.2521276596, 132.7436170213) !important;
}
button.text-neutral-dark-500:hover .Icon--neutral-dark-500.change-stroke-color svg path {
  stroke: rgb(123.0063829787, 126.2521276596, 132.7436170213) !important;
}

button.text-neutral-dark-500:active .Icon--neutral-dark-500.change-fill-color svg path {
  fill: rgb(112.3989361702, 115.3829787234, 121.3510638298) !important;
}
button.text-neutral-dark-500:active .Icon--neutral-dark-500.change-stroke-color svg path {
  stroke: rgb(112.3989361702, 115.3829787234, 121.3510638298) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-500:not(.change-stroke-color) svg path {
  fill: rgb(123.0063829787, 126.2521276596, 132.7436170213) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-500:not(.change-stroke-color) svg path {
  fill: rgb(123.0063829787, 126.2521276596, 132.7436170213) !important;
}

button.text-neutral-dark-600:hover .Icon--neutral-dark-600.change-fill-color svg path {
  fill: rgb(90.21, 93.93, 100.44) !important;
}
button.text-neutral-dark-600:hover .Icon--neutral-dark-600.change-stroke-color svg path {
  stroke: rgb(90.21, 93.93, 100.44) !important;
}

button.text-neutral-dark-600:active .Icon--neutral-dark-600.change-fill-color svg path {
  fill: rgb(82.45, 85.85, 91.8) !important;
}
button.text-neutral-dark-600:active .Icon--neutral-dark-600.change-stroke-color svg path {
  stroke: rgb(82.45, 85.85, 91.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-600:not(.change-stroke-color) svg path {
  fill: rgb(90.21, 93.93, 100.44) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-600:not(.change-stroke-color) svg path {
  fill: rgb(90.21, 93.93, 100.44) !important;
}

button.text-neutral-dark-700:hover .Icon--neutral-dark-700.change-fill-color svg path {
  fill: rgb(51.15, 53.94, 60.45) !important;
}
button.text-neutral-dark-700:hover .Icon--neutral-dark-700.change-stroke-color svg path {
  stroke: rgb(51.15, 53.94, 60.45) !important;
}

button.text-neutral-dark-700:active .Icon--neutral-dark-700.change-fill-color svg path {
  fill: rgb(46.75, 49.3, 55.25) !important;
}
button.text-neutral-dark-700:active .Icon--neutral-dark-700.change-stroke-color svg path {
  stroke: rgb(46.75, 49.3, 55.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-700:not(.change-stroke-color) svg path {
  fill: rgb(51.15, 53.94, 60.45) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-700:not(.change-stroke-color) svg path {
  fill: rgb(51.15, 53.94, 60.45) !important;
}

button.text-neutral-dark-800:hover .Icon--neutral-dark-800.change-fill-color svg path {
  fill: rgb(31.62, 35.34, 43.71) !important;
}
button.text-neutral-dark-800:hover .Icon--neutral-dark-800.change-stroke-color svg path {
  stroke: rgb(31.62, 35.34, 43.71) !important;
}

button.text-neutral-dark-800:active .Icon--neutral-dark-800.change-fill-color svg path {
  fill: rgb(28.9, 32.3, 39.95) !important;
}
button.text-neutral-dark-800:active .Icon--neutral-dark-800.change-stroke-color svg path {
  stroke: rgb(28.9, 32.3, 39.95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-800:not(.change-stroke-color) svg path {
  fill: rgb(31.62, 35.34, 43.71) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-800:not(.change-stroke-color) svg path {
  fill: rgb(31.62, 35.34, 43.71) !important;
}

button.text-neutral-dark-900:hover .Icon--neutral-dark-900.change-fill-color svg path {
  fill: rgb(17.67, 20.46, 25.11) !important;
}
button.text-neutral-dark-900:hover .Icon--neutral-dark-900.change-stroke-color svg path {
  stroke: rgb(17.67, 20.46, 25.11) !important;
}

button.text-neutral-dark-900:active .Icon--neutral-dark-900.change-fill-color svg path {
  fill: rgb(16.15, 18.7, 22.95) !important;
}
button.text-neutral-dark-900:active .Icon--neutral-dark-900.change-stroke-color svg path {
  stroke: rgb(16.15, 18.7, 22.95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-900:not(.change-stroke-color) svg path {
  fill: rgb(17.67, 20.46, 25.11) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-900:not(.change-stroke-color) svg path {
  fill: rgb(17.67, 20.46, 25.11) !important;
}

button.text-neutral-dark-950:hover .Icon--neutral-dark-950.change-fill-color svg path {
  fill: rgb(11.16, 13.02, 16.74) !important;
}
button.text-neutral-dark-950:hover .Icon--neutral-dark-950.change-stroke-color svg path {
  stroke: rgb(11.16, 13.02, 16.74) !important;
}

button.text-neutral-dark-950:active .Icon--neutral-dark-950.change-fill-color svg path {
  fill: rgb(10.2, 11.9, 15.3) !important;
}
button.text-neutral-dark-950:active .Icon--neutral-dark-950.change-stroke-color svg path {
  stroke: rgb(10.2, 11.9, 15.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--neutral-dark-950:not(.change-stroke-color) svg path {
  fill: rgb(11.16, 13.02, 16.74) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--neutral-dark-950:not(.change-stroke-color) svg path {
  fill: rgb(11.16, 13.02, 16.74) !important;
}

button.text-primary-10:hover .Icon--primary-10.change-fill-color svg path {
  fill: rgb(214.65, 238.86, 255) !important;
}
button.text-primary-10:hover .Icon--primary-10.change-stroke-color svg path {
  stroke: rgb(214.65, 238.86, 255) !important;
}

button.text-primary-10:active .Icon--primary-10.change-fill-color svg path {
  fill: rgb(174.25, 222.7, 255) !important;
}
button.text-primary-10:active .Icon--primary-10.change-stroke-color svg path {
  stroke: rgb(174.25, 222.7, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-10:not(.change-stroke-color) svg path {
  fill: rgb(214.65, 238.86, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-10:not(.change-stroke-color) svg path {
  fill: rgb(214.65, 238.86, 255) !important;
}

button.text-primary-25:hover .Icon--primary-25.change-fill-color svg path {
  fill: #d2edff !important;
}
button.text-primary-25:hover .Icon--primary-25.change-stroke-color svg path {
  stroke: #d2edff !important;
}

button.text-primary-25:active .Icon--primary-25.change-fill-color svg path {
  fill: #aaddff !important;
}
button.text-primary-25:active .Icon--primary-25.change-stroke-color svg path {
  stroke: #aaddff !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-25:not(.change-stroke-color) svg path {
  fill: #d2edff !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-25:not(.change-stroke-color) svg path {
  fill: #d2edff !important;
}

button.text-primary-50:hover .Icon--primary-50.change-fill-color svg path {
  fill: rgb(205.35, 235.14, 255) !important;
}
button.text-primary-50:hover .Icon--primary-50.change-stroke-color svg path {
  stroke: rgb(205.35, 235.14, 255) !important;
}

button.text-primary-50:active .Icon--primary-50.change-fill-color svg path {
  fill: rgb(165.75, 219.3, 255) !important;
}
button.text-primary-50:active .Icon--primary-50.change-stroke-color svg path {
  stroke: rgb(165.75, 219.3, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-50:not(.change-stroke-color) svg path {
  fill: rgb(205.35, 235.14, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-50:not(.change-stroke-color) svg path {
  fill: rgb(205.35, 235.14, 255) !important;
}

button.text-primary-100:hover .Icon--primary-100.change-fill-color svg path {
  fill: rgb(191.585625, 228.406875, 252.954375) !important;
}
button.text-primary-100:hover .Icon--primary-100.change-stroke-color svg path {
  stroke: rgb(191.585625, 228.406875, 252.954375) !important;
}

button.text-primary-100:active .Icon--primary-100.change-fill-color svg path {
  fill: rgb(154.540625, 212.871875, 251.759375) !important;
}
button.text-primary-100:active .Icon--primary-100.change-stroke-color svg path {
  stroke: rgb(154.540625, 212.871875, 251.759375) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-100:not(.change-stroke-color) svg path {
  fill: rgb(191.585625, 228.406875, 252.954375) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-100:not(.change-stroke-color) svg path {
  fill: rgb(191.585625, 228.406875, 252.954375) !important;
}

button.text-primary-200:hover .Icon--primary-200.change-fill-color svg path {
  fill: rgb(154.7028169014, 219.1795774648, 253.5671830986) !important;
}
button.text-primary-200:hover .Icon--primary-200.change-stroke-color svg path {
  stroke: rgb(154.7028169014, 219.1795774648, 253.5671830986) !important;
}

button.text-primary-200:active .Icon--primary-200.change-fill-color svg path {
  fill: rgb(120.0774647887, 206.8133802817, 253.0725352113) !important;
}
button.text-primary-200:active .Icon--primary-200.change-stroke-color svg path {
  stroke: rgb(120.0774647887, 206.8133802817, 253.0725352113) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-200:not(.change-stroke-color) svg path {
  fill: rgb(154.7028169014, 219.1795774648, 253.5671830986) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-200:not(.change-stroke-color) svg path {
  fill: rgb(154.7028169014, 219.1795774648, 253.5671830986) !important;
}

button.text-primary-300:hover .Icon--primary-300.change-fill-color svg path {
  fill: rgb(98.0068421053, 203.4678947368, 252.6031578947) !important;
}
button.text-primary-300:hover .Icon--primary-300.change-stroke-color svg path {
  stroke: rgb(98.0068421053, 203.4678947368, 252.6031578947) !important;
}

button.text-primary-300:active .Icon--primary-300.change-fill-color svg path {
  fill: rgb(68.3003759398, 193.7169172932, 252.1496240602) !important;
}
button.text-primary-300:active .Icon--primary-300.change-stroke-color svg path {
  stroke: rgb(68.3003759398, 193.7169172932, 252.1496240602) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-300:not(.change-stroke-color) svg path {
  fill: rgb(98.0068421053, 203.4678947368, 252.6031578947) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-300:not(.change-stroke-color) svg path {
  fill: rgb(98.0068421053, 203.4678947368, 252.6031578947) !important;
}

button.text-primary-400:hover .Icon--primary-400.change-fill-color svg path {
  fill: rgb(33.2365048544, 184.3887378641, 249.4834951456) !important;
}
button.text-primary-400:hover .Icon--primary-400.change-stroke-color svg path {
  stroke: rgb(33.2365048544, 184.3887378641, 249.4834951456) !important;
}

button.text-primary-400:active .Icon--primary-400.change-fill-color svg path {
  fill: rgb(9.5067961165, 176.8330097087, 248.8932038835) !important;
}
button.text-primary-400:active .Icon--primary-400.change-stroke-color svg path {
  stroke: rgb(9.5067961165, 176.8330097087, 248.8932038835) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-400:not(.change-stroke-color) svg path {
  fill: rgb(33.2365048544, 184.3887378641, 249.4834951456) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-400:not(.change-stroke-color) svg path {
  fill: rgb(33.2365048544, 184.3887378641, 249.4834951456) !important;
}

button.text-primary-500:hover .Icon--primary-500.change-fill-color svg path {
  fill: rgb(10.23, 153.45, 219.48) !important;
}
button.text-primary-500:hover .Icon--primary-500.change-stroke-color svg path {
  stroke: rgb(10.23, 153.45, 219.48) !important;
}

button.text-primary-500:active .Icon--primary-500.change-fill-color svg path {
  fill: rgb(9.35, 140.25, 200.6) !important;
}
button.text-primary-500:active .Icon--primary-500.change-stroke-color svg path {
  stroke: rgb(9.35, 140.25, 200.6) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-500:not(.change-stroke-color) svg path {
  fill: rgb(10.23, 153.45, 219.48) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-500:not(.change-stroke-color) svg path {
  fill: rgb(10.23, 153.45, 219.48) !important;
}

button.text-primary-600:hover .Icon--primary-600.change-fill-color svg path {
  fill: rgb(0, 124.62, 186.93) !important;
}
button.text-primary-600:hover .Icon--primary-600.change-stroke-color svg path {
  stroke: rgb(0, 124.62, 186.93) !important;
}

button.text-primary-600:active .Icon--primary-600.change-fill-color svg path {
  fill: rgb(0, 113.9, 170.85) !important;
}
button.text-primary-600:active .Icon--primary-600.change-stroke-color svg path {
  stroke: rgb(0, 113.9, 170.85) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-600:not(.change-stroke-color) svg path {
  fill: rgb(0, 124.62, 186.93) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-600:not(.change-stroke-color) svg path {
  fill: rgb(0, 124.62, 186.93) !important;
}

button.text-primary-700:hover .Icon--primary-700.change-fill-color svg path {
  fill: rgb(1.86, 98.58, 150.66) !important;
}
button.text-primary-700:hover .Icon--primary-700.change-stroke-color svg path {
  stroke: rgb(1.86, 98.58, 150.66) !important;
}

button.text-primary-700:active .Icon--primary-700.change-fill-color svg path {
  fill: rgb(1.7, 90.1, 137.7) !important;
}
button.text-primary-700:active .Icon--primary-700.change-stroke-color svg path {
  stroke: rgb(1.7, 90.1, 137.7) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-700:not(.change-stroke-color) svg path {
  fill: rgb(1.86, 98.58, 150.66) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-700:not(.change-stroke-color) svg path {
  fill: rgb(1.86, 98.58, 150.66) !important;
}

button.text-primary-800:hover .Icon--primary-800.change-fill-color svg path {
  fill: rgb(5.58, 82.77, 124.62) !important;
}
button.text-primary-800:hover .Icon--primary-800.change-stroke-color svg path {
  stroke: rgb(5.58, 82.77, 124.62) !important;
}

button.text-primary-800:active .Icon--primary-800.change-fill-color svg path {
  fill: rgb(5.1, 75.65, 113.9) !important;
}
button.text-primary-800:active .Icon--primary-800.change-stroke-color svg path {
  stroke: rgb(5.1, 75.65, 113.9) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-800:not(.change-stroke-color) svg path {
  fill: rgb(5.58, 82.77, 124.62) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-800:not(.change-stroke-color) svg path {
  fill: rgb(5.58, 82.77, 124.62) !important;
}

button.text-primary-900:hover .Icon--primary-900.change-fill-color svg path {
  fill: rgb(10.23, 68.82, 103.23) !important;
}
button.text-primary-900:hover .Icon--primary-900.change-stroke-color svg path {
  stroke: rgb(10.23, 68.82, 103.23) !important;
}

button.text-primary-900:active .Icon--primary-900.change-fill-color svg path {
  fill: rgb(9.35, 62.9, 94.35) !important;
}
button.text-primary-900:active .Icon--primary-900.change-stroke-color svg path {
  stroke: rgb(9.35, 62.9, 94.35) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-900:not(.change-stroke-color) svg path {
  fill: rgb(10.23, 68.82, 103.23) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-900:not(.change-stroke-color) svg path {
  fill: rgb(10.23, 68.82, 103.23) !important;
}

button.text-primary-950:hover .Icon--primary-950.change-fill-color svg path {
  fill: rgb(5.58, 40.92, 60.45) !important;
}
button.text-primary-950:hover .Icon--primary-950.change-stroke-color svg path {
  stroke: rgb(5.58, 40.92, 60.45) !important;
}

button.text-primary-950:active .Icon--primary-950.change-fill-color svg path {
  fill: rgb(5.1, 37.4, 55.25) !important;
}
button.text-primary-950:active .Icon--primary-950.change-stroke-color svg path {
  stroke: rgb(5.1, 37.4, 55.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-950:not(.change-stroke-color) svg path {
  fill: rgb(5.58, 40.92, 60.45) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-950:not(.change-stroke-color) svg path {
  fill: rgb(5.58, 40.92, 60.45) !important;
}

button.text-danger-25:hover .Icon--danger-25.change-fill-color svg path {
  fill: rgb(255, 222.72, 214.65) !important;
}
button.text-danger-25:hover .Icon--danger-25.change-stroke-color svg path {
  stroke: rgb(255, 222.72, 214.65) !important;
}

button.text-danger-25:active .Icon--danger-25.change-fill-color svg path {
  fill: rgb(255, 190.4, 174.25) !important;
}
button.text-danger-25:active .Icon--danger-25.change-stroke-color svg path {
  stroke: rgb(255, 190.4, 174.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-25:not(.change-stroke-color) svg path {
  fill: rgb(255, 222.72, 214.65) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-25:not(.change-stroke-color) svg path {
  fill: rgb(255, 222.72, 214.65) !important;
}

button.text-danger-50:hover .Icon--danger-50.change-fill-color svg path {
  fill: rgb(251.52, 213.24, 209.76) !important;
}
button.text-danger-50:hover .Icon--danger-50.change-stroke-color svg path {
  stroke: rgb(251.52, 213.24, 209.76) !important;
}

button.text-danger-50:active .Icon--danger-50.change-fill-color svg path {
  fill: rgb(248.6857142857, 179.2285714286, 172.9142857143) !important;
}
button.text-danger-50:active .Icon--danger-50.change-stroke-color svg path {
  stroke: rgb(248.6857142857, 179.2285714286, 172.9142857143) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-50:not(.change-stroke-color) svg path {
  fill: rgb(251.52, 213.24, 209.76) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-50:not(.change-stroke-color) svg path {
  fill: rgb(251.52, 213.24, 209.76) !important;
}

button.text-danger-100:hover .Icon--danger-100.change-fill-color svg path {
  fill: rgb(252.88, 197.76, 193.52) !important;
}
button.text-danger-100:hover .Icon--danger-100.change-stroke-color svg path {
  stroke: rgb(252.88, 197.76, 193.52) !important;
}

button.text-danger-100:active .Icon--danger-100.change-fill-color svg path {
  fill: rgb(251.6, 163.2, 156.4) !important;
}
button.text-danger-100:active .Icon--danger-100.change-stroke-color svg path {
  stroke: rgb(251.6, 163.2, 156.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-100:not(.change-stroke-color) svg path {
  fill: rgb(252.88, 197.76, 193.52) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-100:not(.change-stroke-color) svg path {
  fill: rgb(252.88, 197.76, 193.52) !important;
}

button.text-danger-200:hover .Icon--danger-200.change-fill-color svg path {
  fill: rgb(253.4088888889, 175.4444444444, 170.6711111111) !important;
}
button.text-danger-200:hover .Icon--danger-200.change-stroke-color svg path {
  stroke: rgb(253.4088888889, 175.4444444444, 170.6711111111) !important;
}

button.text-danger-200:active .Icon--danger-200.change-fill-color svg path {
  fill: rgb(252.7333333333, 141.6666666667, 134.8666666667) !important;
}
button.text-danger-200:active .Icon--danger-200.change-stroke-color svg path {
  stroke: rgb(252.7333333333, 141.6666666667, 134.8666666667) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-200:not(.change-stroke-color) svg path {
  fill: rgb(253.4088888889, 175.4444444444, 170.6711111111) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-200:not(.change-stroke-color) svg path {
  fill: rgb(253.4088888889, 175.4444444444, 170.6711111111) !important;
}

button.text-danger-300:hover .Icon--danger-300.change-fill-color svg path {
  fill: rgb(252.44, 135.96, 127) !important;
}
button.text-danger-300:hover .Icon--danger-300.change-stroke-color svg path {
  stroke: rgb(252.44, 135.96, 127) !important;
}

button.text-danger-300:active .Icon--danger-300.change-fill-color svg path {
  fill: rgb(251.8, 106.2, 95) !important;
}
button.text-danger-300:active .Icon--danger-300.change-stroke-color svg path {
  stroke: rgb(251.8, 106.2, 95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-300:not(.change-stroke-color) svg path {
  fill: rgb(252.44, 135.96, 127) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-300:not(.change-stroke-color) svg path {
  fill: rgb(252.44, 135.96, 127) !important;
}

button.text-danger-400:hover .Icon--danger-400.change-fill-color svg path {
  fill: rgb(248.0728301887, 89.9024528302, 78.3571698113) !important;
}
button.text-danger-400:hover .Icon--danger-400.change-stroke-color svg path {
  stroke: rgb(248.0728301887, 89.9024528302, 78.3571698113) !important;
}

button.text-danger-400:active .Icon--danger-400.change-fill-color svg path {
  fill: rgb(247.0132075472, 64.6481132075, 51.3367924528) !important;
}
button.text-danger-400:active .Icon--danger-400.change-stroke-color svg path {
  stroke: rgb(247.0132075472, 64.6481132075, 51.3367924528) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-400:not(.change-stroke-color) svg path {
  fill: rgb(248.0728301887, 89.9024528302, 78.3571698113) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-400:not(.change-stroke-color) svg path {
  fill: rgb(248.0728301887, 89.9024528302, 78.3571698113) !important;
}

button.text-danger-500:hover .Icon--danger-500.change-fill-color svg path {
  fill: rgb(238.5476635514, 49.8942056075, 36.7323364486) !important;
}
button.text-danger-500:hover .Icon--danger-500.change-stroke-color svg path {
  stroke: rgb(238.5476635514, 49.8942056075, 36.7323364486) !important;
}

button.text-danger-500:active .Icon--danger-500.change-fill-color svg path {
  fill: rgb(233.9644859813, 31.7439252336, 17.6355140187) !important;
}
button.text-danger-500:active .Icon--danger-500.change-stroke-color svg path {
  stroke: rgb(233.9644859813, 31.7439252336, 17.6355140187) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-500:not(.change-stroke-color) svg path {
  fill: rgb(238.5476635514, 49.8942056075, 36.7323364486) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-500:not(.change-stroke-color) svg path {
  fill: rgb(238.5476635514, 49.8942056075, 36.7323364486) !important;
}

button.text-danger-600:hover .Icon--danger-600.change-fill-color svg path {
  fill: rgb(201.81, 41.85, 29.76) !important;
}
button.text-danger-600:hover .Icon--danger-600.change-stroke-color svg path {
  stroke: rgb(201.81, 41.85, 29.76) !important;
}

button.text-danger-600:active .Icon--danger-600.change-fill-color svg path {
  fill: rgb(184.45, 38.25, 27.2) !important;
}
button.text-danger-600:active .Icon--danger-600.change-stroke-color svg path {
  stroke: rgb(184.45, 38.25, 27.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-600:not(.change-stroke-color) svg path {
  fill: rgb(201.81, 41.85, 29.76) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-600:not(.change-stroke-color) svg path {
  fill: rgb(201.81, 41.85, 29.76) !important;
}

button.text-danger-700:hover .Icon--danger-700.change-fill-color svg path {
  fill: rgb(167.4, 32.55, 22.32) !important;
}
button.text-danger-700:hover .Icon--danger-700.change-stroke-color svg path {
  stroke: rgb(167.4, 32.55, 22.32) !important;
}

button.text-danger-700:active .Icon--danger-700.change-fill-color svg path {
  fill: rgb(153, 29.75, 20.4) !important;
}
button.text-danger-700:active .Icon--danger-700.change-stroke-color svg path {
  stroke: rgb(153, 29.75, 20.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-700:not(.change-stroke-color) svg path {
  fill: rgb(167.4, 32.55, 22.32) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-700:not(.change-stroke-color) svg path {
  fill: rgb(167.4, 32.55, 22.32) !important;
}

button.text-danger-800:hover .Icon--danger-800.change-fill-color svg path {
  fill: rgb(134.85, 29.76, 22.32) !important;
}
button.text-danger-800:hover .Icon--danger-800.change-stroke-color svg path {
  stroke: rgb(134.85, 29.76, 22.32) !important;
}

button.text-danger-800:active .Icon--danger-800.change-fill-color svg path {
  fill: rgb(123.25, 27.2, 20.4) !important;
}
button.text-danger-800:active .Icon--danger-800.change-stroke-color svg path {
  stroke: rgb(123.25, 27.2, 20.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-800:not(.change-stroke-color) svg path {
  fill: rgb(134.85, 29.76, 22.32) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-800:not(.change-stroke-color) svg path {
  fill: rgb(134.85, 29.76, 22.32) !important;
}

button.text-danger-900:hover .Icon--danger-900.change-fill-color svg path {
  fill: rgb(113.46, 36.27, 24.18) !important;
}
button.text-danger-900:hover .Icon--danger-900.change-stroke-color svg path {
  stroke: rgb(113.46, 36.27, 24.18) !important;
}

button.text-danger-900:active .Icon--danger-900.change-fill-color svg path {
  fill: rgb(103.7, 33.15, 22.1) !important;
}
button.text-danger-900:active .Icon--danger-900.change-stroke-color svg path {
  stroke: rgb(103.7, 33.15, 22.1) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-900:not(.change-stroke-color) svg path {
  fill: rgb(113.46, 36.27, 24.18) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-900:not(.change-stroke-color) svg path {
  fill: rgb(113.46, 36.27, 24.18) !important;
}

button.text-danger-950:hover .Icon--danger-950.change-fill-color svg path {
  fill: rgb(79.05, 20.46, 11.16) !important;
}
button.text-danger-950:hover .Icon--danger-950.change-stroke-color svg path {
  stroke: rgb(79.05, 20.46, 11.16) !important;
}

button.text-danger-950:active .Icon--danger-950.change-fill-color svg path {
  fill: rgb(72.25, 18.7, 10.2) !important;
}
button.text-danger-950:active .Icon--danger-950.change-stroke-color svg path {
  stroke: rgb(72.25, 18.7, 10.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--danger-950:not(.change-stroke-color) svg path {
  fill: rgb(79.05, 20.46, 11.16) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--danger-950:not(.change-stroke-color) svg path {
  fill: rgb(79.05, 20.46, 11.16) !important;
}

button.text-warning-25:hover .Icon--warning-25.change-fill-color svg path {
  fill: rgb(255, 241.5, 210) !important;
}
button.text-warning-25:hover .Icon--warning-25.change-stroke-color svg path {
  stroke: rgb(255, 241.5, 210) !important;
}

button.text-warning-25:active .Icon--warning-25.change-fill-color svg path {
  fill: rgb(255, 229.5, 170) !important;
}
button.text-warning-25:active .Icon--warning-25.change-stroke-color svg path {
  stroke: rgb(255, 229.5, 170) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-25:not(.change-stroke-color) svg path {
  fill: rgb(255, 241.5, 210) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-25:not(.change-stroke-color) svg path {
  fill: rgb(255, 241.5, 210) !important;
}

button.text-warning-50:hover .Icon--warning-50.change-fill-color svg path {
  fill: rgb(255, 241.425, 200.7) !important;
}
button.text-warning-50:hover .Icon--warning-50.change-stroke-color svg path {
  stroke: rgb(255, 241.425, 200.7) !important;
}

button.text-warning-50:active .Icon--warning-50.change-fill-color svg path {
  fill: rgb(255, 231.625, 161.5) !important;
}
button.text-warning-50:active .Icon--warning-50.change-stroke-color svg path {
  stroke: rgb(255, 231.625, 161.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-50:not(.change-stroke-color) svg path {
  fill: rgb(255, 241.425, 200.7) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-50:not(.change-stroke-color) svg path {
  fill: rgb(255, 241.425, 200.7) !important;
}

button.text-warning-100:hover .Icon--warning-100.change-fill-color svg path {
  fill: rgb(253.4436842105, 231.6552631579, 167.8463157895) !important;
}
button.text-warning-100:hover .Icon--warning-100.change-stroke-color svg path {
  stroke: rgb(253.4436842105, 231.6552631579, 167.8463157895) !important;
}

button.text-warning-100:active .Icon--warning-100.change-fill-color svg path {
  fill: rgb(252.8078947368, 222.1184210526, 132.2421052632) !important;
}
button.text-warning-100:active .Icon--warning-100.change-stroke-color svg path {
  stroke: rgb(252.8078947368, 222.1184210526, 132.2421052632) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-100:not(.change-stroke-color) svg path {
  fill: rgb(253.4436842105, 231.6552631579, 167.8463157895) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-100:not(.change-stroke-color) svg path {
  fill: rgb(253.4436842105, 231.6552631579, 167.8463157895) !important;
}

button.text-warning-200:hover .Icon--warning-200.change-fill-color svg path {
  fill: rgb(253.77, 215.64, 109.86) !important;
}
button.text-warning-200:hover .Icon--warning-200.change-stroke-color svg path {
  stroke: rgb(253.77, 215.64, 109.86) !important;
}

button.text-warning-200:active .Icon--warning-200.change-fill-color svg path {
  fill: rgb(253.5071428571, 207.2285714286, 78.8428571429) !important;
}
button.text-warning-200:active .Icon--warning-200.change-stroke-color svg path {
  stroke: rgb(253.5071428571, 207.2285714286, 78.8428571429) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-200:not(.change-stroke-color) svg path {
  fill: rgb(253.77, 215.64, 109.86) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-200:not(.change-stroke-color) svg path {
  fill: rgb(253.77, 215.64, 109.86) !important;
}

button.text-warning-300:hover .Icon--warning-300.change-fill-color svg path {
  fill: rgb(253.8727624309, 193.0019337017, 52.0972375691) !important;
}
button.text-warning-300:hover .Icon--warning-300.change-stroke-color svg path {
  stroke: rgb(253.8727624309, 193.0019337017, 52.0972375691) !important;
}

button.text-warning-300:active .Icon--warning-300.change-fill-color svg path {
  fill: rgb(253.7273480663, 185.0041436464, 25.9226519337) !important;
}
button.text-warning-300:active .Icon--warning-300.change-stroke-color svg path {
  stroke: rgb(253.7273480663, 185.0041436464, 25.9226519337) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-300:not(.change-stroke-color) svg path {
  fill: rgb(253.8727624309, 193.0019337017, 52.0972375691) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-300:not(.change-stroke-color) svg path {
  fill: rgb(253.8727624309, 193.0019337017, 52.0972375691) !important;
}

button.text-warning-400:hover .Icon--warning-400.change-fill-color svg path {
  fill: rgb(252.8198206278, 168.8829147982, 14.0901793722) !important;
}
button.text-warning-400:hover .Icon--warning-400.change-stroke-color svg path {
  stroke: rgb(252.8198206278, 168.8829147982, 14.0901793722) !important;
}

button.text-warning-400:active .Icon--warning-400.change-fill-color svg path {
  fill: rgb(241.7621076233, 157.5282511211, 2.1878923767) !important;
}
button.text-warning-400:active .Icon--warning-400.change-stroke-color svg path {
  stroke: rgb(241.7621076233, 157.5282511211, 2.1878923767) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-400:not(.change-stroke-color) svg path {
  fill: rgb(252.8198206278, 168.8829147982, 14.0901793722) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-400:not(.change-stroke-color) svg path {
  fill: rgb(252.8198206278, 168.8829147982, 14.0901793722) !important;
}

button.text-warning-500:hover .Icon--warning-500.change-fill-color svg path {
  fill: rgb(230.5814173228, 134.0371653543, 7.4985826772) !important;
}
button.text-warning-500:hover .Icon--warning-500.change-stroke-color svg path {
  stroke: rgb(230.5814173228, 134.0371653543, 7.4985826772) !important;
}

button.text-warning-500:active .Icon--warning-500.change-fill-color svg path {
  fill: rgb(210.7464566929, 122.5070866142, 6.8535433071) !important;
}
button.text-warning-500:active .Icon--warning-500.change-stroke-color svg path {
  stroke: rgb(210.7464566929, 122.5070866142, 6.8535433071) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-500:not(.change-stroke-color) svg path {
  fill: rgb(230.5814173228, 134.0371653543, 7.4985826772) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-500:not(.change-stroke-color) svg path {
  fill: rgb(230.5814173228, 134.0371653543, 7.4985826772) !important;
}

button.text-warning-600:hover .Icon--warning-600.change-fill-color svg path {
  fill: rgb(204.6, 96.72, 2.79) !important;
}
button.text-warning-600:hover .Icon--warning-600.change-stroke-color svg path {
  stroke: rgb(204.6, 96.72, 2.79) !important;
}

button.text-warning-600:active .Icon--warning-600.change-fill-color svg path {
  fill: rgb(187, 88.4, 2.55) !important;
}
button.text-warning-600:active .Icon--warning-600.change-stroke-color svg path {
  stroke: rgb(187, 88.4, 2.55) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-600:not(.change-stroke-color) svg path {
  fill: rgb(204.6, 96.72, 2.79) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-600:not(.change-stroke-color) svg path {
  fill: rgb(204.6, 96.72, 2.79) !important;
}

button.text-warning-700:hover .Icon--warning-700.change-fill-color svg path {
  fill: rgb(168.33, 66.03, 7.44) !important;
}
button.text-warning-700:hover .Icon--warning-700.change-stroke-color svg path {
  stroke: rgb(168.33, 66.03, 7.44) !important;
}

button.text-warning-700:active .Icon--warning-700.change-fill-color svg path {
  fill: rgb(153.85, 60.35, 6.8) !important;
}
button.text-warning-700:active .Icon--warning-700.change-stroke-color svg path {
  stroke: rgb(153.85, 60.35, 6.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-700:not(.change-stroke-color) svg path {
  fill: rgb(168.33, 66.03, 7.44) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-700:not(.change-stroke-color) svg path {
  fill: rgb(168.33, 66.03, 7.44) !important;
}

button.text-warning-800:hover .Icon--warning-800.change-fill-color svg path {
  fill: rgb(136.71, 51.15, 12.09) !important;
}
button.text-warning-800:hover .Icon--warning-800.change-stroke-color svg path {
  stroke: rgb(136.71, 51.15, 12.09) !important;
}

button.text-warning-800:active .Icon--warning-800.change-fill-color svg path {
  fill: rgb(124.95, 46.75, 11.05) !important;
}
button.text-warning-800:active .Icon--warning-800.change-stroke-color svg path {
  stroke: rgb(124.95, 46.75, 11.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-800:not(.change-stroke-color) svg path {
  fill: rgb(136.71, 51.15, 12.09) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-800:not(.change-stroke-color) svg path {
  fill: rgb(136.71, 51.15, 12.09) !important;
}

button.text-warning-900:hover .Icon--warning-900.change-fill-color svg path {
  fill: rgb(113.46, 42.78, 13.02) !important;
}
button.text-warning-900:hover .Icon--warning-900.change-stroke-color svg path {
  stroke: rgb(113.46, 42.78, 13.02) !important;
}

button.text-warning-900:active .Icon--warning-900.change-fill-color svg path {
  fill: rgb(103.7, 39.1, 11.9) !important;
}
button.text-warning-900:active .Icon--warning-900.change-stroke-color svg path {
  stroke: rgb(103.7, 39.1, 11.9) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-900:not(.change-stroke-color) svg path {
  fill: rgb(113.46, 42.78, 13.02) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-900:not(.change-stroke-color) svg path {
  fill: rgb(113.46, 42.78, 13.02) !important;
}

button.text-warning-950:hover .Icon--warning-950.change-fill-color svg path {
  fill: rgb(72.54, 26.97, 8.37) !important;
}
button.text-warning-950:hover .Icon--warning-950.change-stroke-color svg path {
  stroke: rgb(72.54, 26.97, 8.37) !important;
}

button.text-warning-950:active .Icon--warning-950.change-fill-color svg path {
  fill: rgb(66.3, 24.65, 7.65) !important;
}
button.text-warning-950:active .Icon--warning-950.change-stroke-color svg path {
  stroke: rgb(66.3, 24.65, 7.65) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--warning-950:not(.change-stroke-color) svg path {
  fill: rgb(72.54, 26.97, 8.37) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--warning-950:not(.change-stroke-color) svg path {
  fill: rgb(72.54, 26.97, 8.37) !important;
}

button.text-success-25:hover .Icon--success-25.change-fill-color svg path {
  fill: rgb(214.5, 250.5, 228) !important;
}
button.text-success-25:hover .Icon--success-25.change-stroke-color svg path {
  stroke: rgb(214.5, 250.5, 228) !important;
}

button.text-success-25:active .Icon--success-25.change-fill-color svg path {
  fill: rgb(178.5, 246.5, 204) !important;
}
button.text-success-25:active .Icon--success-25.change-stroke-color svg path {
  stroke: rgb(178.5, 246.5, 204) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-25:not(.change-stroke-color) svg path {
  fill: rgb(214.5, 250.5, 228) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-25:not(.change-stroke-color) svg path {
  fill: rgb(214.5, 250.5, 228) !important;
}

button.text-success-50:hover .Icon--success-50.change-fill-color svg path {
  fill: rgb(207.66, 247.11, 220.81) !important;
}
button.text-success-50:hover .Icon--success-50.change-stroke-color svg path {
  stroke: rgb(207.66, 247.11, 220.81) !important;
}

button.text-success-50:active .Icon--success-50.change-fill-color svg path {
  fill: rgb(174.1285714286, 241.5214285714, 196.5928571429) !important;
}
button.text-success-50:active .Icon--success-50.change-stroke-color svg path {
  stroke: rgb(174.1285714286, 241.5214285714, 196.5928571429) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-50:not(.change-stroke-color) svg path {
  fill: rgb(207.66, 247.11, 220.81) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-50:not(.change-stroke-color) svg path {
  fill: rgb(207.66, 247.11, 220.81) !important;
}

button.text-success-100:hover .Icon--success-100.change-fill-color svg path {
  fill: rgb(183.28, 243.59, 202.84) !important;
}
button.text-success-100:hover .Icon--success-100.change-stroke-color svg path {
  stroke: rgb(183.28, 243.59, 202.84) !important;
}

button.text-success-100:active .Icon--success-100.change-fill-color svg path {
  fill: rgb(151.6, 238.55, 179.8) !important;
}
button.text-success-100:active .Icon--success-100.change-stroke-color svg path {
  stroke: rgb(151.6, 238.55, 179.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-100:not(.change-stroke-color) svg path {
  fill: rgb(183.28, 243.59, 202.84) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-100:not(.change-stroke-color) svg path {
  fill: rgb(183.28, 243.59, 202.84) !important;
}

button.text-success-200:hover .Icon--success-200.change-fill-color svg path {
  fill: rgb(145.605, 235.695, 179.067) !important;
}
button.text-success-200:hover .Icon--success-200.change-stroke-color svg path {
  stroke: rgb(145.605, 235.695, 179.067) !important;
}

button.text-success-200:active .Icon--success-200.change-fill-color svg path {
  fill: rgb(117.725, 230.775, 159.715) !important;
}
button.text-success-200:active .Icon--success-200.change-stroke-color svg path {
  stroke: rgb(117.725, 230.775, 159.715) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-200:not(.change-stroke-color) svg path {
  fill: rgb(145.605, 235.695, 179.067) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-200:not(.change-stroke-color) svg path {
  fill: rgb(145.605, 235.695, 179.067) !important;
}

button.text-success-300:hover .Icon--success-300.change-fill-color svg path {
  fill: rgb(95.226035503, 221.903964497, 150.0056804734) !important;
}
button.text-success-300:hover .Icon--success-300.change-stroke-color svg path {
  stroke: rgb(95.226035503, 221.903964497, 150.0056804734) !important;
}

button.text-success-300:active .Icon--success-300.change-fill-color svg path {
  fill: rgb(72.6272189349, 217.2227810651, 135.1550295858) !important;
}
button.text-success-300:active .Icon--success-300.change-stroke-color svg path {
  stroke: rgb(72.6272189349, 217.2227810651, 135.1550295858) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-300:not(.change-stroke-color) svg path {
  fill: rgb(95.226035503, 221.903964497, 150.0056804734) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-300:not(.change-stroke-color) svg path {
  fill: rgb(95.226035503, 221.903964497, 150.0056804734) !important;
}

button.text-success-400:hover .Icon--success-400.change-fill-color svg path {
  fill: rgb(51.4926315789, 193.0973684211, 117.8389068826) !important;
}
button.text-success-400:hover .Icon--success-400.change-stroke-color svg path {
  stroke: rgb(51.4926315789, 193.0973684211, 117.8389068826) !important;
}

button.text-success-400:active .Icon--success-400.change-fill-color svg path {
  fill: rgb(47.0631578947, 176.4868421053, 107.7022267206) !important;
}
button.text-success-400:active .Icon--success-400.change-stroke-color svg path {
  stroke: rgb(47.0631578947, 176.4868421053, 107.7022267206) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-400:not(.change-stroke-color) svg path {
  fill: rgb(51.4926315789, 193.0973684211, 117.8389068826) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-400:not(.change-stroke-color) svg path {
  fill: rgb(51.4926315789, 193.0973684211, 117.8389068826) !important;
}

button.text-success-500:hover .Icon--success-500.change-fill-color svg path {
  fill: rgb(20.46, 166.47, 93) !important;
}
button.text-success-500:hover .Icon--success-500.change-stroke-color svg path {
  stroke: rgb(20.46, 166.47, 93) !important;
}

button.text-success-500:active .Icon--success-500.change-fill-color svg path {
  fill: rgb(18.7, 152.15, 85) !important;
}
button.text-success-500:active .Icon--success-500.change-stroke-color svg path {
  stroke: rgb(18.7, 152.15, 85) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-500:not(.change-stroke-color) svg path {
  fill: rgb(20.46, 166.47, 93) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-500:not(.change-stroke-color) svg path {
  fill: rgb(20.46, 166.47, 93) !important;
}

button.text-success-600:hover .Icon--success-600.change-fill-color svg path {
  fill: rgb(8.37, 135.78, 74.4) !important;
}
button.text-success-600:hover .Icon--success-600.change-stroke-color svg path {
  stroke: rgb(8.37, 135.78, 74.4) !important;
}

button.text-success-600:active .Icon--success-600.change-fill-color svg path {
  fill: rgb(7.65, 124.1, 68) !important;
}
button.text-success-600:active .Icon--success-600.change-stroke-color svg path {
  stroke: rgb(7.65, 124.1, 68) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-600:not(.change-stroke-color) svg path {
  fill: rgb(8.37, 135.78, 74.4) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-600:not(.change-stroke-color) svg path {
  fill: rgb(8.37, 135.78, 74.4) !important;
}

button.text-success-700:hover .Icon--success-700.change-fill-color svg path {
  fill: rgb(7.44, 107.88, 62.31) !important;
}
button.text-success-700:hover .Icon--success-700.change-stroke-color svg path {
  stroke: rgb(7.44, 107.88, 62.31) !important;
}

button.text-success-700:active .Icon--success-700.change-fill-color svg path {
  fill: rgb(6.8, 98.6, 56.95) !important;
}
button.text-success-700:active .Icon--success-700.change-stroke-color svg path {
  stroke: rgb(6.8, 98.6, 56.95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-700:not(.change-stroke-color) svg path {
  fill: rgb(7.44, 107.88, 62.31) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-700:not(.change-stroke-color) svg path {
  fill: rgb(7.44, 107.88, 62.31) !important;
}

button.text-success-800:hover .Icon--success-800.change-fill-color svg path {
  fill: rgb(8.37, 85.56, 51.15) !important;
}
button.text-success-800:hover .Icon--success-800.change-stroke-color svg path {
  stroke: rgb(8.37, 85.56, 51.15) !important;
}

button.text-success-800:active .Icon--success-800.change-fill-color svg path {
  fill: rgb(7.65, 78.2, 46.75) !important;
}
button.text-success-800:active .Icon--success-800.change-stroke-color svg path {
  stroke: rgb(7.65, 78.2, 46.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-800:not(.change-stroke-color) svg path {
  fill: rgb(8.37, 85.56, 51.15) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-800:not(.change-stroke-color) svg path {
  fill: rgb(8.37, 85.56, 51.15) !important;
}

button.text-success-900:hover .Icon--success-900.change-fill-color svg path {
  fill: rgb(7.44, 70.68, 42.78) !important;
}
button.text-success-900:hover .Icon--success-900.change-stroke-color svg path {
  stroke: rgb(7.44, 70.68, 42.78) !important;
}

button.text-success-900:active .Icon--success-900.change-fill-color svg path {
  fill: rgb(6.8, 64.6, 39.1) !important;
}
button.text-success-900:active .Icon--success-900.change-stroke-color svg path {
  stroke: rgb(6.8, 64.6, 39.1) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-900:not(.change-stroke-color) svg path {
  fill: rgb(7.44, 70.68, 42.78) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-900:not(.change-stroke-color) svg path {
  fill: rgb(7.44, 70.68, 42.78) !important;
}

button.text-success-950:hover .Icon--success-950.change-fill-color svg path {
  fill: rgb(4.65, 42.78, 26.04) !important;
}
button.text-success-950:hover .Icon--success-950.change-stroke-color svg path {
  stroke: rgb(4.65, 42.78, 26.04) !important;
}

button.text-success-950:active .Icon--success-950.change-fill-color svg path {
  fill: rgb(4.25, 39.1, 23.8) !important;
}
button.text-success-950:active .Icon--success-950.change-stroke-color svg path {
  stroke: rgb(4.25, 39.1, 23.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--success-950:not(.change-stroke-color) svg path {
  fill: rgb(4.65, 42.78, 26.04) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--success-950:not(.change-stroke-color) svg path {
  fill: rgb(4.65, 42.78, 26.04) !important;
}

button.text-moss-25:hover .Icon--moss-25.change-fill-color svg path {
  fill: rgb(232.5, 246, 219) !important;
}
button.text-moss-25:hover .Icon--moss-25.change-stroke-color svg path {
  stroke: rgb(232.5, 246, 219) !important;
}

button.text-moss-25:active .Icon--moss-25.change-fill-color svg path {
  fill: rgb(212.5, 238, 187) !important;
}
button.text-moss-25:active .Icon--moss-25.change-stroke-color svg path {
  stroke: rgb(212.5, 238, 187) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-25:not(.change-stroke-color) svg path {
  fill: rgb(232.5, 246, 219) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-25:not(.change-stroke-color) svg path {
  fill: rgb(232.5, 246, 219) !important;
}

button.text-moss-50:hover .Icon--moss-50.change-fill-color svg path {
  fill: rgb(228.7, 244.48, 210.29) !important;
}
button.text-moss-50:hover .Icon--moss-50.change-stroke-color svg path {
  stroke: rgb(228.7, 244.48, 210.29) !important;
}

button.text-moss-50:active .Icon--moss-50.change-fill-color svg path {
  fill: rgb(210.0714285714, 237.0285714286, 178.6214285714) !important;
}
button.text-moss-50:active .Icon--moss-50.change-stroke-color svg path {
  stroke: rgb(210.0714285714, 237.0285714286, 178.6214285714) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-50:not(.change-stroke-color) svg path {
  fill: rgb(228.7, 244.48, 210.29) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-50:not(.change-stroke-color) svg path {
  fill: rgb(228.7, 244.48, 210.29) !important;
}

button.text-moss-100:hover .Icon--moss-100.change-fill-color svg path {
  fill: rgb(214.25, 237.07, 189.8) !important;
}
button.text-moss-100:hover .Icon--moss-100.change-stroke-color svg path {
  stroke: rgb(214.25, 237.07, 189.8) !important;
}

button.text-moss-100:active .Icon--moss-100.change-fill-color svg path {
  fill: rgb(196.25, 229.15, 161) !important;
}
button.text-moss-100:active .Icon--moss-100.change-stroke-color svg path {
  stroke: rgb(196.25, 229.15, 161) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-100:not(.change-stroke-color) svg path {
  fill: rgb(214.25, 237.07, 189.8) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-100:not(.change-stroke-color) svg path {
  fill: rgb(214.25, 237.07, 189.8) !important;
}

button.text-moss-200:hover .Icon--moss-200.change-fill-color svg path {
  fill: rgb(191.937, 227.973, 153.327) !important;
}
button.text-moss-200:hover .Icon--moss-200.change-stroke-color svg path {
  stroke: rgb(191.937, 227.973, 153.327) !important;
}

button.text-moss-200:active .Icon--moss-200.change-fill-color svg path {
  fill: rgb(175.865, 221.085, 127.415) !important;
}
button.text-moss-200:active .Icon--moss-200.change-stroke-color svg path {
  stroke: rgb(175.865, 221.085, 127.415) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-200:not(.change-stroke-color) svg path {
  fill: rgb(191.937, 227.973, 153.327) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-200:not(.change-stroke-color) svg path {
  fill: rgb(191.937, 227.973, 153.327) !important;
}

button.text-moss-300:hover .Icon--moss-300.change-fill-color svg path {
  fill: rgb(160.2768639053, 215.0565088757, 102.0734911243) !important;
}
button.text-moss-300:hover .Icon--moss-300.change-stroke-color svg path {
  stroke: rgb(160.2768639053, 215.0565088757, 102.0734911243) !important;
}

button.text-moss-300:active .Icon--moss-300.change-fill-color svg path {
  fill: rgb(146.8789940828, 209.4068047337, 80.4431952663) !important;
}
button.text-moss-300:active .Icon--moss-300.change-stroke-color svg path {
  stroke: rgb(146.8789940828, 209.4068047337, 80.4431952663) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-300:not(.change-stroke-color) svg path {
  fill: rgb(160.2768639053, 215.0565088757, 102.0734911243) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-300:not(.change-stroke-color) svg path {
  fill: rgb(160.2768639053, 215.0565088757, 102.0734911243) !important;
}

button.text-moss-400:hover .Icon--moss-400.change-fill-color svg path {
  fill: rgb(124.7706072874, 193.0973684211, 51.4926315789) !important;
}
button.text-moss-400:hover .Icon--moss-400.change-stroke-color svg path {
  stroke: rgb(124.7706072874, 193.0973684211, 51.4926315789) !important;
}

button.text-moss-400:active .Icon--moss-400.change-fill-color svg path {
  fill: rgb(114.0376518219, 176.4868421053, 47.0631578947) !important;
}
button.text-moss-400:active .Icon--moss-400.change-stroke-color svg path {
  stroke: rgb(114.0376518219, 176.4868421053, 47.0631578947) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-400:not(.change-stroke-color) svg path {
  fill: rgb(124.7706072874, 193.0973684211, 51.4926315789) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-400:not(.change-stroke-color) svg path {
  fill: rgb(124.7706072874, 193.0973684211, 51.4926315789) !important;
}

button.text-moss-500:hover .Icon--moss-500.change-fill-color svg path {
  fill: rgb(94.86, 147.87, 39.06) !important;
}
button.text-moss-500:hover .Icon--moss-500.change-stroke-color svg path {
  stroke: rgb(94.86, 147.87, 39.06) !important;
}

button.text-moss-500:active .Icon--moss-500.change-fill-color svg path {
  fill: rgb(86.7, 135.15, 35.7) !important;
}
button.text-moss-500:active .Icon--moss-500.change-stroke-color svg path {
  stroke: rgb(86.7, 135.15, 35.7) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-500:not(.change-stroke-color) svg path {
  fill: rgb(94.86, 147.87, 39.06) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-500:not(.change-stroke-color) svg path {
  fill: rgb(94.86, 147.87, 39.06) !important;
}

button.text-moss-600:hover .Icon--moss-600.change-fill-color svg path {
  fill: rgb(73.47, 113.46, 30.69) !important;
}
button.text-moss-600:hover .Icon--moss-600.change-stroke-color svg path {
  stroke: rgb(73.47, 113.46, 30.69) !important;
}

button.text-moss-600:active .Icon--moss-600.change-fill-color svg path {
  fill: rgb(67.15, 103.7, 28.05) !important;
}
button.text-moss-600:active .Icon--moss-600.change-stroke-color svg path {
  stroke: rgb(67.15, 103.7, 28.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-600:not(.change-stroke-color) svg path {
  fill: rgb(73.47, 113.46, 30.69) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-600:not(.change-stroke-color) svg path {
  fill: rgb(73.47, 113.46, 30.69) !important;
}

button.text-moss-700:hover .Icon--moss-700.change-fill-color svg path {
  fill: rgb(58.59, 91.14, 24.18) !important;
}
button.text-moss-700:hover .Icon--moss-700.change-stroke-color svg path {
  stroke: rgb(58.59, 91.14, 24.18) !important;
}

button.text-moss-700:active .Icon--moss-700.change-fill-color svg path {
  fill: rgb(53.55, 83.3, 22.1) !important;
}
button.text-moss-700:active .Icon--moss-700.change-stroke-color svg path {
  stroke: rgb(53.55, 83.3, 22.1) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-700:not(.change-stroke-color) svg path {
  fill: rgb(58.59, 91.14, 24.18) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-700:not(.change-stroke-color) svg path {
  fill: rgb(58.59, 91.14, 24.18) !important;
}

button.text-moss-800:hover .Icon--moss-800.change-fill-color svg path {
  fill: rgb(47.43, 74.4, 19.53) !important;
}
button.text-moss-800:hover .Icon--moss-800.change-stroke-color svg path {
  stroke: rgb(47.43, 74.4, 19.53) !important;
}

button.text-moss-800:active .Icon--moss-800.change-fill-color svg path {
  fill: rgb(43.35, 68, 17.85) !important;
}
button.text-moss-800:active .Icon--moss-800.change-stroke-color svg path {
  stroke: rgb(43.35, 68, 17.85) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-800:not(.change-stroke-color) svg path {
  fill: rgb(47.43, 74.4, 19.53) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-800:not(.change-stroke-color) svg path {
  fill: rgb(47.43, 74.4, 19.53) !important;
}

button.text-moss-900:hover .Icon--moss-900.change-fill-color svg path {
  fill: rgb(39.99, 61.38, 16.74) !important;
}
button.text-moss-900:hover .Icon--moss-900.change-stroke-color svg path {
  stroke: rgb(39.99, 61.38, 16.74) !important;
}

button.text-moss-900:active .Icon--moss-900.change-fill-color svg path {
  fill: rgb(36.55, 56.1, 15.3) !important;
}
button.text-moss-900:active .Icon--moss-900.change-stroke-color svg path {
  stroke: rgb(36.55, 56.1, 15.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-900:not(.change-stroke-color) svg path {
  fill: rgb(39.99, 61.38, 16.74) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-900:not(.change-stroke-color) svg path {
  fill: rgb(39.99, 61.38, 16.74) !important;
}

button.text-moss-950:hover .Icon--moss-950.change-fill-color svg path {
  fill: rgb(24.18, 37.2, 10.23) !important;
}
button.text-moss-950:hover .Icon--moss-950.change-stroke-color svg path {
  stroke: rgb(24.18, 37.2, 10.23) !important;
}

button.text-moss-950:active .Icon--moss-950.change-fill-color svg path {
  fill: rgb(22.1, 34, 9.35) !important;
}
button.text-moss-950:active .Icon--moss-950.change-stroke-color svg path {
  stroke: rgb(22.1, 34, 9.35) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--moss-950:not(.change-stroke-color) svg path {
  fill: rgb(24.18, 37.2, 10.23) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--moss-950:not(.change-stroke-color) svg path {
  fill: rgb(24.18, 37.2, 10.23) !important;
}

button.text-green-light-25:hover .Icon--green-light-25.change-fill-color svg path {
  fill: rgb(234.1227272727, 250.8245454545, 213.2454545455) !important;
}
button.text-green-light-25:hover .Icon--green-light-25.change-stroke-color svg path {
  stroke: rgb(234.1227272727, 250.8245454545, 213.2454545455) !important;
}

button.text-green-light-25:active .Icon--green-light-25.change-fill-color svg path {
  fill: rgb(215.9772727273, 247.1954545455, 176.9545454545) !important;
}
button.text-green-light-25:active .Icon--green-light-25.change-stroke-color svg path {
  stroke: rgb(215.9772727273, 247.1954545455, 176.9545454545) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-25:not(.change-stroke-color) svg path {
  fill: rgb(234.1227272727, 250.8245454545, 213.2454545455) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-25:not(.change-stroke-color) svg path {
  fill: rgb(234.1227272727, 250.8245454545, 213.2454545455) !important;
}

button.text-green-light-50:hover .Icon--green-light-50.change-fill-color svg path {
  fill: rgb(226.704, 252.642, 198.408) !important;
}
button.text-green-light-50:hover .Icon--green-light-50.change-stroke-color svg path {
  stroke: rgb(226.704, 252.642, 198.408) !important;
}

button.text-green-light-50:active .Icon--green-light-50.change-fill-color svg path {
  fill: rgb(208.08, 251.09, 161.16) !important;
}
button.text-green-light-50:active .Icon--green-light-50.change-stroke-color svg path {
  stroke: rgb(208.08, 251.09, 161.16) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-50:not(.change-stroke-color) svg path {
  fill: rgb(226.704, 252.642, 198.408) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-50:not(.change-stroke-color) svg path {
  fill: rgb(226.704, 252.642, 198.408) !important;
}

button.text-green-light-100:hover .Icon--green-light-100.change-fill-color svg path {
  fill: rgb(212.3645454545, 248.6836363636, 174.4663636364) !important;
}
button.text-green-light-100:hover .Icon--green-light-100.change-stroke-color svg path {
  stroke: rgb(212.3645454545, 248.6836363636, 174.4663636364) !important;
}

button.text-green-light-100:active .Icon--green-light-100.change-fill-color svg path {
  fill: rgb(194.4954545455, 246.0363636364, 140.7136363636) !important;
}
button.text-green-light-100:active .Icon--green-light-100.change-stroke-color svg path {
  stroke: rgb(194.4954545455, 246.0363636364, 140.7136363636) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-100:not(.change-stroke-color) svg path {
  fill: rgb(212.3645454545, 248.6836363636, 174.4663636364) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-100:not(.change-stroke-color) svg path {
  fill: rgb(212.3645454545, 248.6836363636, 174.4663636364) !important;
}

button.text-green-light-200:hover .Icon--green-light-200.change-fill-color svg path {
  fill: rgb(192.8515384615, 245.7438461538, 143.9261538462) !important;
}
button.text-green-light-200:hover .Icon--green-light-200.change-stroke-color svg path {
  stroke: rgb(192.8515384615, 245.7438461538, 143.9261538462) !important;
}

button.text-green-light-200:active .Icon--green-light-200.change-fill-color svg path {
  fill: rgb(175.539010989, 243.1653846154, 112.9846153846) !important;
}
button.text-green-light-200:active .Icon--green-light-200.change-stroke-color svg path {
  stroke: rgb(175.539010989, 243.1653846154, 112.9846153846) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-200:not(.change-stroke-color) svg path {
  fill: rgb(192.8515384615, 245.7438461538, 143.9261538462) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-200:not(.change-stroke-color) svg path {
  fill: rgb(192.8515384615, 245.7438461538, 143.9261538462) !important;
}

button.text-green-light-300:hover .Icon--green-light-300.change-fill-color svg path {
  fill: rgb(153.3175, 236.72, 81.34) !important;
}
button.text-green-light-300:hover .Icon--green-light-300.change-stroke-color svg path {
  stroke: rgb(153.3175, 236.72, 81.34) !important;
}

button.text-green-light-300:active .Icon--green-light-300.change-fill-color svg path {
  fill: rgb(138.8232142857, 234.1142857143, 56.5857142857) !important;
}
button.text-green-light-300:active .Icon--green-light-300.change-stroke-color svg path {
  stroke: rgb(138.8232142857, 234.1142857143, 56.5857142857) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-300:not(.change-stroke-color) svg path {
  fill: rgb(153.3175, 236.72, 81.34) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-300:not(.change-stroke-color) svg path {
  fill: rgb(153.3175, 236.72, 81.34) !important;
}

button.text-green-light-400:hover .Icon--green-light-400.change-fill-color svg path {
  fill: rgb(122.353215859, 222.381938326, 40.808061674) !important;
}
button.text-green-light-400:hover .Icon--green-light-400.change-stroke-color svg path {
  stroke: rgb(122.353215859, 222.381938326, 40.808061674) !important;
}

button.text-green-light-400:active .Icon--green-light-400.change-fill-color svg path {
  fill: rgb(111.2676211454, 208.7592511013, 31.7907488987) !important;
}
button.text-green-light-400:active .Icon--green-light-400.change-stroke-color svg path {
  stroke: rgb(111.2676211454, 208.7592511013, 31.7907488987) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-400:not(.change-stroke-color) svg path {
  fill: rgb(122.353215859, 222.381938326, 40.808061674) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-400:not(.change-stroke-color) svg path {
  fill: rgb(122.353215859, 222.381938326, 40.808061674) !important;
}

button.text-green-light-500:hover .Icon--green-light-500.change-fill-color svg path {
  fill: rgb(94.86, 184.14, 26.04) !important;
}
button.text-green-light-500:hover .Icon--green-light-500.change-stroke-color svg path {
  stroke: rgb(94.86, 184.14, 26.04) !important;
}

button.text-green-light-500:active .Icon--green-light-500.change-fill-color svg path {
  fill: rgb(86.7, 168.3, 23.8) !important;
}
button.text-green-light-500:active .Icon--green-light-500.change-stroke-color svg path {
  stroke: rgb(86.7, 168.3, 23.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-500:not(.change-stroke-color) svg path {
  fill: rgb(94.86, 184.14, 26.04) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-500:not(.change-stroke-color) svg path {
  fill: rgb(94.86, 184.14, 26.04) !important;
}

button.text-green-light-600:hover .Icon--green-light-600.change-fill-color svg path {
  fill: rgb(70.68, 151.59, 12.09) !important;
}
button.text-green-light-600:hover .Icon--green-light-600.change-stroke-color svg path {
  stroke: rgb(70.68, 151.59, 12.09) !important;
}

button.text-green-light-600:active .Icon--green-light-600.change-fill-color svg path {
  fill: rgb(64.6, 138.55, 11.05) !important;
}
button.text-green-light-600:active .Icon--green-light-600.change-stroke-color svg path {
  stroke: rgb(64.6, 138.55, 11.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-600:not(.change-stroke-color) svg path {
  fill: rgb(70.68, 151.59, 12.09) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-600:not(.change-stroke-color) svg path {
  fill: rgb(70.68, 151.59, 12.09) !important;
}

button.text-green-light-700:hover .Icon--green-light-700.change-fill-color svg path {
  fill: rgb(54.87, 115.32, 13.95) !important;
}
button.text-green-light-700:hover .Icon--green-light-700.change-stroke-color svg path {
  stroke: rgb(54.87, 115.32, 13.95) !important;
}

button.text-green-light-700:active .Icon--green-light-700.change-fill-color svg path {
  fill: rgb(50.15, 105.4, 12.75) !important;
}
button.text-green-light-700:active .Icon--green-light-700.change-stroke-color svg path {
  stroke: rgb(50.15, 105.4, 12.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-700:not(.change-stroke-color) svg path {
  fill: rgb(54.87, 115.32, 13.95) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-700:not(.change-stroke-color) svg path {
  fill: rgb(54.87, 115.32, 13.95) !important;
}

button.text-green-light-800:hover .Icon--green-light-800.change-fill-color svg path {
  fill: rgb(46.5, 91.14, 16.74) !important;
}
button.text-green-light-800:hover .Icon--green-light-800.change-stroke-color svg path {
  stroke: rgb(46.5, 91.14, 16.74) !important;
}

button.text-green-light-800:active .Icon--green-light-800.change-fill-color svg path {
  fill: rgb(42.5, 83.3, 15.3) !important;
}
button.text-green-light-800:active .Icon--green-light-800.change-stroke-color svg path {
  stroke: rgb(42.5, 83.3, 15.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-800:not(.change-stroke-color) svg path {
  fill: rgb(46.5, 91.14, 16.74) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-800:not(.change-stroke-color) svg path {
  fill: rgb(46.5, 91.14, 16.74) !important;
}

button.text-green-light-900:hover .Icon--green-light-900.change-fill-color svg path {
  fill: rgb(39.99, 77.19, 18.6) !important;
}
button.text-green-light-900:hover .Icon--green-light-900.change-stroke-color svg path {
  stroke: rgb(39.99, 77.19, 18.6) !important;
}

button.text-green-light-900:active .Icon--green-light-900.change-fill-color svg path {
  fill: rgb(36.55, 70.55, 17) !important;
}
button.text-green-light-900:active .Icon--green-light-900.change-stroke-color svg path {
  stroke: rgb(36.55, 70.55, 17) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-900:not(.change-stroke-color) svg path {
  fill: rgb(39.99, 77.19, 18.6) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-900:not(.change-stroke-color) svg path {
  fill: rgb(39.99, 77.19, 18.6) !important;
}

button.text-green-light-950:hover .Icon--green-light-950.change-fill-color svg path {
  fill: rgb(19.53, 38.13, 9.3) !important;
}
button.text-green-light-950:hover .Icon--green-light-950.change-stroke-color svg path {
  stroke: rgb(19.53, 38.13, 9.3) !important;
}

button.text-green-light-950:active .Icon--green-light-950.change-fill-color svg path {
  fill: rgb(17.85, 34.85, 8.5) !important;
}
button.text-green-light-950:active .Icon--green-light-950.change-stroke-color svg path {
  stroke: rgb(17.85, 34.85, 8.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--green-light-950:not(.change-stroke-color) svg path {
  fill: rgb(19.53, 38.13, 9.3) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--green-light-950:not(.change-stroke-color) svg path {
  fill: rgb(19.53, 38.13, 9.3) !important;
}

button.text-teal-25:hover .Icon--teal-25.change-fill-color svg path {
  fill: rgb(214.5, 250.5, 241.5) !important;
}
button.text-teal-25:hover .Icon--teal-25.change-stroke-color svg path {
  stroke: rgb(214.5, 250.5, 241.5) !important;
}

button.text-teal-25:active .Icon--teal-25.change-fill-color svg path {
  fill: rgb(178.5, 246.5, 229.5) !important;
}
button.text-teal-25:active .Icon--teal-25.change-stroke-color svg path {
  stroke: rgb(178.5, 246.5, 229.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-25:not(.change-stroke-color) svg path {
  fill: rgb(214.5, 250.5, 241.5) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-25:not(.change-stroke-color) svg path {
  fill: rgb(214.5, 250.5, 241.5) !important;
}

button.text-teal-50:hover .Icon--teal-50.change-fill-color svg path {
  fill: rgb(209.55, 248.94, 236.82) !important;
}
button.text-teal-50:hover .Icon--teal-50.change-stroke-color svg path {
  stroke: rgb(209.55, 248.94, 236.82) !important;
}

button.text-teal-50:active .Icon--teal-50.change-fill-color svg path {
  fill: rgb(174.75, 244.3, 222.9) !important;
}
button.text-teal-50:active .Icon--teal-50.change-stroke-color svg path {
  stroke: rgb(174.75, 244.3, 222.9) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-50:not(.change-stroke-color) svg path {
  fill: rgb(209.55, 248.94, 236.82) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-50:not(.change-stroke-color) svg path {
  fill: rgb(209.55, 248.94, 236.82) !important;
}

button.text-teal-100:hover .Icon--teal-100.change-fill-color svg path {
  fill: rgb(174.4663636364, 248.6836363636, 229.7345454545) !important;
}
button.text-teal-100:hover .Icon--teal-100.change-stroke-color svg path {
  stroke: rgb(174.4663636364, 248.6836363636, 229.7345454545) !important;
}

button.text-teal-100:active .Icon--teal-100.change-fill-color svg path {
  fill: rgb(140.7136363636, 246.0363636364, 219.1454545455) !important;
}
button.text-teal-100:active .Icon--teal-100.change-stroke-color svg path {
  stroke: rgb(140.7136363636, 246.0363636364, 219.1454545455) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-100:not(.change-stroke-color) svg path {
  fill: rgb(174.4663636364, 248.6836363636, 229.7345454545) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-100:not(.change-stroke-color) svg path {
  fill: rgb(174.4663636364, 248.6836363636, 229.7345454545) !important;
}

button.text-teal-200:hover .Icon--teal-200.change-fill-color svg path {
  fill: rgb(127.3345945946, 243.7354054054, 216.1997297297) !important;
}
button.text-teal-200:hover .Icon--teal-200.change-stroke-color svg path {
  stroke: rgb(127.3345945946, 243.7354054054, 216.1997297297) !important;
}

button.text-teal-200:active .Icon--teal-200.change-fill-color svg path {
  fill: rgb(98.0027027027, 241.1472972973, 207.2851351351) !important;
}
button.text-teal-200:active .Icon--teal-200.change-stroke-color svg path {
  stroke: rgb(98.0027027027, 241.1472972973, 207.2851351351) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-200:not(.change-stroke-color) svg path {
  fill: rgb(127.3345945946, 243.7354054054, 216.1997297297) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-200:not(.change-stroke-color) svg path {
  fill: rgb(127.3345945946, 243.7354054054, 216.1997297297) !important;
}

button.text-teal-300:hover .Icon--teal-300.change-fill-color svg path {
  fill: rgb(74.8153846154, 230.2246153846, 202.0707692308) !important;
}
button.text-teal-300:hover .Icon--teal-300.change-stroke-color svg path {
  stroke: rgb(74.8153846154, 230.2246153846, 202.0707692308) !important;
}

button.text-teal-300:active .Icon--teal-300.change-fill-color svg path {
  fill: rgb(51.7472527473, 227.0527472527, 195.2945054945) !important;
}
button.text-teal-300:active .Icon--teal-300.change-stroke-color svg path {
  stroke: rgb(51.7472527473, 227.0527472527, 195.2945054945) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-300:not(.change-stroke-color) svg path {
  fill: rgb(74.8153846154, 230.2246153846, 202.0707692308) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-300:not(.change-stroke-color) svg path {
  fill: rgb(74.8153846154, 230.2246153846, 202.0707692308) !important;
}

button.text-teal-400:hover .Icon--teal-400.change-fill-color svg path {
  fill: rgb(41.5669565217, 197.4430434783, 170.9913438735) !important;
}
button.text-teal-400:hover .Icon--teal-400.change-stroke-color svg path {
  stroke: rgb(41.5669565217, 197.4430434783, 170.9913438735) !important;
}

button.text-teal-400:active .Icon--teal-400.change-fill-color svg path {
  fill: rgb(37.9913043478, 180.4586956522, 156.2824110672) !important;
}
button.text-teal-400:active .Icon--teal-400.change-stroke-color svg path {
  stroke: rgb(37.9913043478, 180.4586956522, 156.2824110672) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-400:not(.change-stroke-color) svg path {
  fill: rgb(41.5669565217, 197.4430434783, 170.9913438735) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-400:not(.change-stroke-color) svg path {
  fill: rgb(41.5669565217, 197.4430434783, 170.9913438735) !important;
}

button.text-teal-500:hover .Icon--teal-500.change-fill-color svg path {
  fill: rgb(19.53, 170.19, 146.94) !important;
}
button.text-teal-500:hover .Icon--teal-500.change-stroke-color svg path {
  stroke: rgb(19.53, 170.19, 146.94) !important;
}

button.text-teal-500:active .Icon--teal-500.change-fill-color svg path {
  fill: rgb(17.85, 155.55, 134.3) !important;
}
button.text-teal-500:active .Icon--teal-500.change-stroke-color svg path {
  stroke: rgb(17.85, 155.55, 134.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-500:not(.change-stroke-color) svg path {
  fill: rgb(19.53, 170.19, 146.94) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-500:not(.change-stroke-color) svg path {
  fill: rgb(19.53, 170.19, 146.94) !important;
}

button.text-teal-600:hover .Icon--teal-600.change-fill-color svg path {
  fill: rgb(13.02, 136.71, 122.76) !important;
}
button.text-teal-600:hover .Icon--teal-600.change-stroke-color svg path {
  stroke: rgb(13.02, 136.71, 122.76) !important;
}

button.text-teal-600:active .Icon--teal-600.change-fill-color svg path {
  fill: rgb(11.9, 124.95, 112.2) !important;
}
button.text-teal-600:active .Icon--teal-600.change-stroke-color svg path {
  stroke: rgb(11.9, 124.95, 112.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-600:not(.change-stroke-color) svg path {
  fill: rgb(13.02, 136.71, 122.76) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-600:not(.change-stroke-color) svg path {
  fill: rgb(13.02, 136.71, 122.76) !important;
}

button.text-teal-700:hover .Icon--teal-700.change-fill-color svg path {
  fill: rgb(14.88, 108.81, 97.65) !important;
}
button.text-teal-700:hover .Icon--teal-700.change-stroke-color svg path {
  stroke: rgb(14.88, 108.81, 97.65) !important;
}

button.text-teal-700:active .Icon--teal-700.change-fill-color svg path {
  fill: rgb(13.6, 99.45, 89.25) !important;
}
button.text-teal-700:active .Icon--teal-700.change-stroke-color svg path {
  stroke: rgb(13.6, 99.45, 89.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-700:not(.change-stroke-color) svg path {
  fill: rgb(14.88, 108.81, 97.65) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-700:not(.change-stroke-color) svg path {
  fill: rgb(14.88, 108.81, 97.65) !important;
}

button.text-teal-800:hover .Icon--teal-800.change-fill-color svg path {
  fill: rgb(16.74, 86.49, 79.98) !important;
}
button.text-teal-800:hover .Icon--teal-800.change-stroke-color svg path {
  stroke: rgb(16.74, 86.49, 79.98) !important;
}

button.text-teal-800:active .Icon--teal-800.change-fill-color svg path {
  fill: rgb(15.3, 79.05, 73.1) !important;
}
button.text-teal-800:active .Icon--teal-800.change-stroke-color svg path {
  stroke: rgb(15.3, 79.05, 73.1) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-800:not(.change-stroke-color) svg path {
  fill: rgb(16.74, 86.49, 79.98) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-800:not(.change-stroke-color) svg path {
  fill: rgb(16.74, 86.49, 79.98) !important;
}

button.text-teal-900:hover .Icon--teal-900.change-fill-color svg path {
  fill: rgb(17.67, 72.54, 66.96) !important;
}
button.text-teal-900:hover .Icon--teal-900.change-stroke-color svg path {
  stroke: rgb(17.67, 72.54, 66.96) !important;
}

button.text-teal-900:active .Icon--teal-900.change-fill-color svg path {
  fill: rgb(16.15, 66.3, 61.2) !important;
}
button.text-teal-900:active .Icon--teal-900.change-stroke-color svg path {
  stroke: rgb(16.15, 66.3, 61.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-900:not(.change-stroke-color) svg path {
  fill: rgb(17.67, 72.54, 66.96) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-900:not(.change-stroke-color) svg path {
  fill: rgb(17.67, 72.54, 66.96) !important;
}

button.text-teal-950:hover .Icon--teal-950.change-fill-color svg path {
  fill: rgb(9.3, 38.13, 35.34) !important;
}
button.text-teal-950:hover .Icon--teal-950.change-stroke-color svg path {
  stroke: rgb(9.3, 38.13, 35.34) !important;
}

button.text-teal-950:active .Icon--teal-950.change-fill-color svg path {
  fill: rgb(8.5, 34.85, 32.3) !important;
}
button.text-teal-950:active .Icon--teal-950.change-stroke-color svg path {
  stroke: rgb(8.5, 34.85, 32.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--teal-950:not(.change-stroke-color) svg path {
  fill: rgb(9.3, 38.13, 35.34) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--teal-950:not(.change-stroke-color) svg path {
  fill: rgb(9.3, 38.13, 35.34) !important;
}

button.text-cyan-25:hover .Icon--cyan-25.change-fill-color svg path {
  fill: rgb(210, 250.5, 255) !important;
}
button.text-cyan-25:hover .Icon--cyan-25.change-stroke-color svg path {
  stroke: rgb(210, 250.5, 255) !important;
}

button.text-cyan-25:active .Icon--cyan-25.change-fill-color svg path {
  fill: rgb(170, 246.5, 255) !important;
}
button.text-cyan-25:active .Icon--cyan-25.change-stroke-color svg path {
  stroke: rgb(170, 246.5, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-25:not(.change-stroke-color) svg path {
  fill: rgb(210, 250.5, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-25:not(.change-stroke-color) svg path {
  fill: rgb(210, 250.5, 255) !important;
}

button.text-cyan-50:hover .Icon--cyan-50.change-fill-color svg path {
  fill: rgb(201.63, 249.3821052632, 255) !important;
}
button.text-cyan-50:hover .Icon--cyan-50.change-stroke-color svg path {
  stroke: rgb(201.63, 249.3821052632, 255) !important;
}

button.text-cyan-50:active .Icon--cyan-50.change-fill-color svg path {
  fill: rgb(162.35, 245.2473684211, 255) !important;
}
button.text-cyan-50:active .Icon--cyan-50.change-stroke-color svg path {
  stroke: rgb(162.35, 245.2473684211, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-50:not(.change-stroke-color) svg path {
  fill: rgb(201.63, 249.3821052632, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-50:not(.change-stroke-color) svg path {
  fill: rgb(201.63, 249.3821052632, 255) !important;
}

button.text-cyan-100:hover .Icon--cyan-100.change-fill-color svg path {
  fill: rgb(175.3885714286, 245.0485714286, 253.3414285714) !important;
}
button.text-cyan-100:hover .Icon--cyan-100.change-stroke-color svg path {
  stroke: rgb(175.3885714286, 245.0485714286, 253.3414285714) !important;
}

button.text-cyan-100:active .Icon--cyan-100.change-fill-color svg path {
  fill: rgb(139.2612244898, 240.5326530612, 252.5887755102) !important;
}
button.text-cyan-100:active .Icon--cyan-100.change-stroke-color svg path {
  stroke: rgb(139.2612244898, 240.5326530612, 252.5887755102) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-100:not(.change-stroke-color) svg path {
  fill: rgb(175.3885714286, 245.0485714286, 253.3414285714) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-100:not(.change-stroke-color) svg path {
  fill: rgb(175.3885714286, 245.0485714286, 253.3414285714) !important;
}

button.text-cyan-200:hover .Icon--cyan-200.change-fill-color svg path {
  fill: rgb(136.7516129032, 235.2919354839, 251.0583870968) !important;
}
button.text-cyan-200:hover .Icon--cyan-200.change-stroke-color svg path {
  stroke: rgb(136.7516129032, 235.2919354839, 251.0583870968) !important;
}

button.text-cyan-200:active .Icon--cyan-200.change-fill-color svg path {
  fill: rgb(104.4677419355, 229.9112903226, 249.9822580645) !important;
}
button.text-cyan-200:active .Icon--cyan-200.change-stroke-color svg path {
  stroke: rgb(104.4677419355, 229.9112903226, 249.9822580645) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-200:not(.change-stroke-color) svg path {
  fill: rgb(136.7516129032, 235.2919354839, 251.0583870968) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-200:not(.change-stroke-color) svg path {
  fill: rgb(136.7516129032, 235.2919354839, 251.0583870968) !important;
}

button.text-cyan-300:hover .Icon--cyan-300.change-fill-color svg path {
  fill: rgb(79.2956962025, 222.6334177215, 248.0643037975) !important;
}
button.text-cyan-300:hover .Icon--cyan-300.change-stroke-color svg path {
  stroke: rgb(79.2956962025, 222.6334177215, 248.0643037975) !important;
}

button.text-cyan-300:active .Icon--cyan-300.change-fill-color svg path {
  fill: rgb(52.2050632911, 217.6430379747, 246.9949367089) !important;
}
button.text-cyan-300:active .Icon--cyan-300.change-stroke-color svg path {
  stroke: rgb(52.2050632911, 217.6430379747, 246.9949367089) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-300:not(.change-stroke-color) svg path {
  fill: rgb(79.2956962025, 222.6334177215, 248.0643037975) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-300:not(.change-stroke-color) svg path {
  fill: rgb(79.2956962025, 222.6334177215, 248.0643037975) !important;
}

button.text-cyan-400:hover .Icon--cyan-400.change-fill-color svg path {
  fill: rgb(18.0685714286, 198.7542857143, 234.8914285714) !important;
}
button.text-cyan-400:hover .Icon--cyan-400.change-stroke-color svg path {
  stroke: rgb(18.0685714286, 198.7542857143, 234.8914285714) !important;
}

button.text-cyan-400:active .Icon--cyan-400.change-fill-color svg path {
  fill: rgb(16.5142857143, 181.6571428571, 214.6857142857) !important;
}
button.text-cyan-400:active .Icon--cyan-400.change-stroke-color svg path {
  stroke: rgb(16.5142857143, 181.6571428571, 214.6857142857) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-400:not(.change-stroke-color) svg path {
  fill: rgb(18.0685714286, 198.7542857143, 234.8914285714) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-400:not(.change-stroke-color) svg path {
  fill: rgb(18.0685714286, 198.7542857143, 234.8914285714) !important;
}

button.text-cyan-500:hover .Icon--cyan-500.change-fill-color svg path {
  fill: rgb(5.58, 161.82, 197.16) !important;
}
button.text-cyan-500:hover .Icon--cyan-500.change-stroke-color svg path {
  stroke: rgb(5.58, 161.82, 197.16) !important;
}

button.text-cyan-500:active .Icon--cyan-500.change-fill-color svg path {
  fill: rgb(5.1, 147.9, 180.2) !important;
}
button.text-cyan-500:active .Icon--cyan-500.change-stroke-color svg path {
  stroke: rgb(5.1, 147.9, 180.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-500:not(.change-stroke-color) svg path {
  fill: rgb(5.58, 161.82, 197.16) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-500:not(.change-stroke-color) svg path {
  fill: rgb(5.58, 161.82, 197.16) !important;
}

button.text-cyan-600:hover .Icon--cyan-600.change-fill-color svg path {
  fill: rgb(7.44, 128.34, 165.54) !important;
}
button.text-cyan-600:hover .Icon--cyan-600.change-stroke-color svg path {
  stroke: rgb(7.44, 128.34, 165.54) !important;
}

button.text-cyan-600:active .Icon--cyan-600.change-fill-color svg path {
  fill: rgb(6.8, 117.3, 151.3) !important;
}
button.text-cyan-600:active .Icon--cyan-600.change-stroke-color svg path {
  stroke: rgb(6.8, 117.3, 151.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-600:not(.change-stroke-color) svg path {
  fill: rgb(7.44, 128.34, 165.54) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-600:not(.change-stroke-color) svg path {
  fill: rgb(7.44, 128.34, 165.54) !important;
}

button.text-cyan-700:hover .Icon--cyan-700.change-fill-color svg path {
  fill: rgb(13.02, 104.16, 133.92) !important;
}
button.text-cyan-700:hover .Icon--cyan-700.change-stroke-color svg path {
  stroke: rgb(13.02, 104.16, 133.92) !important;
}

button.text-cyan-700:active .Icon--cyan-700.change-fill-color svg path {
  fill: rgb(11.9, 95.2, 122.4) !important;
}
button.text-cyan-700:active .Icon--cyan-700.change-stroke-color svg path {
  stroke: rgb(11.9, 95.2, 122.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-700:not(.change-stroke-color) svg path {
  fill: rgb(13.02, 104.16, 133.92) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-700:not(.change-stroke-color) svg path {
  fill: rgb(13.02, 104.16, 133.92) !important;
}

button.text-cyan-800:hover .Icon--cyan-800.change-fill-color svg path {
  fill: rgb(19.53, 84.63, 108.81) !important;
}
button.text-cyan-800:hover .Icon--cyan-800.change-stroke-color svg path {
  stroke: rgb(19.53, 84.63, 108.81) !important;
}

button.text-cyan-800:active .Icon--cyan-800.change-fill-color svg path {
  fill: rgb(17.85, 77.35, 99.45) !important;
}
button.text-cyan-800:active .Icon--cyan-800.change-stroke-color svg path {
  stroke: rgb(17.85, 77.35, 99.45) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-800:not(.change-stroke-color) svg path {
  fill: rgb(19.53, 84.63, 108.81) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-800:not(.change-stroke-color) svg path {
  fill: rgb(19.53, 84.63, 108.81) !important;
}

button.text-cyan-900:hover .Icon--cyan-900.change-fill-color svg path {
  fill: rgb(20.46, 70.68, 92.07) !important;
}
button.text-cyan-900:hover .Icon--cyan-900.change-stroke-color svg path {
  stroke: rgb(20.46, 70.68, 92.07) !important;
}

button.text-cyan-900:active .Icon--cyan-900.change-fill-color svg path {
  fill: rgb(18.7, 64.6, 84.15) !important;
}
button.text-cyan-900:active .Icon--cyan-900.change-stroke-color svg path {
  stroke: rgb(18.7, 64.6, 84.15) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-900:not(.change-stroke-color) svg path {
  fill: rgb(20.46, 70.68, 92.07) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-900:not(.change-stroke-color) svg path {
  fill: rgb(20.46, 70.68, 92.07) !important;
}

button.text-cyan-950:hover .Icon--cyan-950.change-fill-color svg path {
  fill: rgb(12.09, 41.85, 53.94) !important;
}
button.text-cyan-950:hover .Icon--cyan-950.change-stroke-color svg path {
  stroke: rgb(12.09, 41.85, 53.94) !important;
}

button.text-cyan-950:active .Icon--cyan-950.change-fill-color svg path {
  fill: rgb(11.05, 38.25, 49.3) !important;
}
button.text-cyan-950:active .Icon--cyan-950.change-stroke-color svg path {
  stroke: rgb(11.05, 38.25, 49.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--cyan-950:not(.change-stroke-color) svg path {
  fill: rgb(12.09, 41.85, 53.94) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--cyan-950:not(.change-stroke-color) svg path {
  fill: rgb(12.09, 41.85, 53.94) !important;
}

button.text-blue-dark-25:hover .Icon--blue-dark-25.change-fill-color svg path {
  fill: rgb(210, 223.5, 255) !important;
}
button.text-blue-dark-25:hover .Icon--blue-dark-25.change-stroke-color svg path {
  stroke: rgb(210, 223.5, 255) !important;
}

button.text-blue-dark-25:active .Icon--blue-dark-25.change-fill-color svg path {
  fill: rgb(170, 195.5, 255) !important;
}
button.text-blue-dark-25:active .Icon--blue-dark-25.change-stroke-color svg path {
  stroke: rgb(170, 195.5, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-25:not(.change-stroke-color) svg path {
  fill: rgb(210, 223.5, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-25:not(.change-stroke-color) svg path {
  fill: rgb(210, 223.5, 255) !important;
}

button.text-blue-dark-50:hover .Icon--blue-dark-50.change-fill-color svg path {
  fill: rgb(204.42, 220.22625, 255) !important;
}
button.text-blue-dark-50:hover .Icon--blue-dark-50.change-stroke-color svg path {
  stroke: rgb(204.42, 220.22625, 255) !important;
}

button.text-blue-dark-50:active .Icon--blue-dark-50.change-fill-color svg path {
  fill: rgb(164.9, 193.05625, 255) !important;
}
button.text-blue-dark-50:active .Icon--blue-dark-50.change-stroke-color svg path {
  stroke: rgb(164.9, 193.05625, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-50:not(.change-stroke-color) svg path {
  fill: rgb(204.42, 220.22625, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-50:not(.change-stroke-color) svg path {
  fill: rgb(204.42, 220.22625, 255) !important;
}

button.text-blue-dark-100:hover .Icon--blue-dark-100.change-fill-color svg path {
  fill: rgb(176.52, 202.1113043478, 255) !important;
}
button.text-blue-dark-100:hover .Icon--blue-dark-100.change-stroke-color svg path {
  stroke: rgb(176.52, 202.1113043478, 255) !important;
}

button.text-blue-dark-100:active .Icon--blue-dark-100.change-fill-color svg path {
  fill: rgb(139.4, 177.0956521739, 255) !important;
}
button.text-blue-dark-100:active .Icon--blue-dark-100.change-stroke-color svg path {
  stroke: rgb(139.4, 177.0956521739, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-100:not(.change-stroke-color) svg path {
  fill: rgb(176.52, 202.1113043478, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-100:not(.change-stroke-color) svg path {
  fill: rgb(176.52, 202.1113043478, 255) !important;
}

button.text-blue-dark-200:hover .Icon--blue-dark-200.change-fill-color svg path {
  fill: rgb(147.69, 183.9245454545, 255) !important;
}
button.text-blue-dark-200:hover .Icon--blue-dark-200.change-stroke-color svg path {
  stroke: rgb(147.69, 183.9245454545, 255) !important;
}

button.text-blue-dark-200:active .Icon--blue-dark-200.change-fill-color svg path {
  fill: rgb(113.05, 160.9811688312, 255) !important;
}
button.text-blue-dark-200:active .Icon--blue-dark-200.change-stroke-color svg path {
  stroke: rgb(113.05, 160.9811688312, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-200:not(.change-stroke-color) svg path {
  fill: rgb(147.69, 183.9245454545, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-200:not(.change-stroke-color) svg path {
  fill: rgb(147.69, 183.9245454545, 255) !important;
}

button.text-blue-dark-300:hover .Icon--blue-dark-300.change-fill-color svg path {
  fill: rgb(104.91, 154.94, 255) !important;
}
button.text-blue-dark-300:hover .Icon--blue-dark-300.change-stroke-color svg path {
  stroke: rgb(104.91, 154.94, 255) !important;
}

button.text-blue-dark-300:active .Icon--blue-dark-300.change-fill-color svg path {
  fill: rgb(73.95, 134.3, 255) !important;
}
button.text-blue-dark-300:active .Icon--blue-dark-300.change-stroke-color svg path {
  stroke: rgb(73.95, 134.3, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-300:not(.change-stroke-color) svg path {
  fill: rgb(104.91, 154.94, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-300:not(.change-stroke-color) svg path {
  fill: rgb(104.91, 154.94, 255) !important;
}

button.text-blue-dark-400:hover .Icon--blue-dark-400.change-fill-color svg path {
  fill: rgb(58.41, 123.1824277457, 255) !important;
}
button.text-blue-dark-400:hover .Icon--blue-dark-400.change-stroke-color svg path {
  stroke: rgb(58.41, 123.1824277457, 255) !important;
}

button.text-blue-dark-400:active .Icon--blue-dark-400.change-fill-color svg path {
  fill: rgb(31.45, 105.1052023121, 255) !important;
}
button.text-blue-dark-400:active .Icon--blue-dark-400.change-stroke-color svg path {
  stroke: rgb(31.45, 105.1052023121, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-400:not(.change-stroke-color) svg path {
  fill: rgb(58.41, 123.1824277457, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-400:not(.change-stroke-color) svg path {
  fill: rgb(58.41, 123.1824277457, 255) !important;
}

button.text-blue-dark-500:hover .Icon--blue-dark-500.change-fill-color svg path {
  fill: rgb(20.28, 98.1543925234, 255) !important;
}
button.text-blue-dark-500:hover .Icon--blue-dark-500.change-stroke-color svg path {
  stroke: rgb(20.28, 98.1543925234, 255) !important;
}

button.text-blue-dark-500:active .Icon--blue-dark-500.change-fill-color svg path {
  fill: rgb(0, 83.4747663551, 251.6) !important;
}
button.text-blue-dark-500:active .Icon--blue-dark-500.change-stroke-color svg path {
  stroke: rgb(0, 83.4747663551, 251.6) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-500:not(.change-stroke-color) svg path {
  fill: rgb(20.28, 98.1543925234, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-500:not(.change-stroke-color) svg path {
  fill: rgb(20.28, 98.1543925234, 255) !important;
}

button.text-blue-dark-600:hover .Icon--blue-dark-600.change-fill-color svg path {
  fill: rgb(15.4752, 86.0808, 226.3248) !important;
}
button.text-blue-dark-600:hover .Icon--blue-dark-600.change-stroke-color svg path {
  stroke: rgb(15.4752, 86.0808, 226.3248) !important;
}

button.text-blue-dark-600:active .Icon--blue-dark-600.change-fill-color svg path {
  fill: rgb(14.144, 78.676, 206.856) !important;
}
button.text-blue-dark-600:active .Icon--blue-dark-600.change-stroke-color svg path {
  stroke: rgb(14.144, 78.676, 206.856) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-600:not(.change-stroke-color) svg path {
  fill: rgb(15.4752, 86.0808, 226.3248) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-600:not(.change-stroke-color) svg path {
  fill: rgb(15.4752, 86.0808, 226.3248) !important;
}

button.text-blue-dark-700:hover .Icon--blue-dark-700.change-fill-color svg path {
  fill: rgb(0, 72.54, 218.55) !important;
}
button.text-blue-dark-700:hover .Icon--blue-dark-700.change-stroke-color svg path {
  stroke: rgb(0, 72.54, 218.55) !important;
}

button.text-blue-dark-700:active .Icon--blue-dark-700.change-fill-color svg path {
  fill: rgb(0, 66.3, 199.75) !important;
}
button.text-blue-dark-700:active .Icon--blue-dark-700.change-stroke-color svg path {
  stroke: rgb(0, 66.3, 199.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-700:not(.change-stroke-color) svg path {
  fill: rgb(0, 72.54, 218.55) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-700:not(.change-stroke-color) svg path {
  fill: rgb(0, 72.54, 218.55) !important;
}

button.text-blue-dark-800:hover .Icon--blue-dark-800.change-fill-color svg path {
  fill: rgb(0, 59.52, 179.49) !important;
}
button.text-blue-dark-800:hover .Icon--blue-dark-800.change-stroke-color svg path {
  stroke: rgb(0, 59.52, 179.49) !important;
}

button.text-blue-dark-800:active .Icon--blue-dark-800.change-fill-color svg path {
  fill: rgb(0, 54.4, 164.05) !important;
}
button.text-blue-dark-800:active .Icon--blue-dark-800.change-stroke-color svg path {
  stroke: rgb(0, 54.4, 164.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-800:not(.change-stroke-color) svg path {
  fill: rgb(0, 59.52, 179.49) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-800:not(.change-stroke-color) svg path {
  fill: rgb(0, 59.52, 179.49) !important;
}

button.text-blue-dark-900:hover .Icon--blue-dark-900.change-fill-color svg path {
  fill: rgb(0, 49.29, 146.94) !important;
}
button.text-blue-dark-900:hover .Icon--blue-dark-900.change-stroke-color svg path {
  stroke: rgb(0, 49.29, 146.94) !important;
}

button.text-blue-dark-900:active .Icon--blue-dark-900.change-fill-color svg path {
  fill: rgb(0, 45.05, 134.3) !important;
}
button.text-blue-dark-900:active .Icon--blue-dark-900.change-stroke-color svg path {
  stroke: rgb(0, 45.05, 134.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-900:not(.change-stroke-color) svg path {
  fill: rgb(0, 49.29, 146.94) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-900:not(.change-stroke-color) svg path {
  fill: rgb(0, 49.29, 146.94) !important;
}

button.text-blue-dark-950:hover .Icon--blue-dark-950.change-fill-color svg path {
  fill: rgb(0, 31.62, 94.86) !important;
}
button.text-blue-dark-950:hover .Icon--blue-dark-950.change-stroke-color svg path {
  stroke: rgb(0, 31.62, 94.86) !important;
}

button.text-blue-dark-950:active .Icon--blue-dark-950.change-fill-color svg path {
  fill: rgb(0, 28.9, 86.7) !important;
}
button.text-blue-dark-950:active .Icon--blue-dark-950.change-stroke-color svg path {
  stroke: rgb(0, 28.9, 86.7) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--blue-dark-950:not(.change-stroke-color) svg path {
  fill: rgb(0, 31.62, 94.86) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--blue-dark-950:not(.change-stroke-color) svg path {
  fill: rgb(0, 31.62, 94.86) !important;
}

button.text-violet-25:hover .Icon--violet-25.change-fill-color svg path {
  fill: rgb(222.72, 214.65, 255) !important;
}
button.text-violet-25:hover .Icon--violet-25.change-stroke-color svg path {
  stroke: rgb(222.72, 214.65, 255) !important;
}

button.text-violet-25:active .Icon--violet-25.change-fill-color svg path {
  fill: rgb(190.4, 174.25, 255) !important;
}
button.text-violet-25:active .Icon--violet-25.change-stroke-color svg path {
  stroke: rgb(190.4, 174.25, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-25:not(.change-stroke-color) svg path {
  fill: rgb(222.72, 214.65, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-25:not(.change-stroke-color) svg path {
  fill: rgb(222.72, 214.65, 255) !important;
}

button.text-violet-50:hover .Icon--violet-50.change-fill-color svg path {
  fill: rgb(215.95, 208.14, 255) !important;
}
button.text-violet-50:hover .Icon--violet-50.change-stroke-color svg path {
  stroke: rgb(215.95, 208.14, 255) !important;
}

button.text-violet-50:active .Icon--violet-50.change-fill-color svg path {
  fill: rgb(182.75, 168.3, 255) !important;
}
button.text-violet-50:active .Icon--violet-50.change-stroke-color svg path {
  stroke: rgb(182.75, 168.3, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-50:not(.change-stroke-color) svg path {
  fill: rgb(215.95, 208.14, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-50:not(.change-stroke-color) svg path {
  fill: rgb(215.95, 208.14, 255) !important;
}

button.text-violet-100:hover .Icon--violet-100.change-fill-color svg path {
  fill: rgb(207.8386956522, 200.392173913, 252.517826087) !important;
}
button.text-violet-100:hover .Icon--violet-100.change-stroke-color svg path {
  stroke: rgb(207.8386956522, 200.392173913, 252.517826087) !important;
}

button.text-violet-100:active .Icon--violet-100.change-fill-color svg path {
  fill: rgb(175.6543478261, 163.1260869565, 250.8239130435) !important;
}
button.text-violet-100:active .Icon--violet-100.change-stroke-color svg path {
  stroke: rgb(175.6543478261, 163.1260869565, 250.8239130435) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-100:not(.change-stroke-color) svg path {
  fill: rgb(207.8386956522, 200.392173913, 252.517826087) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-100:not(.change-stroke-color) svg path {
  fill: rgb(207.8386956522, 200.392173913, 252.517826087) !important;
}

button.text-violet-200:hover .Icon--violet-200.change-fill-color svg path {
  fill: rgb(194.48, 182.02, 253.22) !important;
}
button.text-violet-200:hover .Icon--violet-200.change-stroke-color svg path {
  stroke: rgb(194.48, 182.02, 253.22) !important;
}

button.text-violet-200:active .Icon--violet-200.change-fill-color svg path {
  fill: rgb(164.1714285714, 145.4714285714, 252.3285714286) !important;
}
button.text-violet-200:active .Icon--violet-200.change-stroke-color svg path {
  stroke: rgb(164.1714285714, 145.4714285714, 252.3285714286) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-200:not(.change-stroke-color) svg path {
  fill: rgb(194.48, 182.02, 253.22) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-200:not(.change-stroke-color) svg path {
  fill: rgb(194.48, 182.02, 253.22) !important;
}

button.text-violet-300:hover .Icon--violet-300.change-fill-color svg path {
  fill: rgb(171.0157894737, 151.4194736842, 252.2005263158) !important;
}
button.text-violet-300:hover .Icon--violet-300.change-stroke-color svg path {
  stroke: rgb(171.0157894737, 151.4194736842, 252.2005263158) !important;
}

button.text-violet-300:active .Icon--violet-300.change-fill-color svg path {
  fill: rgb(143.6052631579, 117.6131578947, 251.2868421053) !important;
}
button.text-violet-300:active .Icon--violet-300.change-stroke-color svg path {
  stroke: rgb(143.6052631579, 117.6131578947, 251.2868421053) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-300:not(.change-stroke-color) svg path {
  fill: rgb(171.0157894737, 151.4194736842, 252.2005263158) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-300:not(.change-stroke-color) svg path {
  fill: rgb(171.0157894737, 151.4194736842, 252.2005263158) !important;
}

button.text-violet-400:hover .Icon--violet-400.change-fill-color svg path {
  fill: rgb(143.5212396694, 111.6701652893, 250.0998347107) !important;
}
button.text-violet-400:hover .Icon--violet-400.change-stroke-color svg path {
  stroke: rgb(143.5212396694, 111.6701652893, 250.0998347107) !important;
}

button.text-violet-400:active .Icon--violet-400.change-fill-color svg path {
  fill: rgb(120.1169421488, 81.5789256198, 249.0710743802) !important;
}
button.text-violet-400:active .Icon--violet-400.change-stroke-color svg path {
  stroke: rgb(120.1169421488, 81.5789256198, 249.0710743802) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-400:not(.change-stroke-color) svg path {
  fill: rgb(143.5212396694, 111.6701652893, 250.0998347107) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-400:not(.change-stroke-color) svg path {
  fill: rgb(143.5212396694, 111.6701652893, 250.0998347107) !important;
}

button.text-violet-500:hover .Icon--violet-500.change-fill-color svg path {
  fill: rgb(118.4930232558, 68.4404651163, 245.8995348837) !important;
}
button.text-violet-500:hover .Icon--violet-500.change-stroke-color svg path {
  stroke: rgb(118.4930232558, 68.4404651163, 245.8995348837) !important;
}

button.text-violet-500:active .Icon--violet-500.change-fill-color svg path {
  fill: rgb(99.6279069767, 42.6581395349, 244.6418604651) !important;
}
button.text-violet-500:active .Icon--violet-500.change-stroke-color svg path {
  stroke: rgb(99.6279069767, 42.6581395349, 244.6418604651) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-500:not(.change-stroke-color) svg path {
  fill: rgb(118.4930232558, 68.4404651163, 245.8995348837) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-500:not(.change-stroke-color) svg path {
  fill: rgb(118.4930232558, 68.4404651163, 245.8995348837) !important;
}

button.text-violet-600:hover .Icon--violet-600.change-fill-color svg path {
  fill: rgb(107.0337209302, 37.9827906977, 236.3672093023) !important;
}
button.text-violet-600:hover .Icon--violet-600.change-stroke-color svg path {
  stroke: rgb(107.0337209302, 37.9827906977, 236.3672093023) !important;
}

button.text-violet-600:active .Icon--violet-600.change-fill-color svg path {
  fill: rgb(93.3023255814, 19.826744186, 230.923255814) !important;
}
button.text-violet-600:active .Icon--violet-600.change-stroke-color svg path {
  stroke: rgb(93.3023255814, 19.826744186, 230.923255814) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-600:not(.change-stroke-color) svg path {
  fill: rgb(107.0337209302, 37.9827906977, 236.3672093023) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-600:not(.change-stroke-color) svg path {
  fill: rgb(107.0337209302, 37.9827906977, 236.3672093023) !important;
}

button.text-violet-700:hover .Icon--violet-700.change-fill-color svg path {
  fill: rgb(97.3044664032, 34.9540316206, 204.0559683794) !important;
}
button.text-violet-700:hover .Icon--violet-700.change-stroke-color svg path {
  stroke: rgb(97.3044664032, 34.9540316206, 204.0559683794) !important;
}

button.text-violet-700:active .Icon--violet-700.change-fill-color svg path {
  fill: rgb(88.9341897233, 31.9472332016, 186.5027667984) !important;
}
button.text-violet-700:active .Icon--violet-700.change-stroke-color svg path {
  stroke: rgb(88.9341897233, 31.9472332016, 186.5027667984) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-700:not(.change-stroke-color) svg path {
  fill: rgb(97.3044664032, 34.9540316206, 204.0559683794) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-700:not(.change-stroke-color) svg path {
  fill: rgb(97.3044664032, 34.9540316206, 204.0559683794) !important;
}

button.text-violet-800:hover .Icon--violet-800.change-fill-color svg path {
  fill: rgb(80.91, 29.76, 170.19) !important;
}
button.text-violet-800:hover .Icon--violet-800.change-stroke-color svg path {
  stroke: rgb(80.91, 29.76, 170.19) !important;
}

button.text-violet-800:active .Icon--violet-800.change-fill-color svg path {
  fill: rgb(73.95, 27.2, 155.55) !important;
}
button.text-violet-800:active .Icon--violet-800.change-stroke-color svg path {
  stroke: rgb(73.95, 27.2, 155.55) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-800:not(.change-stroke-color) svg path {
  fill: rgb(80.91, 29.76, 170.19) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-800:not(.change-stroke-color) svg path {
  fill: rgb(80.91, 29.76, 170.19) !important;
}

button.text-violet-900:hover .Icon--violet-900.change-fill-color svg path {
  fill: rgb(67.89, 26.04, 139.5) !important;
}
button.text-violet-900:hover .Icon--violet-900.change-stroke-color svg path {
  stroke: rgb(67.89, 26.04, 139.5) !important;
}

button.text-violet-900:active .Icon--violet-900.change-fill-color svg path {
  fill: rgb(62.05, 23.8, 127.5) !important;
}
button.text-violet-900:active .Icon--violet-900.change-stroke-color svg path {
  stroke: rgb(62.05, 23.8, 127.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-900:not(.change-stroke-color) svg path {
  fill: rgb(67.89, 26.04, 139.5) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-900:not(.change-stroke-color) svg path {
  fill: rgb(67.89, 26.04, 139.5) !important;
}

button.text-violet-950:hover .Icon--violet-950.change-fill-color svg path {
  fill: rgb(42.78, 16.74, 87.42) !important;
}
button.text-violet-950:hover .Icon--violet-950.change-stroke-color svg path {
  stroke: rgb(42.78, 16.74, 87.42) !important;
}

button.text-violet-950:active .Icon--violet-950.change-fill-color svg path {
  fill: rgb(39.1, 15.3, 79.9) !important;
}
button.text-violet-950:active .Icon--violet-950.change-stroke-color svg path {
  stroke: rgb(39.1, 15.3, 79.9) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--violet-950:not(.change-stroke-color) svg path {
  fill: rgb(42.78, 16.74, 87.42) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--violet-950:not(.change-stroke-color) svg path {
  fill: rgb(42.78, 16.74, 87.42) !important;
}

button.text-purple-25:hover .Icon--purple-25.change-fill-color svg path {
  fill: rgb(214.65, 214.65, 255) !important;
}
button.text-purple-25:hover .Icon--purple-25.change-stroke-color svg path {
  stroke: rgb(214.65, 214.65, 255) !important;
}

button.text-purple-25:active .Icon--purple-25.change-fill-color svg path {
  fill: rgb(174.25, 174.25, 255) !important;
}
button.text-purple-25:active .Icon--purple-25.change-stroke-color svg path {
  stroke: rgb(174.25, 174.25, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-25:not(.change-stroke-color) svg path {
  fill: rgb(214.65, 214.65, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-25:not(.change-stroke-color) svg path {
  fill: rgb(214.65, 214.65, 255) !important;
}

button.text-purple-50:hover .Icon--purple-50.change-fill-color svg path {
  fill: rgb(212.045, 208.14, 255) !important;
}
button.text-purple-50:hover .Icon--purple-50.change-stroke-color svg path {
  stroke: rgb(212.045, 208.14, 255) !important;
}

button.text-purple-50:active .Icon--purple-50.change-fill-color svg path {
  fill: rgb(175.525, 168.3, 255) !important;
}
button.text-purple-50:active .Icon--purple-50.change-stroke-color svg path {
  stroke: rgb(175.525, 168.3, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-50:not(.change-stroke-color) svg path {
  fill: rgb(212.045, 208.14, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-50:not(.change-stroke-color) svg path {
  fill: rgb(212.045, 208.14, 255) !important;
}

button.text-purple-100:hover .Icon--purple-100.change-fill-color svg path {
  fill: rgb(205.3565217391, 200.392173913, 252.517826087) !important;
}
button.text-purple-100:hover .Icon--purple-100.change-stroke-color svg path {
  stroke: rgb(205.3565217391, 200.392173913, 252.517826087) !important;
}

button.text-purple-100:active .Icon--purple-100.change-fill-color svg path {
  fill: rgb(171.4782608696, 163.1260869565, 250.8239130435) !important;
}
button.text-purple-100:active .Icon--purple-100.change-stroke-color svg path {
  stroke: rgb(171.4782608696, 163.1260869565, 250.8239130435) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-100:not(.change-stroke-color) svg path {
  fill: rgb(205.3565217391, 200.392173913, 252.517826087) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-100:not(.change-stroke-color) svg path {
  fill: rgb(205.3565217391, 200.392173913, 252.517826087) !important;
}

button.text-purple-200:hover .Icon--purple-200.change-fill-color svg path {
  fill: rgb(187.36, 182.02, 253.22) !important;
}
button.text-purple-200:hover .Icon--purple-200.change-stroke-color svg path {
  stroke: rgb(187.36, 182.02, 253.22) !important;
}

button.text-purple-200:active .Icon--purple-200.change-fill-color svg path {
  fill: rgb(153.4857142857, 145.4714285714, 252.3285714286) !important;
}
button.text-purple-200:active .Icon--purple-200.change-stroke-color svg path {
  stroke: rgb(153.4857142857, 145.4714285714, 252.3285714286) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-200:not(.change-stroke-color) svg path {
  fill: rgb(187.36, 182.02, 253.22) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-200:not(.change-stroke-color) svg path {
  fill: rgb(187.36, 182.02, 253.22) !important;
}

button.text-purple-300:hover .Icon--purple-300.change-fill-color svg path {
  fill: rgb(162.6173684211, 150.0197368421, 253.6002631579) !important;
}
button.text-purple-300:hover .Icon--purple-300.change-stroke-color svg path {
  stroke: rgb(162.6173684211, 150.0197368421, 253.6002631579) !important;
}

button.text-purple-300:active .Icon--purple-300.change-fill-color svg path {
  fill: rgb(132.4657894737, 115.7565789474, 253.1434210526) !important;
}
button.text-purple-300:active .Icon--purple-300.change-stroke-color svg path {
  stroke: rgb(132.4657894737, 115.7565789474, 253.1434210526) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-300:not(.change-stroke-color) svg path {
  fill: rgb(162.6173684211, 150.0197368421, 253.6002631579) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-300:not(.change-stroke-color) svg path {
  fill: rgb(162.6173684211, 150.0197368421, 253.6002631579) !important;
}

button.text-purple-400:hover .Icon--purple-400.change-fill-color svg path {
  fill: rgb(132.4958677686, 111.6701652893, 250.0998347107) !important;
}
button.text-purple-400:hover .Icon--purple-400.change-stroke-color svg path {
  stroke: rgb(132.4958677686, 111.6701652893, 250.0998347107) !important;
}

button.text-purple-400:active .Icon--purple-400.change-fill-color svg path {
  fill: rgb(106.7768595041, 81.5789256198, 249.0710743802) !important;
}
button.text-purple-400:active .Icon--purple-400.change-stroke-color svg path {
  stroke: rgb(106.7768595041, 81.5789256198, 249.0710743802) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-400:not(.change-stroke-color) svg path {
  fill: rgb(132.4958677686, 111.6701652893, 250.0998347107) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-400:not(.change-stroke-color) svg path {
  fill: rgb(132.4958677686, 111.6701652893, 250.0998347107) !important;
}

button.text-purple-500:hover .Icon--purple-500.change-fill-color svg path {
  fill: rgb(103.7047674419, 67.3029069767, 247.0370930233) !important;
}
button.text-purple-500:hover .Icon--purple-500.change-stroke-color svg path {
  stroke: rgb(103.7047674419, 67.3029069767, 247.0370930233) !important;
}

button.text-purple-500:active .Icon--purple-500.change-fill-color svg path {
  fill: rgb(82.7959302326, 41.363372093, 245.936627907) !important;
}
button.text-purple-500:active .Icon--purple-500.change-stroke-color svg path {
  stroke: rgb(82.7959302326, 41.363372093, 245.936627907) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-500:not(.change-stroke-color) svg path {
  fill: rgb(103.7047674419, 67.3029069767, 247.0370930233) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-500:not(.change-stroke-color) svg path {
  fill: rgb(103.7047674419, 67.3029069767, 247.0370930233) !important;
}

button.text-purple-600:hover .Icon--purple-600.change-fill-color svg path {
  fill: rgb(90.5930232558, 36.886744186, 237.463255814) !important;
}
button.text-purple-600:hover .Icon--purple-600.change-stroke-color svg path {
  stroke: rgb(90.5930232558, 36.886744186, 237.463255814) !important;
}

button.text-purple-600:active .Icon--purple-600.change-fill-color svg path {
  fill: rgb(75.8081395349, 18.6604651163, 232.0895348837) !important;
}
button.text-purple-600:active .Icon--purple-600.change-stroke-color svg path {
  stroke: rgb(75.8081395349, 18.6604651163, 232.0895348837) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-600:not(.change-stroke-color) svg path {
  fill: rgb(90.5930232558, 36.886744186, 237.463255814) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-600:not(.change-stroke-color) svg path {
  fill: rgb(90.5930232558, 36.886744186, 237.463255814) !important;
}

button.text-purple-700:hover .Icon--purple-700.change-fill-color svg path {
  fill: rgb(82.1892094862, 33.0646245059, 205.9453754941) !important;
}
button.text-purple-700:hover .Icon--purple-700.change-stroke-color svg path {
  stroke: rgb(82.1892094862, 33.0646245059, 205.9453754941) !important;
}

button.text-purple-700:active .Icon--purple-700.change-fill-color svg path {
  fill: rgb(75.1191699605, 30.2203557312, 188.2296442688) !important;
}
button.text-purple-700:active .Icon--purple-700.change-stroke-color svg path {
  stroke: rgb(75.1191699605, 30.2203557312, 188.2296442688) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-700:not(.change-stroke-color) svg path {
  fill: rgb(82.1892094862, 33.0646245059, 205.9453754941) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-700:not(.change-stroke-color) svg path {
  fill: rgb(82.1892094862, 33.0646245059, 205.9453754941) !important;
}

button.text-purple-800:hover .Icon--purple-800.change-fill-color svg path {
  fill: rgb(68.82, 28.83, 171.12) !important;
}
button.text-purple-800:hover .Icon--purple-800.change-stroke-color svg path {
  stroke: rgb(68.82, 28.83, 171.12) !important;
}

button.text-purple-800:active .Icon--purple-800.change-fill-color svg path {
  fill: rgb(62.9, 26.35, 156.4) !important;
}
button.text-purple-800:active .Icon--purple-800.change-stroke-color svg path {
  stroke: rgb(62.9, 26.35, 156.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-800:not(.change-stroke-color) svg path {
  fill: rgb(68.82, 28.83, 171.12) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-800:not(.change-stroke-color) svg path {
  fill: rgb(68.82, 28.83, 171.12) !important;
}

button.text-purple-900:hover .Icon--purple-900.change-fill-color svg path {
  fill: rgb(57.66, 26.04, 139.5) !important;
}
button.text-purple-900:hover .Icon--purple-900.change-stroke-color svg path {
  stroke: rgb(57.66, 26.04, 139.5) !important;
}

button.text-purple-900:active .Icon--purple-900.change-fill-color svg path {
  fill: rgb(52.7, 23.8, 127.5) !important;
}
button.text-purple-900:active .Icon--purple-900.change-stroke-color svg path {
  stroke: rgb(52.7, 23.8, 127.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-900:not(.change-stroke-color) svg path {
  fill: rgb(57.66, 26.04, 139.5) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-900:not(.change-stroke-color) svg path {
  fill: rgb(57.66, 26.04, 139.5) !important;
}

button.text-purple-950:hover .Icon--purple-950.change-fill-color svg path {
  fill: rgb(36.27, 15.81, 88.35) !important;
}
button.text-purple-950:hover .Icon--purple-950.change-stroke-color svg path {
  stroke: rgb(36.27, 15.81, 88.35) !important;
}

button.text-purple-950:active .Icon--purple-950.change-fill-color svg path {
  fill: rgb(33.15, 14.45, 80.75) !important;
}
button.text-purple-950:active .Icon--purple-950.change-stroke-color svg path {
  stroke: rgb(33.15, 14.45, 80.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--purple-950:not(.change-stroke-color) svg path {
  fill: rgb(36.27, 15.81, 88.35) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--purple-950:not(.change-stroke-color) svg path {
  fill: rgb(36.27, 15.81, 88.35) !important;
}

button.text-fuchsia-25:hover .Icon--fuchsia-25.change-fill-color svg path {
  fill: rgb(246.93, 214.65, 255) !important;
}
button.text-fuchsia-25:hover .Icon--fuchsia-25.change-stroke-color svg path {
  stroke: rgb(246.93, 214.65, 255) !important;
}

button.text-fuchsia-25:active .Icon--fuchsia-25.change-fill-color svg path {
  fill: rgb(238.85, 174.25, 255) !important;
}
button.text-fuchsia-25:active .Icon--fuchsia-25.change-stroke-color svg path {
  stroke: rgb(238.85, 174.25, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-25:not(.change-stroke-color) svg path {
  fill: rgb(246.93, 214.65, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-25:not(.change-stroke-color) svg path {
  fill: rgb(246.93, 214.65, 255) !important;
}

button.text-fuchsia-50:hover .Icon--fuchsia-50.change-fill-color svg path {
  fill: rgb(246.6490909091, 209.07, 255) !important;
}
button.text-fuchsia-50:hover .Icon--fuchsia-50.change-stroke-color svg path {
  stroke: rgb(246.6490909091, 209.07, 255) !important;
}

button.text-fuchsia-50:active .Icon--fuchsia-50.change-fill-color svg path {
  fill: rgb(239.3909090909, 169.15, 255) !important;
}
button.text-fuchsia-50:active .Icon--fuchsia-50.change-stroke-color svg path {
  stroke: rgb(239.3909090909, 169.15, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-50:not(.change-stroke-color) svg path {
  fill: rgb(246.6490909091, 209.07, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-50:not(.change-stroke-color) svg path {
  fill: rgb(246.6490909091, 209.07, 255) !important;
}

button.text-fuchsia-100:hover .Icon--fuchsia-100.change-fill-color svg path {
  fill: rgb(245.0713043478, 197.91, 255) !important;
}
button.text-fuchsia-100:hover .Icon--fuchsia-100.change-stroke-color svg path {
  stroke: rgb(245.0713043478, 197.91, 255) !important;
}

button.text-fuchsia-100:active .Icon--fuchsia-100.change-fill-color svg path {
  fill: rgb(238.2956521739, 158.95, 255) !important;
}
button.text-fuchsia-100:active .Icon--fuchsia-100.change-stroke-color svg path {
  stroke: rgb(238.2956521739, 158.95, 255) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-100:not(.change-stroke-color) svg path {
  fill: rgb(245.0713043478, 197.91, 255) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-100:not(.change-stroke-color) svg path {
  fill: rgb(245.0713043478, 197.91, 255) !important;
}

button.text-fuchsia-200:hover .Icon--fuchsia-200.change-fill-color svg path {
  fill: rgb(239.93625, 176.33375, 253.32625) !important;
}
button.text-fuchsia-200:hover .Icon--fuchsia-200.change-stroke-color svg path {
  stroke: rgb(239.93625, 176.33375, 253.32625) !important;
}

button.text-fuchsia-200:active .Icon--fuchsia-200.change-fill-color svg path {
  fill: rgb(233.00625, 140.14375, 252.55625) !important;
}
button.text-fuchsia-200:active .Icon--fuchsia-200.change-stroke-color svg path {
  stroke: rgb(233.00625, 140.14375, 252.55625) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-200:not(.change-stroke-color) svg path {
  fill: rgb(239.93625, 176.33375, 253.32625) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-200:not(.change-stroke-color) svg path {
  fill: rgb(239.93625, 176.33375, 253.32625) !important;
}

button.text-fuchsia-300:hover .Icon--fuchsia-300.change-fill-color svg path {
  fill: rgb(232.214137931, 141.0706896552, 252.3193103448) !important;
}
button.text-fuchsia-300:hover .Icon--fuchsia-300.change-stroke-color svg path {
  stroke: rgb(232.214137931, 141.0706896552, 252.3193103448) !important;
}

button.text-fuchsia-300:active .Icon--fuchsia-300.change-fill-color svg path {
  fill: rgb(225.6017241379, 108.0086206897, 251.5413793103) !important;
}
button.text-fuchsia-300:active .Icon--fuchsia-300.change-stroke-color svg path {
  stroke: rgb(225.6017241379, 108.0086206897, 251.5413793103) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-300:not(.change-stroke-color) svg path {
  fill: rgb(232.214137931, 141.0706896552, 252.3193103448) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-300:not(.change-stroke-color) svg path {
  fill: rgb(232.214137931, 141.0706896552, 252.3193103448) !important;
}

button.text-fuchsia-400:hover .Icon--fuchsia-400.change-fill-color svg path {
  fill: rgb(223.005, 95.025, 249.075) !important;
}
button.text-fuchsia-400:hover .Icon--fuchsia-400.change-stroke-color svg path {
  stroke: rgb(223.005, 95.025, 249.075) !important;
}

button.text-fuchsia-400:active .Icon--fuchsia-400.change-fill-color svg path {
  fill: rgb(217.2964285714, 66.4821428571, 248.0178571429) !important;
}
button.text-fuchsia-400:active .Icon--fuchsia-400.change-stroke-color svg path {
  stroke: rgb(217.2964285714, 66.4821428571, 248.0178571429) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-400:not(.change-stroke-color) svg path {
  fill: rgb(223.005, 95.025, 249.075) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-400:not(.change-stroke-color) svg path {
  fill: rgb(223.005, 95.025, 249.075) !important;
}

button.text-fuchsia-500:hover .Icon--fuchsia-500.change-fill-color svg path {
  fill: rgb(207.3726865672, 47.8765671642, 239.4934328358) !important;
}
button.text-fuchsia-500:hover .Icon--fuchsia-500.change-stroke-color svg path {
  stroke: rgb(207.3726865672, 47.8765671642, 239.4934328358) !important;
}

button.text-fuchsia-500:active .Icon--fuchsia-500.change-fill-color svg path {
  fill: rgb(202.0843283582, 24.878358209, 237.771641791) !important;
}
button.text-fuchsia-500:active .Icon--fuchsia-500.change-stroke-color svg path {
  stroke: rgb(202.0843283582, 24.878358209, 237.771641791) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-500:not(.change-stroke-color) svg path {
  fill: rgb(207.3726865672, 47.8765671642, 239.4934328358) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-500:not(.change-stroke-color) svg path {
  fill: rgb(207.3726865672, 47.8765671642, 239.4934328358) !important;
}

button.text-fuchsia-600:hover .Icon--fuchsia-600.change-fill-color svg path {
  fill: rgb(172.98, 33.48, 198.09) !important;
}
button.text-fuchsia-600:hover .Icon--fuchsia-600.change-stroke-color svg path {
  stroke: rgb(172.98, 33.48, 198.09) !important;
}

button.text-fuchsia-600:active .Icon--fuchsia-600.change-fill-color svg path {
  fill: rgb(158.1, 30.6, 181.05) !important;
}
button.text-fuchsia-600:active .Icon--fuchsia-600.change-stroke-color svg path {
  stroke: rgb(158.1, 30.6, 181.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-600:not(.change-stroke-color) svg path {
  fill: rgb(172.98, 33.48, 198.09) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-600:not(.change-stroke-color) svg path {
  fill: rgb(172.98, 33.48, 198.09) !important;
}

button.text-fuchsia-700:hover .Icon--fuchsia-700.change-fill-color svg path {
  fill: rgb(147.87, 24.18, 164.61) !important;
}
button.text-fuchsia-700:hover .Icon--fuchsia-700.change-stroke-color svg path {
  stroke: rgb(147.87, 24.18, 164.61) !important;
}

button.text-fuchsia-700:active .Icon--fuchsia-700.change-fill-color svg path {
  fill: rgb(135.15, 22.1, 150.45) !important;
}
button.text-fuchsia-700:active .Icon--fuchsia-700.change-stroke-color svg path {
  stroke: rgb(135.15, 22.1, 150.45) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-700:not(.change-stroke-color) svg path {
  fill: rgb(147.87, 24.18, 164.61) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-700:not(.change-stroke-color) svg path {
  fill: rgb(147.87, 24.18, 164.61) !important;
}

button.text-fuchsia-800:hover .Icon--fuchsia-800.change-fill-color svg path {
  fill: rgb(120.9, 22.32, 133.92) !important;
}
button.text-fuchsia-800:hover .Icon--fuchsia-800.change-stroke-color svg path {
  stroke: rgb(120.9, 22.32, 133.92) !important;
}

button.text-fuchsia-800:active .Icon--fuchsia-800.change-fill-color svg path {
  fill: rgb(110.5, 20.4, 122.4) !important;
}
button.text-fuchsia-800:active .Icon--fuchsia-800.change-stroke-color svg path {
  stroke: rgb(110.5, 20.4, 122.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-800:not(.change-stroke-color) svg path {
  fill: rgb(120.9, 22.32, 133.92) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-800:not(.change-stroke-color) svg path {
  fill: rgb(120.9, 22.32, 133.92) !important;
}

button.text-fuchsia-900:hover .Icon--fuchsia-900.change-fill-color svg path {
  fill: rgb(103.23, 22.32, 110.67) !important;
}
button.text-fuchsia-900:hover .Icon--fuchsia-900.change-stroke-color svg path {
  stroke: rgb(103.23, 22.32, 110.67) !important;
}

button.text-fuchsia-900:active .Icon--fuchsia-900.change-fill-color svg path {
  fill: rgb(94.35, 20.4, 101.15) !important;
}
button.text-fuchsia-900:active .Icon--fuchsia-900.change-stroke-color svg path {
  stroke: rgb(94.35, 20.4, 101.15) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-900:not(.change-stroke-color) svg path {
  fill: rgb(103.23, 22.32, 110.67) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-900:not(.change-stroke-color) svg path {
  fill: rgb(103.23, 22.32, 110.67) !important;
}

button.text-fuchsia-950:hover .Icon--fuchsia-950.change-fill-color svg path {
  fill: rgb(66.03, 14.88, 70.68) !important;
}
button.text-fuchsia-950:hover .Icon--fuchsia-950.change-stroke-color svg path {
  stroke: rgb(66.03, 14.88, 70.68) !important;
}

button.text-fuchsia-950:active .Icon--fuchsia-950.change-fill-color svg path {
  fill: rgb(60.35, 13.6, 64.6) !important;
}
button.text-fuchsia-950:active .Icon--fuchsia-950.change-stroke-color svg path {
  stroke: rgb(60.35, 13.6, 64.6) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--fuchsia-950:not(.change-stroke-color) svg path {
  fill: rgb(66.03, 14.88, 70.68) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--fuchsia-950:not(.change-stroke-color) svg path {
  fill: rgb(66.03, 14.88, 70.68) !important;
}

button.text-pink-25:hover .Icon--pink-25.change-fill-color svg path {
  fill: rgb(250.5, 214.5, 237) !important;
}
button.text-pink-25:hover .Icon--pink-25.change-stroke-color svg path {
  stroke: rgb(250.5, 214.5, 237) !important;
}

button.text-pink-25:active .Icon--pink-25.change-fill-color svg path {
  fill: rgb(246.5, 178.5, 221) !important;
}
button.text-pink-25:active .Icon--pink-25.change-stroke-color svg path {
  stroke: rgb(246.5, 178.5, 221) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-25:not(.change-stroke-color) svg path {
  fill: rgb(250.5, 214.5, 237) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-25:not(.change-stroke-color) svg path {
  fill: rgb(250.5, 214.5, 237) !important;
}

button.text-pink-50:hover .Icon--pink-50.change-fill-color svg path {
  fill: rgb(248.38, 211.97, 238.45) !important;
}
button.text-pink-50:hover .Icon--pink-50.change-stroke-color svg path {
  stroke: rgb(248.38, 211.97, 238.45) !important;
}

button.text-pink-50:active .Icon--pink-50.change-fill-color svg path {
  fill: rgb(243.1, 177.65, 225.25) !important;
}
button.text-pink-50:active .Icon--pink-50.change-stroke-color svg path {
  stroke: rgb(243.1, 177.65, 225.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-50:not(.change-stroke-color) svg path {
  fill: rgb(248.38, 211.97, 238.45) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-50:not(.change-stroke-color) svg path {
  fill: rgb(248.38, 211.97, 238.45) !important;
}

button.text-pink-100:hover .Icon--pink-100.change-fill-color svg path {
  fill: rgb(248.2433333333, 200.9466666667, 234.73) !important;
}
button.text-pink-100:hover .Icon--pink-100.change-stroke-color svg path {
  stroke: rgb(248.2433333333, 200.9466666667, 234.73) !important;
}

button.text-pink-100:active .Icon--pink-100.change-fill-color svg path {
  fill: rgb(243.95, 166.6, 221.85) !important;
}
button.text-pink-100:active .Icon--pink-100.change-stroke-color svg path {
  stroke: rgb(243.95, 166.6, 221.85) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-100:not(.change-stroke-color) svg path {
  fill: rgb(248.2433333333, 200.9466666667, 234.73) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-100:not(.change-stroke-color) svg path {
  fill: rgb(248.2433333333, 200.9466666667, 234.73) !important;
}

button.text-pink-200:hover .Icon--pink-200.change-fill-color svg path {
  fill: rgb(250.1503846154, 175.7896153846, 227.5188461538) !important;
}
button.text-pink-200:hover .Icon--pink-200.change-stroke-color svg path {
  stroke: rgb(250.1503846154, 175.7896153846, 227.5188461538) !important;
}

button.text-pink-200:active .Icon--pink-200.change-fill-color svg path {
  fill: rgb(248.0365384615, 141.2634615385, 215.5403846154) !important;
}
button.text-pink-200:active .Icon--pink-200.change-stroke-color svg path {
  stroke: rgb(248.0365384615, 141.2634615385, 215.5403846154) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-200:not(.change-stroke-color) svg path {
  fill: rgb(250.1503846154, 175.7896153846, 227.5188461538) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-200:not(.change-stroke-color) svg path {
  fill: rgb(250.1503846154, 175.7896153846, 227.5188461538) !important;
}

button.text-pink-300:hover .Icon--pink-300.change-fill-color svg path {
  fill: rgb(248.4306451613, 139.3793548387, 214.27) !important;
}
button.text-pink-300:hover .Icon--pink-300.change-stroke-color svg path {
  stroke: rgb(248.4306451613, 139.3793548387, 214.27) !important;
}

button.text-pink-300:active .Icon--pink-300.change-fill-color svg path {
  fill: rgb(246.6370967742, 107.8129032258, 203.15) !important;
}
button.text-pink-300:active .Icon--pink-300.change-stroke-color svg path {
  stroke: rgb(246.6370967742, 107.8129032258, 203.15) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-300:not(.change-stroke-color) svg path {
  fill: rgb(248.4306451613, 139.3793548387, 214.27) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-300:not(.change-stroke-color) svg path {
  fill: rgb(248.4306451613, 139.3793548387, 214.27) !important;
}

button.text-pink-400:hover .Icon--pink-400.change-fill-color svg path {
  fill: rgb(244.5161842105, 88.4238157895, 189.7673684211) !important;
}
button.text-pink-400:hover .Icon--pink-400.change-stroke-color svg path {
  stroke: rgb(244.5161842105, 88.4238157895, 189.7673684211) !important;
}

button.text-pink-400:active .Icon--pink-400.change-fill-color svg path {
  fill: rgb(242.8203947368, 61.4796052632, 179.2157894737) !important;
}
button.text-pink-400:active .Icon--pink-400.change-stroke-color svg path {
  stroke: rgb(242.8203947368, 61.4796052632, 179.2157894737) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-400:not(.change-stroke-color) svg path {
  fill: rgb(244.5161842105, 88.4238157895, 189.7673684211) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-400:not(.change-stroke-color) svg path {
  fill: rgb(244.5161842105, 88.4238157895, 189.7673684211) !important;
}

button.text-pink-500:hover .Icon--pink-500.change-fill-color svg path {
  fill: rgb(236.1855445545, 50.2544554455, 180.8489108911) !important;
}
button.text-pink-500:hover .Icon--pink-500.change-stroke-color svg path {
  stroke: rgb(236.1855445545, 50.2544554455, 180.8489108911) !important;
}

button.text-pink-500:active .Icon--pink-500.change-fill-color svg path {
  fill: rgb(234.1118811881, 27.6881188119, 172.6762376238) !important;
}
button.text-pink-500:active .Icon--pink-500.change-stroke-color svg path {
  stroke: rgb(234.1118811881, 27.6881188119, 172.6762376238) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-500:not(.change-stroke-color) svg path {
  fill: rgb(236.1855445545, 50.2544554455, 180.8489108911) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-500:not(.change-stroke-color) svg path {
  fill: rgb(236.1855445545, 50.2544554455, 180.8489108911) !important;
}

button.text-pink-600:hover .Icon--pink-600.change-fill-color svg path {
  fill: rgb(207.5671428571, 32.3728571429, 134.2521428571) !important;
}
button.text-pink-600:hover .Icon--pink-600.change-stroke-color svg path {
  stroke: rgb(207.5671428571, 32.3728571429, 134.2521428571) !important;
}

button.text-pink-600:active .Icon--pink-600.change-fill-color svg path {
  fill: rgb(189.7119047619, 29.5880952381, 122.7035714286) !important;
}
button.text-pink-600:active .Icon--pink-600.change-stroke-color svg path {
  stroke: rgb(189.7119047619, 29.5880952381, 122.7035714286) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-600:not(.change-stroke-color) svg path {
  fill: rgb(207.5671428571, 32.3728571429, 134.2521428571) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-600:not(.change-stroke-color) svg path {
  fill: rgb(207.5671428571, 32.3728571429, 134.2521428571) !important;
}

button.text-pink-700:hover .Icon--pink-700.change-fill-color svg path {
  fill: rgb(179.49, 19.53, 107.88) !important;
}
button.text-pink-700:hover .Icon--pink-700.change-stroke-color svg path {
  stroke: rgb(179.49, 19.53, 107.88) !important;
}

button.text-pink-700:active .Icon--pink-700.change-fill-color svg path {
  fill: rgb(164.05, 17.85, 98.6) !important;
}
button.text-pink-700:active .Icon--pink-700.change-stroke-color svg path {
  stroke: rgb(164.05, 17.85, 98.6) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-700:not(.change-stroke-color) svg path {
  fill: rgb(179.49, 19.53, 107.88) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-700:not(.change-stroke-color) svg path {
  fill: rgb(179.49, 19.53, 107.88) !important;
}

button.text-pink-800:hover .Icon--pink-800.change-fill-color svg path {
  fill: rgb(146.94, 20.46, 88.35) !important;
}
button.text-pink-800:hover .Icon--pink-800.change-stroke-color svg path {
  stroke: rgb(146.94, 20.46, 88.35) !important;
}

button.text-pink-800:active .Icon--pink-800.change-fill-color svg path {
  fill: rgb(134.3, 18.7, 80.75) !important;
}
button.text-pink-800:active .Icon--pink-800.change-stroke-color svg path {
  stroke: rgb(134.3, 18.7, 80.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-800:not(.change-stroke-color) svg path {
  fill: rgb(146.94, 20.46, 88.35) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-800:not(.change-stroke-color) svg path {
  fill: rgb(146.94, 20.46, 88.35) !important;
}

button.text-pink-900:hover .Icon--pink-900.change-fill-color svg path {
  fill: rgb(123.69, 20.46, 75.33) !important;
}
button.text-pink-900:hover .Icon--pink-900.change-stroke-color svg path {
  stroke: rgb(123.69, 20.46, 75.33) !important;
}

button.text-pink-900:active .Icon--pink-900.change-fill-color svg path {
  fill: rgb(113.05, 18.7, 68.85) !important;
}
button.text-pink-900:active .Icon--pink-900.change-stroke-color svg path {
  stroke: rgb(113.05, 18.7, 68.85) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-900:not(.change-stroke-color) svg path {
  fill: rgb(123.69, 20.46, 75.33) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-900:not(.change-stroke-color) svg path {
  fill: rgb(123.69, 20.46, 75.33) !important;
}

button.text-pink-950:hover .Icon--pink-950.change-fill-color svg path {
  fill: rgb(72.54, 12.09, 44.64) !important;
}
button.text-pink-950:hover .Icon--pink-950.change-stroke-color svg path {
  stroke: rgb(72.54, 12.09, 44.64) !important;
}

button.text-pink-950:active .Icon--pink-950.change-fill-color svg path {
  fill: rgb(66.3, 11.05, 40.8) !important;
}
button.text-pink-950:active .Icon--pink-950.change-stroke-color svg path {
  stroke: rgb(66.3, 11.05, 40.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--pink-950:not(.change-stroke-color) svg path {
  fill: rgb(72.54, 12.09, 44.64) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--pink-950:not(.change-stroke-color) svg path {
  fill: rgb(72.54, 12.09, 44.64) !important;
}

button.text-rose-25:hover .Icon--rose-25.change-fill-color svg path {
  fill: rgb(255, 210, 214.5) !important;
}
button.text-rose-25:hover .Icon--rose-25.change-stroke-color svg path {
  stroke: rgb(255, 210, 214.5) !important;
}

button.text-rose-25:active .Icon--rose-25.change-fill-color svg path {
  fill: rgb(255, 170, 178.5) !important;
}
button.text-rose-25:active .Icon--rose-25.change-stroke-color svg path {
  stroke: rgb(255, 170, 178.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-25:not(.change-stroke-color) svg path {
  fill: rgb(255, 210, 214.5) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-25:not(.change-stroke-color) svg path {
  fill: rgb(255, 210, 214.5) !important;
}

button.text-rose-50:hover .Icon--rose-50.change-fill-color svg path {
  fill: rgb(255, 206.28, 213.24) !important;
}
button.text-rose-50:hover .Icon--rose-50.change-stroke-color svg path {
  stroke: rgb(255, 206.28, 213.24) !important;
}

button.text-rose-50:active .Icon--rose-50.change-fill-color svg path {
  fill: rgb(255, 166.6, 179.2285714286) !important;
}
button.text-rose-50:active .Icon--rose-50.change-stroke-color svg path {
  stroke: rgb(255, 166.6, 179.2285714286) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-50:not(.change-stroke-color) svg path {
  fill: rgb(255, 206.28, 213.24) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-50:not(.change-stroke-color) svg path {
  fill: rgb(255, 206.28, 213.24) !important;
}

button.text-rose-100:hover .Icon--rose-100.change-fill-color svg path {
  fill: rgb(255, 194.19, 203.1988888889) !important;
}
button.text-rose-100:hover .Icon--rose-100.change-stroke-color svg path {
  stroke: rgb(255, 194.19, 203.1988888889) !important;
}

button.text-rose-100:active .Icon--rose-100.change-fill-color svg path {
  fill: rgb(255, 155.55, 170.2833333333) !important;
}
button.text-rose-100:active .Icon--rose-100.change-stroke-color svg path {
  stroke: rgb(255, 155.55, 170.2833333333) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-100:not(.change-stroke-color) svg path {
  fill: rgb(255, 194.19, 203.1988888889) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-100:not(.change-stroke-color) svg path {
  fill: rgb(255, 194.19, 203.1988888889) !important;
}

button.text-rose-200:hover .Icon--rose-200.change-fill-color svg path {
  fill: rgb(253.37, 173.5, 188.17) !important;
}
button.text-rose-200:hover .Icon--rose-200.change-stroke-color svg path {
  stroke: rgb(253.37, 173.5, 188.17) !important;
}

button.text-rose-200:active .Icon--rose-200.change-fill-color svg path {
  fill: rgb(252.65, 137.5, 158.65) !important;
}
button.text-rose-200:active .Icon--rose-200.change-stroke-color svg path {
  stroke: rgb(252.65, 137.5, 158.65) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-200:not(.change-stroke-color) svg path {
  fill: rgb(253.37, 173.5, 188.17) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-200:not(.change-stroke-color) svg path {
  fill: rgb(253.37, 173.5, 188.17) !important;
}

button.text-rose-300:hover .Icon--rose-300.change-fill-color svg path {
  fill: rgb(253.6861290323, 134.1238709677, 156.4596774194) !important;
}
button.text-rose-300:hover .Icon--rose-300.change-stroke-color svg path {
  stroke: rgb(253.6861290323, 134.1238709677, 156.4596774194) !important;
}

button.text-rose-300:active .Icon--rose-300.change-fill-color svg path {
  fill: rgb(253.3274193548, 101.1225806452, 129.5564516129) !important;
}
button.text-rose-300:active .Icon--rose-300.change-stroke-color svg path {
  stroke: rgb(253.3274193548, 101.1225806452, 129.5564516129) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-300:not(.change-stroke-color) svg path {
  fill: rgb(253.6861290323, 134.1238709677, 156.4596774194) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-300:not(.change-stroke-color) svg path {
  fill: rgb(253.6861290323, 134.1238709677, 156.4596774194) !important;
}

button.text-rose-400:hover .Icon--rose-400.change-fill-color svg path {
  fill: rgb(252.6509589041, 85.8690410959, 122.2791780822) !important;
}
button.text-rose-400:hover .Icon--rose-400.change-stroke-color svg path {
  stroke: rgb(252.6509589041, 85.8690410959, 122.2791780822) !important;
}

button.text-rose-400:active .Icon--rose-400.change-fill-color svg path {
  fill: rgb(252.2520547945, 57.1479452055, 99.7410958904) !important;
}
button.text-rose-400:active .Icon--rose-400.change-stroke-color svg path {
  stroke: rgb(252.2520547945, 57.1479452055, 99.7410958904) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-400:not(.change-stroke-color) svg path {
  fill: rgb(252.6509589041, 85.8690410959, 122.2791780822) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-400:not(.change-stroke-color) svg path {
  fill: rgb(252.6509589041, 85.8690410959, 122.2791780822) !important;
}

button.text-rose-500:hover .Icon--rose-500.change-fill-color svg path {
  fill: rgb(245.0472413793, 40.4627586207, 88.0148275862) !important;
}
button.text-rose-500:hover .Icon--rose-500.change-stroke-color svg path {
  stroke: rgb(245.0472413793, 40.4627586207, 88.0148275862) !important;
}

button.text-rose-500:active .Icon--rose-500.change-fill-color svg path {
  fill: rgb(243.9583743842, 16.9916256158, 69.7460591133) !important;
}
button.text-rose-500:active .Icon--rose-500.change-stroke-color svg path {
  stroke: rgb(243.9583743842, 16.9916256158, 69.7460591133) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-500:not(.change-stroke-color) svg path {
  fill: rgb(245.0472413793, 40.4627586207, 88.0148275862) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-500:not(.change-stroke-color) svg path {
  fill: rgb(245.0472413793, 40.4627586207, 88.0148275862) !important;
}

button.text-rose-600:hover .Icon--rose-600.change-fill-color svg path {
  fill: rgb(211.11, 25.11, 78.12) !important;
}
button.text-rose-600:hover .Icon--rose-600.change-stroke-color svg path {
  stroke: rgb(211.11, 25.11, 78.12) !important;
}

button.text-rose-600:active .Icon--rose-600.change-fill-color svg path {
  fill: rgb(192.95, 22.95, 71.4) !important;
}
button.text-rose-600:active .Icon--rose-600.change-stroke-color svg path {
  stroke: rgb(192.95, 22.95, 71.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-600:not(.change-stroke-color) svg path {
  fill: rgb(211.11, 25.11, 78.12) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-600:not(.change-stroke-color) svg path {
  fill: rgb(211.11, 25.11, 78.12) !important;
}

button.text-rose-700:hover .Icon--rose-700.change-fill-color svg path {
  fill: rgb(178.56, 14.88, 66.96) !important;
}
button.text-rose-700:hover .Icon--rose-700.change-stroke-color svg path {
  stroke: rgb(178.56, 14.88, 66.96) !important;
}

button.text-rose-700:active .Icon--rose-700.change-fill-color svg path {
  fill: rgb(163.2, 13.6, 61.2) !important;
}
button.text-rose-700:active .Icon--rose-700.change-stroke-color svg path {
  stroke: rgb(163.2, 13.6, 61.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-700:not(.change-stroke-color) svg path {
  fill: rgb(178.56, 14.88, 66.96) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-700:not(.change-stroke-color) svg path {
  fill: rgb(178.56, 14.88, 66.96) !important;
}

button.text-rose-800:hover .Icon--rose-800.change-fill-color svg path {
  fill: rgb(149.73, 14.88, 62.31) !important;
}
button.text-rose-800:hover .Icon--rose-800.change-stroke-color svg path {
  stroke: rgb(149.73, 14.88, 62.31) !important;
}

button.text-rose-800:active .Icon--rose-800.change-fill-color svg path {
  fill: rgb(136.85, 13.6, 56.95) !important;
}
button.text-rose-800:active .Icon--rose-800.change-stroke-color svg path {
  stroke: rgb(136.85, 13.6, 56.95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-800:not(.change-stroke-color) svg path {
  fill: rgb(149.73, 14.88, 62.31) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-800:not(.change-stroke-color) svg path {
  fill: rgb(149.73, 14.88, 62.31) !important;
}

button.text-rose-900:hover .Icon--rose-900.change-fill-color svg path {
  fill: rgb(127.41, 16.74, 57.66) !important;
}
button.text-rose-900:hover .Icon--rose-900.change-stroke-color svg path {
  stroke: rgb(127.41, 16.74, 57.66) !important;
}

button.text-rose-900:active .Icon--rose-900.change-fill-color svg path {
  fill: rgb(116.45, 15.3, 52.7) !important;
}
button.text-rose-900:active .Icon--rose-900.change-stroke-color svg path {
  stroke: rgb(116.45, 15.3, 52.7) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-900:not(.change-stroke-color) svg path {
  fill: rgb(127.41, 16.74, 57.66) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-900:not(.change-stroke-color) svg path {
  fill: rgb(127.41, 16.74, 57.66) !important;
}

button.text-rose-950:hover .Icon--rose-950.change-fill-color svg path {
  fill: rgb(75.33, 10.23, 33.48) !important;
}
button.text-rose-950:hover .Icon--rose-950.change-stroke-color svg path {
  stroke: rgb(75.33, 10.23, 33.48) !important;
}

button.text-rose-950:active .Icon--rose-950.change-fill-color svg path {
  fill: rgb(68.85, 9.35, 30.6) !important;
}
button.text-rose-950:active .Icon--rose-950.change-stroke-color svg path {
  stroke: rgb(68.85, 9.35, 30.6) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--rose-950:not(.change-stroke-color) svg path {
  fill: rgb(75.33, 10.23, 33.48) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--rose-950:not(.change-stroke-color) svg path {
  fill: rgb(75.33, 10.23, 33.48) !important;
}

button.text-orange-dark-25:hover .Icon--orange-dark-25.change-fill-color svg path {
  fill: #ffe4d2 !important;
}
button.text-orange-dark-25:hover .Icon--orange-dark-25.change-stroke-color svg path {
  stroke: #ffe4d2 !important;
}

button.text-orange-dark-25:active .Icon--orange-dark-25.change-fill-color svg path {
  fill: #ffccaa !important;
}
button.text-orange-dark-25:active .Icon--orange-dark-25.change-stroke-color svg path {
  stroke: #ffccaa !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-25:not(.change-stroke-color) svg path {
  fill: #ffe4d2 !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-25:not(.change-stroke-color) svg path {
  fill: #ffe4d2 !important;
}

button.text-orange-dark-50:hover .Icon--orange-dark-50.change-fill-color svg path {
  fill: rgb(255, 222.9533333333, 202.56) !important;
}
button.text-orange-dark-50:hover .Icon--orange-dark-50.change-stroke-color svg path {
  stroke: rgb(255, 222.9533333333, 202.56) !important;
}

button.text-orange-dark-50:active .Icon--orange-dark-50.change-fill-color svg path {
  fill: rgb(255, 198.9, 163.2) !important;
}
button.text-orange-dark-50:active .Icon--orange-dark-50.change-stroke-color svg path {
  stroke: rgb(255, 198.9, 163.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-50:not(.change-stroke-color) svg path {
  fill: rgb(255, 222.9533333333, 202.56) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-50:not(.change-stroke-color) svg path {
  fill: rgb(255, 222.9533333333, 202.56) !important;
}

button.text-orange-dark-100:hover .Icon--orange-dark-100.change-fill-color svg path {
  fill: rgb(255, 210.5, 180.24) !important;
}
button.text-orange-dark-100:hover .Icon--orange-dark-100.change-stroke-color svg path {
  stroke: rgb(255, 210.5, 180.24) !important;
}

button.text-orange-dark-100:active .Icon--orange-dark-100.change-fill-color svg path {
  fill: rgb(255, 188.2142857143, 142.8) !important;
}
button.text-orange-dark-100:active .Icon--orange-dark-100.change-stroke-color svg path {
  stroke: rgb(255, 188.2142857143, 142.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-100:not(.change-stroke-color) svg path {
  fill: rgb(255, 210.5, 180.24) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-100:not(.change-stroke-color) svg path {
  fill: rgb(255, 210.5, 180.24) !important;
}

button.text-orange-dark-200:hover .Icon--orange-dark-200.change-fill-color svg path {
  fill: rgb(255, 198.7996296296, 143.97) !important;
}
button.text-orange-dark-200:hover .Icon--orange-dark-200.change-stroke-color svg path {
  stroke: rgb(255, 198.7996296296, 143.97) !important;
}

button.text-orange-dark-200:active .Icon--orange-dark-200.change-fill-color svg path {
  fill: rgb(255, 181.4277777778, 109.65) !important;
}
button.text-orange-dark-200:active .Icon--orange-dark-200.change-stroke-color svg path {
  stroke: rgb(255, 181.4277777778, 109.65) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-200:not(.change-stroke-color) svg path {
  fill: rgb(255, 198.7996296296, 143.97) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-200:not(.change-stroke-color) svg path {
  fill: rgb(255, 198.7996296296, 143.97) !important;
}

button.text-orange-dark-300:hover .Icon--orange-dark-300.change-fill-color svg path {
  fill: rgb(255, 139.83, 77.01) !important;
}
button.text-orange-dark-300:hover .Icon--orange-dark-300.change-stroke-color svg path {
  stroke: rgb(255, 139.83, 77.01) !important;
}

button.text-orange-dark-300:active .Icon--orange-dark-300.change-fill-color svg path {
  fill: rgb(255, 121.35, 48.45) !important;
}
button.text-orange-dark-300:active .Icon--orange-dark-300.change-stroke-color svg path {
  stroke: rgb(255, 121.35, 48.45) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-300:not(.change-stroke-color) svg path {
  fill: rgb(255, 139.83, 77.01) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-300:not(.change-stroke-color) svg path {
  fill: rgb(255, 139.83, 77.01) !important;
}

button.text-orange-dark-400:hover .Icon--orange-dark-400.change-fill-color svg path {
  fill: #ff5a18 !important;
}
button.text-orange-dark-400:hover .Icon--orange-dark-400.change-stroke-color svg path {
  stroke: #ff5a18 !important;
}

button.text-orange-dark-400:active .Icon--orange-dark-400.change-fill-color svg path {
  fill: rgb(255, 72.8571428571, 0) !important;
}
button.text-orange-dark-400:active .Icon--orange-dark-400.change-stroke-color svg path {
  stroke: rgb(255, 72.8571428571, 0) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-400:not(.change-stroke-color) svg path {
  fill: #ff5a18 !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-400:not(.change-stroke-color) svg path {
  fill: #ff5a18 !important;
}

button.text-orange-dark-500:hover .Icon--orange-dark-500.change-fill-color svg path {
  fill: rgb(241.8, 60.9336, 0) !important;
}
button.text-orange-dark-500:hover .Icon--orange-dark-500.change-stroke-color svg path {
  stroke: rgb(241.8, 60.9336, 0) !important;
}

button.text-orange-dark-500:active .Icon--orange-dark-500.change-fill-color svg path {
  fill: rgb(221, 55.692, 0) !important;
}
button.text-orange-dark-500:active .Icon--orange-dark-500.change-stroke-color svg path {
  stroke: rgb(221, 55.692, 0) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-500:not(.change-stroke-color) svg path {
  fill: rgb(241.8, 60.9336, 0) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-500:not(.change-stroke-color) svg path {
  fill: rgb(241.8, 60.9336, 0) !important;
}

button.text-orange-dark-600:hover .Icon--orange-dark-600.change-fill-color svg path {
  fill: rgb(213.9, 42.78, 4.65) !important;
}
button.text-orange-dark-600:hover .Icon--orange-dark-600.change-stroke-color svg path {
  stroke: rgb(213.9, 42.78, 4.65) !important;
}

button.text-orange-dark-600:active .Icon--orange-dark-600.change-fill-color svg path {
  fill: rgb(195.5, 39.1, 4.25) !important;
}
button.text-orange-dark-600:active .Icon--orange-dark-600.change-stroke-color svg path {
  stroke: rgb(195.5, 39.1, 4.25) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-600:not(.change-stroke-color) svg path {
  fill: rgb(213.9, 42.78, 4.65) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-600:not(.change-stroke-color) svg path {
  fill: rgb(213.9, 42.78, 4.65) !important;
}

button.text-orange-dark-700:hover .Icon--orange-dark-700.change-fill-color svg path {
  fill: rgb(174.84, 25.11, 5.58) !important;
}
button.text-orange-dark-700:hover .Icon--orange-dark-700.change-stroke-color svg path {
  stroke: rgb(174.84, 25.11, 5.58) !important;
}

button.text-orange-dark-700:active .Icon--orange-dark-700.change-fill-color svg path {
  fill: rgb(159.8, 22.95, 5.1) !important;
}
button.text-orange-dark-700:active .Icon--orange-dark-700.change-stroke-color svg path {
  stroke: rgb(159.8, 22.95, 5.1) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-700:not(.change-stroke-color) svg path {
  fill: rgb(174.84, 25.11, 5.58) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-700:not(.change-stroke-color) svg path {
  fill: rgb(174.84, 25.11, 5.58) !important;
}

button.text-orange-dark-800:hover .Icon--orange-dark-800.change-fill-color svg path {
  fill: rgb(140.43, 22.32, 11.16) !important;
}
button.text-orange-dark-800:hover .Icon--orange-dark-800.change-stroke-color svg path {
  stroke: rgb(140.43, 22.32, 11.16) !important;
}

button.text-orange-dark-800:active .Icon--orange-dark-800.change-fill-color svg path {
  fill: rgb(128.35, 20.4, 10.2) !important;
}
button.text-orange-dark-800:active .Icon--orange-dark-800.change-stroke-color svg path {
  stroke: rgb(128.35, 20.4, 10.2) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-800:not(.change-stroke-color) svg path {
  fill: rgb(140.43, 22.32, 11.16) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-800:not(.change-stroke-color) svg path {
  fill: rgb(140.43, 22.32, 11.16) !important;
}

button.text-orange-dark-900:hover .Icon--orange-dark-900.change-fill-color svg path {
  fill: rgb(110.67, 24.18, 12.09) !important;
}
button.text-orange-dark-900:hover .Icon--orange-dark-900.change-stroke-color svg path {
  stroke: rgb(110.67, 24.18, 12.09) !important;
}

button.text-orange-dark-900:active .Icon--orange-dark-900.change-fill-color svg path {
  fill: rgb(101.15, 22.1, 11.05) !important;
}
button.text-orange-dark-900:active .Icon--orange-dark-900.change-stroke-color svg path {
  stroke: rgb(101.15, 22.1, 11.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-900:not(.change-stroke-color) svg path {
  fill: rgb(110.67, 24.18, 12.09) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-900:not(.change-stroke-color) svg path {
  fill: rgb(110.67, 24.18, 12.09) !important;
}

button.text-orange-dark-950:hover .Icon--orange-dark-950.change-fill-color svg path {
  fill: rgb(80.91, 17.67, 9.3) !important;
}
button.text-orange-dark-950:hover .Icon--orange-dark-950.change-stroke-color svg path {
  stroke: rgb(80.91, 17.67, 9.3) !important;
}

button.text-orange-dark-950:active .Icon--orange-dark-950.change-fill-color svg path {
  fill: rgb(73.95, 16.15, 8.5) !important;
}
button.text-orange-dark-950:active .Icon--orange-dark-950.change-stroke-color svg path {
  stroke: rgb(73.95, 16.15, 8.5) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--orange-dark-950:not(.change-stroke-color) svg path {
  fill: rgb(80.91, 17.67, 9.3) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--orange-dark-950:not(.change-stroke-color) svg path {
  fill: rgb(80.91, 17.67, 9.3) !important;
}

button.text-yellow-25:hover .Icon--yellow-25.change-fill-color svg path {
  fill: rgb(251.83875, 248.6775, 207.58125) !important;
}
button.text-yellow-25:hover .Icon--yellow-25.change-stroke-color svg path {
  stroke: rgb(251.83875, 248.6775, 207.58125) !important;
}

button.text-yellow-25:active .Icon--yellow-25.change-fill-color svg path {
  fill: rgb(249.36875, 243.7375, 170.53125) !important;
}
button.text-yellow-25:active .Icon--yellow-25.change-stroke-color svg path {
  stroke: rgb(249.36875, 243.7375, 170.53125) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-25:not(.change-stroke-color) svg path {
  fill: rgb(251.83875, 248.6775, 207.58125) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-25:not(.change-stroke-color) svg path {
  fill: rgb(251.83875, 248.6775, 207.58125) !important;
}

button.text-yellow-50:hover .Icon--yellow-50.change-fill-color svg path {
  fill: rgb(252.5825, 245.33, 199.3975) !important;
}
button.text-yellow-50:hover .Icon--yellow-50.change-stroke-color svg path {
  stroke: rgb(252.5825, 245.33, 199.3975) !important;
}

button.text-yellow-50:active .Icon--yellow-50.change-fill-color svg path {
  fill: rgb(250.9625, 238.85, 162.1375) !important;
}
button.text-yellow-50:active .Icon--yellow-50.change-stroke-color svg path {
  stroke: rgb(250.9625, 238.85, 162.1375) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-50:not(.change-stroke-color) svg path {
  fill: rgb(252.5825, 245.33, 199.3975) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-50:not(.change-stroke-color) svg path {
  fill: rgb(252.5825, 245.33, 199.3975) !important;
}

button.text-yellow-100:hover .Icon--yellow-100.change-fill-color svg path {
  fill: rgb(253.4847540984, 242.8780327869, 164.0852459016) !important;
}
button.text-yellow-100:hover .Icon--yellow-100.change-stroke-color svg path {
  stroke: rgb(253.4847540984, 242.8780327869, 164.0852459016) !important;
}

button.text-yellow-100:active .Icon--yellow-100.change-fill-color svg path {
  fill: rgb(252.8959016393, 238.1672131148, 128.7540983607) !important;
}
button.text-yellow-100:active .Icon--yellow-100.change-stroke-color svg path {
  stroke: rgb(252.8959016393, 238.1672131148, 128.7540983607) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-100:not(.change-stroke-color) svg path {
  fill: rgb(253.4847540984, 242.8780327869, 164.0852459016) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-100:not(.change-stroke-color) svg path {
  fill: rgb(253.4847540984, 242.8780327869, 164.0852459016) !important;
}

button.text-yellow-200:hover .Icon--yellow-200.change-fill-color svg path {
  fill: rgb(253.7363551402, 233.5180373832, 121.0536448598) !important;
}
button.text-yellow-200:hover .Icon--yellow-200.change-stroke-color svg path {
  stroke: rgb(253.7363551402, 233.5180373832, 121.0536448598) !important;
}

button.text-yellow-200:active .Icon--yellow-200.change-fill-color svg path {
  fill: rgb(253.435046729, 228.3957943925, 89.114953271) !important;
}
button.text-yellow-200:active .Icon--yellow-200.change-stroke-color svg path {
  stroke: rgb(253.435046729, 228.3957943925, 89.114953271) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-200:not(.change-stroke-color) svg path {
  fill: rgb(253.7363551402, 233.5180373832, 121.0536448598) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-200:not(.change-stroke-color) svg path {
  fill: rgb(253.7363551402, 233.5180373832, 121.0536448598) !important;
}

button.text-yellow-300:hover .Icon--yellow-300.change-fill-color svg path {
  fill: rgb(252.6406993007, 220.7901398601, 88.6693006993) !important;
}
button.text-yellow-300:hover .Icon--yellow-300.change-stroke-color svg path {
  stroke: rgb(252.6406993007, 220.7901398601, 88.6693006993) !important;
}

button.text-yellow-300:active .Icon--yellow-300.change-fill-color svg path {
  fill: rgb(252.2300699301, 214.836013986, 59.7199300699) !important;
}
button.text-yellow-300:active .Icon--yellow-300.change-stroke-color svg path {
  stroke: rgb(252.2300699301, 214.836013986, 59.7199300699) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-300:not(.change-stroke-color) svg path {
  fill: rgb(252.6406993007, 220.7901398601, 88.6693006993) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-300:not(.change-stroke-color) svg path {
  fill: rgb(252.6406993007, 220.7901398601, 88.6693006993) !important;
}

button.text-yellow-400:hover .Icon--yellow-400.change-fill-color svg path {
  fill: rgb(246.7574058577, 190.8679079498, 5.2725941423) !important;
}
button.text-yellow-400:hover .Icon--yellow-400.change-stroke-color svg path {
  stroke: rgb(246.7574058577, 190.8679079498, 5.2725941423) !important;
}

button.text-yellow-400:active .Icon--yellow-400.change-fill-color svg path {
  fill: rgb(225.5309623431, 174.4491631799, 4.8190376569) !important;
}
button.text-yellow-400:active .Icon--yellow-400.change-stroke-color svg path {
  stroke: rgb(225.5309623431, 174.4491631799, 4.8190376569) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-400:not(.change-stroke-color) svg path {
  fill: rgb(246.7574058577, 190.8679079498, 5.2725941423) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-400:not(.change-stroke-color) svg path {
  fill: rgb(246.7574058577, 190.8679079498, 5.2725941423) !important;
}

button.text-yellow-500:hover .Icon--yellow-500.change-fill-color svg path {
  fill: rgb(217.62, 158.1, 7.44) !important;
}
button.text-yellow-500:hover .Icon--yellow-500.change-stroke-color svg path {
  stroke: rgb(217.62, 158.1, 7.44) !important;
}

button.text-yellow-500:active .Icon--yellow-500.change-fill-color svg path {
  fill: rgb(198.9, 144.5, 6.8) !important;
}
button.text-yellow-500:active .Icon--yellow-500.change-stroke-color svg path {
  stroke: rgb(198.9, 144.5, 6.8) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-500:not(.change-stroke-color) svg path {
  fill: rgb(217.62, 158.1, 7.44) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-500:not(.change-stroke-color) svg path {
  fill: rgb(217.62, 158.1, 7.44) !important;
}

button.text-yellow-600:hover .Icon--yellow-600.change-fill-color svg path {
  fill: rgb(187.86, 123.69, 3.72) !important;
}
button.text-yellow-600:hover .Icon--yellow-600.change-stroke-color svg path {
  stroke: rgb(187.86, 123.69, 3.72) !important;
}

button.text-yellow-600:active .Icon--yellow-600.change-fill-color svg path {
  fill: rgb(171.7, 113.05, 3.4) !important;
}
button.text-yellow-600:active .Icon--yellow-600.change-stroke-color svg path {
  stroke: rgb(171.7, 113.05, 3.4) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-600:not(.change-stroke-color) svg path {
  fill: rgb(187.86, 123.69, 3.72) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-600:not(.change-stroke-color) svg path {
  fill: rgb(187.86, 123.69, 3.72) !important;
}

button.text-yellow-700:hover .Icon--yellow-700.change-fill-color svg path {
  fill: rgb(149.73, 85.56, 6.51) !important;
}
button.text-yellow-700:hover .Icon--yellow-700.change-stroke-color svg path {
  stroke: rgb(149.73, 85.56, 6.51) !important;
}

button.text-yellow-700:active .Icon--yellow-700.change-fill-color svg path {
  fill: rgb(136.85, 78.2, 5.95) !important;
}
button.text-yellow-700:active .Icon--yellow-700.change-stroke-color svg path {
  stroke: rgb(136.85, 78.2, 5.95) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-700:not(.change-stroke-color) svg path {
  fill: rgb(149.73, 85.56, 6.51) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-700:not(.change-stroke-color) svg path {
  fill: rgb(149.73, 85.56, 6.51) !important;
}

button.text-yellow-800:hover .Icon--yellow-800.change-fill-color svg path {
  fill: rgb(123.69, 68.82, 13.02) !important;
}
button.text-yellow-800:hover .Icon--yellow-800.change-stroke-color svg path {
  stroke: rgb(123.69, 68.82, 13.02) !important;
}

button.text-yellow-800:active .Icon--yellow-800.change-fill-color svg path {
  fill: rgb(113.05, 62.9, 11.9) !important;
}
button.text-yellow-800:active .Icon--yellow-800.change-stroke-color svg path {
  stroke: rgb(113.05, 62.9, 11.9) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-800:not(.change-stroke-color) svg path {
  fill: rgb(123.69, 68.82, 13.02) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-800:not(.change-stroke-color) svg path {
  fill: rgb(123.69, 68.82, 13.02) !important;
}

button.text-yellow-900:hover .Icon--yellow-900.change-fill-color svg path {
  fill: rgb(105.09, 54.87, 16.74) !important;
}
button.text-yellow-900:hover .Icon--yellow-900.change-stroke-color svg path {
  stroke: rgb(105.09, 54.87, 16.74) !important;
}

button.text-yellow-900:active .Icon--yellow-900.change-fill-color svg path {
  fill: rgb(96.05, 50.15, 15.3) !important;
}
button.text-yellow-900:active .Icon--yellow-900.change-stroke-color svg path {
  stroke: rgb(96.05, 50.15, 15.3) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-900:not(.change-stroke-color) svg path {
  fill: rgb(105.09, 54.87, 16.74) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-900:not(.change-stroke-color) svg path {
  fill: rgb(105.09, 54.87, 16.74) !important;
}

button.text-yellow-950:hover .Icon--yellow-950.change-fill-color svg path {
  fill: rgb(78.12, 40.92, 12.09) !important;
}
button.text-yellow-950:hover .Icon--yellow-950.change-stroke-color svg path {
  stroke: rgb(78.12, 40.92, 12.09) !important;
}

button.text-yellow-950:active .Icon--yellow-950.change-fill-color svg path {
  fill: rgb(71.4, 37.4, 11.05) !important;
}
button.text-yellow-950:active .Icon--yellow-950.change-stroke-color svg path {
  stroke: rgb(71.4, 37.4, 11.05) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--yellow-950:not(.change-stroke-color) svg path {
  fill: rgb(78.12, 40.92, 12.09) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--yellow-950:not(.change-stroke-color) svg path {
  fill: rgb(78.12, 40.92, 12.09) !important;
}

button.text-white-500:hover .Icon--white-500.change-fill-color svg path {
  fill: rgb(237.15, 237.15, 237.15) !important;
}
button.text-white-500:hover .Icon--white-500.change-stroke-color svg path {
  stroke: rgb(237.15, 237.15, 237.15) !important;
}

button.text-white-500:active .Icon--white-500.change-fill-color svg path {
  fill: rgb(216.75, 216.75, 216.75) !important;
}
button.text-white-500:active .Icon--white-500.change-stroke-color svg path {
  stroke: rgb(216.75, 216.75, 216.75) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--white-500:not(.change-stroke-color) svg path {
  fill: rgb(237.15, 237.15, 237.15) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--white-500:not(.change-stroke-color) svg path {
  fill: rgb(237.15, 237.15, 237.15) !important;
}

button.text-black-500:hover .Icon--black-500.change-fill-color svg path {
  fill: black !important;
}
button.text-black-500:hover .Icon--black-500.change-stroke-color svg path {
  stroke: black !important;
}

button.text-black-500:active .Icon--black-500.change-fill-color svg path {
  fill: black !important;
}
button.text-black-500:active .Icon--black-500.change-stroke-color svg path {
  stroke: black !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--black-500:not(.change-stroke-color) svg path {
  fill: black !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--black-500:not(.change-stroke-color) svg path {
  fill: black !important;
}

.Icon.Icon--primary-10.change-fill-color svg path,
.Icon.Icon--primary-10.change-fill-color svg polygon,
.Icon.Icon--primary-10.change-fill-color svg circle,
.Icon.Icon--primary-10.change-fill-color svg rect {
  fill: var(--color-primary-10, #fafdff);
}
.Icon.Icon--primary-10.change-stroke-color svg path,
.Icon.Icon--primary-10.change-stroke-color svg polygon,
.Icon.Icon--primary-10.change-stroke-color svg circle,
.Icon.Icon--primary-10.change-stroke-color svg rect {
  stroke: var(--color-primary-10, #fafdff);
}

button.text-primary-10:hover .Icon--primary-10.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(214.65, 238.86, 255)) !important;
}
button.text-primary-10:hover .Icon--primary-10.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(214.65, 238.86, 255)) !important;
}

button.text-primary-10:active .Icon--primary-10.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(174.25, 222.7, 255)) !important;
}
button.text-primary-10:active .Icon--primary-10.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(174.25, 222.7, 255)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-10:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(214.65, 238.86, 255)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-10:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(214.65, 238.86, 255)) !important;
}

.Icon.Icon--primary-25.change-fill-color svg path,
.Icon.Icon--primary-25.change-fill-color svg polygon,
.Icon.Icon--primary-25.change-fill-color svg circle,
.Icon.Icon--primary-25.change-fill-color svg rect {
  fill: var(--color-primary-25, #f5fbff);
}
.Icon.Icon--primary-25.change-stroke-color svg path,
.Icon.Icon--primary-25.change-stroke-color svg polygon,
.Icon.Icon--primary-25.change-stroke-color svg circle,
.Icon.Icon--primary-25.change-stroke-color svg rect {
  stroke: var(--color-primary-25, #f5fbff);
}

button.text-primary-25:hover .Icon--primary-25.change-fill-color svg path {
  fill: var(--color-primary-600, #d2edff) !important;
}
button.text-primary-25:hover .Icon--primary-25.change-stroke-color svg path {
  stroke: var(--color-primary-600, #d2edff) !important;
}

button.text-primary-25:active .Icon--primary-25.change-fill-color svg path {
  fill: var(--color-primary-700, #aaddff) !important;
}
button.text-primary-25:active .Icon--primary-25.change-stroke-color svg path {
  stroke: var(--color-primary-700, #aaddff) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-25:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, #d2edff) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-25:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, #d2edff) !important;
}

.Icon.Icon--primary-50.change-fill-color svg path,
.Icon.Icon--primary-50.change-fill-color svg polygon,
.Icon.Icon--primary-50.change-fill-color svg circle,
.Icon.Icon--primary-50.change-fill-color svg rect {
  fill: var(--color-primary-50, #f0f9ff);
}
.Icon.Icon--primary-50.change-stroke-color svg path,
.Icon.Icon--primary-50.change-stroke-color svg polygon,
.Icon.Icon--primary-50.change-stroke-color svg circle,
.Icon.Icon--primary-50.change-stroke-color svg rect {
  stroke: var(--color-primary-50, #f0f9ff);
}

button.text-primary-50:hover .Icon--primary-50.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(205.35, 235.14, 255)) !important;
}
button.text-primary-50:hover .Icon--primary-50.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(205.35, 235.14, 255)) !important;
}

button.text-primary-50:active .Icon--primary-50.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(165.75, 219.3, 255)) !important;
}
button.text-primary-50:active .Icon--primary-50.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(165.75, 219.3, 255)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-50:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(205.35, 235.14, 255)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-50:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(205.35, 235.14, 255)) !important;
}

.Icon.Icon--primary-100.change-fill-color svg path,
.Icon.Icon--primary-100.change-fill-color svg polygon,
.Icon.Icon--primary-100.change-fill-color svg circle,
.Icon.Icon--primary-100.change-fill-color svg rect {
  fill: var(--color-primary-100, #e0f2fe);
}
.Icon.Icon--primary-100.change-stroke-color svg path,
.Icon.Icon--primary-100.change-stroke-color svg polygon,
.Icon.Icon--primary-100.change-stroke-color svg circle,
.Icon.Icon--primary-100.change-stroke-color svg rect {
  stroke: var(--color-primary-100, #e0f2fe);
}

button.text-primary-100:hover .Icon--primary-100.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(191.585625, 228.406875, 252.954375)) !important;
}
button.text-primary-100:hover .Icon--primary-100.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(191.585625, 228.406875, 252.954375)) !important;
}

button.text-primary-100:active .Icon--primary-100.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(154.540625, 212.871875, 251.759375)) !important;
}
button.text-primary-100:active .Icon--primary-100.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(154.540625, 212.871875, 251.759375)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-100:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(191.585625, 228.406875, 252.954375)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-100:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(191.585625, 228.406875, 252.954375)) !important;
}

.Icon.Icon--primary-200.change-fill-color svg path,
.Icon.Icon--primary-200.change-fill-color svg polygon,
.Icon.Icon--primary-200.change-fill-color svg circle,
.Icon.Icon--primary-200.change-fill-color svg rect {
  fill: var(--color-primary-200, #b9e6fe);
}
.Icon.Icon--primary-200.change-stroke-color svg path,
.Icon.Icon--primary-200.change-stroke-color svg polygon,
.Icon.Icon--primary-200.change-stroke-color svg circle,
.Icon.Icon--primary-200.change-stroke-color svg rect {
  stroke: var(--color-primary-200, #b9e6fe);
}

button.text-primary-200:hover .Icon--primary-200.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(154.7028169014, 219.1795774648, 253.5671830986)) !important;
}
button.text-primary-200:hover .Icon--primary-200.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(154.7028169014, 219.1795774648, 253.5671830986)) !important;
}

button.text-primary-200:active .Icon--primary-200.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(120.0774647887, 206.8133802817, 253.0725352113)) !important;
}
button.text-primary-200:active .Icon--primary-200.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(120.0774647887, 206.8133802817, 253.0725352113)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-200:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(154.7028169014, 219.1795774648, 253.5671830986)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-200:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(154.7028169014, 219.1795774648, 253.5671830986)) !important;
}

.Icon.Icon--primary-300.change-fill-color svg path,
.Icon.Icon--primary-300.change-fill-color svg polygon,
.Icon.Icon--primary-300.change-fill-color svg circle,
.Icon.Icon--primary-300.change-fill-color svg rect {
  fill: var(--color-primary-300, #7cd4fd);
}
.Icon.Icon--primary-300.change-stroke-color svg path,
.Icon.Icon--primary-300.change-stroke-color svg polygon,
.Icon.Icon--primary-300.change-stroke-color svg circle,
.Icon.Icon--primary-300.change-stroke-color svg rect {
  stroke: var(--color-primary-300, #7cd4fd);
}

button.text-primary-300:hover .Icon--primary-300.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(98.0068421053, 203.4678947368, 252.6031578947)) !important;
}
button.text-primary-300:hover .Icon--primary-300.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(98.0068421053, 203.4678947368, 252.6031578947)) !important;
}

button.text-primary-300:active .Icon--primary-300.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(68.3003759398, 193.7169172932, 252.1496240602)) !important;
}
button.text-primary-300:active .Icon--primary-300.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(68.3003759398, 193.7169172932, 252.1496240602)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-300:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(98.0068421053, 203.4678947368, 252.6031578947)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-300:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(98.0068421053, 203.4678947368, 252.6031578947)) !important;
}

.Icon.Icon--primary-400.change-fill-color svg path,
.Icon.Icon--primary-400.change-fill-color svg polygon,
.Icon.Icon--primary-400.change-fill-color svg circle,
.Icon.Icon--primary-400.change-fill-color svg rect {
  fill: var(--color-primary-400, #36bffa);
}
.Icon.Icon--primary-400.change-stroke-color svg path,
.Icon.Icon--primary-400.change-stroke-color svg polygon,
.Icon.Icon--primary-400.change-stroke-color svg circle,
.Icon.Icon--primary-400.change-stroke-color svg rect {
  stroke: var(--color-primary-400, #36bffa);
}

button.text-primary-400:hover .Icon--primary-400.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(33.2365048544, 184.3887378641, 249.4834951456)) !important;
}
button.text-primary-400:hover .Icon--primary-400.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(33.2365048544, 184.3887378641, 249.4834951456)) !important;
}

button.text-primary-400:active .Icon--primary-400.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(9.5067961165, 176.8330097087, 248.8932038835)) !important;
}
button.text-primary-400:active .Icon--primary-400.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(9.5067961165, 176.8330097087, 248.8932038835)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-400:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(33.2365048544, 184.3887378641, 249.4834951456)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-400:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(33.2365048544, 184.3887378641, 249.4834951456)) !important;
}

.Icon.Icon--primary-500.change-fill-color svg path,
.Icon.Icon--primary-500.change-fill-color svg polygon,
.Icon.Icon--primary-500.change-fill-color svg circle,
.Icon.Icon--primary-500.change-fill-color svg rect {
  fill: var(--color-primary-500, #0ba5ec);
}
.Icon.Icon--primary-500.change-stroke-color svg path,
.Icon.Icon--primary-500.change-stroke-color svg polygon,
.Icon.Icon--primary-500.change-stroke-color svg circle,
.Icon.Icon--primary-500.change-stroke-color svg rect {
  stroke: var(--color-primary-500, #0ba5ec);
}

button.text-primary-500:hover .Icon--primary-500.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(10.23, 153.45, 219.48)) !important;
}
button.text-primary-500:hover .Icon--primary-500.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(10.23, 153.45, 219.48)) !important;
}

button.text-primary-500:active .Icon--primary-500.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(9.35, 140.25, 200.6)) !important;
}
button.text-primary-500:active .Icon--primary-500.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(9.35, 140.25, 200.6)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-500:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(10.23, 153.45, 219.48)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-500:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(10.23, 153.45, 219.48)) !important;
}

.Icon.Icon--primary-600.change-fill-color svg path,
.Icon.Icon--primary-600.change-fill-color svg polygon,
.Icon.Icon--primary-600.change-fill-color svg circle,
.Icon.Icon--primary-600.change-fill-color svg rect {
  fill: var(--color-primary-600, #0086c9);
}
.Icon.Icon--primary-600.change-stroke-color svg path,
.Icon.Icon--primary-600.change-stroke-color svg polygon,
.Icon.Icon--primary-600.change-stroke-color svg circle,
.Icon.Icon--primary-600.change-stroke-color svg rect {
  stroke: var(--color-primary-600, #0086c9);
}

button.text-primary-600:hover .Icon--primary-600.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(0, 124.62, 186.93)) !important;
}
button.text-primary-600:hover .Icon--primary-600.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(0, 124.62, 186.93)) !important;
}

button.text-primary-600:active .Icon--primary-600.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(0, 113.9, 170.85)) !important;
}
button.text-primary-600:active .Icon--primary-600.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(0, 113.9, 170.85)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-600:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(0, 124.62, 186.93)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-600:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(0, 124.62, 186.93)) !important;
}

.Icon.Icon--primary-700.change-fill-color svg path,
.Icon.Icon--primary-700.change-fill-color svg polygon,
.Icon.Icon--primary-700.change-fill-color svg circle,
.Icon.Icon--primary-700.change-fill-color svg rect {
  fill: var(--color-primary-700, #026aa2);
}
.Icon.Icon--primary-700.change-stroke-color svg path,
.Icon.Icon--primary-700.change-stroke-color svg polygon,
.Icon.Icon--primary-700.change-stroke-color svg circle,
.Icon.Icon--primary-700.change-stroke-color svg rect {
  stroke: var(--color-primary-700, #026aa2);
}

button.text-primary-700:hover .Icon--primary-700.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(1.86, 98.58, 150.66)) !important;
}
button.text-primary-700:hover .Icon--primary-700.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(1.86, 98.58, 150.66)) !important;
}

button.text-primary-700:active .Icon--primary-700.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(1.7, 90.1, 137.7)) !important;
}
button.text-primary-700:active .Icon--primary-700.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(1.7, 90.1, 137.7)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-700:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(1.86, 98.58, 150.66)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-700:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(1.86, 98.58, 150.66)) !important;
}

.Icon.Icon--primary-800.change-fill-color svg path,
.Icon.Icon--primary-800.change-fill-color svg polygon,
.Icon.Icon--primary-800.change-fill-color svg circle,
.Icon.Icon--primary-800.change-fill-color svg rect {
  fill: var(--color-primary-800, #065986);
}
.Icon.Icon--primary-800.change-stroke-color svg path,
.Icon.Icon--primary-800.change-stroke-color svg polygon,
.Icon.Icon--primary-800.change-stroke-color svg circle,
.Icon.Icon--primary-800.change-stroke-color svg rect {
  stroke: var(--color-primary-800, #065986);
}

button.text-primary-800:hover .Icon--primary-800.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(5.58, 82.77, 124.62)) !important;
}
button.text-primary-800:hover .Icon--primary-800.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(5.58, 82.77, 124.62)) !important;
}

button.text-primary-800:active .Icon--primary-800.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(5.1, 75.65, 113.9)) !important;
}
button.text-primary-800:active .Icon--primary-800.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(5.1, 75.65, 113.9)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-800:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(5.58, 82.77, 124.62)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-800:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(5.58, 82.77, 124.62)) !important;
}

.Icon.Icon--primary-900.change-fill-color svg path,
.Icon.Icon--primary-900.change-fill-color svg polygon,
.Icon.Icon--primary-900.change-fill-color svg circle,
.Icon.Icon--primary-900.change-fill-color svg rect {
  fill: var(--color-primary-900, #0b4a6f);
}
.Icon.Icon--primary-900.change-stroke-color svg path,
.Icon.Icon--primary-900.change-stroke-color svg polygon,
.Icon.Icon--primary-900.change-stroke-color svg circle,
.Icon.Icon--primary-900.change-stroke-color svg rect {
  stroke: var(--color-primary-900, #0b4a6f);
}

button.text-primary-900:hover .Icon--primary-900.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(10.23, 68.82, 103.23)) !important;
}
button.text-primary-900:hover .Icon--primary-900.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(10.23, 68.82, 103.23)) !important;
}

button.text-primary-900:active .Icon--primary-900.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(9.35, 62.9, 94.35)) !important;
}
button.text-primary-900:active .Icon--primary-900.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(9.35, 62.9, 94.35)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-900:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(10.23, 68.82, 103.23)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-900:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(10.23, 68.82, 103.23)) !important;
}

.Icon.Icon--primary-950.change-fill-color svg path,
.Icon.Icon--primary-950.change-fill-color svg polygon,
.Icon.Icon--primary-950.change-fill-color svg circle,
.Icon.Icon--primary-950.change-fill-color svg rect {
  fill: var(--color-primary-950, #062c41);
}
.Icon.Icon--primary-950.change-stroke-color svg path,
.Icon.Icon--primary-950.change-stroke-color svg polygon,
.Icon.Icon--primary-950.change-stroke-color svg circle,
.Icon.Icon--primary-950.change-stroke-color svg rect {
  stroke: var(--color-primary-950, #062c41);
}

button.text-primary-950:hover .Icon--primary-950.change-fill-color svg path {
  fill: var(--color-primary-600, rgb(5.58, 40.92, 60.45)) !important;
}
button.text-primary-950:hover .Icon--primary-950.change-stroke-color svg path {
  stroke: var(--color-primary-600, rgb(5.58, 40.92, 60.45)) !important;
}

button.text-primary-950:active .Icon--primary-950.change-fill-color svg path {
  fill: var(--color-primary-700, rgb(5.1, 37.4, 55.25)) !important;
}
button.text-primary-950:active .Icon--primary-950.change-stroke-color svg path {
  stroke: var(--color-primary-700, rgb(5.1, 37.4, 55.25)) !important;
}

.popover-button[data-headlessui-state="open active"] .Icon--primary-950:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(5.58, 40.92, 60.45)) !important;
}

.popover-button[data-headlessui-state="open active hover"] .Icon--primary-950:not(.change-stroke-color) svg path {
  fill: var(--color-primary-600, rgb(5.58, 40.92, 60.45)) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/Icon/lib/Icon.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;AAOI;EACE,yBAAA;AALN;AAUI;EACE,WAAA;EACA,YAAA;AARN;AAaI;EACE,eAAA;AAXN;AAYM;;;;EAIE,eAAA;AAVR;AAgBI;EACE,aAAA;AAdN;AAeM;;;;EAIE,aAAA;AAbR;AAuBU;EACE,eCrCH;ADgBT;AAuBU;EACE,eCxCH;ADmBT;AAuBU;EACE,eC3CH;ADsBT;AAuBU;EACE,eC9CH;ADyBT;AA2BU;EACE,aCrDH;AD4BT;AA2BU;EACE,aCxDH;AD+BT;AA2BU;EACE,aC3DH;ADkCT;AA2BU;EACE,aC9DH;ADqCT;AADU;EACE,eCrCH;ADwCT;AADU;EACE,eCxCH;AD2CT;AADU;EACE,eC3CH;AD8CT;AADU;EACE,eC9CH;ADiDT;AAGU;EACE,aCrDH;ADoDT;AAGU;EACE,aCxDH;ADuDT;AAGU;EACE,aC3DH;AD0DT;AAGU;EACE,aC9DH;AD6DT;AAzBU;EACE,eCrCH;ADgET;AAzBU;EACE,eCxCH;ADmET;AAzBU;EACE,eC3CH;ADsET;AAzBU;EACE,eC9CH;ADyET;AArBU;EACE,aCrDH;AD4ET;AArBU;EACE,aCxDH;AD+ET;AArBU;EACE,aC3DH;ADkFT;AArBU;EACE,aC9DH;ADqFT;AAjDU;EACE,eCrCH;ADwFT;AAjDU;EACE,eCxCH;AD2FT;AAjDU;EACE,eC3CH;AD8FT;AAjDU;EACE,eC9CH;ADiGT;AA7CU;EACE,aCrDH;ADoGT;AA7CU;EACE,aCxDH;ADuGT;AA7CU;EACE,aC3DH;AD0GT;AA7CU;EACE,aC9DH;AD6GT;AAzEU;EACE,eCrCH;ADgHT;AAzEU;EACE,eCxCH;ADmHT;AAzEU;EACE,eC3CH;ADsHT;AAzEU;EACE,eC9CH;ADyHT;AArEU;EACE,aCrDH;AD4HT;AArEU;EACE,aCxDH;AD+HT;AArEU;EACE,aC3DH;ADkIT;AArEU;EACE,aC9DH;ADqIT;AAjGU;EACE,eCrCH;ADwIT;AAjGU;EACE,eCxCH;AD2IT;AAjGU;EACE,eC3CH;AD8IT;AAjGU;EACE,eC9CH;ADiJT;AA7FU;EACE,aCrDH;ADoJT;AA7FU;EACE,aCxDH;ADuJT;AA7FU;EACE,aC3DH;AD0JT;AA7FU;EACE,aC9DH;AD6JT;AAzHU;EACE,eCrCH;ADgKT;AAzHU;EACE,eCxCH;ADmKT;AAzHU;EACE,eC3CH;ADsKT;AAzHU;EACE,eC9CH;ADyKT;AArHU;EACE,aCrDH;AD4KT;AArHU;EACE,aCxDH;AD+KT;AArHU;EACE,aC3DH;ADkLT;AArHU;EACE,aC9DH;ADqLT;AAjJU;EACE,eCrCH;ADwLT;AAjJU;EACE,eCxCH;AD2LT;AAjJU;EACE,eC3CH;AD8LT;AAjJU;EACE,eC9CH;ADiMT;AA7IU;EACE,aCrDH;ADoMT;AA7IU;EACE,aCxDH;ADuMT;AA7IU;EACE,aC3DH;AD0MT;AA7IU;EACE,aC9DH;AD6MT;AAzKU;EACE,eCrCH;ADgNT;AAzKU;EACE,eCxCH;ADmNT;AAzKU;EACE,eC3CH;ADsNT;AAzKU;EACE,eC9CH;ADyNT;AArKU;EACE,aCrDH;AD4NT;AArKU;EACE,aCxDH;AD+NT;AArKU;EACE,aC3DH;ADkOT;AArKU;EACE,aC9DH;ADqOT;AAjMU;EACE,eCrCH;ADwOT;AAjMU;EACE,eCxCH;AD2OT;AAjMU;EACE,eC3CH;AD8OT;AAjMU;EACE,eC9CH;ADiPT;AA7LU;EACE,aCrDH;ADoPT;AA7LU;EACE,aCxDH;ADuPT;AA7LU;EACE,aC3DH;AD0PT;AA7LU;EACE,aC9DH;AD6PT;AAzNU;EACE,eCrCH;ADgQT;AAzNU;EACE,eCxCH;ADmQT;AAzNU;EACE,eC3CH;ADsQT;AAzNU;EACE,eC9CH;ADyQT;AArNU;EACE,aCrDH;AD4QT;AArNU;EACE,aCxDH;AD+QT;AArNU;EACE,aC3DH;ADkRT;AArNU;EACE,aC9DH;ADqRT;AAjPU;EACE,eCrCH;ADwRT;AAjPU;EACE,eCxCH;AD2RT;AAjPU;EACE,eC3CH;AD8RT;AAjPU;EACE,eC9CH;ADiST;AA7OU;EACE,aCrDH;ADoST;AA7OU;EACE,aCxDH;ADuST;AA7OU;EACE,aC3DH;AD0ST;AA7OU;EACE,aC9DH;AD6ST;AAzQU;EACE,eCrCH;ADgTT;AAzQU;EACE,eCxCH;ADmTT;AAzQU;EACE,eC3CH;ADsTT;AAzQU;EACE,eC9CH;ADyTT;AArQU;EACE,aCrDH;AD4TT;AArQU;EACE,aCxDH;AD+TT;AArQU;EACE,aC3DH;ADkUT;AArQU;EACE,aC9DH;ADqUT;AAjSU;EACE,eCrCH;ADwUT;AAjSU;EACE,eCxCH;AD2UT;AAjSU;EACE,eC3CH;AD8UT;AAjSU;EACE,eC9CH;ADiVT;AA7RU;EACE,aCrDH;ADoVT;AA7RU;EACE,aCxDH;ADuVT;AA7RU;EACE,aC3DH;AD0VT;AA7RU;EACE,aC9DH;AD6VT;AAzTU;EACE,eCrCH;ADgWT;AAzTU;EACE,eCxCH;ADmWT;AAzTU;EACE,eC3CH;ADsWT;AAzTU;EACE,eC9CH;ADyWT;AArTU;EACE,aCrDH;AD4WT;AArTU;EACE,aCxDH;AD+WT;AArTU;EACE,aC3DH;ADkXT;AArTU;EACE,aC9DH;ADqXT;AAjVU;EACE,eCrCH;ADwXT;AAjVU;EACE,eCxCH;AD2XT;AAjVU;EACE,eC3CH;AD8XT;AAjVU;EACE,eC9CH;ADiYT;AA7UU;EACE,aCrDH;ADoYT;AA7UU;EACE,aCxDH;ADuYT;AA7UU;EACE,aC3DH;AD0YT;AA7UU;EACE,aC9DH;AD6YT;AAzWU;EACE,eCrCH;ADgZT;AAzWU;EACE,eCxCH;ADmZT;AAzWU;EACE,eC3CH;ADsZT;AAzWU;EACE,eC9CH;ADyZT;AArWU;EACE,aCrDH;AD4ZT;AArWU;EACE,aCxDH;AD+ZT;AArWU;EACE,aC3DH;ADkaT;AArWU;EACE,aC9DH;ADqaT;AAjYU;EACE,eCrCH;ADwaT;AAjYU;EACE,eCxCH;AD2aT;AAjYU;EACE,eC3CH;AD8aT;AAjYU;EACE,eC9CH;ADibT;AA7XU;EACE,aCrDH;ADobT;AA7XU;EACE,aCxDH;ADubT;AA7XU;EACE,aC3DH;AD0bT;AA7XU;EACE,aC9DH;AD6bT;AAzZU;EACE,eCrCH;ADgcT;AAzZU;EACE,eCxCH;ADmcT;AAzZU;EACE,eC3CH;ADscT;AAzZU;EACE,eC9CH;ADycT;AArZU;EACE,aCrDH;AD4cT;AArZU;EACE,aCxDH;AD+cT;AArZU;EACE,aC3DH;ADkdT;AArZU;EACE,aC9DH;ADqdT;AAjbU;EACE,eCrCH;ADwdT;AAjbU;EACE,eCxCH;AD2dT;AAjbU;EACE,eC3CH;AD8dT;AAjbU;EACE,eC9CH;ADieT;AA7aU;EACE,aCrDH;ADoeT;AA7aU;EACE,aCxDH;ADueT;AA7aU;EACE,aC3DH;AD0eT;AA7aU;EACE,aC9DH;AD6eT;AAzcU;EACE,eCrCH;ADgfT;AAzcU;EACE,eCxCH;ADmfT;AAzcU;EACE,eC3CH;ADsfT;AAzcU;EACE,eC9CH;ADyfT;AArcU;EACE,aCrDH;AD4fT;AArcU;EACE,aCxDH;AD+fT;AArcU;EACE,aC3DH;ADkgBT;AArcU;EACE,aC9DH;ADqgBT;AAjeU;EACE,eCrCH;ADwgBT;AAjeU;EACE,eCxCH;AD2gBT;AAjeU;EACE,eC3CH;AD8gBT;AAjeU;EACE,eC9CH;ADihBT;AA7dU;EACE,aCrDH;ADohBT;AA7dU;EACE,aCxDH;ADuhBT;AA7dU;EACE,aC3DH;AD0hBT;AA7dU;EACE,aC9DH;AD6hBT;AAzfU;EACE,eCrCH;ADgiBT;AAzfU;EACE,eCxCH;ADmiBT;AAzfU;EACE,eC3CH;ADsiBT;AAzfU;EACE,eC9CH;ADyiBT;AArfU;EACE,aCrDH;AD4iBT;AArfU;EACE,aCxDH;AD+iBT;AArfU;EACE,aC3DH;ADkjBT;AArfU;EACE,aC9DH;ADqjBT;AAjhBU;EACE,eCrCH;ADwjBT;AAjhBU;EACE,eCxCH;AD2jBT;AAjhBU;EACE,eC3CH;AD8jBT;AAjhBU;EACE,eC9CH;ADikBT;AA7gBU;EACE,aCrDH;ADokBT;AA7gBU;EACE,aCxDH;ADukBT;AA7gBU;EACE,aC3DH;AD0kBT;AA7gBU;EACE,aC9DH;AD6kBT;AAziBU;EACE,eCrCH;ADglBT;AAziBU;EACE,eCxCH;ADmlBT;AAziBU;EACE,eC3CH;ADslBT;AAziBU;EACE,eC9CH;ADylBT;AAriBU;EACE,aCrDH;AD4lBT;AAriBU;EACE,aCxDH;AD+lBT;AAriBU;EACE,aC3DH;ADkmBT;AAriBU;EACE,aC9DH;ADqmBT;AAjkBU;EACE,eCrCH;ADwmBT;AAjkBU;EACE,eCxCH;AD2mBT;AAjkBU;EACE,eC3CH;AD8mBT;AAjkBU;EACE,eC9CH;ADinBT;AA7jBU;EACE,aCrDH;ADonBT;AA7jBU;EACE,aCxDH;ADunBT;AA7jBU;EACE,aC3DH;AD0nBT;AA7jBU;EACE,aC9DH;AD6nBT;AAzlBU;EACE,eCrCH;ADgoBT;AAzlBU;EACE,eCxCH;ADmoBT;AAzlBU;EACE,eC3CH;ADsoBT;AAzlBU;EACE,eC9CH;ADyoBT;AArlBU;EACE,aCrDH;AD4oBT;AArlBU;EACE,aCxDH;AD+oBT;AArlBU;EACE,aC3DH;ADkpBT;AArlBU;EACE,aC9DH;ADqpBT;AAjnBU;EACE,eCrCH;ADwpBT;AAjnBU;EACE,eCxCH;AD2pBT;AAjnBU;EACE,eC3CH;AD8pBT;AAjnBU;EACE,eC9CH;ADiqBT;AA7mBU;EACE,aCrDH;ADoqBT;AA7mBU;EACE,aCxDH;ADuqBT;AA7mBU;EACE,aC3DH;AD0qBT;AA7mBU;EACE,aC9DH;AD6qBT;AAzoBU;EACE,eCrCH;ADgrBT;AAzoBU;EACE,eCxCH;ADmrBT;AAzoBU;EACE,eC3CH;ADsrBT;AAzoBU;EACE,eC9CH;ADyrBT;AAroBU;EACE,aCrDH;AD4rBT;AAroBU;EACE,aCxDH;AD+rBT;AAroBU;EACE,aC3DH;ADksBT;AAroBU;EACE,aC9DH;ADqsBT;AAjqBU;EACE,eCrCH;ADwsBT;AAjqBU;EACE,eCxCH;AD2sBT;AAjqBU;EACE,eC3CH;AD8sBT;AAjqBU;EACE,eC9CH;ADitBT;AA7pBU;EACE,aCrDH;ADotBT;AA7pBU;EACE,aCxDH;ADutBT;AA7pBU;EACE,aC3DH;AD0tBT;AA7pBU;EACE,aC9DH;AD6tBT;AAzrBU;EACE,eCrCH;ADguBT;AAzrBU;EACE,eCxCH;ADmuBT;AAzrBU;EACE,eC3CH;ADsuBT;AAzrBU;EACE,eC9CH;ADyuBT;AArrBU;EACE,aCrDH;AD4uBT;AArrBU;EACE,aCxDH;AD+uBT;AArrBU;EACE,aC3DH;ADkvBT;AArrBU;EACE,aC9DH;ADqvBT;AAjtBU;EACE,eCrCH;ADwvBT;AAjtBU;EACE,eCxCH;AD2vBT;AAjtBU;EACE,eC3CH;AD8vBT;AAjtBU;EACE,eC9CH;ADiwBT;AA7sBU;EACE,aCrDH;ADowBT;AA7sBU;EACE,aCxDH;ADuwBT;AA7sBU;EACE,aC3DH;AD0wBT;AA7sBU;EACE,aC9DH;AD6wBT;AAzuBU;EACE,eCrCH;ADgxBT;AAzuBU;EACE,eCxCH;ADmxBT;AAzuBU;EACE,eC3CH;ADsxBT;AAzuBU;EACE,eC9CH;ADyxBT;AAruBU;EACE,aCrDH;AD4xBT;AAruBU;EACE,aCxDH;AD+xBT;AAruBU;EACE,aC3DH;ADkyBT;AAruBU;EACE,aC9DH;ADqyBT;AAjwBU;EACE,eCrCH;ADwyBT;AAjwBU;EACE,eCxCH;AD2yBT;AAjwBU;EACE,eC3CH;AD8yBT;AAjwBU;EACE,eC9CH;ADizBT;AA7vBU;EACE,aCrDH;ADozBT;AA7vBU;EACE,aCxDH;ADuzBT;AA7vBU;EACE,aC3DH;AD0zBT;AA7vBU;EACE,aC9DH;AD6zBT;AAzxBU;EACE,eCrCH;ADg0BT;AAzxBU;EACE,eCxCH;ADm0BT;AAzxBU;EACE,eC3CH;ADs0BT;AAzxBU;EACE,eC9CH;ADy0BT;AArxBU;EACE,aCrDH;AD40BT;AArxBU;EACE,aCxDH;AD+0BT;AArxBU;EACE,aC3DH;ADk1BT;AArxBU;EACE,aC9DH;ADq1BT;AAjzBU;EACE,eCrCH;ADw1BT;AAjzBU;EACE,eCxCH;AD21BT;AAjzBU;EACE,eC3CH;AD81BT;AAjzBU;EACE,eC9CH;ADi2BT;AA7yBU;EACE,aCrDH;ADo2BT;AA7yBU;EACE,aCxDH;ADu2BT;AA7yBU;EACE,aC3DH;AD02BT;AA7yBU;EACE,aC9DH;AD62BT;AAz0BU;EACE,eCrCH;ADg3BT;AAz0BU;EACE,eCxCH;ADm3BT;AAz0BU;EACE,eC3CH;ADs3BT;AAz0BU;EACE,eC9CH;ADy3BT;AAr0BU;EACE,aCrDH;AD43BT;AAr0BU;EACE,aCxDH;AD+3BT;AAr0BU;EACE,aC3DH;ADk4BT;AAr0BU;EACE,aC9DH;ADq4BT;AAj2BU;EACE,eCrCH;ADw4BT;AAj2BU;EACE,eCxCH;AD24BT;AAj2BU;EACE,eC3CH;AD84BT;AAj2BU;EACE,eC9CH;ADi5BT;AA71BU;EACE,aCrDH;ADo5BT;AA71BU;EACE,aCxDH;ADu5BT;AA71BU;EACE,aC3DH;AD05BT;AA71BU;EACE,aC9DH;AD65BT;AAz3BU;EACE,eCrCH;ADg6BT;AAz3BU;EACE,eCxCH;ADm6BT;AAz3BU;EACE,eC3CH;ADs6BT;AAz3BU;EACE,eC9CH;ADy6BT;AAr3BU;EACE,aCrDH;AD46BT;AAr3BU;EACE,aCxDH;AD+6BT;AAr3BU;EACE,aC3DH;ADk7BT;AAr3BU;EACE,aC9DH;ADq7BT;AAj5BU;EACE,eCrCH;ADw7BT;AAj5BU;EACE,eCxCH;AD27BT;AAj5BU;EACE,eC3CH;AD87BT;AAj5BU;EACE,eC9CH;ADi8BT;AA74BU;EACE,aCrDH;ADo8BT;AA74BU;EACE,aCxDH;ADu8BT;AA74BU;EACE,aC3DH;AD08BT;AA74BU;EACE,aC9DH;AD68BT;AAz6BU;EACE,eCrCH;ADg9BT;AAz6BU;EACE,eCxCH;ADm9BT;AAz6BU;EACE,eC3CH;ADs9BT;AAz6BU;EACE,eC9CH;ADy9BT;AAr6BU;EACE,aCrDH;AD49BT;AAr6BU;EACE,aCxDH;AD+9BT;AAr6BU;EACE,aC3DH;ADk+BT;AAr6BU;EACE,aC9DH;ADq+BT;AAj8BU;EACE,eCrCH;ADw+BT;AAj8BU;EACE,eCxCH;AD2+BT;AAj8BU;EACE,eC3CH;AD8+BT;AAj8BU;EACE,eC9CH;ADi/BT;AA77BU;EACE,aCrDH;ADo/BT;AA77BU;EACE,aCxDH;ADu/BT;AA77BU;EACE,aC3DH;AD0/BT;AA77BU;EACE,aC9DH;AD6/BT;AAz9BU;EACE,eCrCH;ADggCT;AAz9BU;EACE,eCxCH;ADmgCT;AAz9BU;EACE,eC3CH;ADsgCT;AAz9BU;EACE,eC9CH;ADygCT;AAr9BU;EACE,aCrDH;AD4gCT;AAr9BU;EACE,aCxDH;AD+gCT;AAr9BU;EACE,aC3DH;ADkhCT;AAr9BU;EACE,aC9DH;ADqhCT;AAj/BU;EACE,eCrCH;ADwhCT;AAj/BU;EACE,eCxCH;AD2hCT;AAj/BU;EACE,eC3CH;AD8hCT;AAj/BU;EACE,eC9CH;ADiiCT;AA7+BU;EACE,aCrDH;ADoiCT;AA7+BU;EACE,aCxDH;ADuiCT;AA7+BU;EACE,aC3DH;AD0iCT;AA7+BU;EACE,aC9DH;AD6iCT;AAzgCU;EACE,eCrCH;ADgjCT;AAzgCU;EACE,eCxCH;ADmjCT;AAzgCU;EACE,eC3CH;ADsjCT;AAzgCU;EACE,eC9CH;ADyjCT;AArgCU;EACE,aCrDH;AD4jCT;AArgCU;EACE,aCxDH;AD+jCT;AArgCU;EACE,aC3DH;ADkkCT;AArgCU;EACE,aC9DH;ADqkCT;AAjiCU;EACE,eCrCH;ADwkCT;AAjiCU;EACE,eCxCH;AD2kCT;AAjiCU;EACE,eC3CH;AD8kCT;AAjiCU;EACE,eC9CH;ADilCT;AA7hCU;EACE,aCrDH;ADolCT;AA7hCU;EACE,aCxDH;ADulCT;AA7hCU;EACE,aC3DH;AD0lCT;AA7hCU;EACE,aC9DH;AD6lCT;AAzjCU;EACE,eCrCH;ADgmCT;AAzjCU;EACE,eCxCH;ADmmCT;AAzjCU;EACE,eC3CH;ADsmCT;AAzjCU;EACE,eC9CH;ADymCT;AArjCU;EACE,aCrDH;AD4mCT;AArjCU;EACE,aCxDH;AD+mCT;AArjCU;EACE,aC3DH;ADknCT;AArjCU;EACE,aC9DH;ADqnCT;AAjlCU;EACE,eCrCH;ADwnCT;AAjlCU;EACE,eCxCH;AD2nCT;AAjlCU;EACE,eC3CH;AD8nCT;AAjlCU;EACE,eC9CH;ADioCT;AA7kCU;EACE,aCrDH;ADooCT;AA7kCU;EACE,aCxDH;ADuoCT;AA7kCU;EACE,aC3DH;AD0oCT;AA7kCU;EACE,aC9DH;AD6oCT;AAzmCU;EACE,eCrCH;ADgpCT;AAzmCU;EACE,eCxCH;ADmpCT;AAzmCU;EACE,eC3CH;ADspCT;AAzmCU;EACE,eC9CH;ADypCT;AArmCU;EACE,aCrDH;AD4pCT;AArmCU;EACE,aCxDH;AD+pCT;AArmCU;EACE,aC3DH;ADkqCT;AArmCU;EACE,aC9DH;ADqqCT;AAjoCU;EACE,eCrCH;ADwqCT;AAjoCU;EACE,eCxCH;AD2qCT;AAjoCU;EACE,eC3CH;AD8qCT;AAjoCU;EACE,eC9CH;ADirCT;AA7nCU;EACE,aCrDH;ADorCT;AA7nCU;EACE,aCxDH;ADurCT;AA7nCU;EACE,aC3DH;AD0rCT;AA7nCU;EACE,aC9DH;AD6rCT;AAzpCU;EACE,eCrCH;ADgsCT;AAzpCU;EACE,eCxCH;ADmsCT;AAzpCU;EACE,eC3CH;ADssCT;AAzpCU;EACE,eC9CH;ADysCT;AArpCU;EACE,aCrDH;AD4sCT;AArpCU;EACE,aCxDH;AD+sCT;AArpCU;EACE,aC3DH;ADktCT;AArpCU;EACE,aC9DH;ADqtCT;AAjrCU;EACE,eCrCH;ADwtCT;AAjrCU;EACE,eCxCH;AD2tCT;AAjrCU;EACE,eC3CH;AD8tCT;AAjrCU;EACE,eC9CH;ADiuCT;AA7qCU;EACE,aCrDH;ADouCT;AA7qCU;EACE,aCxDH;ADuuCT;AA7qCU;EACE,aC3DH;AD0uCT;AA7qCU;EACE,aC9DH;AD6uCT;AAzsCU;EACE,eCrCH;ADgvCT;AAzsCU;EACE,eCxCH;ADmvCT;AAzsCU;EACE,eC3CH;ADsvCT;AAzsCU;EACE,eC9CH;ADyvCT;AArsCU;EACE,aCrDH;AD4vCT;AArsCU;EACE,aCxDH;AD+vCT;AArsCU;EACE,aC3DH;ADkwCT;AArsCU;EACE,aC9DH;ADqwCT;AAjuCU;EACE,eCrCH;ADwwCT;AAjuCU;EACE,eCxCH;AD2wCT;AAjuCU;EACE,eC3CH;AD8wCT;AAjuCU;EACE,eC9CH;ADixCT;AA7tCU;EACE,aCrDH;ADoxCT;AA7tCU;EACE,aCxDH;ADuxCT;AA7tCU;EACE,aC3DH;AD0xCT;AA7tCU;EACE,aC9DH;AD6xCT;AAzvCU;EACE,eCrCH;ADgyCT;AAzvCU;EACE,eCxCH;ADmyCT;AAzvCU;EACE,eC3CH;ADsyCT;AAzvCU;EACE,eC9CH;ADyyCT;AArvCU;EACE,aCrDH;AD4yCT;AArvCU;EACE,aCxDH;AD+yCT;AArvCU;EACE,aC3DH;ADkzCT;AArvCU;EACE,aC9DH;ADqzCT;AAjxCU;EACE,eCrCH;ADwzCT;AAjxCU;EACE,eCxCH;AD2zCT;AAjxCU;EACE,eC3CH;AD8zCT;AAjxCU;EACE,eC9CH;ADi0CT;AA7wCU;EACE,aCrDH;ADo0CT;AA7wCU;EACE,aCxDH;ADu0CT;AA7wCU;EACE,aC3DH;AD00CT;AA7wCU;EACE,aC9DH;AD60CT;AAzyCU;EACE,eCrCH;ADg1CT;AAzyCU;EACE,eCxCH;ADm1CT;AAzyCU;EACE,eC3CH;ADs1CT;AAzyCU;EACE,eC9CH;ADy1CT;AAryCU;EACE,aCrDH;AD41CT;AAryCU;EACE,aCxDH;AD+1CT;AAryCU;EACE,aC3DH;ADk2CT;AAryCU;EACE,aC9DH;ADq2CT;AAj0CU;EACE,eCrCH;ADw2CT;AAj0CU;EACE,eCxCH;AD22CT;AAj0CU;EACE,eC3CH;AD82CT;AAj0CU;EACE,eC9CH;ADi3CT;AA7zCU;EACE,aCrDH;ADo3CT;AA7zCU;EACE,aCxDH;ADu3CT;AA7zCU;EACE,aC3DH;AD03CT;AA7zCU;EACE,aC9DH;AD63CT;AAz1CU;EACE,eCrCH;ADg4CT;AAz1CU;EACE,eCxCH;ADm4CT;AAz1CU;EACE,eC3CH;ADs4CT;AAz1CU;EACE,eC9CH;ADy4CT;AAr1CU;EACE,aCrDH;AD44CT;AAr1CU;EACE,aCxDH;AD+4CT;AAr1CU;EACE,aC3DH;ADk5CT;AAr1CU;EACE,aC9DH;ADq5CT;AAj3CU;EACE,eCrCH;ADw5CT;AAj3CU;EACE,eCxCH;AD25CT;AAj3CU;EACE,eC3CH;AD85CT;AAj3CU;EACE,eC9CH;ADi6CT;AA72CU;EACE,aCrDH;ADo6CT;AA72CU;EACE,aCxDH;ADu6CT;AA72CU;EACE,aC3DH;AD06CT;AA72CU;EACE,aC9DH;AD66CT;AAz4CU;EACE,eCrCH;ADg7CT;AAz4CU;EACE,eCxCH;ADm7CT;AAz4CU;EACE,eC3CH;ADs7CT;AAz4CU;EACE,eC9CH;ADy7CT;AAr4CU;EACE,aCrDH;AD47CT;AAr4CU;EACE,aCxDH;AD+7CT;AAr4CU;EACE,aC3DH;ADk8CT;AAr4CU;EACE,aC9DH;ADq8CT;AAj6CU;EACE,eCrCH;ADw8CT;AAj6CU;EACE,eCxCH;AD28CT;AAj6CU;EACE,eC3CH;AD88CT;AAj6CU;EACE,eC9CH;ADi9CT;AA75CU;EACE,aCrDH;ADo9CT;AA75CU;EACE,aCxDH;ADu9CT;AA75CU;EACE,aC3DH;AD09CT;AA75CU;EACE,aC9DH;AD69CT;AAz7CU;EACE,eCrCH;ADg+CT;AAz7CU;EACE,eCxCH;ADm+CT;AAz7CU;EACE,eC3CH;ADs+CT;AAz7CU;EACE,eC9CH;ADy+CT;AAr7CU;EACE,aCrDH;AD4+CT;AAr7CU;EACE,aCxDH;AD++CT;AAr7CU;EACE,aC3DH;ADk/CT;AAr7CU;EACE,aC9DH;ADq/CT;AAj9CU;EACE,eCrCH;ADw/CT;AAj9CU;EACE,eCxCH;AD2/CT;AAj9CU;EACE,eC3CH;AD8/CT;AAj9CU;EACE,eC9CH;ADigDT;AA78CU;EACE,aCrDH;ADogDT;AA78CU;EACE,aCxDH;ADugDT;AA78CU;EACE,aC3DH;AD0gDT;AA78CU;EACE,aC9DH;AD6gDT;AAz+CU;EACE,eCrCH;ADghDT;AAz+CU;EACE,eCxCH;ADmhDT;AAz+CU;EACE,eC3CH;ADshDT;AAz+CU;EACE,eC9CH;ADyhDT;AAr+CU;EACE,aCrDH;AD4hDT;AAr+CU;EACE,aCxDH;AD+hDT;AAr+CU;EACE,aC3DH;ADkiDT;AAr+CU;EACE,aC9DH;ADqiDT;AAjgDU;EACE,eCrCH;ADwiDT;AAjgDU;EACE,eCxCH;AD2iDT;AAjgDU;EACE,eC3CH;AD8iDT;AAjgDU;EACE,eC9CH;ADijDT;AA7/CU;EACE,aCrDH;ADojDT;AA7/CU;EACE,aCxDH;ADujDT;AA7/CU;EACE,aC3DH;AD0jDT;AA7/CU;EACE,aC9DH;AD6jDT;AAzhDU;EACE,eCrCH;ADgkDT;AAzhDU;EACE,eCxCH;ADmkDT;AAzhDU;EACE,eC3CH;ADskDT;AAzhDU;EACE,eC9CH;ADykDT;AArhDU;EACE,aCrDH;AD4kDT;AArhDU;EACE,aCxDH;AD+kDT;AArhDU;EACE,aC3DH;ADklDT;AArhDU;EACE,aC9DH;ADqlDT;AAjjDU;EACE,eCrCH;ADwlDT;AAjjDU;EACE,eCxCH;AD2lDT;AAjjDU;EACE,eC3CH;AD8lDT;AAjjDU;EACE,eC9CH;ADimDT;AA7iDU;EACE,aCrDH;ADomDT;AA7iDU;EACE,aCxDH;ADumDT;AA7iDU;EACE,aC3DH;AD0mDT;AA7iDU;EACE,aC9DH;AD6mDT;AAzkDU;EACE,eCrCH;ADgnDT;AAzkDU;EACE,eCxCH;ADmnDT;AAzkDU;EACE,eC3CH;ADsnDT;AAzkDU;EACE,eC9CH;ADynDT;AArkDU;EACE,aCrDH;AD4nDT;AArkDU;EACE,aCxDH;AD+nDT;AArkDU;EACE,aC3DH;ADkoDT;AArkDU;EACE,aC9DH;ADqoDT;AAjmDU;EACE,eCrCH;ADwoDT;AAjmDU;EACE,eCxCH;AD2oDT;AAjmDU;EACE,eC3CH;AD8oDT;AAjmDU;EACE,eC9CH;ADipDT;AA7lDU;EACE,aCrDH;ADopDT;AA7lDU;EACE,aCxDH;ADupDT;AA7lDU;EACE,aC3DH;AD0pDT;AA7lDU;EACE,aC9DH;AD6pDT;AAznDU;EACE,eCrCH;ADgqDT;AAznDU;EACE,eCxCH;ADmqDT;AAznDU;EACE,eC3CH;ADsqDT;AAznDU;EACE,eC9CH;ADyqDT;AArnDU;EACE,aCrDH;AD4qDT;AArnDU;EACE,aCxDH;AD+qDT;AArnDU;EACE,aC3DH;ADkrDT;AArnDU;EACE,aC9DH;ADqrDT;AAjpDU;EACE,eCrCH;ADwrDT;AAjpDU;EACE,eCxCH;AD2rDT;AAjpDU;EACE,eC3CH;AD8rDT;AAjpDU;EACE,eC9CH;ADisDT;AA7oDU;EACE,aCrDH;ADosDT;AA7oDU;EACE,aCxDH;ADusDT;AA7oDU;EACE,aC3DH;AD0sDT;AA7oDU;EACE,aC9DH;AD6sDT;AAzqDU;EACE,eCrCH;ADgtDT;AAzqDU;EACE,eCxCH;ADmtDT;AAzqDU;EACE,eC3CH;ADstDT;AAzqDU;EACE,eC9CH;ADytDT;AArqDU;EACE,aCrDH;AD4tDT;AArqDU;EACE,aCxDH;AD+tDT;AArqDU;EACE,aC3DH;ADkuDT;AArqDU;EACE,aC9DH;ADquDT;AAjsDU;EACE,eCrCH;ADwuDT;AAjsDU;EACE,eCxCH;AD2uDT;AAjsDU;EACE,eC3CH;AD8uDT;AAjsDU;EACE,eC9CH;ADivDT;AA7rDU;EACE,aCrDH;ADovDT;AA7rDU;EACE,aCxDH;ADuvDT;AA7rDU;EACE,aC3DH;AD0vDT;AA7rDU;EACE,aC9DH;AD6vDT;AAztDU;EACE,eCrCH;ADgwDT;AAztDU;EACE,eCxCH;ADmwDT;AAztDU;EACE,eC3CH;ADswDT;AAztDU;EACE,eC9CH;ADywDT;AArtDU;EACE,aCrDH;AD4wDT;AArtDU;EACE,aCxDH;AD+wDT;AArtDU;EACE,aC3DH;ADkxDT;AArtDU;EACE,aC9DH;ADqxDT;AAjvDU;EACE,eCrCH;ADwxDT;AAjvDU;EACE,eCxCH;AD2xDT;AAjvDU;EACE,eC3CH;AD8xDT;AAjvDU;EACE,eC9CH;ADiyDT;AA7uDU;EACE,aCrDH;ADoyDT;AA7uDU;EACE,aCxDH;ADuyDT;AA7uDU;EACE,aC3DH;AD0yDT;AA7uDU;EACE,aC9DH;AD6yDT;AAzwDU;EACE,eCrCH;ADgzDT;AAzwDU;EACE,eCxCH;ADmzDT;AAzwDU;EACE,eC3CH;ADszDT;AAzwDU;EACE,eC9CH;ADyzDT;AArwDU;EACE,aCrDH;AD4zDT;AArwDU;EACE,aCxDH;AD+zDT;AArwDU;EACE,aC3DH;ADk0DT;AArwDU;EACE,aC9DH;ADq0DT;AAjyDU;EACE,eCrCH;ADw0DT;AAjyDU;EACE,eCxCH;AD20DT;AAjyDU;EACE,eC3CH;AD80DT;AAjyDU;EACE,eC9CH;ADi1DT;AA7xDU;EACE,aCrDH;ADo1DT;AA7xDU;EACE,aCxDH;ADu1DT;AA7xDU;EACE,aC3DH;AD01DT;AA7xDU;EACE,aC9DH;AD61DT;AAzzDU;EACE,eCrCH;ADg2DT;AAzzDU;EACE,eCxCH;ADm2DT;AAzzDU;EACE,eC3CH;ADs2DT;AAzzDU;EACE,eC9CH;ADy2DT;AArzDU;EACE,aCrDH;AD42DT;AArzDU;EACE,aCxDH;AD+2DT;AArzDU;EACE,aC3DH;ADk3DT;AArzDU;EACE,aC9DH;ADq3DT;AAj1DU;EACE,eCrCH;ADw3DT;AAj1DU;EACE,eCxCH;AD23DT;AAj1DU;EACE,eC3CH;AD83DT;AAj1DU;EACE,eC9CH;ADi4DT;AA70DU;EACE,aCrDH;ADo4DT;AA70DU;EACE,aCxDH;ADu4DT;AA70DU;EACE,aC3DH;AD04DT;AA70DU;EACE,aC9DH;AD64DT;AAz2DU;EACE,eCrCH;ADg5DT;AAz2DU;EACE,eCxCH;ADm5DT;AAz2DU;EACE,eC3CH;ADs5DT;AAz2DU;EACE,eC9CH;ADy5DT;AAr2DU;EACE,aCrDH;AD45DT;AAr2DU;EACE,aCxDH;AD+5DT;AAr2DU;EACE,aC3DH;ADk6DT;AAr2DU;EACE,aC9DH;ADq6DT;AAj4DU;EACE,eCrCH;ADw6DT;AAj4DU;EACE,eCxCH;AD26DT;AAj4DU;EACE,eC3CH;AD86DT;AAj4DU;EACE,eC9CH;ADi7DT;AA73DU;EACE,aCrDH;ADo7DT;AA73DU;EACE,aCxDH;ADu7DT;AA73DU;EACE,aC3DH;AD07DT;AA73DU;EACE,aC9DH;AD67DT;AAz5DU;EACE,eCrCH;ADg8DT;AAz5DU;EACE,eCxCH;ADm8DT;AAz5DU;EACE,eC3CH;ADs8DT;AAz5DU;EACE,eC9CH;ADy8DT;AAr5DU;EACE,aCrDH;AD48DT;AAr5DU;EACE,aCxDH;AD+8DT;AAr5DU;EACE,aC3DH;ADk9DT;AAr5DU;EACE,aC9DH;ADq9DT;AAj7DU;EACE,eCrCH;ADw9DT;AAj7DU;EACE,eCxCH;AD29DT;AAj7DU;EACE,eC3CH;AD89DT;AAj7DU;EACE,eC9CH;ADi+DT;AA76DU;EACE,aCrDH;ADo+DT;AA76DU;EACE,aCxDH;ADu+DT;AA76DU;EACE,aC3DH;AD0+DT;AA76DU;EACE,aC9DH;AD6+DT;AAz8DU;EACE,eCrCH;ADg/DT;AAz8DU;EACE,eCxCH;ADm/DT;AAz8DU;EACE,eC3CH;ADs/DT;AAz8DU;EACE,eC9CH;ADy/DT;AAr8DU;EACE,aCrDH;AD4/DT;AAr8DU;EACE,aCxDH;AD+/DT;AAr8DU;EACE,aC3DH;ADkgET;AAr8DU;EACE,aC9DH;ADqgET;AAj+DU;EACE,eCrCH;ADwgET;AAj+DU;EACE,eCxCH;AD2gET;AAj+DU;EACE,eC3CH;AD8gET;AAj+DU;EACE,eC9CH;ADihET;AA79DU;EACE,aCrDH;ADohET;AA79DU;EACE,aCxDH;ADuhET;AA79DU;EACE,aC3DH;AD0hET;AA79DU;EACE,aC9DH;AD6hET;AAz/DU;EACE,eCrCH;ADgiET;AAz/DU;EACE,eCxCH;ADmiET;AAz/DU;EACE,eC3CH;ADsiET;AAz/DU;EACE,eC9CH;ADyiET;AAr/DU;EACE,aCrDH;AD4iET;AAr/DU;EACE,aCxDH;AD+iET;AAr/DU;EACE,aC3DH;ADkjET;AAr/DU;EACE,aC9DH;ADqjET;AAjhEU;EACE,eCrCH;ADwjET;AAjhEU;EACE,eCxCH;AD2jET;AAjhEU;EACE,eC3CH;AD8jET;AAjhEU;EACE,eC9CH;ADikET;AA7gEU;EACE,aCrDH;ADokET;AA7gEU;EACE,aCxDH;ADukET;AA7gEU;EACE,aC3DH;AD0kET;AA7gEU;EACE,aC9DH;AD6kET;AAziEU;EACE,eCrCH;ADglET;AAziEU;EACE,eCxCH;ADmlET;AAziEU;EACE,eC3CH;ADslET;AAziEU;EACE,eC9CH;ADylET;AAriEU;EACE,aCrDH;AD4lET;AAriEU;EACE,aCxDH;AD+lET;AAriEU;EACE,aC3DH;ADkmET;AAriEU;EACE,aC9DH;ADqmET;AAjkEU;EACE,eCrCH;ADwmET;AAjkEU;EACE,eCxCH;AD2mET;AAjkEU;EACE,eC3CH;AD8mET;AAjkEU;EACE,eC9CH;ADinET;AA7jEU;EACE,aCrDH;ADonET;AA7jEU;EACE,aCxDH;ADunET;AA7jEU;EACE,aC3DH;AD0nET;AA7jEU;EACE,aC9DH;AD6nET;AAzlEU;EACE,eCrCH;ADgoET;AAzlEU;EACE,eCxCH;ADmoET;AAzlEU;EACE,eC3CH;ADsoET;AAzlEU;EACE,eC9CH;ADyoET;AArlEU;EACE,aCrDH;AD4oET;AArlEU;EACE,aCxDH;AD+oET;AArlEU;EACE,aC3DH;ADkpET;AArlEU;EACE,aC9DH;ADqpET;AAjnEU;EACE,eCrCH;ADwpET;AAjnEU;EACE,eCxCH;AD2pET;AAjnEU;EACE,eC3CH;AD8pET;AAjnEU;EACE,eC9CH;ADiqET;AA7mEU;EACE,aCrDH;ADoqET;AA7mEU;EACE,aCxDH;ADuqET;AA7mEU;EACE,aC3DH;AD0qET;AA7mEU;EACE,aC9DH;AD6qET;AAzoEU;EACE,eCrCH;ADgrET;AAzoEU;EACE,eCxCH;ADmrET;AAzoEU;EACE,eC3CH;ADsrET;AAzoEU;EACE,eC9CH;ADyrET;AAroEU;EACE,aCrDH;AD4rET;AAroEU;EACE,aCxDH;AD+rET;AAroEU;EACE,aC3DH;ADksET;AAroEU;EACE,aC9DH;ADqsET;AAjqEU;EACE,eCrCH;ADwsET;AAjqEU;EACE,eCxCH;AD2sET;AAjqEU;EACE,eC3CH;AD8sET;AAjqEU;EACE,eC9CH;ADitET;AA7pEU;EACE,aCrDH;ADotET;AA7pEU;EACE,aCxDH;ADutET;AA7pEU;EACE,aC3DH;AD0tET;AA7pEU;EACE,aC9DH;AD6tET;AAzrEU;EACE,eCrCH;ADguET;AAzrEU;EACE,eCxCH;ADmuET;AAzrEU;EACE,eC3CH;ADsuET;AAzrEU;EACE,eC9CH;ADyuET;AArrEU;EACE,aCrDH;AD4uET;AArrEU;EACE,aCxDH;AD+uET;AArrEU;EACE,aC3DH;ADkvET;AArrEU;EACE,aC9DH;ADqvET;AAjtEU;EACE,eCrCH;ADwvET;AAjtEU;EACE,eCxCH;AD2vET;AAjtEU;EACE,eC3CH;AD8vET;AAjtEU;EACE,eC9CH;ADiwET;AA7sEU;EACE,aCrDH;ADowET;AA7sEU;EACE,aCxDH;ADuwET;AA7sEU;EACE,aC3DH;AD0wET;AA7sEU;EACE,aC9DH;AD6wET;AAzuEU;EACE,eCrCH;ADgxET;AAzuEU;EACE,eCxCH;ADmxET;AAzuEU;EACE,eC3CH;ADsxET;AAzuEU;EACE,eC9CH;ADyxET;AAruEU;EACE,aCrDH;AD4xET;AAruEU;EACE,aCxDH;AD+xET;AAruEU;EACE,aC3DH;ADkyET;AAruEU;EACE,aC9DH;ADqyET;AAjwEU;EACE,eCrCH;ADwyET;AAjwEU;EACE,eCxCH;AD2yET;AAjwEU;EACE,eC3CH;AD8yET;AAjwEU;EACE,eC9CH;ADizET;AA7vEU;EACE,aCrDH;ADozET;AA7vEU;EACE,aCxDH;ADuzET;AA7vEU;EACE,aC3DH;AD0zET;AA7vEU;EACE,aC9DH;AD6zET;AAzxEU;EACE,eCrCH;ADg0ET;AAzxEU;EACE,eCxCH;ADm0ET;AAzxEU;EACE,eC3CH;ADs0ET;AAzxEU;EACE,eC9CH;ADy0ET;AArxEU;EACE,aCrDH;AD40ET;AArxEU;EACE,aCxDH;AD+0ET;AArxEU;EACE,aC3DH;ADk1ET;AArxEU;EACE,aC9DH;ADq1ET;AAjzEU;EACE,eCrCH;ADw1ET;AAjzEU;EACE,eCxCH;AD21ET;AAjzEU;EACE,eC3CH;AD81ET;AAjzEU;EACE,eC9CH;ADi2ET;AA7yEU;EACE,aCrDH;ADo2ET;AA7yEU;EACE,aCxDH;ADu2ET;AA7yEU;EACE,aC3DH;AD02ET;AA7yEU;EACE,aC9DH;AD62ET;AAz0EU;EACE,eCrCH;ADg3ET;AAz0EU;EACE,eCxCH;ADm3ET;AAz0EU;EACE,eC3CH;ADs3ET;AAz0EU;EACE,eC9CH;ADy3ET;AAr0EU;EACE,aCrDH;AD43ET;AAr0EU;EACE,aCxDH;AD+3ET;AAr0EU;EACE,aC3DH;ADk4ET;AAr0EU;EACE,aC9DH;ADq4ET;AAj2EU;EACE,eCrCH;ADw4ET;AAj2EU;EACE,eCxCH;AD24ET;AAj2EU;EACE,eC3CH;AD84ET;AAj2EU;EACE,eC9CH;ADi5ET;AA71EU;EACE,aCrDH;ADo5ET;AA71EU;EACE,aCxDH;ADu5ET;AA71EU;EACE,aC3DH;AD05ET;AA71EU;EACE,aC9DH;AD65ET;AAz3EU;EACE,eCrCH;ADg6ET;AAz3EU;EACE,eCxCH;ADm6ET;AAz3EU;EACE,eC3CH;ADs6ET;AAz3EU;EACE,eC9CH;ADy6ET;AAr3EU;EACE,aCrDH;AD46ET;AAr3EU;EACE,aCxDH;AD+6ET;AAr3EU;EACE,aC3DH;ADk7ET;AAr3EU;EACE,aC9DH;ADq7ET;AAj5EU;EACE,eCrCH;ADw7ET;AAj5EU;EACE,eCxCH;AD27ET;AAj5EU;EACE,eC3CH;AD87ET;AAj5EU;EACE,eC9CH;ADi8ET;AA74EU;EACE,aCrDH;ADo8ET;AA74EU;EACE,aCxDH;ADu8ET;AA74EU;EACE,aC3DH;AD08ET;AA74EU;EACE,aC9DH;AD68ET;AAz6EU;EACE,eCrCH;ADg9ET;AAz6EU;EACE,eCxCH;ADm9ET;AAz6EU;EACE,eC3CH;ADs9ET;AAz6EU;EACE,eC9CH;ADy9ET;AAr6EU;EACE,aCrDH;AD49ET;AAr6EU;EACE,aCxDH;AD+9ET;AAr6EU;EACE,aC3DH;ADk+ET;AAr6EU;EACE,aC9DH;ADq+ET;AAj8EU;EACE,eCrCH;ADw+ET;AAj8EU;EACE,eCxCH;AD2+ET;AAj8EU;EACE,eC3CH;AD8+ET;AAj8EU;EACE,eC9CH;ADi/ET;AA77EU;EACE,aCrDH;ADo/ET;AA77EU;EACE,aCxDH;ADu/ET;AA77EU;EACE,aC3DH;AD0/ET;AA77EU;EACE,aC9DH;AD6/ET;AAz9EU;EACE,eCrCH;ADggFT;AAz9EU;EACE,eCxCH;ADmgFT;AAz9EU;EACE,eC3CH;ADsgFT;AAz9EU;EACE,eC9CH;ADygFT;AAr9EU;EACE,aCrDH;AD4gFT;AAr9EU;EACE,aCxDH;AD+gFT;AAr9EU;EACE,aC3DH;ADkhFT;AAr9EU;EACE,aC9DH;ADqhFT;AAj/EU;EACE,eCrCH;ADwhFT;AAj/EU;EACE,eCxCH;AD2hFT;AAj/EU;EACE,eC3CH;AD8hFT;AAj/EU;EACE,eC9CH;ADiiFT;AA7+EU;EACE,aCrDH;ADoiFT;AA7+EU;EACE,aCxDH;ADuiFT;AA7+EU;EACE,aC3DH;AD0iFT;AA7+EU;EACE,aC9DH;AD6iFT;AAzgFU;EACE,eCrCH;ADgjFT;AAzgFU;EACE,eCxCH;ADmjFT;AAzgFU;EACE,eC3CH;ADsjFT;AAzgFU;EACE,eC9CH;ADyjFT;AArgFU;EACE,aCrDH;AD4jFT;AArgFU;EACE,aCxDH;AD+jFT;AArgFU;EACE,aC3DH;ADkkFT;AArgFU;EACE,aC9DH;ADqkFT;AAjiFU;EACE,eCrCH;ADwkFT;AAjiFU;EACE,eCxCH;AD2kFT;AAjiFU;EACE,eC3CH;AD8kFT;AAjiFU;EACE,eC9CH;ADilFT;AA7hFU;EACE,aCrDH;ADolFT;AA7hFU;EACE,aCxDH;ADulFT;AA7hFU;EACE,aC3DH;AD0lFT;AA7hFU;EACE,aC9DH;AD6lFT;AAzjFU;EACE,eCrCH;ADgmFT;AAzjFU;EACE,eCxCH;ADmmFT;AAzjFU;EACE,eC3CH;ADsmFT;AAzjFU;EACE,eC9CH;ADymFT;AArjFU;EACE,aCrDH;AD4mFT;AArjFU;EACE,aCxDH;AD+mFT;AArjFU;EACE,aC3DH;ADknFT;AArjFU;EACE,aC9DH;ADqnFT;AAjlFU;EACE,eCrCH;ADwnFT;AAjlFU;EACE,eCxCH;AD2nFT;AAjlFU;EACE,eC3CH;AD8nFT;AAjlFU;EACE,eC9CH;ADioFT;AA7kFU;EACE,aCrDH;ADooFT;AA7kFU;EACE,aCxDH;ADuoFT;AA7kFU;EACE,aC3DH;AD0oFT;AA7kFU;EACE,aC9DH;AD6oFT;AAzmFU;EACE,eCrCH;ADgpFT;AAzmFU;EACE,eCxCH;ADmpFT;AAzmFU;EACE,eC3CH;ADspFT;AAzmFU;EACE,eC9CH;ADypFT;AArmFU;EACE,aCrDH;AD4pFT;AArmFU;EACE,aCxDH;AD+pFT;AArmFU;EACE,aC3DH;ADkqFT;AArmFU;EACE,aC9DH;ADqqFT;AAjoFU;EACE,eCrCH;ADwqFT;AAjoFU;EACE,eCxCH;AD2qFT;AAjoFU;EACE,eC3CH;AD8qFT;AAjoFU;EACE,eC9CH;ADirFT;AA7nFU;EACE,aCrDH;ADorFT;AA7nFU;EACE,aCxDH;ADurFT;AA7nFU;EACE,aC3DH;AD0rFT;AA7nFU;EACE,aC9DH;AD6rFT;AAzpFU;EACE,eCrCH;ADgsFT;AAzpFU;EACE,eCxCH;ADmsFT;AAzpFU;EACE,eC3CH;ADssFT;AAzpFU;EACE,eC9CH;ADysFT;AArpFU;EACE,aCrDH;AD4sFT;AArpFU;EACE,aCxDH;AD+sFT;AArpFU;EACE,aC3DH;ADktFT;AArpFU;EACE,aC9DH;ADqtFT;AAjrFU;EACE,eCrCH;ADwtFT;AAjrFU;EACE,eCxCH;AD2tFT;AAjrFU;EACE,eC3CH;AD8tFT;AAjrFU;EACE,eC9CH;ADiuFT;AA7qFU;EACE,aCrDH;ADouFT;AA7qFU;EACE,aCxDH;ADuuFT;AA7qFU;EACE,aC3DH;AD0uFT;AA7qFU;EACE,aC9DH;AD6uFT;AAzsFU;EACE,eCrCH;ADgvFT;AAzsFU;EACE,eCxCH;ADmvFT;AAzsFU;EACE,eC3CH;ADsvFT;AAzsFU;EACE,eC9CH;ADyvFT;AArsFU;EACE,aCrDH;AD4vFT;AArsFU;EACE,aCxDH;AD+vFT;AArsFU;EACE,aC3DH;ADkwFT;AArsFU;EACE,aC9DH;ADqwFT;AAjuFU;EACE,eCrCH;ADwwFT;AAjuFU;EACE,eCxCH;AD2wFT;AAjuFU;EACE,eC3CH;AD8wFT;AAjuFU;EACE,eC9CH;ADixFT;AA7tFU;EACE,aCrDH;ADoxFT;AA7tFU;EACE,aCxDH;ADuxFT;AA7tFU;EACE,aC3DH;AD0xFT;AA7tFU;EACE,aC9DH;AD6xFT;AAzvFU;EACE,eCrCH;ADgyFT;AAzvFU;EACE,eCxCH;ADmyFT;AAzvFU;EACE,eC3CH;ADsyFT;AAzvFU;EACE,eC9CH;ADyyFT;AArvFU;EACE,aCrDH;AD4yFT;AArvFU;EACE,aCxDH;AD+yFT;AArvFU;EACE,aC3DH;ADkzFT;AArvFU;EACE,aC9DH;ADqzFT;AAjxFU;EACE,eCrCH;ADwzFT;AAjxFU;EACE,eCxCH;AD2zFT;AAjxFU;EACE,eC3CH;AD8zFT;AAjxFU;EACE,eC9CH;ADi0FT;AA7wFU;EACE,aCrDH;ADo0FT;AA7wFU;EACE,aCxDH;ADu0FT;AA7wFU;EACE,aC3DH;AD00FT;AA7wFU;EACE,aC9DH;AD60FT;AAzyFU;EACE,eCrCH;ADg1FT;AAzyFU;EACE,eCxCH;ADm1FT;AAzyFU;EACE,eC3CH;ADs1FT;AAzyFU;EACE,eC9CH;ADy1FT;AAryFU;EACE,aCrDH;AD41FT;AAryFU;EACE,aCxDH;AD+1FT;AAryFU;EACE,aC3DH;ADk2FT;AAryFU;EACE,aC9DH;ADq2FT;AAj0FU;EACE,eCrCH;ADw2FT;AAj0FU;EACE,eCxCH;AD22FT;AAj0FU;EACE,eC3CH;AD82FT;AAj0FU;EACE,eC9CH;ADi3FT;AA7zFU;EACE,aCrDH;ADo3FT;AA7zFU;EACE,aCxDH;ADu3FT;AA7zFU;EACE,aC3DH;AD03FT;AA7zFU;EACE,aC9DH;AD63FT;AAz1FU;EACE,eCrCH;ADg4FT;AAz1FU;EACE,eCxCH;ADm4FT;AAz1FU;EACE,eC3CH;ADs4FT;AAz1FU;EACE,eC9CH;ADy4FT;AAr1FU;EACE,aCrDH;AD44FT;AAr1FU;EACE,aCxDH;AD+4FT;AAr1FU;EACE,aC3DH;ADk5FT;AAr1FU;EACE,aC9DH;ADq5FT;AAj3FU;EACE,eCrCH;ADw5FT;AAj3FU;EACE,eCxCH;AD25FT;AAj3FU;EACE,eC3CH;AD85FT;AAj3FU;EACE,eC9CH;ADi6FT;AA72FU;EACE,aCrDH;ADo6FT;AA72FU;EACE,aCxDH;ADu6FT;AA72FU;EACE,aC3DH;AD06FT;AA72FU;EACE,aC9DH;AD66FT;AAz4FU;EACE,eCrCH;ADg7FT;AAz4FU;EACE,eCxCH;ADm7FT;AAz4FU;EACE,eC3CH;ADs7FT;AAz4FU;EACE,eC9CH;ADy7FT;AAr4FU;EACE,aCrDH;AD47FT;AAr4FU;EACE,aCxDH;AD+7FT;AAr4FU;EACE,aC3DH;ADk8FT;AAr4FU;EACE,aC9DH;ADq8FT;AAj6FU;EACE,eCrCH;ADw8FT;AAj6FU;EACE,eCxCH;AD28FT;AAj6FU;EACE,eC3CH;AD88FT;AAj6FU;EACE,eC9CH;ADi9FT;AA75FU;EACE,aCrDH;ADo9FT;AA75FU;EACE,aCxDH;ADu9FT;AA75FU;EACE,aC3DH;AD09FT;AA75FU;EACE,aC9DH;AD69FT;AAz7FU;EACE,eCrCH;ADg+FT;AAz7FU;EACE,eCxCH;ADm+FT;AAz7FU;EACE,eC3CH;ADs+FT;AAz7FU;EACE,eC9CH;ADy+FT;AAr7FU;EACE,aCrDH;AD4+FT;AAr7FU;EACE,aCxDH;AD++FT;AAr7FU;EACE,aC3DH;ADk/FT;AAr7FU;EACE,aC9DH;ADq/FT;AAj9FU;EACE,eCrCH;ADw/FT;AAj9FU;EACE,eCxCH;AD2/FT;AAj9FU;EACE,eC3CH;AD8/FT;AAj9FU;EACE,eC9CH;ADigGT;AA78FU;EACE,aCrDH;ADogGT;AA78FU;EACE,aCxDH;ADugGT;AA78FU;EACE,aC3DH;AD0gGT;AA78FU;EACE,aC9DH;AD6gGT;AAz+FU;EACE,eCrCH;ADghGT;AAz+FU;EACE,eCxCH;ADmhGT;AAz+FU;EACE,eC3CH;ADshGT;AAz+FU;EACE,eC9CH;ADyhGT;AAr+FU;EACE,aCrDH;AD4hGT;AAr+FU;EACE,aCxDH;AD+hGT;AAr+FU;EACE,aC3DH;ADkiGT;AAr+FU;EACE,aC9DH;ADqiGT;AAjgGU;EACE,eCrCH;ADwiGT;AAjgGU;EACE,eCxCH;AD2iGT;AAjgGU;EACE,eC3CH;AD8iGT;AAjgGU;EACE,eC9CH;ADijGT;AA7/FU;EACE,aCrDH;ADojGT;AA7/FU;EACE,aCxDH;ADujGT;AA7/FU;EACE,aC3DH;AD0jGT;AA7/FU;EACE,aC9DH;AD6jGT;AAzhGU;EACE,eCrCH;ADgkGT;AAzhGU;EACE,eCxCH;ADmkGT;AAzhGU;EACE,eC3CH;ADskGT;AAzhGU;EACE,eC9CH;ADykGT;AArhGU;EACE,aCrDH;AD4kGT;AArhGU;EACE,aCxDH;AD+kGT;AArhGU;EACE,aC3DH;ADklGT;AArhGU;EACE,aC9DH;ADqlGT;AAjjGU;EACE,eCrCH;ADwlGT;AAjjGU;EACE,eCxCH;AD2lGT;AAjjGU;EACE,eC3CH;AD8lGT;AAjjGU;EACE,eC9CH;ADimGT;AA7iGU;EACE,aCrDH;ADomGT;AA7iGU;EACE,aCxDH;ADumGT;AA7iGU;EACE,aC3DH;AD0mGT;AA7iGU;EACE,aC9DH;AD6mGT;AAzkGU;EACE,eCrCH;ADgnGT;AAzkGU;EACE,eCxCH;ADmnGT;AAzkGU;EACE,eC3CH;ADsnGT;AAzkGU;EACE,eC9CH;ADynGT;AArkGU;EACE,aCrDH;AD4nGT;AArkGU;EACE,aCxDH;AD+nGT;AArkGU;EACE,aC3DH;ADkoGT;AArkGU;EACE,aC9DH;ADqoGT;AAjmGU;EACE,eCrCH;ADwoGT;AAjmGU;EACE,eCxCH;AD2oGT;AAjmGU;EACE,eC3CH;AD8oGT;AAjmGU;EACE,eC9CH;ADipGT;AA7lGU;EACE,aCrDH;ADopGT;AA7lGU;EACE,aCxDH;ADupGT;AA7lGU;EACE,aC3DH;AD0pGT;AA7lGU;EACE,aC9DH;AD6pGT;AAznGU;EACE,eCrCH;ADgqGT;AAznGU;EACE,eCxCH;ADmqGT;AAznGU;EACE,eC3CH;ADsqGT;AAznGU;EACE,eC9CH;ADyqGT;AArnGU;EACE,aCrDH;AD4qGT;AArnGU;EACE,aCxDH;AD+qGT;AArnGU;EACE,aC3DH;ADkrGT;AArnGU;EACE,aC9DH;ADqrGT;AAjpGU;EACE,eCrCH;ADwrGT;AAjpGU;EACE,eCxCH;AD2rGT;AAjpGU;EACE,eC3CH;AD8rGT;AAjpGU;EACE,eC9CH;ADisGT;AA7oGU;EACE,aCrDH;ADosGT;AA7oGU;EACE,aCxDH;ADusGT;AA7oGU;EACE,aC3DH;AD0sGT;AA7oGU;EACE,aC9DH;AD6sGT;AAzqGU;EACE,eCrCH;ADgtGT;AAzqGU;EACE,eCxCH;ADmtGT;AAzqGU;EACE,eC3CH;ADstGT;AAzqGU;EACE,eC9CH;ADytGT;AArqGU;EACE,aCrDH;AD4tGT;AArqGU;EACE,aCxDH;AD+tGT;AArqGU;EACE,aC3DH;ADkuGT;AArqGU;EACE,aC9DH;ADquGT;AAjsGU;EACE,eCrCH;ADwuGT;AAjsGU;EACE,eCxCH;AD2uGT;AAjsGU;EACE,eC3CH;AD8uGT;AAjsGU;EACE,eC9CH;ADivGT;AA7rGU;EACE,aCrDH;ADovGT;AA7rGU;EACE,aCxDH;ADuvGT;AA7rGU;EACE,aC3DH;AD0vGT;AA7rGU;EACE,aC9DH;AD6vGT;AAztGU;EACE,eCrCH;ADgwGT;AAztGU;EACE,eCxCH;ADmwGT;AAztGU;EACE,eC3CH;ADswGT;AAztGU;EACE,eC9CH;ADywGT;AArtGU;EACE,aCrDH;AD4wGT;AArtGU;EACE,aCxDH;AD+wGT;AArtGU;EACE,aC3DH;ADkxGT;AArtGU;EACE,aC9DH;ADqxGT;AAjvGU;EACE,eCrCH;ADwxGT;AAjvGU;EACE,eCxCH;AD2xGT;AAjvGU;EACE,eC3CH;AD8xGT;AAjvGU;EACE,eC9CH;ADiyGT;AA7uGU;EACE,aCrDH;ADoyGT;AA7uGU;EACE,aCxDH;ADuyGT;AA7uGU;EACE,aC3DH;AD0yGT;AA7uGU;EACE,aC9DH;AD6yGT;AAzwGU;EACE,eCrCH;ADgzGT;AAzwGU;EACE,eCxCH;ADmzGT;AAzwGU;EACE,eC3CH;ADszGT;AAzwGU;EACE,eC9CH;ADyzGT;AArwGU;EACE,aCrDH;AD4zGT;AArwGU;EACE,aCxDH;AD+zGT;AArwGU;EACE,aC3DH;ADk0GT;AArwGU;EACE,aC9DH;ADq0GT;AAjyGU;EACE,eCrCH;ADw0GT;AAjyGU;EACE,eCxCH;AD20GT;AAjyGU;EACE,eC3CH;AD80GT;AAjyGU;EACE,eC9CH;ADi1GT;AA7xGU;EACE,aCrDH;ADo1GT;AA7xGU;EACE,aCxDH;ADu1GT;AA7xGU;EACE,aC3DH;AD01GT;AA7xGU;EACE,aC9DH;AD61GT;AAzzGU;EACE,eCrCH;ADg2GT;AAzzGU;EACE,eCxCH;ADm2GT;AAzzGU;EACE,eC3CH;ADs2GT;AAzzGU;EACE,eC9CH;ADy2GT;AArzGU;EACE,aCrDH;AD42GT;AArzGU;EACE,aCxDH;AD+2GT;AArzGU;EACE,aC3DH;ADk3GT;AArzGU;EACE,aC9DH;ADq3GT;AAj1GU;EACE,eCrCH;ADw3GT;AAj1GU;EACE,eCxCH;AD23GT;AAj1GU;EACE,eC3CH;AD83GT;AAj1GU;EACE,eC9CH;ADi4GT;AA70GU;EACE,aCrDH;ADo4GT;AA70GU;EACE,aCxDH;ADu4GT;AA70GU;EACE,aC3DH;AD04GT;AA70GU;EACE,aC9DH;AD64GT;AAz2GU;EACE,eCrCH;ADg5GT;AAz2GU;EACE,eCxCH;ADm5GT;AAz2GU;EACE,eC3CH;ADs5GT;AAz2GU;EACE,eC9CH;ADy5GT;AAr2GU;EACE,aCrDH;AD45GT;AAr2GU;EACE,aCxDH;AD+5GT;AAr2GU;EACE,aC3DH;ADk6GT;AAr2GU;EACE,aC9DH;ADq6GT;AAj4GU;EACE,eCrCH;ADw6GT;AAj4GU;EACE,eCxCH;AD26GT;AAj4GU;EACE,eC3CH;AD86GT;AAj4GU;EACE,eC9CH;ADi7GT;AA73GU;EACE,aCrDH;ADo7GT;AA73GU;EACE,aCxDH;ADu7GT;AA73GU;EACE,aC3DH;AD07GT;AA73GU;EACE,aC9DH;AD67GT;AAz5GU;EACE,eCrCH;ADg8GT;AAz5GU;EACE,eCxCH;ADm8GT;AAz5GU;EACE,eC3CH;ADs8GT;AAz5GU;EACE,eC9CH;ADy8GT;AAr5GU;EACE,aCrDH;AD48GT;AAr5GU;EACE,aCxDH;AD+8GT;AAr5GU;EACE,aC3DH;ADk9GT;AAr5GU;EACE,aC9DH;ADq9GT;AAj7GU;EACE,eCrCH;ADw9GT;AAj7GU;EACE,eCxCH;AD29GT;AAj7GU;EACE,eC3CH;AD89GT;AAj7GU;EACE,eC9CH;ADi+GT;AA76GU;EACE,aCrDH;ADo+GT;AA76GU;EACE,aCxDH;ADu+GT;AA76GU;EACE,aC3DH;AD0+GT;AA76GU;EACE,aC9DH;AD6+GT;AAz8GU;EACE,eCrCH;ADg/GT;AAz8GU;EACE,eCxCH;ADm/GT;AAz8GU;EACE,eC3CH;ADs/GT;AAz8GU;EACE,eC9CH;ADy/GT;AAr8GU;EACE,aCrDH;AD4/GT;AAr8GU;EACE,aCxDH;AD+/GT;AAr8GU;EACE,aC3DH;ADkgHT;AAr8GU;EACE,aC9DH;ADqgHT;AAj+GU;EACE,eCrCH;ADwgHT;AAj+GU;EACE,eCxCH;AD2gHT;AAj+GU;EACE,eC3CH;AD8gHT;AAj+GU;EACE,eC9CH;ADihHT;AA79GU;EACE,aCrDH;ADohHT;AA79GU;EACE,aCxDH;ADuhHT;AA79GU;EACE,aC3DH;AD0hHT;AA79GU;EACE,aC9DH;AD6hHT;AAz/GU;EACE,eCrCH;ADgiHT;AAz/GU;EACE,eCxCH;ADmiHT;AAz/GU;EACE,eC3CH;ADsiHT;AAz/GU;EACE,eC9CH;ADyiHT;AAr/GU;EACE,aCrDH;AD4iHT;AAr/GU;EACE,aCxDH;AD+iHT;AAr/GU;EACE,aC3DH;ADkjHT;AAr/GU;EACE,aC9DH;ADqjHT;AAjhHU;EACE,eCrCH;ADwjHT;AAjhHU;EACE,eCxCH;AD2jHT;AAjhHU;EACE,eC3CH;AD8jHT;AAjhHU;EACE,eC9CH;ADikHT;AA7gHU;EACE,aCrDH;ADokHT;AA7gHU;EACE,aCxDH;ADukHT;AA7gHU;EACE,aC3DH;AD0kHT;AA7gHU;EACE,aC9DH;AD6kHT;AAziHU;EACE,eCrCH;ADglHT;AAziHU;EACE,eCxCH;ADmlHT;AAziHU;EACE,eC3CH;ADslHT;AAziHU;EACE,eC9CH;ADylHT;AAriHU;EACE,aCrDH;AD4lHT;AAriHU;EACE,aCxDH;AD+lHT;AAriHU;EACE,aC3DH;ADkmHT;AAriHU;EACE,aC9DH;ADqmHT;AAjkHU;EACE,eCrCH;ADwmHT;AAjkHU;EACE,eCxCH;AD2mHT;AAjkHU;EACE,eC3CH;AD8mHT;AAjkHU;EACE,eC9CH;ADinHT;AA7jHU;EACE,aCrDH;ADonHT;AA7jHU;EACE,aCxDH;ADunHT;AA7jHU;EACE,aC3DH;AD0nHT;AA7jHU;EACE,aC9DH;AD6nHT;AAzlHU;EACE,eCrCH;ADgoHT;AAzlHU;EACE,eCxCH;ADmoHT;AAzlHU;EACE,eC3CH;ADsoHT;AAzlHU;EACE,eC9CH;ADyoHT;AArlHU;EACE,aCrDH;AD4oHT;AArlHU;EACE,aCxDH;AD+oHT;AArlHU;EACE,aC3DH;ADkpHT;AArlHU;EACE,aC9DH;ADqpHT;AAjnHU;EACE,eCrCH;ADwpHT;AAjnHU;EACE,eCxCH;AD2pHT;AAjnHU;EACE,eC3CH;AD8pHT;AAjnHU;EACE,eC9CH;ADiqHT;AA7mHU;EACE,aCrDH;ADoqHT;AA7mHU;EACE,aCxDH;ADuqHT;AA7mHU;EACE,aC3DH;AD0qHT;AA7mHU;EACE,aC9DH;AD6qHT;AAzoHU;EACE,eCrCH;ADgrHT;AAzoHU;EACE,eCxCH;ADmrHT;AAzoHU;EACE,eC3CH;ADsrHT;AAzoHU;EACE,eC9CH;ADyrHT;AAroHU;EACE,aCrDH;AD4rHT;AAroHU;EACE,aCxDH;AD+rHT;AAroHU;EACE,aC3DH;ADksHT;AAroHU;EACE,aC9DH;ADqsHT;AAjqHU;EACE,eCrCH;ADwsHT;AAjqHU;EACE,eCxCH;AD2sHT;AAjqHU;EACE,eC3CH;AD8sHT;AAjqHU;EACE,eC9CH;ADitHT;AA7pHU;EACE,aCrDH;ADotHT;AA7pHU;EACE,aCxDH;ADutHT;AA7pHU;EACE,aC3DH;AD0tHT;AA7pHU;EACE,aC9DH;AD6tHT;AAzrHU;EACE,eCrCH;ADguHT;AAzrHU;EACE,eCxCH;ADmuHT;AAzrHU;EACE,eC3CH;ADsuHT;AAzrHU;EACE,eC9CH;ADyuHT;AArrHU;EACE,aCrDH;AD4uHT;AArrHU;EACE,aCxDH;AD+uHT;AArrHU;EACE,aC3DH;ADkvHT;AArrHU;EACE,aC9DH;ADqvHT;AAjtHU;EACE,eCrCH;ADwvHT;AAjtHU;EACE,eCxCH;AD2vHT;AAjtHU;EACE,eC3CH;AD8vHT;AAjtHU;EACE,eC9CH;ADiwHT;AA7sHU;EACE,aCrDH;ADowHT;AA7sHU;EACE,aCxDH;ADuwHT;AA7sHU;EACE,aC3DH;AD0wHT;AA7sHU;EACE,aC9DH;AD6wHT;AAzuHU;EACE,eCrCH;ADgxHT;AAzuHU;EACE,eCxCH;ADmxHT;AAzuHU;EACE,eC3CH;ADsxHT;AAzuHU;EACE,eC9CH;ADyxHT;AAruHU;EACE,aCrDH;AD4xHT;AAruHU;EACE,aCxDH;AD+xHT;AAruHU;EACE,aC3DH;ADkyHT;AAruHU;EACE,aC9DH;ADqyHT;AAjwHU;EACE,eCrCH;ADwyHT;AAjwHU;EACE,eCxCH;AD2yHT;AAjwHU;EACE,eC3CH;AD8yHT;AAjwHU;EACE,eC9CH;ADizHT;AA7vHU;EACE,aCrDH;ADozHT;AA7vHU;EACE,aCxDH;ADuzHT;AA7vHU;EACE,aC3DH;AD0zHT;AA7vHU;EACE,aC9DH;AD6zHT;AAzxHU;EACE,eCrCH;ADg0HT;AAzxHU;EACE,eCxCH;ADm0HT;AAzxHU;EACE,eC3CH;ADs0HT;AAzxHU;EACE,eC9CH;ADy0HT;AArxHU;EACE,aCrDH;AD40HT;AArxHU;EACE,aCxDH;AD+0HT;AArxHU;EACE,aC3DH;ADk1HT;AArxHU;EACE,aC9DH;ADq1HT;AAjzHU;EACE,eCrCH;ADw1HT;AAjzHU;EACE,eCxCH;AD21HT;AAjzHU;EACE,eC3CH;AD81HT;AAjzHU;EACE,eC9CH;ADi2HT;AA7yHU;EACE,aCrDH;ADo2HT;AA7yHU;EACE,aCxDH;ADu2HT;AA7yHU;EACE,aC3DH;AD02HT;AA7yHU;EACE,aC9DH;AD62HT;AAz0HU;EACE,eCrCH;ADg3HT;AAz0HU;EACE,eCxCH;ADm3HT;AAz0HU;EACE,eC3CH;ADs3HT;AAz0HU;EACE,eC9CH;ADy3HT;AAr0HU;EACE,aCrDH;AD43HT;AAr0HU;EACE,aCxDH;AD+3HT;AAr0HU;EACE,aC3DH;ADk4HT;AAr0HU;EACE,aC9DH;ADq4HT;AAj2HU;EACE,eCrCH;ADw4HT;AAj2HU;EACE,eCxCH;AD24HT;AAj2HU;EACE,eC3CH;AD84HT;AAj2HU;EACE,eC9CH;ADi5HT;AA71HU;EACE,aCrDH;ADo5HT;AA71HU;EACE,aCxDH;ADu5HT;AA71HU;EACE,aC3DH;AD05HT;AA71HU;EACE,aC9DH;AD65HT;AAz3HU;EACE,eCrCH;ADg6HT;AAz3HU;EACE,eCxCH;ADm6HT;AAz3HU;EACE,eC3CH;ADs6HT;AAz3HU;EACE,eC9CH;ADy6HT;AAr3HU;EACE,aCrDH;AD46HT;AAr3HU;EACE,aCxDH;AD+6HT;AAr3HU;EACE,aC3DH;ADk7HT;AAr3HU;EACE,aC9DH;ADq7HT;AAj5HU;EACE,eCrCH;ADw7HT;AAj5HU;EACE,eCxCH;AD27HT;AAj5HU;EACE,eC3CH;AD87HT;AAj5HU;EACE,eC9CH;ADi8HT;AA74HU;EACE,aCrDH;ADo8HT;AA74HU;EACE,aCxDH;ADu8HT;AA74HU;EACE,aC3DH;AD08HT;AA74HU;EACE,aC9DH;AD68HT;AAz6HU;EACE,eCrCH;ADg9HT;AAz6HU;EACE,eCxCH;ADm9HT;AAz6HU;EACE,eC3CH;ADs9HT;AAz6HU;EACE,eC9CH;ADy9HT;AAr6HU;EACE,aCrDH;AD49HT;AAr6HU;EACE,aCxDH;AD+9HT;AAr6HU;EACE,aC3DH;ADk+HT;AAr6HU;EACE,aC9DH;ADq+HT;AAj8HU;EACE,eCrCH;ADw+HT;AAj8HU;EACE,eCxCH;AD2+HT;AAj8HU;EACE,eC3CH;AD8+HT;AAj8HU;EACE,eC9CH;ADi/HT;AA77HU;EACE,aCrDH;ADo/HT;AA77HU;EACE,aCxDH;ADu/HT;AA77HU;EACE,aC3DH;AD0/HT;AA77HU;EACE,aC9DH;AD6/HT;AAz9HU;EACE,eCrCH;ADggIT;AAz9HU;EACE,eCxCH;ADmgIT;AAz9HU;EACE,eC3CH;ADsgIT;AAz9HU;EACE,eC9CH;ADygIT;AAr9HU;EACE,aCrDH;AD4gIT;AAr9HU;EACE,aCxDH;AD+gIT;AAr9HU;EACE,aC3DH;ADkhIT;AAr9HU;EACE,aC9DH;ADqhIT;AAj/HU;EACE,eCrCH;ADwhIT;AAj/HU;EACE,eCxCH;AD2hIT;AAj/HU;EACE,eC3CH;AD8hIT;AAj/HU;EACE,eC9CH;ADiiIT;AA7+HU;EACE,aCrDH;ADoiIT;AA7+HU;EACE,aCxDH;ADuiIT;AA7+HU;EACE,aC3DH;AD0iIT;AA7+HU;EACE,aC9DH;AD6iIT;AAzgIU;EACE,eCrCH;ADgjIT;AAzgIU;EACE,eCxCH;ADmjIT;AAzgIU;EACE,eC3CH;ADsjIT;AAzgIU;EACE,eC9CH;ADyjIT;AArgIU;EACE,aCrDH;AD4jIT;AArgIU;EACE,aCxDH;AD+jIT;AArgIU;EACE,aC3DH;ADkkIT;AArgIU;EACE,aC9DH;ADqkIT;AAjiIU;EACE,eCrCH;ADwkIT;AAjiIU;EACE,eCxCH;AD2kIT;AAjiIU;EACE,eC3CH;AD8kIT;AAjiIU;EACE,eC9CH;ADilIT;AA7hIU;EACE,aCrDH;ADolIT;AA7hIU;EACE,aCxDH;ADulIT;AA7hIU;EACE,aC3DH;AD0lIT;AA7hIU;EACE,aC9DH;AD6lIT;AAzjIU;EACE,eCrCH;ADgmIT;AAzjIU;EACE,eCxCH;ADmmIT;AAzjIU;EACE,eC3CH;ADsmIT;AAzjIU;EACE,eC9CH;ADymIT;AArjIU;EACE,aCrDH;AD4mIT;AArjIU;EACE,aCxDH;AD+mIT;AArjIU;EACE,aC3DH;ADknIT;AArjIU;EACE,aC9DH;ADqnIT;AAjlIU;EACE,eCrCH;ADwnIT;AAjlIU;EACE,eCxCH;AD2nIT;AAjlIU;EACE,eC3CH;AD8nIT;AAjlIU;EACE,eC9CH;ADioIT;AA7kIU;EACE,aCrDH;ADooIT;AA7kIU;EACE,aCxDH;ADuoIT;AA7kIU;EACE,aC3DH;AD0oIT;AA7kIU;EACE,aC9DH;AD6oIT;AAzmIU;EACE,eCrCH;ADgpIT;AAzmIU;EACE,eCxCH;ADmpIT;AAzmIU;EACE,eC3CH;ADspIT;AAzmIU;EACE,eC9CH;ADypIT;AArmIU;EACE,aCrDH;AD4pIT;AArmIU;EACE,aCxDH;AD+pIT;AArmIU;EACE,aC3DH;ADkqIT;AArmIU;EACE,aC9DH;ADqqIT;AAjoIU;EACE,eCrCH;ADwqIT;AAjoIU;EACE,eCxCH;AD2qIT;AAjoIU;EACE,eC3CH;AD8qIT;AAjoIU;EACE,eC9CH;ADirIT;AA7nIU;EACE,aCrDH;ADorIT;AA7nIU;EACE,aCxDH;ADurIT;AA7nIU;EACE,aC3DH;AD0rIT;AA7nIU;EACE,aC9DH;AD6rIT;AAzpIU;EACE,eCrCH;ADgsIT;AAzpIU;EACE,eCxCH;ADmsIT;AAzpIU;EACE,eC3CH;ADssIT;AAzpIU;EACE,eC9CH;ADysIT;AArpIU;EACE,aCrDH;AD4sIT;AArpIU;EACE,aCxDH;AD+sIT;AArpIU;EACE,aC3DH;ADktIT;AArpIU;EACE,aC9DH;ADqtIT;AAjrIU;EACE,eCrCH;ADwtIT;AAjrIU;EACE,eCxCH;AD2tIT;AAjrIU;EACE,eC3CH;AD8tIT;AAjrIU;EACE,eC9CH;ADiuIT;AA7qIU;EACE,aCrDH;ADouIT;AA7qIU;EACE,aCxDH;ADuuIT;AA7qIU;EACE,aC3DH;AD0uIT;AA7qIU;EACE,aC9DH;AD6uIT;AAzsIU;EACE,eCrCH;ADgvIT;AAzsIU;EACE,eCxCH;ADmvIT;AAzsIU;EACE,eC3CH;ADsvIT;AAzsIU;EACE,eC9CH;ADyvIT;AArsIU;EACE,aCrDH;AD4vIT;AArsIU;EACE,aCxDH;AD+vIT;AArsIU;EACE,aC3DH;ADkwIT;AArsIU;EACE,aC9DH;ADqwIT;AAjuIU;EACE,eCrCH;ADwwIT;AAjuIU;EACE,eCxCH;AD2wIT;AAjuIU;EACE,eC3CH;AD8wIT;AAjuIU;EACE,eC9CH;ADixIT;AA7tIU;EACE,aCrDH;ADoxIT;AA7tIU;EACE,aCxDH;ADuxIT;AA7tIU;EACE,aC3DH;AD0xIT;AA7tIU;EACE,aC9DH;AD6xIT;AAzvIU;EACE,eCrCH;ADgyIT;AAzvIU;EACE,eCxCH;ADmyIT;AAzvIU;EACE,eC3CH;ADsyIT;AAzvIU;EACE,eC9CH;ADyyIT;AArvIU;EACE,aCrDH;AD4yIT;AArvIU;EACE,aCxDH;AD+yIT;AArvIU;EACE,aC3DH;ADkzIT;AArvIU;EACE,aC9DH;ADqzIT;AAjxIU;EACE,eCrCH;ADwzIT;AAjxIU;EACE,eCxCH;AD2zIT;AAjxIU;EACE,eC3CH;AD8zIT;AAjxIU;EACE,eC9CH;ADi0IT;AA7wIU;EACE,aCrDH;ADo0IT;AA7wIU;EACE,aCxDH;ADu0IT;AA7wIU;EACE,aC3DH;AD00IT;AA7wIU;EACE,aC9DH;AD60IT;AAzyIU;EACE,eCrCH;ADg1IT;AAzyIU;EACE,eCxCH;ADm1IT;AAzyIU;EACE,eC3CH;ADs1IT;AAzyIU;EACE,eC9CH;ADy1IT;AAryIU;EACE,aCrDH;AD41IT;AAryIU;EACE,aCxDH;AD+1IT;AAryIU;EACE,aC3DH;ADk2IT;AAryIU;EACE,aC9DH;ADq2IT;AAj0IU;EACE,eCrCH;ADw2IT;AAj0IU;EACE,eCxCH;AD22IT;AAj0IU;EACE,eC3CH;AD82IT;AAj0IU;EACE,eC9CH;ADi3IT;AA7zIU;EACE,aCrDH;ADo3IT;AA7zIU;EACE,aCxDH;ADu3IT;AA7zIU;EACE,aC3DH;AD03IT;AA7zIU;EACE,aC9DH;AD63IT;AAz1IU;EACE,eCrCH;ADg4IT;AAz1IU;EACE,eCxCH;ADm4IT;AAz1IU;EACE,eC3CH;ADs4IT;AAz1IU;EACE,eC9CH;ADy4IT;AAr1IU;EACE,aCrDH;AD44IT;AAr1IU;EACE,aCxDH;AD+4IT;AAr1IU;EACE,aC3DH;ADk5IT;AAr1IU;EACE,aC9DH;ADq5IT;AAj3IU;EACE,eCrCH;ADw5IT;AAj3IU;EACE,eCxCH;AD25IT;AAj3IU;EACE,eC3CH;AD85IT;AAj3IU;EACE,eC9CH;ADi6IT;AA72IU;EACE,aCrDH;ADo6IT;AA72IU;EACE,aCxDH;ADu6IT;AA72IU;EACE,aC3DH;AD06IT;AA72IU;EACE,aC9DH;AD66IT;AAz4IU;EACE,eCrCH;ADg7IT;AAz4IU;EACE,eCxCH;ADm7IT;AAz4IU;EACE,eC3CH;ADs7IT;AAz4IU;EACE,eC9CH;ADy7IT;AAr4IU;EACE,aCrDH;AD47IT;AAr4IU;EACE,aCxDH;AD+7IT;AAr4IU;EACE,aC3DH;ADk8IT;AAr4IU;EACE,aC9DH;ADq8IT;AAj6IU;EACE,eCrCH;ADw8IT;AAj6IU;EACE,eCxCH;AD28IT;AAj6IU;EACE,eC3CH;AD88IT;AAj6IU;EACE,eC9CH;ADi9IT;AA75IU;EACE,aCrDH;ADo9IT;AA75IU;EACE,aCxDH;ADu9IT;AA75IU;EACE,aC3DH;AD09IT;AA75IU;EACE,aC9DH;AD69IT;AAz7IU;EACE,eCrCH;ADg+IT;AAz7IU;EACE,eCxCH;ADm+IT;AAz7IU;EACE,eC3CH;ADs+IT;AAz7IU;EACE,eC9CH;ADy+IT;AAr7IU;EACE,aCrDH;AD4+IT;AAr7IU;EACE,aCxDH;AD++IT;AAr7IU;EACE,aC3DH;ADk/IT;AAr7IU;EACE,aC9DH;ADq/IT;AAj9IU;EACE,eCrCH;ADw/IT;AAj9IU;EACE,eCxCH;AD2/IT;AAj9IU;EACE,eC3CH;AD8/IT;AAj9IU;EACE,eC9CH;ADigJT;AA78IU;EACE,aCrDH;ADogJT;AA78IU;EACE,aCxDH;ADugJT;AA78IU;EACE,aC3DH;AD0gJT;AA78IU;EACE,aC9DH;AD6gJT;AAz+IU;EACE,eCrCH;ADghJT;AAz+IU;EACE,eCxCH;ADmhJT;AAz+IU;EACE,eC3CH;ADshJT;AAz+IU;EACE,eC9CH;ADyhJT;AAr+IU;EACE,aCrDH;AD4hJT;AAr+IU;EACE,aCxDH;AD+hJT;AAr+IU;EACE,aC3DH;ADkiJT;AAr+IU;EACE,aC9DH;ADqiJT;AAjgJU;EACE,eCrCH;ADwiJT;AAjgJU;EACE,eCxCH;AD2iJT;AAjgJU;EACE,eC3CH;AD8iJT;AAjgJU;EACE,eC9CH;ADijJT;AA7/IU;EACE,aCrDH;ADojJT;AA7/IU;EACE,aCxDH;ADujJT;AA7/IU;EACE,aC3DH;AD0jJT;AA7/IU;EACE,aC9DH;AD6jJT;AAzhJU;EACE,eCrCH;ADgkJT;AAzhJU;EACE,eCxCH;ADmkJT;AAzhJU;EACE,eC3CH;ADskJT;AAzhJU;EACE,eC9CH;ADykJT;AArhJU;EACE,aCrDH;AD4kJT;AArhJU;EACE,aCxDH;AD+kJT;AArhJU;EACE,aC3DH;ADklJT;AArhJU;EACE,aC9DH;ADqlJT;AAjjJU;EACE,eCrCH;ADwlJT;AAjjJU;EACE,eCxCH;AD2lJT;AAjjJU;EACE,eC3CH;AD8lJT;AAjjJU;EACE,eC9CH;ADimJT;AA7iJU;EACE,aCrDH;ADomJT;AA7iJU;EACE,aCxDH;ADumJT;AA7iJU;EACE,aC3DH;AD0mJT;AA7iJU;EACE,aC9DH;AD6mJT;AAzkJU;EACE,eCrCH;ADgnJT;AAzkJU;EACE,eCxCH;ADmnJT;AAzkJU;EACE,eC3CH;ADsnJT;AAzkJU;EACE,eC9CH;ADynJT;AArkJU;EACE,aCrDH;AD4nJT;AArkJU;EACE,aCxDH;AD+nJT;AArkJU;EACE,aC3DH;ADkoJT;AArkJU;EACE,aC9DH;ADqoJT;AAjmJU;EACE,eCrCH;ADwoJT;AAjmJU;EACE,eCxCH;AD2oJT;AAjmJU;EACE,eC3CH;AD8oJT;AAjmJU;EACE,eC9CH;ADipJT;AA7lJU;EACE,aCrDH;ADopJT;AA7lJU;EACE,aCxDH;ADupJT;AA7lJU;EACE,aC3DH;AD0pJT;AA7lJU;EACE,aC9DH;AD6pJT;AAznJU;EACE,eCrCH;ADgqJT;AAznJU;EACE,eCxCH;ADmqJT;AAznJU;EACE,eC3CH;ADsqJT;AAznJU;EACE,eC9CH;ADyqJT;AArnJU;EACE,aCrDH;AD4qJT;AArnJU;EACE,aCxDH;AD+qJT;AArnJU;EACE,aC3DH;ADkrJT;AArnJU;EACE,aC9DH;ADqrJT;AAjpJU;EACE,eCrCH;ADwrJT;AAjpJU;EACE,eCxCH;AD2rJT;AAjpJU;EACE,eC3CH;AD8rJT;AAjpJU;EACE,eC9CH;ADisJT;AA7oJU;EACE,aCrDH;ADosJT;AA7oJU;EACE,aCxDH;ADusJT;AA7oJU;EACE,aC3DH;AD0sJT;AA7oJU;EACE,aC9DH;AD6sJT;AAzqJU;EACE,eCrCH;ADgtJT;AAzqJU;EACE,eCxCH;ADmtJT;AAzqJU;EACE,eC3CH;ADstJT;AAzqJU;EACE,eC9CH;ADytJT;AArqJU;EACE,aCrDH;AD4tJT;AArqJU;EACE,aCxDH;AD+tJT;AArqJU;EACE,aC3DH;ADkuJT;AArqJU;EACE,aC9DH;ADquJT;AAjsJU;EACE,eCrCH;ADwuJT;AAjsJU;EACE,eCxCH;AD2uJT;AAjsJU;EACE,eC3CH;AD8uJT;AAjsJU;EACE,eC9CH;ADivJT;AA7rJU;EACE,aCrDH;ADovJT;AA7rJU;EACE,aCxDH;ADuvJT;AA7rJU;EACE,aC3DH;AD0vJT;AA7rJU;EACE,aC9DH;AD6vJT;AAztJU;EACE,eCrCH;ADgwJT;AAztJU;EACE,eCxCH;ADmwJT;AAztJU;EACE,eC3CH;ADswJT;AAztJU;EACE,eC9CH;ADywJT;AArtJU;EACE,aCrDH;AD4wJT;AArtJU;EACE,aCxDH;AD+wJT;AArtJU;EACE,aC3DH;ADkxJT;AArtJU;EACE,aC9DH;ADqxJT;AAjvJU;EACE,eCrCH;ADwxJT;AAjvJU;EACE,eCxCH;AD2xJT;AAjvJU;EACE,eC3CH;AD8xJT;AAjvJU;EACE,eC9CH;ADiyJT;AA7uJU;EACE,aCrDH;ADoyJT;AA7uJU;EACE,aCxDH;ADuyJT;AA7uJU;EACE,aC3DH;AD0yJT;AA7uJU;EACE,aC9DH;AD6yJT;AAzwJU;EACE,eCrCH;ADgzJT;AAzwJU;EACE,eCxCH;ADmzJT;AAzwJU;EACE,eC3CH;ADszJT;AAzwJU;EACE,eC9CH;ADyzJT;AArwJU;EACE,aCrDH;AD4zJT;AArwJU;EACE,aCxDH;AD+zJT;AArwJU;EACE,aC3DH;ADk0JT;AArwJU;EACE,aC9DH;ADq0JT;AAjyJU;EACE,eCrCH;ADw0JT;AAjyJU;EACE,eCxCH;AD20JT;AAjyJU;EACE,eC3CH;AD80JT;AAjyJU;EACE,eC9CH;ADi1JT;AA7xJU;EACE,aCrDH;ADo1JT;AA7xJU;EACE,aCxDH;ADu1JT;AA7xJU;EACE,aC3DH;AD01JT;AA7xJU;EACE,aC9DH;AD61JT;AAzzJU;EACE,eCrCH;ADg2JT;AAzzJU;EACE,eCxCH;ADm2JT;AAzzJU;EACE,eC3CH;ADs2JT;AAzzJU;EACE,eC9CH;ADy2JT;AArzJU;EACE,aCrDH;AD42JT;AArzJU;EACE,aCxDH;AD+2JT;AArzJU;EACE,aC3DH;ADk3JT;AArzJU;EACE,aC9DH;ADq3JT;AAj1JU;EACE,eCrCH;ADw3JT;AAj1JU;EACE,eCxCH;AD23JT;AAj1JU;EACE,eC3CH;AD83JT;AAj1JU;EACE,eC9CH;ADi4JT;AA70JU;EACE,aCrDH;ADo4JT;AA70JU;EACE,aCxDH;ADu4JT;AA70JU;EACE,aC3DH;AD04JT;AA70JU;EACE,aC9DH;AD64JT;AAz2JU;EACE,eCrCH;ADg5JT;AAz2JU;EACE,eCxCH;ADm5JT;AAz2JU;EACE,eC3CH;ADs5JT;AAz2JU;EACE,eC9CH;ADy5JT;AAr2JU;EACE,aCrDH;AD45JT;AAr2JU;EACE,aCxDH;AD+5JT;AAr2JU;EACE,aC3DH;ADk6JT;AAr2JU;EACE,aC9DH;ADq6JT;AAj4JU;EACE,eCrCH;ADw6JT;AAj4JU;EACE,eCxCH;AD26JT;AAj4JU;EACE,eC3CH;AD86JT;AAj4JU;EACE,eC9CH;ADi7JT;AA73JU;EACE,aCrDH;ADo7JT;AA73JU;EACE,aCxDH;ADu7JT;AA73JU;EACE,aC3DH;AD07JT;AA73JU;EACE,aC9DH;AD67JT;AAz5JU;EACE,eCrCH;ADg8JT;AAz5JU;EACE,eCxCH;ADm8JT;AAz5JU;EACE,eC3CH;ADs8JT;AAz5JU;EACE,eC9CH;ADy8JT;AAr5JU;EACE,aCrDH;AD48JT;AAr5JU;EACE,aCxDH;AD+8JT;AAr5JU;EACE,aC3DH;ADk9JT;AAr5JU;EACE,aC9DH;ADq9JT;AAj7JU;EACE,eCrCH;ADw9JT;AAj7JU;EACE,eCxCH;AD29JT;AAj7JU;EACE,eC3CH;AD89JT;AAj7JU;EACE,eC9CH;ADi+JT;AA76JU;EACE,aCrDH;ADo+JT;AA76JU;EACE,aCxDH;ADu+JT;AA76JU;EACE,aC3DH;AD0+JT;AA76JU;EACE,aC9DH;AD6+JT;AAz8JU;EACE,eCrCH;ADg/JT;AAz8JU;EACE,eCxCH;ADm/JT;AAz8JU;EACE,eC3CH;ADs/JT;AAz8JU;EACE,eC9CH;ADy/JT;AAr8JU;EACE,aCrDH;AD4/JT;AAr8JU;EACE,aCxDH;AD+/JT;AAr8JU;EACE,aC3DH;ADkgKT;AAr8JU;EACE,aC9DH;ADqgKT;AAj+JU;EACE,eCrCH;ADwgKT;AAj+JU;EACE,eCxCH;AD2gKT;AAj+JU;EACE,eC3CH;AD8gKT;AAj+JU;EACE,eC9CH;ADihKT;AA79JU;EACE,aCrDH;ADohKT;AA79JU;EACE,aCxDH;ADuhKT;AA79JU;EACE,aC3DH;AD0hKT;AA79JU;EACE,aC9DH;AD6hKT;AAz/JU;EACE,eCrCH;ADgiKT;AAz/JU;EACE,eCxCH;ADmiKT;AAz/JU;EACE,eC3CH;ADsiKT;AAz/JU;EACE,eC9CH;ADyiKT;AAr/JU;EACE,aCrDH;AD4iKT;AAr/JU;EACE,aCxDH;AD+iKT;AAr/JU;EACE,aC3DH;ADkjKT;AAr/JU;EACE,aC9DH;ADqjKT;AAjhKU;EACE,eCrCH;ADwjKT;AAjhKU;EACE,eCxCH;AD2jKT;AAjhKU;EACE,eC3CH;AD8jKT;AAjhKU;EACE,eC9CH;ADikKT;AA7gKU;EACE,aCrDH;ADokKT;AA7gKU;EACE,aCxDH;ADukKT;AA7gKU;EACE,aC3DH;AD0kKT;AA7gKU;EACE,aC9DH;AD6kKT;AAziKU;EACE,eCrCH;ADglKT;AAziKU;EACE,eCxCH;ADmlKT;AAziKU;EACE,eC3CH;ADslKT;AAziKU;EACE,eC9CH;ADylKT;AAriKU;EACE,aCrDH;AD4lKT;AAriKU;EACE,aCxDH;AD+lKT;AAriKU;EACE,aC3DH;ADkmKT;AAriKU;EACE,aC9DH;ADqmKT;AAjkKU;EACE,eCrCH;ADwmKT;AAjkKU;EACE,eCxCH;AD2mKT;AAjkKU;EACE,eC3CH;AD8mKT;AAjkKU;EACE,eC9CH;ADinKT;AA7jKU;EACE,aCrDH;ADonKT;AA7jKU;EACE,aCxDH;ADunKT;AA7jKU;EACE,aC3DH;AD0nKT;AA7jKU;EACE,aC9DH;AD6nKT;AAzlKU;EACE,eCrCH;ADgoKT;AAzlKU;EACE,eCxCH;ADmoKT;AAzlKU;EACE,eC3CH;ADsoKT;AAzlKU;EACE,eC9CH;ADyoKT;AArlKU;EACE,aCrDH;AD4oKT;AArlKU;EACE,aCxDH;AD+oKT;AArlKU;EACE,aC3DH;ADkpKT;AArlKU;EACE,aC9DH;ADqpKT;AAjnKU;EACE,eCrCH;ADwpKT;AAjnKU;EACE,eCxCH;AD2pKT;AAjnKU;EACE,eC3CH;AD8pKT;AAjnKU;EACE,eC9CH;ADiqKT;AA7mKU;EACE,aCrDH;ADoqKT;AA7mKU;EACE,aCxDH;ADuqKT;AA7mKU;EACE,aC3DH;AD0qKT;AA7mKU;EACE,aC9DH;AD6qKT;AApmKQ;;;EAGE,aAiBkB;AAqlK5B;AA/lKQ;;;EAGE,WAOkB;AA0lK5B;AA9mKQ;;;EAGE,aAqBkB;AA2lK5B;AAzmKQ;;;EAGE,WAWkB;AAgmK5B;;AArlKY;EACE,4CAAA;AAwlKd;AAllKY;EACE,8CAAA;AAolKd;;AA1kKY;EACE,4CAAA;AA6kKd;AAvkKY;EACE,8CAAA;AAykKd;;AAhkKU;EACE,4CAAA;AAmkKZ;;AA3jKU;EACE,4CAAA;AA8jKZ;;AA3mKY;EACE,oEAAA;AA8mKd;AAxmKY;EACE,sEAAA;AA0mKd;;AAhmKY;EACE,oEAAA;AAmmKd;AA7lKY;EACE,sEAAA;AA+lKd;;AAtlKU;EACE,oEAAA;AAylKZ;;AAjlKU;EACE,oEAAA;AAolKZ;;AAjoKY;EACE,4CAAA;AAooKd;AA9nKY;EACE,8CAAA;AAgoKd;;AAtnKY;EACE,yCAAA;AAynKd;AAnnKY;EACE,2CAAA;AAqnKd;;AA5mKU;EACE,4CAAA;AA+mKZ;;AAvmKU;EACE,4CAAA;AA0mKZ;;AAvpKY;EACE,4CAAA;AA0pKd;AAppKY;EACE,8CAAA;AAspKd;;AA5oKY;EACE,4CAAA;AA+oKd;AAzoKY;EACE,8CAAA;AA2oKd;;AAloKU;EACE,4CAAA;AAqoKZ;;AA7nKU;EACE,4CAAA;AAgoKZ;;AA7qKY;EACE,2CAAA;AAgrKd;AA1qKY;EACE,6CAAA;AA4qKd;;AAlqKY;EACE,2DAAA;AAqqKd;AA/pKY;EACE,6DAAA;AAiqKd;;AAxpKU;EACE,2CAAA;AA2pKZ;;AAnpKU;EACE,2CAAA;AAspKZ;;AAnsKY;EACE,oEAAA;AAssKd;AAhsKY;EACE,sEAAA;AAksKd;;AAxrKY;EACE,oEAAA;AA2rKd;AArrKY;EACE,sEAAA;AAurKd;;AA9qKU;EACE,oEAAA;AAirKZ;;AAzqKU;EACE,oEAAA;AA4qKZ;;AAztKY;EACE,oEAAA;AA4tKd;AAttKY;EACE,sEAAA;AAwtKd;;AA9sKY;EACE,oEAAA;AAitKd;AA3sKY;EACE,sEAAA;AA6sKd;;AApsKU;EACE,oEAAA;AAusKZ;;AA/rKU;EACE,oEAAA;AAksKZ;;AA/uKY;EACE,4CAAA;AAkvKd;AA5uKY;EACE,8CAAA;AA8uKd;;AApuKY;EACE,yCAAA;AAuuKd;AAjuKY;EACE,2CAAA;AAmuKd;;AA1tKU;EACE,4CAAA;AA6tKZ;;AArtKU;EACE,4CAAA;AAwtKZ;;AArwKY;EACE,yCAAA;AAwwKd;AAlwKY;EACE,2CAAA;AAowKd;;AA1vKY;EACE,uCAAA;AA6vKd;AAvvKY;EACE,yCAAA;AAyvKd;;AAhvKU;EACE,yCAAA;AAmvKZ;;AA3uKU;EACE,yCAAA;AA8uKZ;;AA3xKY;EACE,wCAAA;AA8xKd;AAxxKY;EACE,0CAAA;AA0xKd;;AAhxKY;EACE,wCAAA;AAmxKd;AA7wKY;EACE,0CAAA;AA+wKd;;AAtwKU;EACE,wCAAA;AAywKZ;;AAjwKU;EACE,wCAAA;AAowKZ;;AAjzKY;EACE,yCAAA;AAozKd;AA9yKY;EACE,2CAAA;AAgzKd;;AAtyKY;EACE,yCAAA;AAyyKd;AAnyKY;EACE,2CAAA;AAqyKd;;AA5xKU;EACE,yCAAA;AA+xKZ;;AAvxKU;EACE,yCAAA;AA0xKZ;;AAv0KY;EACE,yCAAA;AA00Kd;AAp0KY;EACE,2CAAA;AAs0Kd;;AA5zKY;EACE,wCAAA;AA+zKd;AAzzKY;EACE,0CAAA;AA2zKd;;AAlzKU;EACE,yCAAA;AAqzKZ;;AA7yKU;EACE,yCAAA;AAgzKZ;;AA71KY;EACE,uCAAA;AAg2Kd;AA11KY;EACE,yCAAA;AA41Kd;;AAl1KY;EACE,sCAAA;AAq1Kd;AA/0KY;EACE,wCAAA;AAi1Kd;;AAx0KU;EACE,uCAAA;AA20KZ;;AAn0KU;EACE,uCAAA;AAs0KZ;;AAn3KY;EACE,yCAAA;AAs3Kd;AAh3KY;EACE,2CAAA;AAk3Kd;;AAx2KY;EACE,yCAAA;AA22Kd;AAr2KY;EACE,2CAAA;AAu2Kd;;AA91KU;EACE,yCAAA;AAi2KZ;;AAz1KU;EACE,yCAAA;AA41KZ;;AAz4KY;EACE,4CAAA;AA44Kd;AAt4KY;EACE,8CAAA;AAw4Kd;;AA93KY;EACE,4CAAA;AAi4Kd;AA33KY;EACE,8CAAA;AA63Kd;;AAp3KU;EACE,4CAAA;AAu3KZ;;AA/2KU;EACE,4CAAA;AAk3KZ;;AA/5KY;EACE,oEAAA;AAk6Kd;AA55KY;EACE,sEAAA;AA85Kd;;AAp5KY;EACE,oEAAA;AAu5Kd;AAj5KY;EACE,sEAAA;AAm5Kd;;AA14KU;EACE,oEAAA;AA64KZ;;AAr4KU;EACE,oEAAA;AAw4KZ;;AAr7KY;EACE,oEAAA;AAw7Kd;AAl7KY;EACE,sEAAA;AAo7Kd;;AA16KY;EACE,oEAAA;AA66Kd;AAv6KY;EACE,sEAAA;AAy6Kd;;AAh6KU;EACE,oEAAA;AAm6KZ;;AA35KU;EACE,oEAAA;AA85KZ;;AA38KY;EACE,mEAAA;AA88Kd;AAx8KY;EACE,qEAAA;AA08Kd;;AAh8KY;EACE,oEAAA;AAm8Kd;AA77KY;EACE,sEAAA;AA+7Kd;;AAt7KU;EACE,mEAAA;AAy7KZ;;AAj7KU;EACE,mEAAA;AAo7KZ;;AAj+KY;EACE,oEAAA;AAo+Kd;AA99KY;EACE,sEAAA;AAg+Kd;;AAt9KY;EACE,oEAAA;AAy9Kd;AAn9KY;EACE,sEAAA;AAq9Kd;;AA58KU;EACE,oEAAA;AA+8KZ;;AAv8KU;EACE,oEAAA;AA08KZ;;AAv/KY;EACE,oEAAA;AA0/Kd;AAp/KY;EACE,sEAAA;AAs/Kd;;AA5+KY;EACE,oEAAA;AA++Kd;AAz+KY;EACE,sEAAA;AA2+Kd;;AAl+KU;EACE,oEAAA;AAq+KZ;;AA79KU;EACE,oEAAA;AAg+KZ;;AA7gLY;EACE,0CAAA;AAghLd;AA1gLY;EACE,4CAAA;AA4gLd;;AAlgLY;EACE,wCAAA;AAqgLd;AA//KY;EACE,0CAAA;AAigLd;;AAx/KU;EACE,0CAAA;AA2/KZ;;AAn/KU;EACE,0CAAA;AAs/KZ;;AAniLY;EACE,yCAAA;AAsiLd;AAhiLY;EACE,2CAAA;AAkiLd;;AAxhLY;EACE,wCAAA;AA2hLd;AArhLY;EACE,0CAAA;AAuhLd;;AA9gLU;EACE,yCAAA;AAihLZ;;AAzgLU;EACE,yCAAA;AA4gLZ;;AAzjLY;EACE,yCAAA;AA4jLd;AAtjLY;EACE,2CAAA;AAwjLd;;AA9iLY;EACE,uCAAA;AAijLd;AA3iLY;EACE,yCAAA;AA6iLd;;AApiLU;EACE,yCAAA;AAuiLZ;;AA/hLU;EACE,yCAAA;AAkiLZ;;AA/kLY;EACE,yCAAA;AAklLd;AA5kLY;EACE,2CAAA;AA8kLd;;AApkLY;EACE,wCAAA;AAukLd;AAjkLY;EACE,0CAAA;AAmkLd;;AA1jLU;EACE,yCAAA;AA6jLZ;;AArjLU;EACE,yCAAA;AAwjLZ;;AArmLY;EACE,yCAAA;AAwmLd;AAlmLY;EACE,2CAAA;AAomLd;;AA1lLY;EACE,sCAAA;AA6lLd;AAvlLY;EACE,wCAAA;AAylLd;;AAhlLU;EACE,yCAAA;AAmlLZ;;AA3kLU;EACE,yCAAA;AA8kLZ;;AA3nLY;EACE,yCAAA;AA8nLd;AAxnLY;EACE,2CAAA;AA0nLd;;AAhnLY;EACE,wCAAA;AAmnLd;AA7mLY;EACE,0CAAA;AA+mLd;;AAtmLU;EACE,yCAAA;AAymLZ;;AAjmLU;EACE,yCAAA;AAomLZ;;AAjpLY;EACE,wBAAA;AAopLd;AA9oLY;EACE,0BAAA;AAgpLd;;AAtoLY;EACE,wBAAA;AAyoLd;AAnoLY;EACE,0BAAA;AAqoLd;;AA5nLU;EACE,wBAAA;AA+nLZ;;AAvnLU;EACE,wBAAA;AA0nLZ;;AAvqLY;EACE,yCAAA;AA0qLd;AApqLY;EACE,2CAAA;AAsqLd;;AA5pLY;EACE,wCAAA;AA+pLd;AAzpLY;EACE,0CAAA;AA2pLd;;AAlpLU;EACE,yCAAA;AAqpLZ;;AA7oLU;EACE,yCAAA;AAgpLZ;;AA7rLY;EACE,wDAAA;AAgsLd;AA1rLY;EACE,0DAAA;AA4rLd;;AAlrLY;EACE,wDAAA;AAqrLd;AA/qLY;EACE,0DAAA;AAirLd;;AAxqLU;EACE,wDAAA;AA2qLZ;;AAnqLU;EACE,wDAAA;AAsqLZ;;AAntLY;EACE,oEAAA;AAstLd;AAhtLY;EACE,sEAAA;AAktLd;;AAxsLY;EACE,oEAAA;AA2sLd;AArsLY;EACE,sEAAA;AAusLd;;AA9rLU;EACE,oEAAA;AAisLZ;;AAzrLU;EACE,oEAAA;AA4rLZ;;AAzuLY;EACE,mEAAA;AA4uLd;AAtuLY;EACE,qEAAA;AAwuLd;;AA9tLY;EACE,mEAAA;AAiuLd;AA3tLY;EACE,qEAAA;AA6tLd;;AAptLU;EACE,mEAAA;AAutLZ;;AA/sLU;EACE,mEAAA;AAktLZ;;AA/vLY;EACE,mEAAA;AAkwLd;AA5vLY;EACE,qEAAA;AA8vLd;;AApvLY;EACE,kEAAA;AAuvLd;AAjvLY;EACE,oEAAA;AAmvLd;;AA1uLU;EACE,mEAAA;AA6uLZ;;AAruLU;EACE,mEAAA;AAwuLZ;;AArxLY;EACE,2CAAA;AAwxLd;AAlxLY;EACE,6CAAA;AAoxLd;;AA1wLY;EACE,yCAAA;AA6wLd;AAvwLY;EACE,2CAAA;AAywLd;;AAhwLU;EACE,2CAAA;AAmwLZ;;AA3vLU;EACE,2CAAA;AA8vLZ;;AA3yLY;EACE,uCAAA;AA8yLd;AAxyLY;EACE,yCAAA;AA0yLd;;AAhyLY;EACE,sCAAA;AAmyLd;AA7xLY;EACE,wCAAA;AA+xLd;;AAtxLU;EACE,uCAAA;AAyxLZ;;AAjxLU;EACE,uCAAA;AAoxLZ;;AAj0LY;EACE,yCAAA;AAo0Ld;AA9zLY;EACE,2CAAA;AAg0Ld;;AAtzLY;EACE,sCAAA;AAyzLd;AAnzLY;EACE,wCAAA;AAqzLd;;AA5yLU;EACE,yCAAA;AA+yLZ;;AAvyLU;EACE,yCAAA;AA0yLZ;;AAv1LY;EACE,yCAAA;AA01Ld;AAp1LY;EACE,2CAAA;AAs1Ld;;AA50LY;EACE,uCAAA;AA+0Ld;AAz0LY;EACE,yCAAA;AA20Ld;;AAl0LU;EACE,yCAAA;AAq0LZ;;AA7zLU;EACE,yCAAA;AAg0LZ;;AA72LY;EACE,0CAAA;AAg3Ld;AA12LY;EACE,4CAAA;AA42Ld;;AAl2LY;EACE,uCAAA;AAq2Ld;AA/1LY;EACE,yCAAA;AAi2Ld;;AAx1LU;EACE,0CAAA;AA21LZ;;AAn1LU;EACE,0CAAA;AAs1LZ;;AAn4LY;EACE,wCAAA;AAs4Ld;AAh4LY;EACE,0CAAA;AAk4Ld;;AAx3LY;EACE,sCAAA;AA23Ld;AAr3LY;EACE,wCAAA;AAu3Ld;;AA92LU;EACE,wCAAA;AAi3LZ;;AAz2LU;EACE,wCAAA;AA42LZ;;AAz5LY;EACE,yCAAA;AA45Ld;AAt5LY;EACE,2CAAA;AAw5Ld;;AA94LY;EACE,wCAAA;AAi5Ld;AA34LY;EACE,0CAAA;AA64Ld;;AAp4LU;EACE,yCAAA;AAu4LZ;;AA/3LU;EACE,yCAAA;AAk4LZ;;AA/6LY;EACE,4CAAA;AAk7Ld;AA56LY;EACE,8CAAA;AA86Ld;;AAp6LY;EACE,oEAAA;AAu6Ld;AAj6LY;EACE,sEAAA;AAm6Ld;;AA15LU;EACE,4CAAA;AA65LZ;;AAr5LU;EACE,4CAAA;AAw5LZ;;AAr8LY;EACE,4CAAA;AAw8Ld;AAl8LY;EACE,8CAAA;AAo8Ld;;AA17LY;EACE,yCAAA;AA67Ld;AAv7LY;EACE,2CAAA;AAy7Ld;;AAh7LU;EACE,4CAAA;AAm7LZ;;AA36LU;EACE,4CAAA;AA86LZ;;AA39LY;EACE,oEAAA;AA89Ld;AAx9LY;EACE,sEAAA;AA09Ld;;AAh9LY;EACE,oEAAA;AAm9Ld;AA78LY;EACE,sEAAA;AA+8Ld;;AAt8LU;EACE,oEAAA;AAy8LZ;;AAj8LU;EACE,oEAAA;AAo8LZ;;AAj/LY;EACE,yCAAA;AAo/Ld;AA9+LY;EACE,2CAAA;AAg/Ld;;AAt+LY;EACE,sCAAA;AAy+Ld;AAn+LY;EACE,wCAAA;AAq+Ld;;AA59LU;EACE,yCAAA;AA+9LZ;;AAv9LU;EACE,yCAAA;AA09LZ;;AAvgMY;EACE,kEAAA;AA0gMd;AApgMY;EACE,oEAAA;AAsgMd;;AA5/LY;EACE,kEAAA;AA+/Ld;AAz/LY;EACE,oEAAA;AA2/Ld;;AAl/LU;EACE,kEAAA;AAq/LZ;;AA7+LU;EACE,kEAAA;AAg/LZ;;AA7hMY;EACE,kEAAA;AAgiMd;AA1hMY;EACE,oEAAA;AA4hMd;;AAlhMY;EACE,kEAAA;AAqhMd;AA/gMY;EACE,oEAAA;AAihMd;;AAxgMU;EACE,kEAAA;AA2gMZ;;AAngMU;EACE,kEAAA;AAsgMZ;;AAnjMY;EACE,0CAAA;AAsjMd;AAhjMY;EACE,4CAAA;AAkjMd;;AAxiMY;EACE,yCAAA;AA2iMd;AAriMY;EACE,2CAAA;AAuiMd;;AA9hMU;EACE,0CAAA;AAiiMZ;;AAzhMU;EACE,0CAAA;AA4hMZ;;AAzkMY;EACE,yCAAA;AA4kMd;AAtkMY;EACE,2CAAA;AAwkMd;;AA9jMY;EACE,sCAAA;AAikMd;AA3jMY;EACE,wCAAA;AA6jMd;;AApjMU;EACE,yCAAA;AAujMZ;;AA/iMU;EACE,yCAAA;AAkjMZ;;AA/lMY;EACE,0CAAA;AAkmMd;AA5lMY;EACE,4CAAA;AA8lMd;;AAplMY;EACE,wCAAA;AAulMd;AAjlMY;EACE,0CAAA;AAmlMd;;AA1kMU;EACE,0CAAA;AA6kMZ;;AArkMU;EACE,0CAAA;AAwkMZ;;AArnMY;EACE,0CAAA;AAwnMd;AAlnMY;EACE,4CAAA;AAonMd;;AA1mMY;EACE,wCAAA;AA6mMd;AAvmMY;EACE,0CAAA;AAymMd;;AAhmMU;EACE,0CAAA;AAmmMZ;;AA3lMU;EACE,0CAAA;AA8lMZ;;AA3oMY;EACE,yCAAA;AA8oMd;AAxoMY;EACE,2CAAA;AA0oMd;;AAhoMY;EACE,uCAAA;AAmoMd;AA7nMY;EACE,yCAAA;AA+nMd;;AAtnMU;EACE,yCAAA;AAynMZ;;AAjnMU;EACE,yCAAA;AAonMZ;;AAjqMY;EACE,qCAAA;AAoqMd;AA9pMY;EACE,uCAAA;AAgqMd;;AAtpMY;EACE,qCAAA;AAypMd;AAnpMY;EACE,uCAAA;AAqpMd;;AA5oMU;EACE,qCAAA;AA+oMZ;;AAvoMU;EACE,qCAAA;AA0oMZ;;AAvrMY;EACE,yCAAA;AA0rMd;AAprMY;EACE,2CAAA;AAsrMd;;AA5qMY;EACE,yCAAA;AA+qMd;AAzqMY;EACE,2CAAA;AA2qMd;;AAlqMU;EACE,yCAAA;AAqqMZ;;AA7pMU;EACE,yCAAA;AAgqMZ;;AA7sMY;EACE,oEAAA;AAgtMd;AA1sMY;EACE,sEAAA;AA4sMd;;AAlsMY;EACE,oEAAA;AAqsMd;AA/rMY;EACE,sEAAA;AAisMd;;AAxrMU;EACE,oEAAA;AA2rMZ;;AAnrMU;EACE,oEAAA;AAsrMZ;;AAnuMY;EACE,4CAAA;AAsuMd;AAhuMY;EACE,8CAAA;AAkuMd;;AAxtMY;EACE,mEAAA;AA2tMd;AArtMY;EACE,qEAAA;AAutMd;;AA9sMU;EACE,4CAAA;AAitMZ;;AAzsMU;EACE,4CAAA;AA4sMZ;;AAzvMY;EACE,mEAAA;AA4vMd;AAtvMY;EACE,qEAAA;AAwvMd;;AA9uMY;EACE,mEAAA;AAivMd;AA3uMY;EACE,qEAAA;AA6uMd;;AApuMU;EACE,mEAAA;AAuuMZ;;AA/tMU;EACE,mEAAA;AAkuMZ;;AA/wMY;EACE,mEAAA;AAkxMd;AA5wMY;EACE,qEAAA;AA8wMd;;AApwMY;EACE,kEAAA;AAuwMd;AAjwMY;EACE,oEAAA;AAmwMd;;AA1vMU;EACE,mEAAA;AA6vMZ;;AArvMU;EACE,mEAAA;AAwvMZ;;AAryMY;EACE,kEAAA;AAwyMd;AAlyMY;EACE,oEAAA;AAoyMd;;AA1xMY;EACE,kEAAA;AA6xMd;AAvxMY;EACE,oEAAA;AAyxMd;;AAhxMU;EACE,kEAAA;AAmxMZ;;AA3wMU;EACE,kEAAA;AA8wMZ;;AA3zMY;EACE,wCAAA;AA8zMd;AAxzMY;EACE,0CAAA;AA0zMd;;AAhzMY;EACE,qCAAA;AAmzMd;AA7yMY;EACE,uCAAA;AA+yMd;;AAtyMU;EACE,wCAAA;AAyyMZ;;AAjyMU;EACE,wCAAA;AAoyMZ;;AAj1MY;EACE,yCAAA;AAo1Md;AA90MY;EACE,2CAAA;AAg1Md;;AAt0MY;EACE,wCAAA;AAy0Md;AAn0MY;EACE,0CAAA;AAq0Md;;AA5zMU;EACE,yCAAA;AA+zMZ;;AAvzMU;EACE,yCAAA;AA0zMZ;;AAv2MY;EACE,0CAAA;AA02Md;AAp2MY;EACE,4CAAA;AAs2Md;;AA51MY;EACE,0CAAA;AA+1Md;AAz1MY;EACE,4CAAA;AA21Md;;AAl1MU;EACE,0CAAA;AAq1MZ;;AA70MU;EACE,0CAAA;AAg1MZ;;AA73MY;EACE,0CAAA;AAg4Md;AA13MY;EACE,4CAAA;AA43Md;;AAl3MY;EACE,uCAAA;AAq3Md;AA/2MY;EACE,yCAAA;AAi3Md;;AAx2MU;EACE,0CAAA;AA22MZ;;AAn2MU;EACE,0CAAA;AAs2MZ;;AAn5MY;EACE,wCAAA;AAs5Md;AAh5MY;EACE,0CAAA;AAk5Md;;AAx4MY;EACE,uCAAA;AA24Md;AAr4MY;EACE,yCAAA;AAu4Md;;AA93MU;EACE,wCAAA;AAi4MZ;;AAz3MU;EACE,wCAAA;AA43MZ;;AAz6MY;EACE,uCAAA;AA46Md;AAt6MY;EACE,yCAAA;AAw6Md;;AA95MY;EACE,uCAAA;AAi6Md;AA35MY;EACE,yCAAA;AA65Md;;AAp5MU;EACE,uCAAA;AAu5MZ;;AA/4MU;EACE,uCAAA;AAk5MZ;;AA/7MY;EACE,4CAAA;AAk8Md;AA57MY;EACE,8CAAA;AA87Md;;AAp7MY;EACE,oEAAA;AAu7Md;AAj7MY;EACE,sEAAA;AAm7Md;;AA16MU;EACE,4CAAA;AA66MZ;;AAr6MU;EACE,4CAAA;AAw6MZ;;AAr9MY;EACE,4CAAA;AAw9Md;AAl9MY;EACE,8CAAA;AAo9Md;;AA18MY;EACE,0CAAA;AA68Md;AAv8MY;EACE,4CAAA;AAy8Md;;AAh8MU;EACE,4CAAA;AAm8MZ;;AA37MU;EACE,4CAAA;AA87MZ;;AA3+MY;EACE,+CAAA;AA8+Md;AAx+MY;EACE,iDAAA;AA0+Md;;AAh+MY;EACE,+CAAA;AAm+Md;AA79MY;EACE,iDAAA;AA+9Md;;AAt9MU;EACE,+CAAA;AAy9MZ;;AAj9MU;EACE,+CAAA;AAo9MZ;;AAjgNY;EACE,iEAAA;AAogNd;AA9/MY;EACE,mEAAA;AAggNd;;AAt/MY;EACE,mEAAA;AAy/Md;AAn/MY;EACE,qEAAA;AAq/Md;;AA5+MU;EACE,iEAAA;AA++MZ;;AAv+MU;EACE,iEAAA;AA0+MZ;;AAvhNY;EACE,mEAAA;AA0hNd;AAphNY;EACE,qEAAA;AAshNd;;AA5gNY;EACE,mEAAA;AA+gNd;AAzgNY;EACE,qEAAA;AA2gNd;;AAlgNU;EACE,mEAAA;AAqgNZ;;AA7/MU;EACE,mEAAA;AAggNZ;;AA7iNY;EACE,uCAAA;AAgjNd;AA1iNY;EACE,yCAAA;AA4iNd;;AAliNY;EACE,sCAAA;AAqiNd;AA/hNY;EACE,wCAAA;AAiiNd;;AAxhNU;EACE,uCAAA;AA2hNZ;;AAnhNU;EACE,uCAAA;AAshNZ;;AAnkNY;EACE,wCAAA;AAskNd;AAhkNY;EACE,0CAAA;AAkkNd;;AAxjNY;EACE,qCAAA;AA2jNd;AArjNY;EACE,uCAAA;AAujNd;;AA9iNU;EACE,wCAAA;AAijNZ;;AAziNU;EACE,wCAAA;AA4iNZ;;AAzlNY;EACE,yCAAA;AA4lNd;AAtlNY;EACE,2CAAA;AAwlNd;;AA9kNY;EACE,sCAAA;AAilNd;AA3kNY;EACE,wCAAA;AA6kNd;;AApkNU;EACE,yCAAA;AAukNZ;;AA/jNU;EACE,yCAAA;AAkkNZ;;AA/mNY;EACE,wCAAA;AAknNd;AA5mNY;EACE,0CAAA;AA8mNd;;AApmNY;EACE,uCAAA;AAumNd;AAjmNY;EACE,yCAAA;AAmmNd;;AA1lNU;EACE,wCAAA;AA6lNZ;;AArlNU;EACE,wCAAA;AAwlNZ;;AAroNY;EACE,wCAAA;AAwoNd;AAloNY;EACE,0CAAA;AAooNd;;AA1nNY;EACE,qCAAA;AA6nNd;AAvnNY;EACE,uCAAA;AAynNd;;AAhnNU;EACE,wCAAA;AAmnNZ;;AA3mNU;EACE,wCAAA;AA8mNZ;;AA3pNY;EACE,wCAAA;AA8pNd;AAxpNY;EACE,0CAAA;AA0pNd;;AAhpNY;EACE,sCAAA;AAmpNd;AA7oNY;EACE,wCAAA;AA+oNd;;AAtoNU;EACE,wCAAA;AAyoNZ;;AAjoNU;EACE,wCAAA;AAooNZ;;AAjrNY;EACE,qCAAA;AAorNd;AA9qNY;EACE,uCAAA;AAgrNd;;AAtqNY;EACE,qCAAA;AAyqNd;AAnqNY;EACE,uCAAA;AAqqNd;;AA5pNU;EACE,qCAAA;AA+pNZ;;AAvpNU;EACE,qCAAA;AA0pNZ;;AAvsNY;EACE,2CAAA;AA0sNd;AApsNY;EACE,6CAAA;AAssNd;;AA5rNY;EACE,oEAAA;AA+rNd;AAzrNY;EACE,sEAAA;AA2rNd;;AAlrNU;EACE,2CAAA;AAqrNZ;;AA7qNU;EACE,2CAAA;AAgrNZ;;AA7tNY;EACE,2CAAA;AAguNd;AA1tNY;EACE,6CAAA;AA4tNd;;AAltNY;EACE,yCAAA;AAqtNd;AA/sNY;EACE,2CAAA;AAitNd;;AAxsNU;EACE,2CAAA;AA2sNZ;;AAnsNU;EACE,2CAAA;AAssNZ;;AAnvNY;EACE,+CAAA;AAsvNd;AAhvNY;EACE,iDAAA;AAkvNd;;AAxuNY;EACE,+CAAA;AA2uNd;AAruNY;EACE,iDAAA;AAuuNd;;AA9tNU;EACE,+CAAA;AAiuNZ;;AAztNU;EACE,+CAAA;AA4tNZ;;AAzwNY;EACE,oEAAA;AA4wNd;AAtwNY;EACE,sEAAA;AAwwNd;;AA9vNY;EACE,mEAAA;AAiwNd;AA3vNY;EACE,qEAAA;AA6vNd;;AApvNU;EACE,oEAAA;AAuvNZ;;AA/uNU;EACE,oEAAA;AAkvNZ;;AA/xNY;EACE,mEAAA;AAkyNd;AA5xNY;EACE,qEAAA;AA8xNd;;AApxNY;EACE,mEAAA;AAuxNd;AAjxNY;EACE,qEAAA;AAmxNd;;AA1wNU;EACE,mEAAA;AA6wNZ;;AArwNU;EACE,mEAAA;AAwwNZ;;AArzNY;EACE,0CAAA;AAwzNd;AAlzNY;EACE,4CAAA;AAozNd;;AA1yNY;EACE,wCAAA;AA6yNd;AAvyNY;EACE,0CAAA;AAyyNd;;AAhyNU;EACE,0CAAA;AAmyNZ;;AA3xNU;EACE,0CAAA;AA8xNZ;;AA30NY;EACE,0CAAA;AA80Nd;AAx0NY;EACE,4CAAA;AA00Nd;;AAh0NY;EACE,yCAAA;AAm0Nd;AA7zNY;EACE,2CAAA;AA+zNd;;AAtzNU;EACE,0CAAA;AAyzNZ;;AAjzNU;EACE,0CAAA;AAozNZ;;AAj2NY;EACE,yCAAA;AAo2Nd;AA91NY;EACE,2CAAA;AAg2Nd;;AAt1NY;EACE,uCAAA;AAy1Nd;AAn1NY;EACE,yCAAA;AAq1Nd;;AA50NU;EACE,yCAAA;AA+0NZ;;AAv0NU;EACE,yCAAA;AA00NZ;;AAv3NY;EACE,wCAAA;AA03Nd;AAp3NY;EACE,0CAAA;AAs3Nd;;AA52NY;EACE,sCAAA;AA+2Nd;AAz2NY;EACE,wCAAA;AA22Nd;;AAl2NU;EACE,wCAAA;AAq2NZ;;AA71NU;EACE,wCAAA;AAg2NZ;;AA74NY;EACE,yCAAA;AAg5Nd;AA14NY;EACE,2CAAA;AA44Nd;;AAl4NY;EACE,uCAAA;AAq4Nd;AA/3NY;EACE,yCAAA;AAi4Nd;;AAx3NU;EACE,yCAAA;AA23NZ;;AAn3NU;EACE,yCAAA;AAs3NZ;;AAn6NY;EACE,wCAAA;AAs6Nd;AAh6NY;EACE,0CAAA;AAk6Nd;;AAx5NY;EACE,oCAAA;AA25Nd;AAr5NY;EACE,sCAAA;AAu5Nd;;AA94NU;EACE,wCAAA;AAi5NZ;;AAz4NU;EACE,wCAAA;AA44NZ;;AAz7NY;EACE,oEAAA;AA47Nd;AAt7NY;EACE,sEAAA;AAw7Nd;;AA96NY;EACE,oEAAA;AAi7Nd;AA36NY;EACE,sEAAA;AA66Nd;;AAp6NU;EACE,oEAAA;AAu6NZ;;AA/5NU;EACE,oEAAA;AAk6NZ;;AA/8NY;EACE,+CAAA;AAk9Nd;AA58NY;EACE,iDAAA;AA88Nd;;AAp8NY;EACE,4CAAA;AAu8Nd;AAj8NY;EACE,8CAAA;AAm8Nd;;AA17NU;EACE,+CAAA;AA67NZ;;AAr7NU;EACE,+CAAA;AAw7NZ;;AAr+NY;EACE,oEAAA;AAw+Nd;AAl+NY;EACE,sEAAA;AAo+Nd;;AA19NY;EACE,oEAAA;AA69Nd;AAv9NY;EACE,sEAAA;AAy9Nd;;AAh9NU;EACE,oEAAA;AAm9NZ;;AA38NU;EACE,oEAAA;AA88NZ;;AA3/NY;EACE,oEAAA;AA8/Nd;AAx/NY;EACE,sEAAA;AA0/Nd;;AAh/NY;EACE,mEAAA;AAm/Nd;AA7+NY;EACE,qEAAA;AA++Nd;;AAt+NU;EACE,oEAAA;AAy+NZ;;AAj+NU;EACE,oEAAA;AAo+NZ;;AAjhOY;EACE,6CAAA;AAohOd;AA9gOY;EACE,+CAAA;AAghOd;;AAtgOY;EACE,mEAAA;AAygOd;AAngOY;EACE,qEAAA;AAqgOd;;AA5/NU;EACE,6CAAA;AA+/NZ;;AAv/NU;EACE,6CAAA;AA0/NZ;;AAviOY;EACE,gEAAA;AA0iOd;AApiOY;EACE,kEAAA;AAsiOd;;AA5hOY;EACE,mEAAA;AA+hOd;AAzhOY;EACE,qEAAA;AA2hOd;;AAlhOU;EACE,gEAAA;AAqhOZ;;AA7gOU;EACE,gEAAA;AAghOZ;;AA7jOY;EACE,0CAAA;AAgkOd;AA1jOY;EACE,4CAAA;AA4jOd;;AAljOY;EACE,uCAAA;AAqjOd;AA/iOY;EACE,yCAAA;AAijOd;;AAxiOU;EACE,0CAAA;AA2iOZ;;AAniOU;EACE,0CAAA;AAsiOZ;;AAnlOY;EACE,0CAAA;AAslOd;AAhlOY;EACE,4CAAA;AAklOd;;AAxkOY;EACE,yCAAA;AA2kOd;AArkOY;EACE,2CAAA;AAukOd;;AA9jOU;EACE,0CAAA;AAikOZ;;AAzjOU;EACE,0CAAA;AA4jOZ;;AAzmOY;EACE,0CAAA;AA4mOd;AAtmOY;EACE,4CAAA;AAwmOd;;AA9lOY;EACE,yCAAA;AAimOd;AA3lOY;EACE,2CAAA;AA6lOd;;AAplOU;EACE,0CAAA;AAulOZ;;AA/kOU;EACE,0CAAA;AAklOZ;;AA/nOY;EACE,wCAAA;AAkoOd;AA5nOY;EACE,0CAAA;AA8nOd;;AApnOY;EACE,sCAAA;AAunOd;AAjnOY;EACE,wCAAA;AAmnOd;;AA1mOU;EACE,wCAAA;AA6mOZ;;AArmOU;EACE,wCAAA;AAwmOZ;;AArpOY;EACE,wCAAA;AAwpOd;AAlpOY;EACE,0CAAA;AAopOd;;AA1oOY;EACE,sCAAA;AA6oOd;AAvoOY;EACE,wCAAA;AAyoOd;;AAhoOU;EACE,wCAAA;AAmoOZ;;AA3nOU;EACE,wCAAA;AA8nOZ;;AA3qOY;EACE,uCAAA;AA8qOd;AAxqOY;EACE,yCAAA;AA0qOd;;AAhqOY;EACE,uCAAA;AAmqOd;AA7pOY;EACE,yCAAA;AA+pOd;;AAtpOU;EACE,uCAAA;AAypOZ;;AAjpOU;EACE,uCAAA;AAopOZ;;AAjsOY;EACE,yCAAA;AAosOd;AA9rOY;EACE,2CAAA;AAgsOd;;AAtrOY;EACE,yCAAA;AAyrOd;AAnrOY;EACE,2CAAA;AAqrOd;;AA5qOU;EACE,yCAAA;AA+qOZ;;AAvqOU;EACE,yCAAA;AA0qOZ;;AAvtOY;EACE,4CAAA;AA0tOd;AAptOY;EACE,8CAAA;AAstOd;;AA5sOY;EACE,0CAAA;AA+sOd;AAzsOY;EACE,4CAAA;AA2sOd;;AAlsOU;EACE,4CAAA;AAqsOZ;;AA7rOU;EACE,4CAAA;AAgsOZ;;AA7uOY;EACE,oEAAA;AAgvOd;AA1uOY;EACE,sEAAA;AA4uOd;;AAluOY;EACE,oEAAA;AAquOd;AA/tOY;EACE,sEAAA;AAiuOd;;AAxtOU;EACE,oEAAA;AA2tOZ;;AAntOU;EACE,oEAAA;AAstOZ;;AAnwOY;EACE,oEAAA;AAswOd;AAhwOY;EACE,sEAAA;AAkwOd;;AAxvOY;EACE,mEAAA;AA2vOd;AArvOY;EACE,qEAAA;AAuvOd;;AA9uOU;EACE,oEAAA;AAivOZ;;AAzuOU;EACE,oEAAA;AA4uOZ;;AAzxOY;EACE,mEAAA;AA4xOd;AAtxOY;EACE,qEAAA;AAwxOd;;AA9wOY;EACE,mEAAA;AAixOd;AA3wOY;EACE,qEAAA;AA6wOd;;AApwOU;EACE,mEAAA;AAuwOZ;;AA/vOU;EACE,mEAAA;AAkwOZ;;AA/yOY;EACE,mEAAA;AAkzOd;AA5yOY;EACE,qEAAA;AA8yOd;;AApyOY;EACE,mEAAA;AAuyOd;AAjyOY;EACE,qEAAA;AAmyOd;;AA1xOU;EACE,mEAAA;AA6xOZ;;AArxOU;EACE,mEAAA;AAwxOZ;;AAr0OY;EACE,2CAAA;AAw0Od;AAl0OY;EACE,6CAAA;AAo0Od;;AA1zOY;EACE,0CAAA;AA6zOd;AAvzOY;EACE,4CAAA;AAyzOd;;AAhzOU;EACE,2CAAA;AAmzOZ;;AA3yOU;EACE,2CAAA;AA8yOZ;;AA31OY;EACE,2CAAA;AA81Od;AAx1OY;EACE,6CAAA;AA01Od;;AAh1OY;EACE,yCAAA;AAm1Od;AA70OY;EACE,2CAAA;AA+0Od;;AAt0OU;EACE,2CAAA;AAy0OZ;;AAj0OU;EACE,2CAAA;AAo0OZ;;AAj3OY;EACE,0CAAA;AAo3Od;AA92OY;EACE,4CAAA;AAg3Od;;AAt2OY;EACE,wCAAA;AAy2Od;AAn2OY;EACE,0CAAA;AAq2Od;;AA51OU;EACE,0CAAA;AA+1OZ;;AAv1OU;EACE,0CAAA;AA01OZ;;AAv4OY;EACE,yCAAA;AA04Od;AAp4OY;EACE,2CAAA;AAs4Od;;AA53OY;EACE,uCAAA;AA+3Od;AAz3OY;EACE,yCAAA;AA23Od;;AAl3OU;EACE,yCAAA;AAq3OZ;;AA72OU;EACE,yCAAA;AAg3OZ;;AA75OY;EACE,yCAAA;AAg6Od;AA15OY;EACE,2CAAA;AA45Od;;AAl5OY;EACE,uCAAA;AAq5Od;AA/4OY;EACE,yCAAA;AAi5Od;;AAx4OU;EACE,yCAAA;AA24OZ;;AAn4OU;EACE,yCAAA;AAs4OZ;;AAn7OY;EACE,uCAAA;AAs7Od;AAh7OY;EACE,yCAAA;AAk7Od;;AAx6OY;EACE,sCAAA;AA26Od;AAr6OY;EACE,wCAAA;AAu6Od;;AA95OU;EACE,uCAAA;AAi6OZ;;AAz5OU;EACE,uCAAA;AA45OZ;;AAz8OY;EACE,qCAAA;AA48Od;AAt8OY;EACE,uCAAA;AAw8Od;;AA97OY;EACE,qCAAA;AAi8Od;AA37OY;EACE,uCAAA;AA67Od;;AAp7OU;EACE,qCAAA;AAu7OZ;;AA/6OU;EACE,qCAAA;AAk7OZ;;AA/9OY;EACE,iDAAA;AAk+Od;AA59OY;EACE,mDAAA;AA89Od;;AAp9OY;EACE,iDAAA;AAu9Od;AAj9OY;EACE,mDAAA;AAm9Od;;AA18OU;EACE,iDAAA;AA68OZ;;AAr8OU;EACE,iDAAA;AAw8OZ;;AAr/OY;EACE,oEAAA;AAw/Od;AAl/OY;EACE,sEAAA;AAo/Od;;AA1+OY;EACE,oEAAA;AA6+Od;AAv+OY;EACE,sEAAA;AAy+Od;;AAh+OU;EACE,oEAAA;AAm+OZ;;AA39OU;EACE,oEAAA;AA89OZ;;AA3gPY;EACE,oEAAA;AA8gPd;AAxgPY;EACE,sEAAA;AA0gPd;;AAhgPY;EACE,oEAAA;AAmgPd;AA7/OY;EACE,sEAAA;AA+/Od;;AAt/OU;EACE,oEAAA;AAy/OZ;;AAj/OU;EACE,oEAAA;AAo/OZ;;AAjiPY;EACE,mEAAA;AAoiPd;AA9hPY;EACE,qEAAA;AAgiPd;;AAthPY;EACE,mEAAA;AAyhPd;AAnhPY;EACE,qEAAA;AAqhPd;;AA5gPU;EACE,mEAAA;AA+gPZ;;AAvgPU;EACE,mEAAA;AA0gPZ;;AAvjPY;EACE,mEAAA;AA0jPd;AApjPY;EACE,qEAAA;AAsjPd;;AA5iPY;EACE,mEAAA;AA+iPd;AAziPY;EACE,qEAAA;AA2iPd;;AAliPU;EACE,mEAAA;AAqiPZ;;AA7hPU;EACE,mEAAA;AAgiPZ;;AA7kPY;EACE,0CAAA;AAglPd;AA1kPY;EACE,4CAAA;AA4kPd;;AAlkPY;EACE,uCAAA;AAqkPd;AA/jPY;EACE,yCAAA;AAikPd;;AAxjPU;EACE,0CAAA;AA2jPZ;;AAnjPU;EACE,0CAAA;AAsjPZ;;AAnmPY;EACE,0CAAA;AAsmPd;AAhmPY;EACE,4CAAA;AAkmPd;;AAxlPY;EACE,uCAAA;AA2lPd;AArlPY;EACE,yCAAA;AAulPd;;AA9kPU;EACE,0CAAA;AAilPZ;;AAzkPU;EACE,0CAAA;AA4kPZ;;AAznPY;EACE,2CAAA;AA4nPd;AAtnPY;EACE,6CAAA;AAwnPd;;AA9mPY;EACE,uCAAA;AAinPd;AA3mPY;EACE,yCAAA;AA6mPd;;AApmPU;EACE,2CAAA;AAumPZ;;AA/lPU;EACE,2CAAA;AAkmPZ;;AA/oPY;EACE,0CAAA;AAkpPd;AA5oPY;EACE,4CAAA;AA8oPd;;AApoPY;EACE,yCAAA;AAuoPd;AAjoPY;EACE,2CAAA;AAmoPd;;AA1nPU;EACE,0CAAA;AA6nPZ;;AArnPU;EACE,0CAAA;AAwnPZ;;AArqPY;EACE,yCAAA;AAwqPd;AAlqPY;EACE,2CAAA;AAoqPd;;AA1pPY;EACE,uCAAA;AA6pPd;AAvpPY;EACE,yCAAA;AAypPd;;AAhpPU;EACE,yCAAA;AAmpPZ;;AA3oPU;EACE,yCAAA;AA8oPZ;;AA3rPY;EACE,yCAAA;AA8rPd;AAxrPY;EACE,2CAAA;AA0rPd;;AAhrPY;EACE,wCAAA;AAmrPd;AA7qPY;EACE,0CAAA;AA+qPd;;AAtqPU;EACE,yCAAA;AAyqPZ;;AAjqPU;EACE,yCAAA;AAoqPZ;;AAjtPY;EACE,qCAAA;AAotPd;AA9sPY;EACE,uCAAA;AAgtPd;;AAtsPY;EACE,qCAAA;AAysPd;AAnsPY;EACE,uCAAA;AAqsPd;;AA5rPU;EACE,qCAAA;AA+rPZ;;AAvrPU;EACE,qCAAA;AA0rPZ;;AAvuPY;EACE,4CAAA;AA0uPd;AApuPY;EACE,8CAAA;AAsuPd;;AA5tPY;EACE,2CAAA;AA+tPd;AAztPY;EACE,6CAAA;AA2tPd;;AAltPU;EACE,4CAAA;AAqtPZ;;AA7sPU;EACE,4CAAA;AAgtPZ;;AA7vPY;EACE,iDAAA;AAgwPd;AA1vPY;EACE,mDAAA;AA4vPd;;AAlvPY;EACE,gDAAA;AAqvPd;AA/uPY;EACE,kDAAA;AAivPd;;AAxuPU;EACE,iDAAA;AA2uPZ;;AAnuPU;EACE,iDAAA;AAsuPZ;;AAnxPY;EACE,iDAAA;AAsxPd;AAhxPY;EACE,mDAAA;AAkxPd;;AAxwPY;EACE,iDAAA;AA2wPd;AArwPY;EACE,mDAAA;AAuwPd;;AA9vPU;EACE,iDAAA;AAiwPZ;;AAzvPU;EACE,iDAAA;AA4vPZ;;AAzyPY;EACE,yCAAA;AA4yPd;AAtyPY;EACE,2CAAA;AAwyPd;;AA9xPY;EACE,uCAAA;AAiyPd;AA3xPY;EACE,yCAAA;AA6xPd;;AApxPU;EACE,yCAAA;AAuxPZ;;AA/wPU;EACE,yCAAA;AAkxPZ;;AA/zPY;EACE,gDAAA;AAk0Pd;AA5zPY;EACE,kDAAA;AA8zPd;;AApzPY;EACE,gDAAA;AAuzPd;AAjzPY;EACE,kDAAA;AAmzPd;;AA1yPU;EACE,gDAAA;AA6yPZ;;AAryPU;EACE,gDAAA;AAwyPZ;;AAr1PY;EACE,+CAAA;AAw1Pd;AAl1PY;EACE,iDAAA;AAo1Pd;;AA10PY;EACE,6CAAA;AA60Pd;AAv0PY;EACE,+CAAA;AAy0Pd;;AAh0PU;EACE,+CAAA;AAm0PZ;;AA3zPU;EACE,+CAAA;AA8zPZ;;AA32PY;EACE,gDAAA;AA82Pd;AAx2PY;EACE,kDAAA;AA02Pd;;AAh2PY;EACE,6CAAA;AAm2Pd;AA71PY;EACE,+CAAA;AA+1Pd;;AAt1PU;EACE,gDAAA;AAy1PZ;;AAj1PU;EACE,gDAAA;AAo1PZ;;AAj4PY;EACE,sCAAA;AAo4Pd;AA93PY;EACE,wCAAA;AAg4Pd;;AAt3PY;EACE,qCAAA;AAy3Pd;AAn3PY;EACE,uCAAA;AAq3Pd;;AA52PU;EACE,sCAAA;AA+2PZ;;AAv2PU;EACE,sCAAA;AA02PZ;;AAv5PY;EACE,sCAAA;AA05Pd;AAp5PY;EACE,wCAAA;AAs5Pd;;AA54PY;EACE,qCAAA;AA+4Pd;AAz4PY;EACE,uCAAA;AA24Pd;;AAl4PU;EACE,sCAAA;AAq4PZ;;AA73PU;EACE,sCAAA;AAg4PZ;;AA76PY;EACE,sCAAA;AAg7Pd;AA16PY;EACE,wCAAA;AA46Pd;;AAl6PY;EACE,qCAAA;AAq6Pd;AA/5PY;EACE,uCAAA;AAi6Pd;;AAx5PU;EACE,sCAAA;AA25PZ;;AAn5PU;EACE,sCAAA;AAs5PZ;;AAn8PY;EACE,qCAAA;AAs8Pd;AAh8PY;EACE,uCAAA;AAk8Pd;;AAx7PY;EACE,mCAAA;AA27Pd;AAr7PY;EACE,qCAAA;AAu7Pd;;AA96PU;EACE,qCAAA;AAi7PZ;;AAz6PU;EACE,qCAAA;AA46PZ;;AAz9PY;EACE,yCAAA;AA49Pd;AAt9PY;EACE,2CAAA;AAw9Pd;;AA98PY;EACE,wCAAA;AAi9Pd;AA38PY;EACE,0CAAA;AA68Pd;;AAp8PU;EACE,yCAAA;AAu8PZ;;AA/7PU;EACE,yCAAA;AAk8PZ;;AA/+PY;EACE,yCAAA;AAk/Pd;AA5+PY;EACE,2CAAA;AA8+Pd;;AAp+PY;EACE,wCAAA;AAu+Pd;AAj+PY;EACE,0CAAA;AAm+Pd;;AA19PU;EACE,yCAAA;AA69PZ;;AAr9PU;EACE,yCAAA;AAw9PZ;;AArgQY;EACE,kEAAA;AAwgQd;AAlgQY;EACE,oEAAA;AAogQd;;AA1/PY;EACE,oEAAA;AA6/Pd;AAv/PY;EACE,sEAAA;AAy/Pd;;AAh/PU;EACE,kEAAA;AAm/PZ;;AA3+PU;EACE,kEAAA;AA8+PZ;;AA3hQY;EACE,4CAAA;AA8hQd;AAxhQY;EACE,8CAAA;AA0hQd;;AAhhQY;EACE,oEAAA;AAmhQd;AA7gQY;EACE,sEAAA;AA+gQd;;AAtgQU;EACE,4CAAA;AAygQZ;;AAjgQU;EACE,4CAAA;AAogQZ;;AAjjQY;EACE,oEAAA;AAojQd;AA9iQY;EACE,sEAAA;AAgjQd;;AAtiQY;EACE,oEAAA;AAyiQd;AAniQY;EACE,sEAAA;AAqiQd;;AA5hQU;EACE,oEAAA;AA+hQZ;;AAvhQU;EACE,oEAAA;AA0hQZ;;AAvkQY;EACE,oEAAA;AA0kQd;AApkQY;EACE,sEAAA;AAskQd;;AA5jQY;EACE,mEAAA;AA+jQd;AAzjQY;EACE,qEAAA;AA2jQd;;AAljQU;EACE,oEAAA;AAqjQZ;;AA7iQU;EACE,oEAAA;AAgjQZ;;AA7lQY;EACE,mEAAA;AAgmQd;AA1lQY;EACE,qEAAA;AA4lQd;;AAllQY;EACE,kEAAA;AAqlQd;AA/kQY;EACE,oEAAA;AAilQd;;AAxkQU;EACE,mEAAA;AA2kQZ;;AAnkQU;EACE,mEAAA;AAskQZ;;AAnnQY;EACE,mEAAA;AAsnQd;AAhnQY;EACE,qEAAA;AAknQd;;AAxmQY;EACE,gEAAA;AA2mQd;AArmQY;EACE,kEAAA;AAumQd;;AA9lQU;EACE,mEAAA;AAimQZ;;AAzlQU;EACE,mEAAA;AA4lQZ;;AAzoQY;EACE,kEAAA;AA4oQd;AAtoQY;EACE,oEAAA;AAwoQd;;AA9nQY;EACE,kEAAA;AAioQd;AA3nQY;EACE,oEAAA;AA6nQd;;AApnQU;EACE,kEAAA;AAunQZ;;AA/mQU;EACE,kEAAA;AAknQZ;;AA/pQY;EACE,0CAAA;AAkqQd;AA5pQY;EACE,4CAAA;AA8pQd;;AAppQY;EACE,yCAAA;AAupQd;AAjpQY;EACE,2CAAA;AAmpQd;;AA1oQU;EACE,0CAAA;AA6oQZ;;AAroQU;EACE,0CAAA;AAwoQZ;;AArrQY;EACE,yCAAA;AAwrQd;AAlrQY;EACE,2CAAA;AAorQd;;AA1qQY;EACE,wCAAA;AA6qQd;AAvqQY;EACE,0CAAA;AAyqQd;;AAhqQU;EACE,yCAAA;AAmqQZ;;AA3pQU;EACE,yCAAA;AA8pQZ;;AA3sQY;EACE,yCAAA;AA8sQd;AAxsQY;EACE,2CAAA;AA0sQd;;AAhsQY;EACE,sCAAA;AAmsQd;AA7rQY;EACE,wCAAA;AA+rQd;;AAtrQU;EACE,yCAAA;AAyrQZ;;AAjrQU;EACE,yCAAA;AAorQZ;;AAjuQY;EACE,yCAAA;AAouQd;AA9tQY;EACE,2CAAA;AAguQd;;AAttQY;EACE,yCAAA;AAytQd;AAntQY;EACE,2CAAA;AAqtQd;;AA5sQU;EACE,yCAAA;AA+sQZ;;AAvsQU;EACE,yCAAA;AA0sQZ;;AAvvQY;EACE,0CAAA;AA0vQd;AApvQY;EACE,4CAAA;AAsvQd;;AA5uQY;EACE,yCAAA;AA+uQd;AAzuQY;EACE,2CAAA;AA2uQd;;AAluQU;EACE,0CAAA;AAquQZ;;AA7tQU;EACE,0CAAA;AAguQZ;;AA7wQY;EACE,kEAAA;AAgxQd;AA1wQY;EACE,oEAAA;AA4wQd;;AAlwQY;EACE,oEAAA;AAqwQd;AA/vQY;EACE,sEAAA;AAiwQd;;AAxvQU;EACE,kEAAA;AA2vQZ;;AAnvQU;EACE,kEAAA;AAsvQZ;;AAnyQY;EACE,4CAAA;AAsyQd;AAhyQY;EACE,8CAAA;AAkyQd;;AAxxQY;EACE,oEAAA;AA2xQd;AArxQY;EACE,sEAAA;AAuxQd;;AA9wQU;EACE,4CAAA;AAixQZ;;AAzwQU;EACE,4CAAA;AA4wQZ;;AAzzQY;EACE,oEAAA;AA4zQd;AAtzQY;EACE,sEAAA;AAwzQd;;AA9yQY;EACE,oEAAA;AAizQd;AA3yQY;EACE,sEAAA;AA6yQd;;AApyQU;EACE,oEAAA;AAuyQZ;;AA/xQU;EACE,oEAAA;AAkyQZ;;AA/0QY;EACE,oEAAA;AAk1Qd;AA50QY;EACE,sEAAA;AA80Qd;;AAp0QY;EACE,mEAAA;AAu0Qd;AAj0QY;EACE,qEAAA;AAm0Qd;;AA1zQU;EACE,oEAAA;AA6zQZ;;AArzQU;EACE,oEAAA;AAwzQZ;;AAr2QY;EACE,mEAAA;AAw2Qd;AAl2QY;EACE,qEAAA;AAo2Qd;;AA11QY;EACE,gEAAA;AA61Qd;AAv1QY;EACE,kEAAA;AAy1Qd;;AAh1QU;EACE,mEAAA;AAm1QZ;;AA30QU;EACE,mEAAA;AA80QZ;;AA33QY;EACE,gEAAA;AA83Qd;AAx3QY;EACE,kEAAA;AA03Qd;;AAh3QY;EACE,kEAAA;AAm3Qd;AA72QY;EACE,oEAAA;AA+2Qd;;AAt2QU;EACE,gEAAA;AAy2QZ;;AAj2QU;EACE,gEAAA;AAo2QZ;;AAj5QY;EACE,kEAAA;AAo5Qd;AA94QY;EACE,oEAAA;AAg5Qd;;AAt4QY;EACE,kEAAA;AAy4Qd;AAn4QY;EACE,oEAAA;AAq4Qd;;AA53QU;EACE,kEAAA;AA+3QZ;;AAv3QU;EACE,kEAAA;AA03QZ;;AAv6QY;EACE,0CAAA;AA06Qd;AAp6QY;EACE,4CAAA;AAs6Qd;;AA55QY;EACE,wCAAA;AA+5Qd;AAz5QY;EACE,0CAAA;AA25Qd;;AAl5QU;EACE,0CAAA;AAq5QZ;;AA74QU;EACE,0CAAA;AAg5QZ;;AA77QY;EACE,yCAAA;AAg8Qd;AA17QY;EACE,2CAAA;AA47Qd;;AAl7QY;EACE,uCAAA;AAq7Qd;AA/6QY;EACE,yCAAA;AAi7Qd;;AAx6QU;EACE,yCAAA;AA26QZ;;AAn6QU;EACE,yCAAA;AAs6QZ;;AAn9QY;EACE,yCAAA;AAs9Qd;AAh9QY;EACE,2CAAA;AAk9Qd;;AAx8QY;EACE,yCAAA;AA28Qd;AAr8QY;EACE,2CAAA;AAu8Qd;;AA97QU;EACE,yCAAA;AAi8QZ;;AAz7QU;EACE,yCAAA;AA47QZ;;AAz+QY;EACE,yCAAA;AA4+Qd;AAt+QY;EACE,2CAAA;AAw+Qd;;AA99QY;EACE,yCAAA;AAi+Qd;AA39QY;EACE,2CAAA;AA69Qd;;AAp9QU;EACE,yCAAA;AAu9QZ;;AA/8QU;EACE,yCAAA;AAk9QZ;;AA//QY;EACE,iDAAA;AAkgRd;AA5/QY;EACE,mDAAA;AA8/Qd;;AAp/QY;EACE,iDAAA;AAu/Qd;AAj/QY;EACE,mDAAA;AAm/Qd;;AA1+QU;EACE,iDAAA;AA6+QZ;;AAr+QU;EACE,iDAAA;AAw+QZ;;AArhRY;EACE,iDAAA;AAwhRd;AAlhRY;EACE,mDAAA;AAohRd;;AA1gRY;EACE,iDAAA;AA6gRd;AAvgRY;EACE,mDAAA;AAygRd;;AAhgRU;EACE,iDAAA;AAmgRZ;;AA3/QU;EACE,iDAAA;AA8/QZ;;AA3iRY;EACE,qDAAA;AA8iRd;AAxiRY;EACE,uDAAA;AA0iRd;;AAhiRY;EACE,qDAAA;AAmiRd;AA7hRY;EACE,uDAAA;AA+hRd;;AAthRU;EACE,qDAAA;AAyhRZ;;AAjhRU;EACE,qDAAA;AAohRZ;;AAjkRY;EACE,mEAAA;AAokRd;AA9jRY;EACE,qEAAA;AAgkRd;;AAtjRY;EACE,oEAAA;AAyjRd;AAnjRY;EACE,sEAAA;AAqjRd;;AA5iRU;EACE,mEAAA;AA+iRZ;;AAviRU;EACE,mEAAA;AA0iRZ;;AAvlRY;EACE,8CAAA;AA0lRd;AAplRY;EACE,gDAAA;AAslRd;;AA5kRY;EACE,mEAAA;AA+kRd;AAzkRY;EACE,qEAAA;AA2kRd;;AAlkRU;EACE,8CAAA;AAqkRZ;;AA7jRU;EACE,8CAAA;AAgkRZ;;AA7mRY;EACE,mEAAA;AAgnRd;AA1mRY;EACE,qEAAA;AA4mRd;;AAlmRY;EACE,iEAAA;AAqmRd;AA/lRY;EACE,mEAAA;AAimRd;;AAxlRU;EACE,mEAAA;AA2lRZ;;AAnlRU;EACE,mEAAA;AAslRZ;;AAnoRY;EACE,2CAAA;AAsoRd;AAhoRY;EACE,6CAAA;AAkoRd;;AAxnRY;EACE,yCAAA;AA2nRd;AArnRY;EACE,2CAAA;AAunRd;;AA9mRU;EACE,2CAAA;AAinRZ;;AAzmRU;EACE,2CAAA;AA4mRZ;;AAzpRY;EACE,2CAAA;AA4pRd;AAtpRY;EACE,6CAAA;AAwpRd;;AA9oRY;EACE,0CAAA;AAipRd;AA3oRY;EACE,4CAAA;AA6oRd;;AApoRU;EACE,2CAAA;AAuoRZ;;AA/nRU;EACE,2CAAA;AAkoRZ;;AA/qRY;EACE,0CAAA;AAkrRd;AA5qRY;EACE,4CAAA;AA8qRd;;AApqRY;EACE,wCAAA;AAuqRd;AAjqRY;EACE,0CAAA;AAmqRd;;AA1pRU;EACE,0CAAA;AA6pRZ;;AArpRU;EACE,0CAAA;AAwpRZ;;AArsRY;EACE,2CAAA;AAwsRd;AAlsRY;EACE,6CAAA;AAosRd;;AA1rRY;EACE,yCAAA;AA6rRd;AAvrRY;EACE,2CAAA;AAyrRd;;AAhrRU;EACE,2CAAA;AAmrRZ;;AA3qRU;EACE,2CAAA;AA8qRZ;;AA3tRY;EACE,yCAAA;AA8tRd;AAxtRY;EACE,2CAAA;AA0tRd;;AAhtRY;EACE,uCAAA;AAmtRd;AA7sRY;EACE,yCAAA;AA+sRd;;AAtsRU;EACE,yCAAA;AAysRZ;;AAjsRU;EACE,yCAAA;AAosRZ;;AAjvRY;EACE,uCAAA;AAovRd;AA9uRY;EACE,yCAAA;AAgvRd;;AAtuRY;EACE,uCAAA;AAyuRd;AAnuRY;EACE,yCAAA;AAquRd;;AA5tRU;EACE,uCAAA;AA+tRZ;;AAvtRU;EACE,uCAAA;AA0tRZ;;AAvwRY;EACE,4CAAA;AA0wRd;AApwRY;EACE,8CAAA;AAswRd;;AA5vRY;EACE,2CAAA;AA+vRd;AAzvRY;EACE,6CAAA;AA2vRd;;AAlvRU;EACE,4CAAA;AAqvRZ;;AA7uRU;EACE,4CAAA;AAgvRZ;;AA7xRY;EACE,4DAAA;AAgyRd;AA1xRY;EACE,8DAAA;AA4xRd;;AAlxRY;EACE,2CAAA;AAqxRd;AA/wRY;EACE,6CAAA;AAixRd;;AAxwRU;EACE,4DAAA;AA2wRZ;;AAnwRU;EACE,4DAAA;AAswRZ;;AAnzRY;EACE,oEAAA;AAszRd;AAhzRY;EACE,sEAAA;AAkzRd;;AAxyRY;EACE,oEAAA;AA2yRd;AAryRY;EACE,sEAAA;AAuyRd;;AA9xRU;EACE,oEAAA;AAiyRZ;;AAzxRU;EACE,oEAAA;AA4xRZ;;AAz0RY;EACE,4DAAA;AA40Rd;AAt0RY;EACE,8DAAA;AAw0Rd;;AA9zRY;EACE,4DAAA;AAi0Rd;AA3zRY;EACE,8DAAA;AA6zRd;;AApzRU;EACE,4DAAA;AAuzRZ;;AA/yRU;EACE,4DAAA;AAkzRZ;;AA/1RY;EACE,mEAAA;AAk2Rd;AA51RY;EACE,qEAAA;AA81Rd;;AAp1RY;EACE,mEAAA;AAu1Rd;AAj1RY;EACE,qEAAA;AAm1Rd;;AA10RU;EACE,mEAAA;AA60RZ;;AAr0RU;EACE,mEAAA;AAw0RZ;;AAr3RY;EACE,mEAAA;AAw3Rd;AAl3RY;EACE,qEAAA;AAo3Rd;;AA12RY;EACE,mEAAA;AA62Rd;AAv2RY;EACE,qEAAA;AAy2Rd;;AAh2RU;EACE,mEAAA;AAm2RZ;;AA31RU;EACE,mEAAA;AA81RZ;;AA34RY;EACE,mEAAA;AA84Rd;AAx4RY;EACE,qEAAA;AA04Rd;;AAh4RY;EACE,mEAAA;AAm4Rd;AA73RY;EACE,qEAAA;AA+3Rd;;AAt3RU;EACE,mEAAA;AAy3RZ;;AAj3RU;EACE,mEAAA;AAo3RZ;;AAj6RY;EACE,2CAAA;AAo6Rd;AA95RY;EACE,6CAAA;AAg6Rd;;AAt5RY;EACE,yCAAA;AAy5Rd;AAn5RY;EACE,2CAAA;AAq5Rd;;AA54RU;EACE,2CAAA;AA+4RZ;;AAv4RU;EACE,2CAAA;AA04RZ;;AAv7RY;EACE,0CAAA;AA07Rd;AAp7RY;EACE,4CAAA;AAs7Rd;;AA56RY;EACE,wCAAA;AA+6Rd;AAz6RY;EACE,0CAAA;AA26Rd;;AAl6RU;EACE,0CAAA;AAq6RZ;;AA75RU;EACE,0CAAA;AAg6RZ;;AA78RY;EACE,0CAAA;AAg9Rd;AA18RY;EACE,4CAAA;AA48Rd;;AAl8RY;EACE,yCAAA;AAq8Rd;AA/7RY;EACE,2CAAA;AAi8Rd;;AAx7RU;EACE,0CAAA;AA27RZ;;AAn7RU;EACE,0CAAA;AAs7RZ;;AAn+RY;EACE,yCAAA;AAs+Rd;AAh+RY;EACE,2CAAA;AAk+Rd;;AAx9RY;EACE,uCAAA;AA29Rd;AAr9RY;EACE,yCAAA;AAu9Rd;;AA98RU;EACE,yCAAA;AAi9RZ;;AAz8RU;EACE,yCAAA;AA48RZ;;AAz/RY;EACE,qCAAA;AA4/Rd;AAt/RY;EACE,uCAAA;AAw/Rd;;AA9+RY;EACE,qCAAA;AAi/Rd;AA3+RY;EACE,uCAAA;AA6+Rd;;AAp+RU;EACE,qCAAA;AAu+RZ;;AA/9RU;EACE,qCAAA;AAk+RZ;;AA/gSY;EACE,yCAAA;AAkhSd;AA5gSY;EACE,2CAAA;AA8gSd;;AApgSY;EACE,gDAAA;AAugSd;AAjgSY;EACE,kDAAA;AAmgSd;;AA1/RU;EACE,yCAAA;AA6/RZ;;AAr/RU;EACE,yCAAA;AAw/RZ;;AAriSY;EACE,iDAAA;AAwiSd;AAliSY;EACE,mDAAA;AAoiSd;;AA1hSY;EACE,iDAAA;AA6hSd;AAvhSY;EACE,mDAAA;AAyhSd;;AAhhSU;EACE,iDAAA;AAmhSZ;;AA3gSU;EACE,iDAAA;AA8gSZ;;AA3jSY;EACE,2CAAA;AA8jSd;AAxjSY;EACE,6CAAA;AA0jSd;;AAhjSY;EACE,2CAAA;AAmjSd;AA7iSY;EACE,6CAAA;AA+iSd;;AAtiSU;EACE,2CAAA;AAyiSZ;;AAjiSU;EACE,2CAAA;AAoiSZ;;AAjlSY;EACE,oEAAA;AAolSd;AA9kSY;EACE,sEAAA;AAglSd;;AAtkSY;EACE,oEAAA;AAykSd;AAnkSY;EACE,sEAAA;AAqkSd;;AA5jSU;EACE,oEAAA;AA+jSZ;;AAvjSU;EACE,oEAAA;AA0jSZ;;AAvmSY;EACE,mEAAA;AA0mSd;AApmSY;EACE,qEAAA;AAsmSd;;AA5lSY;EACE,kEAAA;AA+lSd;AAzlSY;EACE,oEAAA;AA2lSd;;AAllSU;EACE,mEAAA;AAqlSZ;;AA7kSU;EACE,mEAAA;AAglSZ;;AA7nSY;EACE,kEAAA;AAgoSd;AA1nSY;EACE,oEAAA;AA4nSd;;AAlnSY;EACE,kEAAA;AAqnSd;AA/mSY;EACE,oEAAA;AAinSd;;AAxmSU;EACE,kEAAA;AA2mSZ;;AAnmSU;EACE,kEAAA;AAsmSZ;;AAnpSY;EACE,0CAAA;AAspSd;AAhpSY;EACE,4CAAA;AAkpSd;;AAxoSY;EACE,yCAAA;AA2oSd;AAroSY;EACE,2CAAA;AAuoSd;;AA9nSU;EACE,0CAAA;AAioSZ;;AAznSU;EACE,0CAAA;AA4nSZ;;AAzqSY;EACE,0CAAA;AA4qSd;AAtqSY;EACE,4CAAA;AAwqSd;;AA9pSY;EACE,uCAAA;AAiqSd;AA3pSY;EACE,yCAAA;AA6pSd;;AAppSU;EACE,0CAAA;AAupSZ;;AA/oSU;EACE,0CAAA;AAkpSZ;;AA/rSY;EACE,0CAAA;AAksSd;AA5rSY;EACE,4CAAA;AA8rSd;;AAprSY;EACE,yCAAA;AAurSd;AAjrSY;EACE,2CAAA;AAmrSd;;AA1qSU;EACE,0CAAA;AA6qSZ;;AArqSU;EACE,0CAAA;AAwqSZ;;AArtSY;EACE,0CAAA;AAwtSd;AAltSY;EACE,4CAAA;AAotSd;;AA1sSY;EACE,wCAAA;AA6sSd;AAvsSY;EACE,0CAAA;AAysSd;;AAhsSU;EACE,0CAAA;AAmsSZ;;AA3rSU;EACE,0CAAA;AA8rSZ;;AA3uSY;EACE,yCAAA;AA8uSd;AAxuSY;EACE,2CAAA;AA0uSd;;AAhuSY;EACE,uCAAA;AAmuSd;AA7tSY;EACE,yCAAA;AA+tSd;;AAttSU;EACE,yCAAA;AAytSZ;;AAjtSU;EACE,yCAAA;AAotSZ;;AAjwSY;EACE,wBAAA;AAowSd;AA9vSY;EACE,0BAAA;AAgwSd;;AAtvSY;EACE,wBAAA;AAyvSd;AAnvSY;EACE,0BAAA;AAqvSd;;AA5uSU;EACE,wBAAA;AA+uSZ;;AAvuSU;EACE,wBAAA;AA0uSZ;;AAvxSY;EACE,iDAAA;AA0xSd;AApxSY;EACE,mDAAA;AAsxSd;;AA5wSY;EACE,uCAAA;AA+wSd;AAzwSY;EACE,yCAAA;AA2wSd;;AAlwSU;EACE,iDAAA;AAqwSZ;;AA7vSU;EACE,iDAAA;AAgwSZ;;AA7ySY;EACE,wCAAA;AAgzSd;AA1ySY;EACE,0CAAA;AA4ySd;;AAlySY;EACE,gDAAA;AAqySd;AA/xSY;EACE,kDAAA;AAiySd;;AAxxSU;EACE,wCAAA;AA2xSZ;;AAnxSU;EACE,wCAAA;AAsxSZ;;AAn0SY;EACE,iDAAA;AAs0Sd;AAh0SY;EACE,mDAAA;AAk0Sd;;AAxzSY;EACE,iDAAA;AA2zSd;AArzSY;EACE,mDAAA;AAuzSd;;AA9ySU;EACE,iDAAA;AAizSZ;;AAzySU;EACE,iDAAA;AA4ySZ;;AAz1SY;EACE,wCAAA;AA41Sd;AAt1SY;EACE,0CAAA;AAw1Sd;;AA90SY;EACE,wCAAA;AAi1Sd;AA30SY;EACE,0CAAA;AA60Sd;;AAp0SU;EACE,wCAAA;AAu0SZ;;AA/zSU;EACE,wCAAA;AAk0SZ;;AA/2SY;EACE,wBAAA;AAk3Sd;AA52SY;EACE,0BAAA;AA82Sd;;AAp2SY;EACE,2CAAA;AAu2Sd;AAj2SY;EACE,6CAAA;AAm2Sd;;AA11SU;EACE,wBAAA;AA61SZ;;AAr1SU;EACE,wBAAA;AAw1SZ;;AAr4SY;EACE,uCAAA;AAw4Sd;AAl4SY;EACE,yCAAA;AAo4Sd;;AA13SY;EACE,oCAAA;AA63Sd;AAv3SY;EACE,sCAAA;AAy3Sd;;AAh3SU;EACE,uCAAA;AAm3SZ;;AA32SU;EACE,uCAAA;AA82SZ;;AA35SY;EACE,wCAAA;AA85Sd;AAx5SY;EACE,0CAAA;AA05Sd;;AAh5SY;EACE,uCAAA;AAm5Sd;AA74SY;EACE,yCAAA;AA+4Sd;;AAt4SU;EACE,wCAAA;AAy4SZ;;AAj4SU;EACE,wCAAA;AAo4SZ;;AAj7SY;EACE,yCAAA;AAo7Sd;AA96SY;EACE,2CAAA;AAg7Sd;;AAt6SY;EACE,uCAAA;AAy6Sd;AAn6SY;EACE,yCAAA;AAq6Sd;;AA55SU;EACE,yCAAA;AA+5SZ;;AAv5SU;EACE,yCAAA;AA05SZ;;AAv8SY;EACE,0CAAA;AA08Sd;AAp8SY;EACE,4CAAA;AAs8Sd;;AA57SY;EACE,wCAAA;AA+7Sd;AAz7SY;EACE,0CAAA;AA27Sd;;AAl7SU;EACE,0CAAA;AAq7SZ;;AA76SU;EACE,0CAAA;AAg7SZ;;AA79SY;EACE,0CAAA;AAg+Sd;AA19SY;EACE,4CAAA;AA49Sd;;AAl9SY;EACE,yCAAA;AAq9Sd;AA/8SY;EACE,2CAAA;AAi9Sd;;AAx8SU;EACE,0CAAA;AA28SZ;;AAn8SU;EACE,0CAAA;AAs8SZ;;AAn/SY;EACE,uCAAA;AAs/Sd;AAh/SY;EACE,yCAAA;AAk/Sd;;AAx+SY;EACE,uCAAA;AA2+Sd;AAr+SY;EACE,yCAAA;AAu+Sd;;AA99SU;EACE,uCAAA;AAi+SZ;;AAz9SU;EACE,uCAAA;AA49SZ;;AAzgTY;EACE,oDAAA;AA4gTd;AAtgTY;EACE,sDAAA;AAwgTd;;AA9/SY;EACE,oDAAA;AAigTd;AA3/SY;EACE,sDAAA;AA6/Sd;;AAp/SU;EACE,oDAAA;AAu/SZ;;AA/+SU;EACE,oDAAA;AAk/SZ;;AA/hTY;EACE,gDAAA;AAkiTd;AA5hTY;EACE,kDAAA;AA8hTd;;AAphTY;EACE,gDAAA;AAuhTd;AAjhTY;EACE,kDAAA;AAmhTd;;AA1gTU;EACE,gDAAA;AA6gTZ;;AArgTU;EACE,gDAAA;AAwgTZ;;AArjTY;EACE,oEAAA;AAwjTd;AAljTY;EACE,sEAAA;AAojTd;;AA1iTY;EACE,oEAAA;AA6iTd;AAviTY;EACE,sEAAA;AAyiTd;;AAhiTU;EACE,oEAAA;AAmiTZ;;AA3hTU;EACE,oEAAA;AA8hTZ;;AA3kTY;EACE,oEAAA;AA8kTd;AAxkTY;EACE,sEAAA;AA0kTd;;AAhkTY;EACE,iEAAA;AAmkTd;AA7jTY;EACE,mEAAA;AA+jTd;;AAtjTU;EACE,oEAAA;AAyjTZ;;AAjjTU;EACE,oEAAA;AAojTZ;;AAjmTY;EACE,mEAAA;AAomTd;AA9lTY;EACE,qEAAA;AAgmTd;;AAtlTY;EACE,kEAAA;AAylTd;AAnlTY;EACE,oEAAA;AAqlTd;;AA5kTU;EACE,mEAAA;AA+kTZ;;AAvkTU;EACE,mEAAA;AA0kTZ;;AAvnTY;EACE,kEAAA;AA0nTd;AApnTY;EACE,oEAAA;AAsnTd;;AA5mTY;EACE,kEAAA;AA+mTd;AAzmTY;EACE,oEAAA;AA2mTd;;AAlmTU;EACE,kEAAA;AAqmTZ;;AA7lTU;EACE,kEAAA;AAgmTZ;;AA7oTY;EACE,yCAAA;AAgpTd;AA1oTY;EACE,2CAAA;AA4oTd;;AAloTY;EACE,uCAAA;AAqoTd;AA/nTY;EACE,yCAAA;AAioTd;;AAxnTU;EACE,yCAAA;AA2nTZ;;AAnnTU;EACE,yCAAA;AAsnTZ;;AAnqTY;EACE,0CAAA;AAsqTd;AAhqTY;EACE,4CAAA;AAkqTd;;AAxpTY;EACE,wCAAA;AA2pTd;AArpTY;EACE,0CAAA;AAupTd;;AA9oTU;EACE,0CAAA;AAipTZ;;AAzoTU;EACE,0CAAA;AA4oTZ;;AAzrTY;EACE,yCAAA;AA4rTd;AAtrTY;EACE,2CAAA;AAwrTd;;AA9qTY;EACE,wCAAA;AAirTd;AA3qTY;EACE,0CAAA;AA6qTd;;AApqTU;EACE,yCAAA;AAuqTZ;;AA/pTU;EACE,yCAAA;AAkqTZ;;AA/sTY;EACE,0CAAA;AAktTd;AA5sTY;EACE,4CAAA;AA8sTd;;AApsTY;EACE,wCAAA;AAusTd;AAjsTY;EACE,0CAAA;AAmsTd;;AA1rTU;EACE,0CAAA;AA6rTZ;;AArrTU;EACE,0CAAA;AAwrTZ;;AAruTY;EACE,0CAAA;AAwuTd;AAluTY;EACE,4CAAA;AAouTd;;AA1tTY;EACE,wCAAA;AA6tTd;AAvtTY;EACE,0CAAA;AAytTd;;AAhtTU;EACE,0CAAA;AAmtTZ;;AA3sTU;EACE,0CAAA;AA8sTZ;;AA3vTY;EACE,yCAAA;AA8vTd;AAxvTY;EACE,2CAAA;AA0vTd;;AAhvTY;EACE,uCAAA;AAmvTd;AA7uTY;EACE,yCAAA;AA+uTd;;AAtuTU;EACE,yCAAA;AAyuTZ;;AAjuTU;EACE,yCAAA;AAouTZ;;AAjxTY;EACE,4CAAA;AAoxTd;AA9wTY;EACE,8CAAA;AAgxTd;;AAtwTY;EACE,4CAAA;AAywTd;AAnwTY;EACE,8CAAA;AAqwTd;;AA5vTU;EACE,4CAAA;AA+vTZ;;AAvvTU;EACE,4CAAA;AA0vTZ;;AAvyTY;EACE,sBAAA;AA0yTd;AApyTY;EACE,wBAAA;AAsyTd;;AA5xTY;EACE,sBAAA;AA+xTd;AAzxTY;EACE,wBAAA;AA2xTd;;AAlxTU;EACE,sBAAA;AAqxTZ;;AA7wTU;EACE,sBAAA;AAgxTZ;;AAlwTU;;;;EAIE,sCAAA;AAqwTZ;AAjwTU;;;;EAIE,wCAAA;AAmwTZ;;AA9vTQ;EACE,mEAAA;AAiwTV;AA/vTQ;EACE,qEAAA;AAiwTV;;AA7vTQ;EACE,kEAAA;AAgwTV;AA9vTQ;EACE,oEAAA;AAgwTV;;AA7vTM;EAIE,mEAAA;AA6vTR;;AA3vTM;EAIE,mEAAA;AA2vTR;;AAryTU;;;;EAIE,sCAAA;AAwyTZ;AApyTU;;;;EAIE,wCAAA;AAsyTZ;;AAjyTQ;EACE,kDAAA;AAoyTV;AAlyTQ;EACE,oDAAA;AAoyTV;;AAhyTQ;EACE,kDAAA;AAmyTV;AAjyTQ;EACE,oDAAA;AAmyTV;;AAhyTM;EAIE,kDAAA;AAgyTR;;AA9xTM;EAIE,kDAAA;AA8xTR;;AAx0TU;;;;EAIE,sCAAA;AA20TZ;AAv0TU;;;;EAIE,wCAAA;AAy0TZ;;AAp0TQ;EACE,mEAAA;AAu0TV;AAr0TQ;EACE,qEAAA;AAu0TV;;AAn0TQ;EACE,kEAAA;AAs0TV;AAp0TQ;EACE,oEAAA;AAs0TV;;AAn0TM;EAIE,mEAAA;AAm0TR;;AAj0TM;EAIE,mEAAA;AAi0TR;;AA32TU;;;;EAIE,uCAAA;AA82TZ;AA12TU;;;;EAIE,yCAAA;AA42TZ;;AAv2TQ;EACE,kFAAA;AA02TV;AAx2TQ;EACE,oFAAA;AA02TV;;AAt2TQ;EACE,kFAAA;AAy2TV;AAv2TQ;EACE,oFAAA;AAy2TV;;AAt2TM;EAIE,kFAAA;AAs2TR;;AAp2TM;EAIE,kFAAA;AAo2TR;;AA94TU;;;;EAIE,uCAAA;AAi5TZ;AA74TU;;;;EAIE,yCAAA;AA+4TZ;;AA14TQ;EACE,8FAAA;AA64TV;AA34TQ;EACE,gGAAA;AA64TV;;AAz4TQ;EACE,8FAAA;AA44TV;AA14TQ;EACE,gGAAA;AA44TV;;AAz4TM;EAIE,8FAAA;AAy4TR;;AAv4TM;EAIE,8FAAA;AAu4TR;;AAj7TU;;;;EAIE,uCAAA;AAo7TZ;AAh7TU;;;;EAIE,yCAAA;AAk7TZ;;AA76TQ;EACE,6FAAA;AAg7TV;AA96TQ;EACE,+FAAA;AAg7TV;;AA56TQ;EACE,6FAAA;AA+6TV;AA76TQ;EACE,+FAAA;AA+6TV;;AA56TM;EAIE,6FAAA;AA46TR;;AA16TM;EAIE,6FAAA;AA06TR;;AAp9TU;;;;EAIE,uCAAA;AAu9TZ;AAn9TU;;;;EAIE,yCAAA;AAq9TZ;;AAh9TQ;EACE,6FAAA;AAm9TV;AAj9TQ;EACE,+FAAA;AAm9TV;;AA/8TQ;EACE,4FAAA;AAk9TV;AAh9TQ;EACE,8FAAA;AAk9TV;;AA/8TM;EAIE,6FAAA;AA+8TR;;AA78TM;EAIE,6FAAA;AA68TR;;AAv/TU;;;;EAIE,uCAAA;AA0/TZ;AAt/TU;;;;EAIE,yCAAA;AAw/TZ;;AAn/TQ;EACE,qEAAA;AAs/TV;AAp/TQ;EACE,uEAAA;AAs/TV;;AAl/TQ;EACE,mEAAA;AAq/TV;AAn/TQ;EACE,qEAAA;AAq/TV;;AAl/TM;EAIE,qEAAA;AAk/TR;;AAh/TM;EAIE,qEAAA;AAg/TR;;AA1hUU;;;;EAIE,uCAAA;AA6hUZ;AAzhUU;;;;EAIE,yCAAA;AA2hUZ;;AAthUQ;EACE,iEAAA;AAyhUV;AAvhUQ;EACE,mEAAA;AAyhUV;;AArhUQ;EACE,gEAAA;AAwhUV;AAthUQ;EACE,kEAAA;AAwhUV;;AArhUM;EAIE,iEAAA;AAqhUR;;AAnhUM;EAIE,iEAAA;AAmhUR;;AA7jUU;;;;EAIE,uCAAA;AAgkUZ;AA5jUU;;;;EAIE,yCAAA;AA8jUZ;;AAzjUQ;EACE,mEAAA;AA4jUV;AA1jUQ;EACE,qEAAA;AA4jUV;;AAxjUQ;EACE,gEAAA;AA2jUV;AAzjUQ;EACE,kEAAA;AA2jUV;;AAxjUM;EAIE,mEAAA;AAwjUR;;AAtjUM;EAIE,mEAAA;AAsjUR;;AAhmUU;;;;EAIE,uCAAA;AAmmUZ;AA/lUU;;;;EAIE,yCAAA;AAimUZ;;AA5lUQ;EACE,mEAAA;AA+lUV;AA7lUQ;EACE,qEAAA;AA+lUV;;AA3lUQ;EACE,iEAAA;AA8lUV;AA5lUQ;EACE,mEAAA;AA8lUV;;AA3lUM;EAIE,mEAAA;AA2lUR;;AAzlUM;EAIE,mEAAA;AAylUR;;AAnoUU;;;;EAIE,uCAAA;AAsoUZ;AAloUU;;;;EAIE,yCAAA;AAooUZ;;AA/nUQ;EACE,oEAAA;AAkoUV;AAhoUQ;EACE,sEAAA;AAkoUV;;AA9nUQ;EACE,iEAAA;AAioUV;AA/nUQ;EACE,mEAAA;AAioUV;;AA9nUM;EAIE,oEAAA;AA8nUR;;AA5nUM;EAIE,oEAAA;AA4nUR;;AAtqUU;;;;EAIE,uCAAA;AAyqUZ;AArqUU;;;;EAIE,yCAAA;AAuqUZ;;AAlqUQ;EACE,kEAAA;AAqqUV;AAnqUQ;EACE,oEAAA;AAqqUV;;AAjqUQ;EACE,gEAAA;AAoqUV;AAlqUQ;EACE,kEAAA;AAoqUV;;AAjqUM;EAIE,kEAAA;AAiqUR;;AA/pUM;EAIE,kEAAA;AA+pUR","sourcesContent":["@use '../../../../styles/lib' as lib;\n@use '../../../../styles/variables' as var;\n@use 'sass:color';\n\n.Icon {\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n\n  svg {\n    transition: 0.2s;\n  }\n\n  &--rotate {\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  &--size {\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &.custom-stroke-color {\n    svg {\n      stroke: inherit;\n      path,\n      polygon,\n      circle,\n      rect {\n        stroke: inherit;\n      }\n    }\n  }\n\n  &.custom-fill-color {\n    svg {\n      fill: inherit;\n      path,\n      polygon,\n      circle,\n      rect {\n        fill: inherit;\n      }\n    }\n  }\n\n  // Change color\n  @each $group, $colors in var.$colors {\n    @each $number, $color in $colors {\n      &--#{$group}-#{$number}.change-stroke-color {\n        svg {\n          path {\n            stroke: $color;\n          }\n          polygon {\n            stroke: $color;\n          }\n          circle {\n            stroke: $color;\n          }\n          rect {\n            stroke: $color;\n          }\n        }\n      }\n      &--#{$group}-#{$number}.change-fill-color {\n        svg {\n          path {\n            fill: $color;\n          }\n          polygon {\n            fill: $color;\n          }\n          circle {\n            fill: $color;\n          }\n          rect {\n            fill: $color;\n          }\n        }\n      }\n    }\n  }\n\n  // Mixin for White and Black\n  @mixin color-variants($color) {\n    &.change-stroke-color {\n      svg {\n        path,\n        polygon,\n        circle {\n          stroke: $color;\n        }\n      }\n    }\n\n    &.change-fill-color {\n      svg {\n        path,\n        polygon,\n        circle {\n          fill: $color;\n        }\n      }\n    }\n  }\n\n  &--black {\n    @include color-variants(black);\n  }\n\n  &--white {\n    @include color-variants(white);\n  }\n}\n\n// Icon of Button\n@each $group, $colors in var.$colors {\n  @each $number, $color in $colors {\n    button.text-#{$group}-#{$number}:hover {\n      .Icon--#{$group}-#{$number} {\n        &.change-fill-color {\n          svg {\n            path {\n              fill: color.scale($color, $lightness: -7%) !important;\n            }\n          }\n        }\n        &.change-stroke-color {\n          svg {\n            path {\n              stroke: color.scale($color, $lightness: -7%) !important;\n            }\n          }\n        }\n      }\n    }\n    button.text-#{$group}-#{$number}:active {\n      .Icon--#{$group}-#{$number} {\n        &.change-fill-color {\n          svg {\n            path {\n              fill: color.scale($color, $lightness: -15%) !important;\n            }\n          }\n        }\n        &.change-stroke-color {\n          svg {\n            path {\n              stroke: color.scale($color, $lightness: -15%) !important;\n            }\n          }\n        }\n      }\n    }\n    .popover-button[data-headlessui-state='open active'] {\n      .Icon--#{$group}-#{$number}:not(.change-stroke-color) {\n        svg {\n          path {\n            fill: color.scale($color, $lightness: -7%) !important;\n          }\n        }\n      }\n    }\n    .popover-button[data-headlessui-state='open active hover'] {\n      .Icon--#{$group}-#{$number}:not(.change-stroke-color) {\n        svg {\n          path {\n            fill: color.scale($color, $lightness: -7%) !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Primary icons follow per-practice branding via CSS variables; hex fallback keeps the default.\n@each $group, $shades in var.$colors {\n  @if $group == 'primary' {\n    @each $number, $hex in $shades {\n      .Icon.Icon--primary-#{$number} {\n        &.change-fill-color svg {\n          path,\n          polygon,\n          circle,\n          rect {\n            fill: var(--color-primary-#{$number}, #{$hex});\n          }\n        }\n        &.change-stroke-color svg {\n          path,\n          polygon,\n          circle,\n          rect {\n            stroke: var(--color-primary-#{$number}, #{$hex});\n          }\n        }\n      }\n      button.text-primary-#{$number}:hover .Icon--primary-#{$number} {\n        &.change-fill-color svg path {\n          fill: var(--color-primary-600, #{color.scale($hex, $lightness: -7%)}) !important;\n        }\n        &.change-stroke-color svg path {\n          stroke: var(--color-primary-600, #{color.scale($hex, $lightness: -7%)}) !important;\n        }\n      }\n      button.text-primary-#{$number}:active .Icon--primary-#{$number} {\n        &.change-fill-color svg path {\n          fill: var(--color-primary-700, #{color.scale($hex, $lightness: -15%)}) !important;\n        }\n        &.change-stroke-color svg path {\n          stroke: var(--color-primary-700, #{color.scale($hex, $lightness: -15%)}) !important;\n        }\n      }\n      .popover-button[data-headlessui-state='open active']\n        .Icon--primary-#{$number}:not(.change-stroke-color)\n        svg\n        path {\n        fill: var(--color-primary-600, #{color.scale($hex, $lightness: -7%)}) !important;\n      }\n      .popover-button[data-headlessui-state='open active hover']\n        .Icon--primary-#{$number}:not(.change-stroke-color)\n        svg\n        path {\n        fill: var(--color-primary-600, #{color.scale($hex, $lightness: -7%)}) !important;\n      }\n    }\n  }\n}\n","@use 'sass:map';\n\n$font-family-sans-serif:\n  'Geist',\n  -apple-system,\n  BlinkMacSystemFont,\n  'Segoe UI',\n  Roboto,\n  'Helvetica Neue',\n  Arial,\n  'Noto Sans',\n  sans-serif,\n  'Apple Color Emoji',\n  'Segoe UI Emoji',\n  'Segoe UI Symbol',\n  'Noto Color Emoji' !default;\n$main-font: 'Geist', sans-serif;\n\n// colors — kept in sync with tailwind.config.js\n$colors: (\n  'neutral': (\n    25: #fdfdfd,\n    50: #f9fafa,\n    75: #f6f6f6,\n    100: #f5f5f5,\n    200: #e9eaeb,\n    300: #d5d7da,\n    400: #a4a7ae,\n    500: #717680,\n    600: #535862,\n    700: #414651,\n    800: #252b37,\n    900: #181d27,\n    950: #0a0d12\n  ),\n  'neutral-dark': (\n    25: #fafafa,\n    50: #f7f7f7,\n    100: #f0f0f1,\n    200: #ececed,\n    300: #cecfd2,\n    400: #94979c,\n    500: #85888e,\n    600: #61656c,\n    700: #373a41,\n    800: #22262f,\n    900: #13161b,\n    950: #0c0e12\n  ),\n  'primary': (\n    10: #fafdff,\n    25: #f5fbff,\n    50: #f0f9ff,\n    100: #e0f2fe,\n    200: #b9e6fe,\n    300: #7cd4fd,\n    400: #36bffa,\n    500: #0ba5ec,\n    600: #0086c9,\n    700: #026aa2,\n    800: #065986,\n    900: #0b4a6f,\n    950: #062c41\n  ),\n  'danger': (\n    25: #fffbfa,\n    50: #fef3f2,\n    100: #fee4e2,\n    200: #fecdca,\n    300: #fda29b,\n    400: #f97066,\n    500: #f04438,\n    600: #d92d20,\n    700: #b42318,\n    800: #912018,\n    900: #7a271a,\n    950: #55160c\n  ),\n  'warning': (\n    25: #fffcf5,\n    50: #fffaeb,\n    100: #fef0c7,\n    200: #fedf89,\n    300: #fec84b,\n    400: #fdb022,\n    500: #f79009,\n    600: #dc6803,\n    700: #b54708,\n    800: #93370d,\n    900: #7a2e0e,\n    950: #4e1d09\n  ),\n  'success': (\n    25: #f6fef9,\n    50: #edfcf2,\n    100: #d3f8df,\n    200: #aaf0c4,\n    300: #73e2a3,\n    400: #3ccb7f,\n    500: #16b364,\n    600: #099250,\n    700: #087443,\n    800: #095c37,\n    900: #084c2e,\n    950: #052e1c\n  ),\n  'moss': (\n    25: #fafdf7,\n    50: #f5fbee,\n    100: #e6f4d7,\n    200: #ceeab0,\n    300: #acdc79,\n    400: #86cb3c,\n    500: #669f2a,\n    600: #4f7a21,\n    700: #3f621a,\n    800: #335015,\n    900: #2b4212,\n    950: #1a280b\n  ),\n  'green-light': (\n    25: #fafef5,\n    50: #f3fee7,\n    100: #e4fbcc,\n    200: #d0f8ab,\n    300: #a6ef67,\n    400: #85e13a,\n    500: #66c61c,\n    600: #4ca30d,\n    700: #3b7c0f,\n    800: #326212,\n    900: #2b5314,\n    950: #15290a\n  ),\n  'teal': (\n    25: #f6fefc,\n    50: #f0fdf9,\n    100: #ccfbef,\n    200: #99f6e0,\n    300: #5fe9d0,\n    400: #2ed3b7,\n    500: #15b79e,\n    600: #0e9384,\n    700: #107569,\n    800: #125d56,\n    900: #134e48,\n    950: #0a2926\n  ),\n  'cyan': (\n    25: #f5feff,\n    50: #ecfdff,\n    100: #cff9fe,\n    200: #a5f0fc,\n    300: #67e3f9,\n    400: #22ccee,\n    500: #06aed4,\n    600: #088ab2,\n    700: #0e7090,\n    800: #155b75,\n    900: #164c63,\n    950: #0d2d3a\n  ),\n  'blue-dark': (\n    25: #f5f8ff,\n    50: #eff4ff,\n    100: #d1e0ff,\n    200: #b2ccff,\n    300: #84adff,\n    400: #528bff,\n    500: #2970ff,\n    600: #155eef,\n    700: #004eeb,\n    800: #0040c1,\n    900: #00359e,\n    950: #002266\n  ),\n  'violet': (\n    25: #fbfaff,\n    50: #f5f3ff,\n    100: #ece9fe,\n    200: #ddd6fe,\n    300: #c3b5fd,\n    400: #a48afb,\n    500: #875bf7,\n    600: #7839ee,\n    700: #6927da,\n    800: #5720b7,\n    900: #491c96,\n    950: #2e125e\n  ),\n  'purple': (\n    25: #fafaff,\n    50: #f4f3ff,\n    100: #ebe9fe,\n    200: #d9d6fe,\n    300: #bdb4fe,\n    400: #9b8afb,\n    500: #7a5af8,\n    600: #6938ef,\n    700: #5925dc,\n    800: #4a1fb8,\n    900: #3e1c96,\n    950: #27115f\n  ),\n  'fuchsia': (\n    25: #fefaff,\n    50: #fdf4ff,\n    100: #fbe8ff,\n    200: #f6d0fe,\n    300: #eeaafd,\n    400: #e478fa,\n    500: #d444f1,\n    600: #ba24d5,\n    700: #9f1ab1,\n    800: #821890,\n    900: #6f1877,\n    950: #47104c\n  ),\n  'pink': (\n    25: #fef6fb,\n    50: #fdf2fa,\n    100: #fce7f6,\n    200: #fcceee,\n    300: #faa7e0,\n    400: #f670c7,\n    500: #ee46bc,\n    600: #dd2590,\n    700: #c11574,\n    800: #9e165f,\n    900: #851651,\n    950: #4e0d30\n  ),\n  'rose': (\n    25: #fff5f6,\n    50: #fff1f3,\n    100: #ffe4e8,\n    200: #fecdd6,\n    300: #fea3b4,\n    400: #fd6f8e,\n    500: #f63d68,\n    600: #e31b54,\n    700: #c01048,\n    800: #a11043,\n    900: #89123e,\n    950: #510b24\n  ),\n  'orange-dark': (\n    25: #fff9f5,\n    50: #fff4ed,\n    100: #ffe6d5,\n    200: #ffd6ae,\n    300: #ff9c66,\n    400: #ff692d,\n    500: #ff4405,\n    600: #e62e05,\n    700: #bc1b06,\n    800: #97180c,\n    900: #771a0d,\n    950: #57130a\n  ),\n  'yellow': (\n    25: #fefdf0,\n    50: #fefbe8,\n    100: #fef7c3,\n    200: #feee95,\n    300: #fde272,\n    400: #fac515,\n    500: #eaaa08,\n    600: #ca8504,\n    700: #a15c07,\n    800: #854a0e,\n    900: #713b12,\n    950: #542c0d\n  ),\n  'white': (\n    500: #ffffff\n  ),\n  'black': (\n    500: #000000\n  )\n);\n\n//colors\n$dark: map.get(map.get($colors, 'neutral'), 900);\n$black: map.get(map.get($colors, 'neutral'), 800);\n$primary: var(--color-primary-500, #{map.get(map.get($colors, 'primary'), 500)});\n$primary-dark: map.get(map.get($colors, 'primary'), 900);\n$secondary: var(--color-secondary-500, #b0d5e2);\n$gray: map.get(map.get($colors, 'neutral'), 400);\n$gray-dark: map.get(map.get($colors, 'neutral'), 800);\n$gray-light: map.get(map.get($colors, 'neutral'), 50);\n$success: map.get(map.get($colors, 'success'), 500);\n$warning: map.get(map.get($colors, 'warning'), 500);\n$danger: map.get(map.get($colors, 'danger'), 500);\n$blue-light: #f8fdff;\n$blue: #4876ff;\n\n//card theme colors\n$yellow: #ffc700;\n$purple: #aa56ff;\n$green: #00bf93;\n$greenLight: #10ca00;\n\n//media queries\n$xxs: 390px;\n$xs: 480px;\n$sm: 768px;\n$md: 1024px;\n$lg: 1512px;\n$xl: 1513px;\n$xxl: 2001px;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
